import type { TranslationMap } from './types';

// Hindi (हिन्दी) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion': 'त्वरित, हमेशा उपलब्ध मदद के लिए एक फ़्लोटिंग डेस्कटॉप साथी।',
  'settings.assistant.desktopCompanion': 'डेस्कटॉप साथी',
  'settings.assistant.desktopCompanionDesc': 'सिस्टम ट्रे शॉर्टकट के साथ हमेशा-चालू साथी मोड',
  'pages.settings.features.desktopCompanion': 'डेस्कटॉप कंपैनियन',
  'settings.companion.title': 'डेस्कटॉप साथी',
  'settings.companion.session': 'सत्र',
  'settings.companion.activeLabel': 'सक्रिय',
  'settings.companion.inactiveStatus': 'निष्क्रिय',
  'settings.companion.stopping': 'रुक रहा हूँ...',
  'settings.companion.stopSession': 'सत्र रोकें',
  'settings.companion.starting': 'शुरू हो रहा है...',
  'settings.companion.startSession': 'सत्र प्रारंभ करें',
  'settings.companion.sessionId': 'सत्र आईडी',
  'settings.companion.turns': 'टर्न',
  'settings.companion.remaining': 'शेष',
  'settings.companion.configuration': 'विन्यास',
  'settings.companion.hotkey': 'हॉटकी',
  'settings.companion.activationMode': 'सक्रियण मोड',
  'settings.companion.sessionTtl': 'सत्र टीटीएल',
  // Share cards (#5006).
  'share.button': 'साझा करें',
  'share.modalTitle': 'इस पल को साझा करें',
  'share.modalSubtitle': 'आपके एजेंट ने जो किया उसे X या LinkedIn पर पोस्ट करें',
  'share.drafting': 'आपका कार्ड बनाया जा रहा है...',
  'share.cardAlt': 'साझा कार्ड का पूर्वावलोकन',
  'share.imageError': 'छवि नहीं बनाई जा सकी। फिर से प्रयास करें।',
  'share.captionLabel': 'कैप्शन',
  'share.captionPlaceholder': 'एक कैप्शन लिखें...',
  'share.privacyNote':
    'केवल शीर्षक, कैप्शन, एजेंट का नाम और ब्रांडिंग साझा की जाती है। आपकी चैट, मेमोरी और फ़ाइलें निजी रहती हैं।',
  'share.defaultHeadline': 'देखिए मेरे OpenHuman एजेंट ने अभी क्या किया',
  'share.defaultAgentName': 'मेरा एजेंट',
  'share.defaultCaption': 'देखिए मेरे OpenHuman एजेंट ने अभी क्या किया।',
  'share.captionWithHeadline': '{headline}। मेरे OpenHuman एजेंट के साथ बनाया गया।',
  'share.linkedInHint': 'कैप्शन कॉपी हो गया। इसे अपनी LinkedIn पोस्ट में पेस्ट करें।',
  'share.shareX': 'X पर साझा करें',
  'share.shareLinkedIn': 'LinkedIn पर साझा करें',
  'share.copyImage': 'छवि कॉपी करें',
  'share.copiedImage': 'छवि कॉपी हो गई',
  'share.copyCaption': 'कैप्शन कॉपी करें',
  'share.copiedCaption': 'कैप्शन कॉपी हो गया',
  'agentWorld.welcome.nav': 'स्वागत है',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': 'एक ऐसी दुनिया जहाँ आपके एजेंट मिलते हैं',
  'agentWorld.welcome.body':
    'TinyPlace एआई एजेंटों के लिए सामाजिक परत है: आपका एजेंट दूसरे एजेंटों को खोज सकता है, उन्हें संदेश भेज सकता है, बाउंटी ले सकता है और आपकी ओर से व्यापार कर सकता है। इस दुनिया में कदम रखें और देखें कि वे क्या करते हैं।',
  'agentWorld.welcome.ctaWorld': 'दुनिया में प्रवेश करें',
  'agentWorld.welcome.ctaFeed': 'फ़ीड ब्राउज़ करें',
  'agentWorld.welcome.ctaDirectory': 'एजेंट खोजें',
  'agentWorld.welcome.featsLabel': 'यहाँ क्या होता है',
  'agentWorld.welcome.feat1Title': 'दूसरे एजेंटों से मिलें',
  'agentWorld.welcome.feat1Body': 'पूरे नेटवर्क के एजेंटों को खोजें और संदेश भेजें।',
  'agentWorld.welcome.feat2Title': 'बाउंटी लें',
  'agentWorld.welcome.feat2Body': 'आपका एजेंट पोस्ट किया गया काम पूरा करके कमाई कर सकता है।',
  'agentWorld.welcome.feat3Title': 'व्यापार और लेन-देन',
  'agentWorld.welcome.feat3Body': 'आपकी मंज़ूरी के साथ एजेंटों के बीच वॉलेट-समर्थित भुगतान।',
  'brain.header.graph': 'आपके एजेंट का ज्ञान कैसे जुड़ता है: लोग, विषय और यादें।',
  'brain.header.goals': 'आपका एजेंट किस दिशा में काम कर रहा है, और क्यों।',
  'brain.header.sources': 'वह डेटा जिससे आपका एजेंट सीखता है।',
  'brain.header.sync': 'अपनी मेमोरी को ताज़ा रखें और देखें कि क्या बदला।',
  'brain.header.subconscious': 'पृष्ठभूमि में चलने वाली सोच जो आपके दूर रहने पर काम करती है।',
  'brain.welcome.nav': 'स्वागत है',
  'brain.welcome.eyebrow': 'ब्रेन',
  'brain.welcome.title': 'आपके एजेंट की मेमोरी, मानचित्रित',
  'brain.welcome.body':
    'ब्रेन वह जगह है जहाँ आपका एजेंट अपनी जानकारी रखता है: वे लोग, बातचीत, स्रोत और लक्ष्य जिनका सहारा लेकर वह हर बार शून्य से शुरू करने के बजाय असली संदर्भ के साथ आपकी मदद करता है।',
  'brain.welcome.ctaGraph': 'मेमोरी ग्राफ़ खोलें',
  'brain.welcome.ctaGoals': 'लक्ष्य निर्धारित करें',
  'brain.welcome.ctaSources': 'स्रोत जोड़ें',
  'brain.welcome.featsLabel': 'यहाँ क्या रहता है',
  'brain.welcome.feat1Title': 'मेमोरी ग्राफ़',
  'brain.welcome.feat1Body': 'एक नज़र में देखें कि लोग, विषय और संदेश कैसे जुड़ते हैं।',
  'brain.welcome.feat2Title': 'लक्ष्य और फ़ोकस',
  'brain.welcome.feat2Body':
    'अपने एजेंट को बताएं कि क्या मायने रखता है ताकि वह सही काम को प्राथमिकता दे।',
  'brain.welcome.feat3Title': 'स्रोत और सिंक',
  'brain.welcome.feat3Body': 'वह डेटा जोड़ें जिससे आपका एजेंट सीखता है और उसे ताज़ा रखें।',
  'feedback.header.title': 'प्रतिक्रिया',
  'feedback.header.desc': 'विचार साझा करें और वोट दें कि हम आगे क्या बनाएँ।',
  'feedback.welcome.nav': 'स्वागत है',
  'feedback.welcome.main': 'प्रतिक्रिया बोर्ड',
  'feedback.welcome.eyebrow': 'प्रतिक्रिया',
  'feedback.welcome.title': 'हम क्या बनाएँ, यह आकार देने में मदद करें',
  'feedback.welcome.body':
    'हमें बताएं कि क्या अच्छा चल रहा है, क्या कमी है, और क्या OpenHuman को बेहतर बनाएगा। एक विचार पोस्ट करें, दूसरों के सुझावों पर वोट दें, और देखें कि सबसे अच्छे विचार हमारे रोडमैप के शीर्ष पर कैसे पहुँचते हैं।',
  'feedback.welcome.ctaShare': 'एक विचार साझा करें',
  'feedback.welcome.ctaBoard': 'बोर्ड देखें',
  'feedback.welcome.featsLabel': 'आप क्या कर सकते हैं',
  'feedback.welcome.feat1Title': 'विचार साझा करें',
  'feedback.welcome.feat1Body': 'बग, फ़ीचर अनुरोध, कच्चे विचार: सभी का स्वागत है।',
  'feedback.welcome.feat2Title': 'वोट दें',
  'feedback.welcome.feat2Body':
    'जो मायने रखता है उसे अपवोट करें ताकि हमें पता चले कि क्या प्राथमिकता देनी है।',
  'feedback.welcome.feat3Title': 'प्रगति ट्रैक करें',
  'feedback.welcome.feat3Body': 'देखें कि क्या योजनाबद्ध है, प्रगति पर है, और शिप हो चुका है।',
  'connections.header.composio': 'उन ऐप्स को जोड़ें जिनमें आपका एजेंट कार्य कर सकता है।',
  'connections.header.channels': 'उन चैट ऐप्स को लिंक करें जिनमें आपका समुदाय रहता है।',
  'connections.header.mcp': 'अपने एजेंट के टूल का विस्तार करने के लिए MCP सर्वर जोड़ें।',
  'connections.header.skills': 'एजेंट स्किल्स इंस्टॉल और प्रबंधित करें।',
  'connections.header.meetings': 'कैलेंडर जोड़ें और अपने एजेंट को कॉल में शामिल होने दें।',
  'connections.header.llm': 'AI प्रदाता, स्थानीय मॉडल और एजेंट चैट परीक्षक कॉन्फ़िगर करें।',
  'connections.header.embeddings': 'मेमोरी खोज के लिए उपयोग किया जाने वाला एम्बेडिंग मॉडल चुनें।',
  'connections.header.search': 'अपने एजेंट के लिए वेब खोज कॉन्फ़िगर करें।',
  'connections.header.wallet': 'आपके स्थानीय वॉलेट का बैलेंस और रिकवरी वाक्यांश।',
  'connections.header.composioKey':
    'सैकड़ों ऐप एकीकरण अनलॉक करने के लिए एक Composio API कुंजी जोड़ें।',
  'connections.llm.apiKeys': 'API कुंजियाँ और रूटिंग',
  'connections.welcome.nav': 'स्वागत है',
  'connections.welcome.eyebrow': 'कनेक्शन',
  'connections.welcome.title': 'जो कुछ भी आप उपयोग करते हैं, सब एक जगह',
  'connections.welcome.body':
    'अपने मैसेजिंग ऐप्स, ईमेल, कैलेंडर और टूल जोड़ें ताकि आपका एजेंट उन सभी में संदर्भ पढ़ सके और कार्रवाई कर सके, दर्जनों टैब के बीच कॉपी-पेस्ट किए बिना। यह क्या छू सकता है, इस पर नियंत्रण आपके पास रहता है।',
  'connections.welcome.ctaChannel': 'एक चैनल जोड़ें',
  'connections.welcome.ctaApps': 'ऐप्स जोड़ें',
  'connections.welcome.ctaSkills': 'स्किल्स ब्राउज़ करें',
  'connections.welcome.featsLabel': 'आप यहाँ क्या कर सकते हैं',
  'connections.welcome.feat1Title': 'चैनल लाएँ',
  'connections.welcome.feat1Body':
    'Slack, WhatsApp, Telegram, Gmail और अधिक: कुछ ही क्लिक में लिंक करें।',
  'connections.welcome.feat2Title': 'अपने एजेंट को कार्य करने दें',
  'connections.welcome.feat2Body':
    'यह जुड़ी हुई हर चीज़ के पूरे संदर्भ के साथ पढ़ता है, ड्राफ़्ट बनाता है और जवाब देता है।',
  'connections.welcome.feat3Title': 'नियंत्रण में रहें',
  'connections.welcome.feat3Body':
    'किसी भी समय प्रति चैनल एक्सेस दें या रद्द करें। आपकी सहमति के बिना कुछ नहीं चलता।',
  'alerts.header.desc': 'एजेंट गतिविधि और वह सब कुछ जिस पर आपका ध्यान चाहिए।',
  'notifications.welcome.nav': 'स्वागत है',
  'notifications.welcome.main': 'अलर्ट',
  'notifications.welcome.eyebrow': 'सूचनाएँ',
  'notifications.welcome.title': 'सिर्फ़ वही जिसके लिए वाकई आपकी ज़रूरत है',
  'notifications.welcome.body':
    'आपके एजेंटों ने क्या किया और किस पर निर्णय चाहिए, इसका एक शांत, स्कोर किया हुआ सारांश देखें, ताकि ज़रूरी चीज़ें सामने आएँ और शोर आपके रास्ते से दूर रहे।',
  'notifications.welcome.ctaView': 'अलर्ट देखें',
  'notifications.welcome.featsLabel': 'आप क्या देखेंगे',
  'notifications.welcome.feat1Title': 'जिसके लिए आपकी ज़रूरत है',
  'notifications.welcome.feat1Body':
    'निर्णय और उल्लेख जिन्हें आपके एजेंटों ने किसी इंसान के लिए चिह्नित किया।',
  'notifications.welcome.feat2Title': 'एजेंट गतिविधि',
  'notifications.welcome.feat2Body': 'क्या चला और उसने क्या बनाया, इसका एक चालू लॉग।',
  'notifications.welcome.feat3Title': 'श्रेणी के अनुसार फ़िल्टर किया गया',
  'notifications.welcome.feat3Body': 'संदेश, मीटिंग, रिमाइंडर: जैसे आप सोचते हैं वैसे विभाजित।',
  'rewards.header.desc': 'आपके पॉइंट, स्ट्रीक, रेफ़रल और पर्क्स।',
  'rewards.welcome.nav': 'स्वागत है',
  'rewards.welcome.main': 'रिवॉर्ड्स',
  'rewards.welcome.eyebrow': 'रिवॉर्ड्स',
  'rewards.welcome.title': 'आते रहने के लिए पुरस्कार पाएँ',
  'rewards.welcome.body':
    'जैसे-जैसे आप OpenHuman का उपयोग करते हैं और दूसरों को आमंत्रित करते हैं, पॉइंट कमाएँ, अपनी स्ट्रीक जीवित रखें और जो कमाया है उसे भुनाएँ। सब कुछ एक ही जगह ट्रैक किया जाता है।',
  'rewards.welcome.ctaView': 'रिवॉर्ड्स देखें',
  'rewards.welcome.featsLabel': 'यह कैसे काम करता है',
  'rewards.welcome.feat1Title': 'पॉइंट कमाएँ',
  'rewards.welcome.feat1Body': 'रोज़मर्रा के कार्य और रेफ़रल समय के साथ जुड़ते जाते हैं।',
  'rewards.welcome.feat2Title': 'अपनी स्ट्रीक बनाए रखें',
  'rewards.welcome.feat2Body': 'स्ट्रीक बोनस अनलॉक करने के लिए नियमित रूप से आते रहें।',
  'rewards.welcome.feat3Title': 'पर्क्स भुनाएँ',
  'rewards.welcome.feat3Body': 'पॉइंट को कूपन और रिवॉर्ड्स में बदलें।',
  'flows.welcome.nav': 'स्वागत है',
  'flows.welcome.main': 'वर्कफ़्लो',
  'flows.welcome.eyebrow': 'वर्कफ़्लो',
  'flows.welcome.title': 'दोहराव वाले काम को ऑटोपायलट पर लगाएँ',
  'flows.welcome.body':
    'ऐसा कुछ बताएं जो आप बार-बार करते हैं (ट्राइएज, फ़ॉलो-अप, डाइजेस्ट) और आपका एजेंट उसे एक वर्कफ़्लो में बदल देता है जिसे वह शुरू से अंत तक, शेड्यूल पर या माँग पर चला सकता है।',
  'flows.welcome.ctaNew': 'नया वर्कफ़्लो',
  'flows.welcome.ctaBrowse': 'वर्कफ़्लो ब्राउज़ करें',
  'flows.welcome.featsLabel': 'आप क्या स्वचालित कर सकते हैं',
  'flows.welcome.feat1Title': 'शब्दों में बताएं',
  'flows.welcome.feat1Body':
    'सरल भाषा में बताएं कि आप क्या चाहते हैं; बिल्डर फ़्लो का ड्राफ़्ट बनाता है।',
  'flows.welcome.feat2Title': 'शेड्यूल पर चलाएँ',
  'flows.welcome.feat2Body': 'टाइमर पर, किसी इवेंट पर, या एक बटन पर चलाएँ: आपकी मर्ज़ी।',
  'flows.welcome.feat3Title': 'इंसानों को शामिल रखें',
  'flows.welcome.feat3Body': 'कुछ भी बाहर जाने से पहले संवेदनशील चरणों को मंज़ूरी दें।',
  // Privacy Mode selector (#4435): data-egress posture
  'privacy.mode.title': 'गोपनीयता मोड',
  'privacy.mode.description':
    'नियंत्रित करता है कि आपका कितना डेटा इस डिवाइस से बाहर जा सकता है। एजेंट एक्सेस मोड से अलग।',
  'privacy.mode.localOnly': 'केवल लोकल',
  'privacy.mode.localOnlyDesc': 'केवल डिवाइस पर मौजूद मॉडल। बाहरी मॉडल कॉल अवरुद्ध हैं।',
  'privacy.mode.standard': 'मानक',
  'privacy.mode.standardDesc': 'संतुलित। बाहरी मॉडल कॉन्फ़िगरेशन के अनुसार उपयोग किए जाते हैं।',
  'privacy.mode.sensitive': 'संवेदनशील',
  'privacy.mode.sensitiveDesc': 'संवेदनशील डेटा के लिए अतिरिक्त सावधानी। अधिक नियंत्रण जल्द ही।',
  'privacy.mode.saved': 'सहेजा गया',
  'privacy.mode.saveError': 'गोपनीयता मोड अपडेट नहीं किया जा सका।',
  'skills.recallCalendar.title': 'गूगल कैलेंडर',
  'skills.recallCalendar.description': 'Recall.ai के ज़रिए Google Meet कॉल में अपने-आप शामिल हों',
  // Core connection panel (GH-4396)
  'settings.core.title': 'कोर कनेक्शन',
  'settings.core.menuDesc':
    'अंतर्निहित स्थानीय कोर का उपयोग करें या किसी रिमोट कोर से कनेक्ट करें।',
  'settings.core.useRemoteToggle': 'रिमोट कोर का उपयोग करें',
  'settings.core.useRemoteToggleDesc':
    'अंतर्निहित स्थानीय कोर के बजाय HTTP के माध्यम से किसी रिमोट कोर से कनेक्ट करें।',
  'settings.core.statusConnectedRemote': 'रिमोट कोर से कनेक्ट हो गया',
  'settings.core.statusConnectedLocal': 'स्थानीय कोर से कनेक्ट हो गया',
  'settings.core.statusChecking': 'कनेक्शन जाँचा जा रहा है…',
  'settings.core.statusAuthFailed': 'पहुँच योग्य, लेकिन टोकन अस्वीकृत हो गया',
  'settings.core.statusUnreachable': 'कोर तक नहीं पहुँचा जा सकता',
  'settings.core.recheck': 'फिर से जाँचें',
  'settings.core.save': 'सहेजें और पुनरारंभ करें',
  'settings.core.applyRestartNote':
    'सहेजने पर OpenHuman फिर से कनेक्ट होने के लिए पुनरारंभ होता है।',
  // Cross-host vault (#4278)
  'crossHostVault.title': 'वॉल्ट कोर होस्ट पर है।',
  'crossHostVault.message':
    'यह मेमोरी वॉल्ट openhuman-core होस्ट ({os}) पर संग्रहीत है। इसे केवल उसी मशीन पर खोला या दिखाया जा सकता है, इस डिवाइस से नहीं।',
  'conversations.toolFailure.whyLabel': 'क्यों',
  'conversations.toolFailure.nextLabel': 'आगे क्या करें',
  'conversations.toolFailure.missingPermission.cause':
    'OpenHuman के पास अभी यह करने की अनुमति नहीं है।',
  'conversations.toolFailure.missingPermission.next': 'आवश्यक अनुमति दें, फिर दोबारा प्रयास करें।',
  'conversations.toolFailure.missingApp.cause':
    'इस कार्य के लिए आवश्यक ऐप या प्रोग्राम उपलब्ध नहीं है।',
  'conversations.toolFailure.missingApp.next': 'ऐप इंस्टॉल करें या खोलें, फिर दोबारा प्रयास करें।',
  'conversations.toolFailure.serviceUnavailable.cause':
    'OpenHuman को जिस सेवा की आवश्यकता है वह अस्थायी रूप से अनुपलब्ध है।',
  'conversations.toolFailure.serviceUnavailable.next':
    'OpenHuman शीघ्र ही फिर से प्रयास करेगा: कोई कार्रवाई आवश्यक नहीं।',
  'conversations.toolFailure.badCredentials.cause':
    'सहेजी गई साइन-इन जानकारी गायब है या अब मान्य नहीं है।',
  'conversations.toolFailure.badCredentials.next':
    'फिर से साइन इन करें या क्रेडेंशियल अपडेट करें, फिर दोबारा प्रयास करें।',
  'conversations.toolFailure.blockedByPolicy.cause':
    'यह कार्य आपकी सुरक्षा सेटिंग्स द्वारा अवरुद्ध है।',
  'conversations.toolFailure.blockedByPolicy.next':
    'यदि आप इसे चलाना चाहते हैं तो इसे सेटिंग्स → एजेंट एक्सेस में अनुमति दें।',
  'conversations.toolFailure.modelConnection.cause': 'OpenHuman AI मॉडल तक नहीं पहुँच सका।',
  'conversations.toolFailure.modelConnection.next':
    'अपना कनेक्शन या मॉडल सेटिंग्स जाँचें; OpenHuman फिर से प्रयास करेगा।',
  'conversations.toolFailure.timeout.cause': 'कार्य में बहुत अधिक समय लगा और इसे रोक दिया गया।',
  'conversations.toolFailure.timeout.next':
    'OpenHuman फिर से प्रयास करेगा, या आप इसे मैन्युअल रूप से दोबारा कर सकते हैं।',
  'conversations.toolFailure.denied.cause': 'आपने इस क्रिया को अस्वीकार कर दिया।',
  'conversations.toolFailure.denied.next':
    'कुछ नहीं करना है: यह चलाई नहीं गई। मन बदलें तो फिर से कहें।',
  'conversations.toolFailure.approvalExpired.cause':
    'किसी के जवाब देने से पहले ही अनुमोदन अनुरोध की समय-सीमा समाप्त हो गई।',
  'conversations.toolFailure.approvalExpired.next':
    'इसे चलाने के लिए फिर से कहें: OpenHuman इसे स्वयं दोबारा नहीं आज़माएगा।',
  'conversations.toolFailure.unknown.cause': 'इस कार्य में कुछ गड़बड़ हो गई।',
  'conversations.toolFailure.unknown.next':
    'दोबारा प्रयास करें; यदि यह बार-बार विफल हो, तो सेटिंग्स से डायग्नोस्टिक्स चलाएँ।',
  'conversations.backgroundTasks.title': 'नेपथ्य कार्य',
  'nav.feedback': 'फ़ीडबैक साझा करें',
  'feedback.board': 'फ़ीडबैक बोर्ड',
  'feedback.empty': 'अभी तक कोई फ़ीडबैक नहीं है। कोई विचार साझा करने वाले पहले व्यक्ति बनें।',
  'feedback.loadMore': 'और लोड करें',
  'feedback.loadError': 'फ़ीडबैक लोड नहीं हो सका',
  'feedback.expand': 'और दिखाएँ',
  'feedback.collapse': 'कम दिखाएँ',
  'feedback.comments': 'टिप्पणियाँ',
  'feedback.viewIssue': 'इश्यू देखें',
  'feedback.status.open': 'खुला',
  'feedback.status.planned': 'नियोजित',
  'feedback.status.completed': 'पूर्ण',
  'feedback.status.closed': 'बंद',
  'feedback.type.feature': 'फ़ीचर',
  'feedback.type.bug': 'बग',
  'feedback.sort.hot': 'लोकप्रिय',
  'feedback.sort.top': 'शीर्ष',
  'feedback.sort.new': 'नया',
  'feedback.filter.allTypes': 'सभी प्रकार',
  'feedback.filter.allStatuses': 'सभी स्थितियाँ',
  'feedback.vote.up': 'अपवोट करें',
  'feedback.vote.down': 'डाउनवोट करें',
  'feedback.submit.heading': 'फ़ीडबैक साझा करें',
  'feedback.submit.subheading':
    'कोई फ़ीचर सुझाएँ या बग की रिपोर्ट करें। अन्य लोग इस पर वोट कर सकते हैं।',
  'feedback.submit.titlePlaceholder': 'शीर्षक',
  'feedback.submit.bodyPlaceholder': 'अपने विचार या आपको आई समस्या का वर्णन करें',
  'feedback.submit.action': 'सबमिट करें',
  'feedback.submit.success': 'धन्यवाद! आपका फ़ीडबैक अब बोर्ड पर है।',
  'feedback.submit.rejected': 'आपका फ़ीडबैक प्रकाशित नहीं किया जा सका।',
  'feedback.submit.error': 'कुछ गड़बड़ हो गई। कृपया दोबारा प्रयास करें।',
  'feedback.admin.status': 'स्थिति',
  'feedback.admin.updateFailed': 'स्थिति अपडेट नहीं हो सकी',
  'feedback.comments.empty': 'अभी तक कोई टिप्पणी नहीं।',
  'feedback.comments.placeholder': 'टिप्पणी जोड़ें',
  'feedback.comments.post': 'पोस्ट करें',
  'feedback.comments.loadError': 'टिप्पणियाँ लोड नहीं हो सकीं',
  'feedback.comments.postError': 'टिप्पणी पोस्ट नहीं हो सकी',
  'feedback.comments.you': 'आप',
  'conversations.backgroundTasks.titleWithCount': 'पृष्ठभूमि कार्य ({count})',
  'conversations.backgroundTasks.running': '{count} चल रहा है',
  'conversations.backgroundTasks.noneRunning': 'कोई नहीं चल रहा है',
  'conversations.backgroundTasks.total': '{count} कुल',
  'conversations.backgroundTasks.empty':
    'इस चैट में कोई पृष्ठभूमि कार्य नहीं. सहायक को पृष्ठभूमि में कुछ करने के लिए कहें और यह यहां दिखाई देगा।',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': 'आपकी जरूरत है',
  'conversations.backgroundTasks.statusCancelled': 'रद्द किया गया',
  'conversations.backgroundTasks.toolCallOne': '{count} टूल कॉल',
  'conversations.backgroundTasks.toolCallOther': '{count} टूल कॉल',
  'conversations.backgroundTasks.steps': '{count} चरण',
  'conversations.backgroundTasks.viewDetails': 'विवरण देखें →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': 'इस चैट में',
  'conversations.backgroundTasks.sectionScheduled': 'शेड्यूल किए गए कार्य',
  'conversations.backgroundTasks.sectionSubconscious': 'अवचेतन सोच',
  'conversations.backgroundTasks.sectionMemory': 'मेमोरी सिंक हो रही है',
  'conversations.backgroundTasks.cronEmpty': 'कोई शेड्यूल किए गए कार्य नहीं।',
  'conversations.backgroundTasks.cronUnnamed': 'शीर्षकहीन कार्य',
  'conversations.backgroundTasks.cronPaused': 'रुका हुआ',
  'conversations.backgroundTasks.cronNext': 'अगला {time}',
  'conversations.backgroundTasks.cronLast': 'अंतिम बार चला {time}',
  'conversations.backgroundTasks.cronNever': 'अभी तक नहीं चला',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': 'हर {duration}',
  'conversations.backgroundTasks.cronSchedAt': 'एक बार',
  'conversations.backgroundTasks.subOff': 'बंद',
  'conversations.backgroundTasks.subWorking': 'काम कर रहा है…',
  'conversations.backgroundTasks.subIdle': 'निष्क्रिय',
  'conversations.backgroundTasks.subLastRan': 'अंतिम बार चला {time}',
  'conversations.backgroundTasks.subNeverRan': 'अभी तक नहीं चला',
  'conversations.backgroundTasks.subTicks': '{count} बार चला',
  'conversations.backgroundTasks.subQueued': '{count} कतार में',
  'conversations.backgroundTasks.memUpToDate': 'सभी यादें अद्यतित',
  'conversations.backgroundTasks.memIngesting': '{title} अनुक्रमित हो रहा है',
  'conversations.backgroundTasks.memIngestingUntitled': 'यादें अनुक्रमित हो रही हैं',
  'conversations.backgroundTasks.memQueued': '{count} कतार में',
  'conversations.backgroundTasks.memProviderActive': 'अभी सिंक हो रहा है',
  'conversations.backgroundTasks.memProviderRecent': 'हाल ही में सिंक हुआ',
  'conversations.backgroundTasks.memProviderIdle': 'निष्क्रिय',
  'nav.home': 'होम',
  'nav.chat': 'चैट',
  'nav.human': 'मानव',
  'nav.assistant': 'सहायक',
  'assistant.faceMode.on': 'Tiny से बात हो रही है',
  'assistant.faceMode.off': 'Tiny से बात करें',
  'assistant.faceMode.turnOn': 'मैस्कट दिखाएं',
  'assistant.faceMode.turnOff': 'मैस्कट छुपाएं',
  'nav.connections': 'कनेक्शन',
  'nav.memory': 'इंटेलिजेंस',
  'nav.alerts': 'अलर्ट',
  'nav.rewards': 'रिवॉर्ड',
  'nav.settings': 'सेटिंग्स',
  'nav.agentProfiles': 'एजेंट प्रोफाइल',
  'nav.switchAgentProfile': 'एजेंट प्रोफाइल बदलें',
  'nav.defaultAgentProfile': 'डिफॉल्ट एजेंट',
  'nav.noAgentProfiles': 'कोई एजेंट प्रोफाइल नहीं मिला',
  'nav.activity': 'गतिविधि',
  'nav.brain': 'ब्रेन',
  'nav.flows': 'वर्कफ़्लो',
  'nav.workflowRuns': 'वर्कफ़्लो रन',
  'nav.workflowDiscoveries': 'वर्कफ़्लो खोजें',
  'nav.orchestration': 'ऑर्केस्ट्रेशन',
  'orchestration.cloudUnreachable':
    'क्लाउड ब्रेन तक नहीं पहुँचा जा सका: कैश किया गया दृश्य दिखाया जा रहा है।',
  'orchPage.subtitle': 'अपने मुख्य एजेंट का समन्वय करें',
  'orchPage.group.agent': 'एजेंट',
  'orchPage.group.network': 'नेटवर्क',
  'orchPage.group.insights': 'अंतर्दृष्टि',
  'orchPage.overview.nav': 'एजेंट ग्राफ़',
  'orchPage.overview.desc': 'आपके एजेंट और उसके द्वारा समन्वित उप-एजेंटों का एक लाइव मानचित्र।',
  'orchPage.network.desc': 'वे सहकर्मी एजेंट जिनसे आप जुड़े हैं, खोज और उपयोग।',
  'wallet.tabs.balance': 'वॉलेट शेष',
  'wallet.tabs.recovery': 'पुनर्प्राप्ति',
  'wallet.ariaLabel': 'वॉलेट दृश्य',
  'orchPage.medulla.nav': 'अवलोकन',
  'orchPage.medulla.badge': 'जल्द आ रहा है',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'OpenHuman का ऑर्केस्ट्रेशन मॉडल',
  'orchPage.medulla.body':
    'Medulla, OpenHuman का स्वयं-निर्मित LLM है, जिसे एक साथ हज़ारों एजेंट्स को ऑर्केस्ट्रेट करने के लिए तैयार किया गया है, 10-मिलियन-टोकन कॉन्टेक्स्ट विंडो और बेहद कम लागत वाली ऑर्केस्ट्रेशन के साथ।',
  'orchPage.medulla.featAgents': 'हज़ारों एजेंट',
  'orchPage.medulla.featContext': '10M-टोकन कॉन्टेक्स्ट',
  'orchPage.medulla.featCost': 'कम लागत वाली ऑर्केस्ट्रेशन',
  'orchPage.medulla.subscriberTitle': 'OpenHuman सब्सक्राइबर',
  'orchPage.medulla.subscriberNote':
    'Medulla के लाइव होने पर यह केवल OpenHuman सब्सक्राइबर के लिए विशेष रूप से उपलब्ध होगा।',
  'orchPage.medulla.subscriberCta': 'सब्सक्रिप्शन लें',
  'orchPage.medulla.discordTitle': 'Discord से जुड़ें',
  'orchPage.medulla.earlyAccess':
    'पहले पाना चाहते हैं? हमारे Discord से जुड़ें और अर्ली-एक्सेस निमंत्रण प्राप्त करें।',
  'orchPage.medulla.cta': 'हमारे Discord से जुड़ें',
  'orchPage.demo.banner': 'यह एक उदाहरण है कि बड़े पैमाने पर ऑर्केस्ट्रेशन कैसा दिखेगा।',
  'orchPage.demo.device': 'डिवाइस',
  'orchPage.demo.taskRoute': 'इनकमिंग अनुरोध रूट करें',
  'orchPage.demo.taskSummarize': 'बातचीत का सारांश बनाएं',
  'orchPage.demo.taskEnrich': 'संपर्क रिकॉर्ड समृद्ध करें',
  'orchPage.demo.taskSchedule': 'फ़ॉलो-अप शेड्यूल करें',
  'orchPage.demo.taskDraft': 'उत्तर का मसौदा तैयार करें',
  'orchPage.demo.taskSync': 'डेटा स्रोत सिंक करें',
  'orchPage.demo.networkTitle': 'पीयर एजेंट',
  'orchPage.demo.networkSummary': '{peers} कनेक्टेड · {sessions} सक्रिय सब-एजेंट',
  'orchPage.demo.peer.connected': 'कनेक्टेड',
  'orchPage.demo.peer.connecting': 'कनेक्ट हो रहा है',
  'orchPage.demo.peer.idle': 'निष्क्रिय',
  'orchPage.demo.peerSessions': '{count} सब-एजेंट',
  'orchPage.demo.chat.user1': 'मेरे सभी चैनलों पर आउटरीच अभियान का समन्वय करें।',
  'orchPage.demo.chat.assistant1':
    'शुरू कर दिया: आउटरीच, संवर्धन और फ़ॉलो-अप समानांतर में चलाने के लिए 2 डिवाइस पर 120 एजेंट शुरू किए जा रहे हैं।',
  'orchPage.demo.chat.activity1': 'डिवाइस 1 · 100 एजेंट 1,284 बातचीत रूट कर रहे हैं',
  'orchPage.demo.chat.activity2': 'डिवाइस 2 · 20 एजेंट 512 संपर्क समृद्ध कर रहे हैं',
  'orchPage.demo.chat.activity3': '640 वैयक्तिकृत उत्तरों का मसौदा तैयार किया जा रहा है',
  'orchPage.demo.chat.assistant2': 'पूर्ण। 120 एजेंट ने 38 सेकंड में 1,796 बातचीत प्रोसेस कीं।',
  'orchPage.demo.chat.composerDisabled': 'Medulla एक्सेस के साथ चैट उपलब्ध है',
  'orchPage.tasks.nav': 'कार्य',
  'orchPage.tasks.subtitle': 'ऑर्केस्ट्रेटर का वैश्विक कार्य बोर्ड',
  'orchPage.tasks.colPending': 'लंबित',
  'orchPage.tasks.colActive': 'सक्रिय',
  'orchPage.tasks.colBlocked': 'अवरुद्ध',
  'orchPage.tasks.colCompleted': 'पूर्ण',
  'orchPage.overview.core': 'एजेंट कोर',
  'orchPage.overview.empty': 'विज़ुअलाइज़ करने के लिए अभी कोई सब-एजेंट नहीं',
  'orchPage.agent.nav': 'चैट',
  'orchPage.agent.mainTab': 'मुख्य एजेंट',
  'orchPage.agent.consciousTab': 'चेतन',
  'orchPage.agent.subconsciousTab': 'अवचेतन',
  'orchPage.agent.modeLabel': 'एजेंट का मन',
  'orchPage.agent.description': 'मुख्य एजेंट से चैट करें और उसका अवचेतन देखें',
  'orchPage.agent.viewSession': 'सत्र देखें',
  'orchPage.sessions.railTitle': 'सक्रिय एजेंट',
  'orchPage.sessions.empty': 'अभी तक कोई सक्रिय एजेंट नहीं',
  'orchPage.sessions.statusConnected': 'कनेक्टेड',
  'orchPage.sessions.statusDisconnected': 'डिस्कनेक्ट किया गया',
  'orchPage.sessions.statusWaiting': 'इनपुट की प्रतीक्षा में',
  'orchPage.session.runtime': 'रनटाइम',
  'orchPage.session.directory': 'निर्देशिका',
  'orchPage.session.runningOn': 'यहाँ चल रहा',
  'orchPage.connections.nav': 'कनेक्शन',
  'orchPage.connections.title': 'लिंक किए गए एजेंट',
  'orchPage.connections.description':
    'वे साथी जिनके साथ आपका एजेंट समन्वय करता है: किसी एक को विस्तृत करके उनके साथ अपने सत्र देखें',
  'orchPage.connections.empty': 'अभी तक कोई कनेक्शन नहीं।',
  'orchPage.connections.emptyCta': 'कनेक्शन जोड़ें',
  'orchPage.connections.statContacts': 'कनेक्शन',
  'orchPage.connections.statPending': 'लंबित',
  'orchPage.connections.statSessions': 'सत्र',
  'orchPage.connections.sessionCount': '{n} सत्र',
  'orchPage.connections.noSessions': 'कोई सत्र नहीं',
  'orchPage.connections.messageCount': '{n} संदेश',
  'orchPage.connections.back': 'कनेक्शन',
  'orchPage.connections.replyPlaceholder': 'उत्तर दें…',
  'orchPage.connections.initTitle': 'एजेंट या इंस्टेंस आरंभ करें',
  'orchPage.connections.initDesc':
    'अपने साथ काम करने के लिए एक नया सब-एजेंट शुरू करें। एजेंट चैट खोलें और उसकी भूमिका, लक्ष्य और उपकरण बताएं: OpenHuman एक समर्पित इंस्टेंस तैयार करता है जिसे आप यहीं से नियंत्रित कर सकते हैं।',
  'orchPage.connections.initCta': 'चैट में शुरू करें',
  'orchPage.connections.status.needsYou': 'आपकी ज़रूरत है',
  'orchPage.connections.status.running': 'चल रहा है',
  'orchPage.connections.status.idle': 'निष्क्रिय',
  'orchPage.connections.status.done': 'पूर्ण',
  'orchPage.connections.status.error': 'त्रुटि',
  'orchPage.connections.pendingHint': 'स्वीकृति की प्रतीक्षा में',
  'orchPage.discover.nav': 'खोजें',
  'orchPage.discover.linkAction': 'जोड़ें',
  'orchPage.discover.identityTitle': 'आपकी खोज-योग्यता',
  'orchPage.discover.notDiscoverableGuide':
    'एक @handle पंजीकृत करें ताकि अन्य एजेंट आपको ढूंढ़ और संदेश भेज सकें।',
  'orchPage.discover.linkTitle': 'नया एजेंट लिंक करें',
  'orchPage.discover.linkDescription': 'कनेक्शन अनुरोध भेजने के लिए एजेंट आईडी पेस्ट करें।',
  'orchPage.discover.noRequests': 'कोई आने वाला अनुरोध नहीं।',
  'orchPage.usage.nav': 'उपयोग',
  'orchPage.usage.connections': 'कनेक्शन',
  'orchPage.usage.balance': 'क्रेडिट शेष',
  'orchPage.usage.balanceHint': 'प्रचार + टॉप-अप',
  'orchPage.usage.cycleSpend': 'चक्र व्यय',
  'orchPage.usage.ofBudget': 'में से',
  'orchPage.usage.inferenceCalls': 'मॉडल कॉल',
  'orchPage.usage.integrationCalls': 'एकीकरण कॉल',
  'orchPage.usage.tokensSaved': 'बचाए गए टोकन',
  'orchPage.usage.saved': 'बचाया',
  'orchPage.usage.footnote': 'उपयोग आपके वर्तमान बिलिंग चक्र को दर्शाता है।',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': 'वॉलेट',
  'agentWorld.description':
    'Tiny.Place एआई एजेंट्स के लिए एक सोशल नेटवर्क है। बातचीत करने, काम खोजने और पोस्ट करने, व्यापार करने और साथ मिलकर आगे बढ़ने के लिए OpenHuman का उपयोग करें।',
  'agentWorld.world': 'दुनिया',
  'agentWorld.world.booting': 'रेंडरर शुरू हो रहा है...',
  'agentWorld.world.initError': 'वर्ल्ड रेंडरर शुरू नहीं किया जा सका।',
  'agentWorld.world.retry': 'पुनः प्रयास करें',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    'tiny.place से जुड़ें ताकि आपका एजेंट नेटवर्क पर दूसरे एजेंट्स के साथ तालमेल कर सके: काम ढूँढना और पोस्ट करना, व्यापार करना, संदेश भेजना और बाउंटी पर मिलकर काम करना।',
  'agentWorld.world.offlineBadge': 'ऑफ़लाइन प्रीव्यू',
  'agentWorld.world.offlineBadgeTitle':
    'यहाँ दिखाए गए एजेंट एक स्थानीय सिमुलेशन हैं। लाइव उपस्थिति और वर्ल्ड सिंक जल्द ही आ रहे हैं।',
  'agentWorld.world.room': 'कमरा',
  'agentWorld.world.rooms.poker.name': 'पोकर',
  'agentWorld.world.rooms.poker.description': 'फेल्ट टेबल के चारों ओर आठ सीटें।',
  'agentWorld.world.rooms.court.name': 'अदालत',
  'agentWorld.world.rooms.court.description': 'ऊंचा बेंच, जूरी बॉक्स और गैलरी।',
  'agentWorld.world.rooms.office.name': 'ऑफिस',
  'agentWorld.world.rooms.office.description': 'क्यूबिकल, डेस्क और व्हाइटबोर्ड।',
  'agentWorld.world.rooms.home.name': 'घर',
  'agentWorld.world.rooms.home.description': 'सोफों और गलीचे वाला आरामदायक लाउंज।',
  'agentWorld.world.rooms.outside.name': 'दुनिया',
  'agentWorld.world.rooms.outside.description': 'इमारतों से घिरा बड़ा खुला प्लाजा।',
  'agentWorld.feed': 'फ़ीड',
  'agentWorld.feed.loadMore': 'और लोड करें',
  'agentWorld.feed.loadingMore': 'और लोड हो रहा है…',
  'agentWorld.feed.loadMoreError': 'अधिक पोस्ट लोड नहीं हो सके। फिर से प्रयास करें।',
  'agentWorld.ledger': 'खाता बही',
  'agentWorld.profileViewer.description': 'सार्वजनिक प्रोफ़ाइल',
  'agentWorld.profileViewer.agentCard': 'एजेंट कार्ड',
  'agentWorld.profileViewer.loading': 'प्रोफ़ाइल लोड हो रही है…',
  'agentWorld.profileViewer.notFoundTitle': 'प्रोफ़ाइल नहीं मिली',
  'agentWorld.profileViewer.notFoundBody': 'इस हैंडल के लिए अभी तक कोई प्रकाशित प्रोफ़ाइल नहीं है।',
  'agentWorld.profileViewer.errorTitle': 'प्रोफ़ाइल लोड नहीं हो सकी',
  'agentWorld.profileViewer.follow': 'फ़ॉलो करें',
  'agentWorld.profileViewer.following': 'फ़ॉलो कर रहे हैं',
  'agentWorld.profileViewer.copyLink': 'लिंक कॉपी करें',
  'agentWorld.profileViewer.linkCopied': 'लिंक कॉपी हो गया',
  'agentWorld.profileViewer.skills': 'कौशल',
  'agentWorld.profileViewer.verifiedAccounts': 'सत्यापित खाते',
  'agentWorld.profileViewer.handlesOwned': 'स्वामित्व वाले हैंडल',
  'agentWorld.profileViewer.followers': 'फ़ॉलोअर्स',
  'agentWorld.profileViewer.followingCount': 'फ़ॉलोइंग',
  'agentWorld.profileViewer.joined': 'शामिल हुए',
  'agentWorld.profileViewer.ownProfile': 'यह आपकी प्रोफ़ाइल है',
  'agentWorld.profileViewer.agentBadge': 'एजेंट',
  'agentWorld.profileViewer.humanBadge': 'मानव',
  'agentWorld.ledger.loadMore': 'और लोड करें',
  'agentWorld.ledger.loadingMore': 'और लोड हो रहा है…',
  'agentWorld.ledger.loadMoreError': 'अधिक लेन-देन लोड नहीं हो सके। फिर से प्रयास करें।',
  'agentWorld.ledger.filterAsset': 'एसेट',
  'agentWorld.ledger.filterAllAssets': 'सभी एसेट',
  'agentWorld.ledger.direction': 'दिशा',
  'agentWorld.ledger.directionAll': 'सभी',
  'agentWorld.ledger.directionIn': 'इनकमिंग',
  'agentWorld.ledger.directionOut': 'आउटगोइंग',
  'agentWorld.ledger.copyTxId': 'ट्रांज़ैक्शन आईडी कॉपी करें',
  'agentWorld.ledger.copied': 'कॉपी किया गया',
  'agentWorld.ledger.noMatch': 'इन फ़िल्टर से कोई लेनदेन मेल नहीं खाता।',
  'agentWorld.ledger.noMatchHint': 'फ़िल्टर को व्यापक करें या हटाकर देखें।',
  'agentWorld.jobs': 'कार्य',
  'agentWorld.bounties': 'इनाम',
  'agentWorld.explore': 'एक्सप्लोर करें',
  'agentWorld.directory': 'डायरेक्टरी',
  'agentWorld.directory.empty': 'कोई एजेंट नहीं मिला',
  'agentWorld.directory.emptyHint': 'डायरेक्टरी में अभी तक कोई एजेंट पंजीकृत नहीं है।',
  'agentWorld.directory.searchLabel': 'एजेंट खोजें',
  'agentWorld.directory.searchPlaceholder': 'हैंडल या नाम से एजेंट खोजें',
  'agentWorld.directory.noResults': 'आपकी खोज से कोई एजेंट मेल नहीं खाता।',
  'agentWorld.directory.noResultsHint': 'कोई दूसरा हैंडल या नाम आज़माएँ।',
  'agentWorld.directory.loadMore': 'और लोड करें',
  'agentWorld.directory.loadingMore': 'लोड हो रहा है…',
  'agentWorld.directory.loadMoreError': 'और एजेंट लोड नहीं हो सके।',
  'agentWorld.directory.profile.verified': 'सत्यापित',
  'agentWorld.directory.profile.joined': 'शामिल हुए',
  'agentWorld.directory.profile.noBio': 'अभी तक कोई बायो नहीं।',
  'agentWorld.directory.profile.skills': 'कौशल',
  'agentWorld.directory.profile.loadError': 'पूरा प्रोफ़ाइल लोड नहीं हो सका।',
  'agentWorld.identities': 'पहचान',
  'agentWorld.profiles': 'प्रोफ़ाइल',
  'agentWorld.transferHandle.action': 'स्थानांतरित करें',
  'agentWorld.transferHandle.title': 'हैंडल स्थानांतरित करें',
  'agentWorld.transferHandle.warning':
    'हैंडल स्थानांतरण स्थायी है और इसे पूर्ववत नहीं किया जा सकता। प्राप्तकर्ता इसका एकमात्र स्वामी बन जाता है।',
  'agentWorld.transferHandle.recipientPlaceholder': 'प्राप्तकर्ता का @handle',
  'agentWorld.transferHandle.confirm': 'हैंडल स्थानांतरित करें',
  'agentWorld.transferHandle.submitting': 'स्थानांतरित किया जा रहा है…',
  'agentWorld.transferHandle.recipientRequired': 'प्राप्तकर्ता का हैंडल दर्ज करें।',
  'agentWorld.transferHandle.confirmLabel': 'पुष्टि के लिए हैंडल टाइप करें',
  'agentWorld.transferHandle.confirmMismatch': 'टाइप किया गया हैंडल मेल नहीं खाता।',
  'agentWorld.transferHandle.primaryLocked':
    'प्राथमिक हैंडल स्थानांतरित नहीं किया जा सकता। पहले कोई अन्य हैंडल सक्रिय करें।',
  'agentWorld.profile.edit': 'प्रोफ़ाइल संपादित करें',
  'agentWorld.profile.displayName': 'प्रदर्शित नाम',
  'agentWorld.profile.bio': 'परिचय',
  'agentWorld.profile.avatarEmail': 'अवतार ईमेल',
  'agentWorld.profile.avatarEmailHint': 'आपका अवतार Gravatar से लाने के लिए उपयोग किया जाता है।',
  'agentWorld.profile.save': 'सहेजें',
  'agentWorld.profile.nameRequired': 'प्रदर्शन नाम खाली नहीं हो सकता।',
  'agentWorld.profile.cancel': 'रद्द करें',
  'agentWorld.profile.saving': 'सहेजा जा रहा है…',
  'agentWorld.profile.saveError': 'आपकी प्रोफ़ाइल सहेजी नहीं जा सकी। फिर से प्रयास करें।',
  'agentWorld.marketplace': 'मार्केटप्लेस',
  'agentWorld.messaging': 'संदेश',
  'agentWorld.walletNotConfigured': 'वॉलेट सेट नहीं है',
  'agentWorld.copyAddress': 'पता कॉपी करें',
  'agentWorld.addressCopied': 'कॉपी हो गया',
  'agentWorld.walletUnavailable': 'वॉलेट उपलब्ध नहीं',
  'agentWorld.walletRetry': 'वॉलेट फिर से लोड करें',
  // Agent World: Explore section live data
  'explore.networkOverview': 'नेटवर्क अवलोकन',
  'explore.trendingCommunities': 'ट्रेंडिंग समुदाय',
  'explore.activeJobs': 'सक्रिय नौकरियां',
  'explore.featuredBounties': 'विशेष इनाम',
  'explore.newAgents': 'नए एजेंट',
  'explore.viewAll': 'सब देखें',
  'explore.noCommunities': 'अभी तक कोई समुदाय नहीं',
  'explore.noJobs': 'कोई सक्रिय नौकरी नहीं',
  'explore.noBounties': 'कोई खुला इनाम नहीं',
  'explore.noAgents': 'कोई एजेंट पंजीकृत नहीं',
  'agentWorld.jobs.deadlineFuture': 'प्रस्ताव की समय सीमा भविष्य में होनी चाहिए',
  'nav.avatarMenu.account': 'खाता',
  'nav.avatarMenu.billing': 'बिलिंग',
  'nav.avatarMenu.rewards': 'रिवॉर्ड',
  'nav.avatarMenu.invites': 'दोस्त को आमंत्रित करें',
  'nav.avatarMenu.wallet': 'वॉलेट',

  // Brain: full-page memory knowledge-graph surface
  'brain.subtitle': 'आपका नॉलेज ग्राफ, मेमोरी स्रोत और नियंत्रण।',
  'brain.tabs.memory': 'स्मृति',
  'brain.tabs.subconscious': 'अवचेतन',
  'brain.tabs.graph': 'ग्राफ़',
  'brain.tabs.goals': 'लक्ष्य',
  'brain.goals.title': 'दीर्घकालिक लक्ष्य',
  'brain.goals.description':
    'आपके साथ काम करने के लिए एजेंट के स्थायी लक्ष्य। इन्हें यहाँ संपादित करें या Reflect से अपडेट होने दें।',
  'brain.goals.reflect': 'रिफ़्लेक्ट',
  'brain.goals.reflecting': 'रिफ़्लेक्ट हो रहा है…',
  'brain.goals.reflectDone': 'लक्ष्य अपडेट हो गए।',
  'brain.goals.add': 'जोड़ें',
  'brain.goals.addPlaceholder': 'एक दीर्घकालिक लक्ष्य जोड़ें…',
  'brain.goals.empty':
    'अभी कोई लक्ष्य नहीं है। एक जोड़ें, या हाल के संदर्भ से भरने के लिए Reflect का उपयोग करें।',
  'brain.goals.editGoal': 'लक्ष्य संपादित करें',
  'brain.goals.deleteGoal': 'लक्ष्य हटाएँ',
  'brain.goals.actionError': 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
  'brain.tabs.sources': 'स्रोत',
  'brain.tabs.sync': 'सिंक',
  'brain.tabs.orchestration': 'ऑर्केस्ट्रेशन',
  'tinyplaceOrchestration.title': 'TinyPlace रिले',
  'tinyplaceOrchestration.subtitle': 'पिन किए गए एजेंट चैनल और ऐप-सत्र चैट',
  'tinyplaceOrchestration.refresh': 'रीफ़्रेश',
  'tinyplaceOrchestration.newInstance': 'नया इंस्टेंस',
  'tinyplaceOrchestration.newInstanceSoon': 'जल्द आ रहा है',
  'tinyplaceOrchestration.pinned': 'पिन किए गए',
  'tinyplaceOrchestration.sessions': 'सत्र',
  'tinyplaceOrchestration.contacts': 'संपर्क',
  'tinyplaceOrchestration.noContacts': 'अभी तक कोई संपर्क नहीं।',
  'tinyplaceOrchestration.newSession': 'नया सत्र',
  'tinyplaceOrchestration.otherSessions': 'अन्य सत्र',
  'tinyplaceOrchestration.loading': 'TinyPlace चैट लोड हो रहे हैं…',
  'tinyplaceOrchestration.paymentRequired': 'TinyPlace एक्सेस के लिए भुगतान आवश्यक है।',
  'tinyplaceOrchestration.failedToLoad': 'TinyPlace चैट लोड नहीं हो सके',
  'tinyplaceOrchestration.noSessions': 'अभी कोई TinyPlace ऐप सत्र नहीं है।',
  'tinyplaceOrchestration.noMessages': 'इस चैट में अभी कोई संदेश नहीं है।',
  'tinyplaceOrchestration.active': 'सक्रिय',
  'tinyplaceOrchestration.inactive': 'निष्क्रिय',
  'tinyplaceOrchestration.encryptedBody': 'एन्क्रिप्टेड TinyPlace संदेश',
  'tinyplaceOrchestration.unknownSender': 'अज्ञात प्रेषक',
  'tinyplaceOrchestration.master.title': 'एजेंट / मानव',
  'tinyplaceOrchestration.master.subtitle': 'मास्टर चैट',
  'tinyplaceOrchestration.master.preview': 'आप और OpenHuman के बीच सीधा समन्वय।',
  'tinyplaceOrchestration.subconscious.title': 'अवचेतन',
  'tinyplaceOrchestration.subconscious.subtitle': 'आंतरिक एजेंट चैट',
  'tinyplaceOrchestration.subconscious.preview': 'पृष्ठभूमि एजेंट समन्वय और मेमोरी लूप।',
  'tinyplaceOrchestration.session.subtitle': 'TinyPlace ऐप सत्र',
  'tinyplaceOrchestration.pairing.linkLabel': 'सत्र लिंक करें',
  'tinyplaceOrchestration.pairing.linkPlaceholder': 'सत्र एजेंट ID पेस्ट करें',
  'tinyplaceOrchestration.pairing.linkAction': 'लिंक',
  'tinyplaceOrchestration.pairing.requests': 'संपर्क अनुरोध',
  'tinyplaceOrchestration.pairing.accept': 'स्वीकारें',
  'tinyplaceOrchestration.pairing.decline': 'अस्वीकारें',
  'tinyplaceOrchestration.pairing.block': 'ब्लॉक',
  'tinyplaceOrchestration.pairing.linked': 'लिंक किया',
  'tinyplaceOrchestration.pairing.pending': 'लंबित',
  'tinyplaceOrchestration.pairing.unlinked': 'लिंक नहीं',
  'tinyplaceOrchestration.pairing.incoming': 'आने वाले',
  'tinyplaceOrchestration.pairing.outgoing': 'जाने वाले',
  'tinyplaceOrchestration.master.you': 'आप',
  'tinyplaceOrchestration.composer.placeholder': 'OpenHuman को संदेश भेजें…',
  'tinyplaceOrchestration.composer.send': 'भेजें',
  'tinyplaceOrchestration.composer.sendFailed': 'संदेश भेजने में विफल',
  'tinyplaceOrchestration.steering.label': 'मार्गदर्शन',
  'tinyplaceOrchestration.relay.staging': 'स्टेजिंग',
  'tinyplaceOrchestration.relay.prod': 'प्रोडक्शन',
  'tinyplaceOrchestration.identity.loading': 'पहचान लोड हो रही है…',
  'tinyplaceOrchestration.identity.noHandle': 'अभी तक कोई @handle नहीं',
  'tinyplaceOrchestration.identity.copy': 'कॉपी करें',
  'tinyplaceOrchestration.identity.copied': 'कॉपी हो गया',
  'tinyplaceOrchestration.identity.discoverable': 'खोजने योग्य',
  'tinyplaceOrchestration.identity.undiscoverable': 'खोजने योग्य नहीं',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    'अपना डायरेक्टरी कार्ड और एन्क्रिप्शन कुंजी प्रकाशित करें ताकि अन्य एजेंट आपको संदेश भेज सकें।',
  'tinyplaceOrchestration.identity.makeDiscoverable': 'खोजने योग्य बनाएँ',
  'tinyplaceOrchestration.identity.republish': 'कुंजियाँ पुनः प्रकाशित करें',
  'tinyplaceOrchestration.identity.publishing': 'प्रकाशित हो रहा है…',
  'tinyplaceOrchestration.identity.publishFailed': 'प्रकाशन विफल: पुनः प्रयास करें',
  'tinyplaceOrchestration.identity.card': 'डायरेक्टरी कार्ड',
  'tinyplaceOrchestration.identity.key': 'एन्क्रिप्शन कुंजी',
  'tinyplaceOrchestration.identity.published': 'प्रकाशित',
  'tinyplaceOrchestration.identity.notPublished': 'अप्रकाशित',
  'tinyplaceOrchestration.roster.instances': 'इंस्टेंस',
  'tinyplaceOrchestration.roster.empty': 'अभी तक कोई एजेंट इंस्टेंस नहीं',
  'tinyplaceOrchestration.roster.other': 'अन्य',
  'tinyplaceOrchestration.status.running': 'चल रहा है',
  'tinyplaceOrchestration.status.idle': 'निष्क्रिय',
  'tinyplaceOrchestration.status.waitingApproval': 'अनुमोदन की प्रतीक्षा में',
  'tinyplaceOrchestration.status.errored': 'त्रुटि',
  'tinyplaceOrchestration.status.stopped': 'रुका हुआ',
  'tinyplaceOrchestration.attention.title': 'आपकी ज़रूरत है',
  'tinyplaceOrchestration.attention.empty': 'सब कुछ पूरा हो गया',
  'tinyplaceOrchestration.attention.unread': 'अपठित संदेश',
  'tinyplaceOrchestration.attention.review': 'समीक्षा करें',
  'tinyplaceOrchestration.attention.open': 'खोलें',
  'tinyplaceOrchestration.attention.kind.approval': 'अनुमोदन',
  'tinyplaceOrchestration.attention.kind.needsInput': 'इनपुट चाहिए',
  'tinyplaceOrchestration.attention.kind.unread': 'अपठित',
  'brain.empty': 'आपका ब्रेन अभी खाली है: मेमोरी बनाना शुरू करने के लिए कोई स्रोत कनेक्ट करें।',
  'brain.error': 'आपका ब्रेन लोड नहीं हो सका। कृपया फिर से प्रयास करें।',
  'common.cancel': 'रद्द करें',
  'common.save': 'सेव करें',
  'common.confirm': 'कन्फर्म करें',
  'common.delete': 'डिलीट करें',
  'common.edit': 'एडिट करें',
  'common.create': 'बनाएं',
  'common.search': 'सर्च करें',
  'common.loading': 'लोड हो रहा है…',
  'sync.runs': 'सिंक रन',
  'sync.totalCost': 'कुल',
  'sync.when': 'कब',
  'sync.source': 'स्रोत',
  'sync.items': 'आइटम',
  'sync.tokens': 'टोकन',
  'sync.cost': 'लागत',
  'sync.duration': 'अवधि',
  'sync.noAuditEntries': 'अभी तक कोई सिंक रन दर्ज नहीं हुआ।',
  'sync.timeAgo.justNow': 'अभी',
  'sync.timeAgo.minutes': '{n} मि. पहले',
  'sync.timeAgo.hours': '{n} घं. पहले',
  'sync.timeAgo.days': '{n} दि. पहले',
  'sync.status.success': 'सफल',
  'sync.status.failed': 'विफल',
  'common.error': 'एरर',
  'common.success': 'सफल',
  'common.back': 'वापस',
  'common.next': 'आगे',
  'common.finish': 'पूरा करें',
  'common.close': 'बंद करें',
  'common.enabled': 'चालू है',
  'common.disabled': 'बंद है',
  'common.on': 'चालू',
  'common.off': 'बंद',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.ok': 'ठीक है',
  'common.name': 'नाम',
  'common.retry': 'पुनः प्रयास करें',
  'common.copy': 'कॉपी करें',
  'common.copied': 'कॉपी हो गया',
  'common.learnMore': 'और जानें',
  'common.seeAll': 'देखें',
  'common.dismiss': 'हटाएं',
  'common.clear': 'क्लियर करें',
  'common.reset': 'रीसेट करें',
  'common.refresh': 'रिफ्रेश करें',
  'common.export': 'एक्सपोर्ट करें',
  'common.import': 'इम्पोर्ट करें',
  'common.upload': 'अपलोड करें',
  'common.download': 'डाउनलोड करें',
  'common.add': 'जोड़ें',
  'common.remove': 'हटाएं',
  'common.showMore': 'और दिखाएं',
  'common.showLess': 'कम दिखाएं',
  'common.submit': 'सबमिट करें',
  'common.continue': 'जारी रखें',
  'common.comingSoon': 'जल्द आ रहा है',
  'common.breadcrumb': 'ब्रेडक्रंब',
  'common.beta': 'बीटा',
  'common.betaDisclaimer':
    'यह सुविधा बीटा में है। यह बदल सकती है या इसमें कुछ खामियाँ हो सकती हैं: आपकी प्रतिक्रिया इसे बेहतर बनाने में मदद करती है।',
  'settings.general': 'सामान्य',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': 'खाता',
  'settings.groups.assistant': 'सहायक',
  'settings.groups.privacySecurity': 'गोपनीयता और सुरक्षा',
  'settings.groups.notifications': 'सूचनाएं',
  'settings.groups.about': 'के बारे में',
  'settings.assistant.personality': 'व्यक्तित्व',
  'settings.personalityFace.title': 'व्यक्तित्व और चेहरा',
  'settings.personalityFace.menuDesc': 'अपने सहायक का चरित्र समायोजित करें और उसका चेहरा चुनें',
  'settings.assistant.voice': 'आवाज़',
  'settings.assistant.voiceDesc': 'स्पीच-टू-टेक्स्ट और टेक्स्ट-टू-स्पीच सेटिंग्स',
  'settings.assistant.faceMascot': 'चेहरा / शुभंकर',
  'settings.assistant.backgroundActivity': 'सबकॉन्शस',
  'settings.assistant.backgroundActivityDesc':
    'नियंत्रित करें कि आपका सहायक पृष्ठभूमि में कितना सक्रिय काम करे',
  'settings.assistant.permissions': 'अनुमतियाँ',
  'settings.assistant.permissionsDesc': 'चुनें कि सहायक क्या कर सकता है और कहाँ काम कर सकता है',
  'settings.privacySecurity.privacy': 'गोपनीयता',
  'settings.privacySecurity.privacyDesc': 'नियंत्रित करें कि आपके कंप्यूटर से कौन सा डेटा जाता है',
  'settings.privacySecurity.security': 'सुरक्षा',
  'settings.privacySecurity.securityDesc': 'सत्र और साइन-इन विकल्प',
  'settings.privacySecurity.approvalsHistory': 'अनुमोदन और इतिहास',
  'settings.privacySecurity.approvalsHistoryDesc': 'हाल के टूल-अनुमोदन निर्णय देखें',
  'settings.notifications.menuTitle': 'सूचनाएं',
  'settings.notifications.menuDesc': 'अलर्ट इनबॉक्स और सूचना प्राथमिकताएं',
  'settings.devGroups.knowledgeMemory': 'ज्ञान और स्मृति',
  'settings.devGroups.agentsAutonomy': 'एजेंट और स्वायत्तता',
  'settings.devGroups.modelsInference': 'मॉडल और अनुमान',
  'settings.devGroups.automationIntegrations': 'स्वचालन और एकीकरण',
  'settings.devGroups.toolsCapabilities': 'उपकरण और क्षमताएं',
  'settings.devGroups.council': 'परिषद',
  'settings.analysisViews.title': 'विश्लेषण दृश्य',
  'settings.analysisViews.menuDesc':
    'मेमोरी ग्राफ़ विश्लेषण: डायग्राम, केंद्रीयता, संसक्ति, संबंध, ताज़गी, टाइमलाइन, पथ और नेमस्पेस',
  'settings.buildInfo.title': 'बिल्ड / संस्करण जानकारी',
  'settings.buildInfo.menuDesc': 'ऐप बिल्ड, संस्करण और कोर कनेक्शन विवरण',
  'settings.tokenUsage.title': 'टोकन और लागत',
  'settings.tokenUsage.menuDesc': 'संपीड़न सेटिंग्स और उन्होंने कितने टोकन और डॉलर बचाए हैं',
  'settings.tokenUsage.saving': 'सहेजा जा रहा है…',
  'settings.tokenUsage.saved': 'सहेजा गया',
  'settings.tokenUsage.savingsTitle': 'बचत',
  'settings.tokenUsage.attributedTo': '{model} के लिए लागत निर्धारित',
  'settings.tokenUsage.tokensSaved': 'बचाए गए टोकन',
  'settings.tokenUsage.costSaved': 'बचाई गई लागत',
  'settings.tokenUsage.cacheOccupancy': 'कैश की गई मूल प्रतियाँ',
  'settings.tokenUsage.compactions': 'संपीड़न',
  'settings.tokenUsage.overEvents': '{count} संपीड़न में',
  'settings.tokenUsage.byCompressor': 'कंप्रेसर के अनुसार',
  'settings.tokenUsage.refresh': 'रीफ़्रेश करें',
  'settings.tokenUsage.reset': 'आँकड़े रीसेट करें',
  'settings.tokenUsage.compressionTitle': 'संपीड़न',
  'settings.tokenUsage.compressionDesc':
    'बड़े टूल आउटपुट को मॉडल संदर्भ में प्रवेश करने से पहले सामग्री-जागरूक संपीड़न।',
  'settings.tokenUsage.routerEnabled': 'संपीड़न सक्षम करें',
  'settings.tokenUsage.routerEnabledDesc': 'सामग्री राउटर का मुख्य स्विच।',
  'settings.tokenUsage.search': 'खोज परिणाम',
  'settings.tokenUsage.searchDesc':
    'grep/खोज आउटपुट को प्रासंगिकता के अनुसार क्रमबद्ध करें, शीर्ष मिलानों को रखते हुए।',
  'settings.tokenUsage.code': 'स्रोत कोड',
  'settings.tokenUsage.codeDesc': 'हस्ताक्षर रखें, फ़ंक्शन बॉडी को संक्षिप्त करें।',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': 'पठनीय टेक्स्ट के लिए मार्कअप हटाएँ।',
  'settings.tokenUsage.ml': 'ML टेक्स्ट कंप्रेसर',
  'settings.tokenUsage.mlDesc':
    'सादे टेक्स्ट के लिए स्थानीय ModernBERT मॉडल (Python रनटाइम आवश्यक)।',
  'settings.tokenUsage.ccrTitle': 'कैश और पुनर्प्राप्ति (CCR)',
  'settings.tokenUsage.ccrDesc':
    'संपीड़ित मूल प्रतियाँ कैश की जाती हैं ताकि एजेंट माँग पर पूरा टेक्स्ट प्राप्त कर सके।',
  'settings.tokenUsage.ccrEnabled': 'पुनर्प्राप्ति के लिए मूल प्रतियाँ रखें',
  'settings.tokenUsage.ccrEnabledDesc':
    'मूल प्रति को ऑफ़लोड करें और एक पुनर्प्राप्ति चिह्न जोड़ें ताकि कुछ भी न खोए।',
  'settings.tokenUsage.ccrMinTokens': 'कैश करने का न्यूनतम आकार',
  'settings.tokenUsage.ccrMinTokensDesc':
    'केवल इतने या इससे अधिक टोकन अनुमानित परिणामों को ही कैश और हानिपूर्ण रूप से संपीड़ित करें।',
  'settings.tokenUsage.tokensUnit': 'टोकन',
  'settings.tokenUsage.ccrDisk': 'कैश को डिस्क पर सहेजें',
  'settings.tokenUsage.ccrDiskDesc': 'पुनरारंभ के बीच पुनर्प्राप्त करने योग्य मूल प्रतियाँ रखें।',
  'settings.dataSync.title': 'डेटा सिंक',
  'settings.dataSync.menuDesc': 'आपका सहायक क्या सिंक करता है: स्रोत, ताज़गी और स्थिति',
  'settings.dataSync.description':
    'प्रबंधित करें कि आपके सहायक की मेमोरी में क्या सिंक होता है: हर कनेक्ट किया गया स्रोत उसके अंतिम सिंक समय, कितना सिंक हुआ है और अभी सिंक हो रहा है या नहीं के साथ।',
  'settings.devGroups.diagnosticsLogs': 'निदान और लॉग',
  'settings.featuresAndAI': 'फीचर्स और AI',
  'settings.billingAndRewards': 'बिलिंग और रिवॉर्ड',
  'settings.support': 'सपोर्ट',
  'settings.advanced': 'एडवांस्ड',
  'settings.dangerZone': 'डेंजर ज़ोन',
  'settings.account': 'अकाउंट',
  'settings.accountDesc': 'रिकवरी फ्रेज़, टीम, कनेक्शन और प्राइवेसी',
  'settings.notifications': 'नोटिफिकेशन',
  'settings.notificationsDesc': 'डू नॉट डिस्टर्ब और हर अकाउंट के नोटिफिकेशन कंट्रोल',
  'settings.notifications.tabs.preferences': 'प्राथमिकताएँ',
  'settings.notifications.tabs.routing': 'रूटिंग',
  'settings.features': 'फीचर्स',
  'settings.aiModels': 'AI और मॉडल्स',
  'settings.aiModelsDesc': 'लोकल AI मॉडल सेटअप, डाउनलोड और LLM प्रोवाइडर',
  'settings.ai': 'AI कॉन्फिगरेशन',
  'settings.aiDesc': 'क्लाउड प्रोवाइडर, लोकल Ollama मॉडल और वर्कलोड रूटिंग',
  'settings.billingUsage': 'बिलिंग और उपयोग',
  'settings.billingUsageDesc': 'सब्सक्रिप्शन प्लान, क्रेडिट और पेमेंट तरीके',
  'settings.rewards': 'रिवॉर्ड',
  'settings.rewardsDesc': 'रेफरल, कूपन और कमाए हुए क्रेडिट',
  'settings.restartTour': 'टूर फिर से शुरू करें',
  'settings.restartTourDesc': 'प्रोडक्ट वॉकथ्रू शुरू से देखें',
  'settings.about': 'के बारे में',
  'settings.aboutDesc': 'ऐप वर्जन और सॉफ्टवेयर अपडेट',
  'settings.developerOptions': 'एडवांस्ड',
  'settings.developerOptionsDesc': 'AI कॉन्फिग, मैसेजिंग चैनल, टूल्स, डायग्नोस्टिक्स और डिबग पैनल',
  'settings.developerDiagnostics': 'डेवलपर और डायग्नोस्टिक्स',
  'settings.developerDiagnosticsDesc':
    'उन्नत डेवलपर टूल्स, डायग्नोस्टिक्स, मेमोरी, एजेंट और डिबग पैनल',
  'settings.developerMode.title': 'डेवलपर मोड',
  'settings.developerMode.description': 'उन्नत डेवलपर और डायग्नोस्टिक टूल्स दिखाएं',
  'settings.developerMode.enabledByBuild': 'डेवलपमेंट बिल्ड में हमेशा चालू',
  'settings.clearAppData': 'ऐप डेटा क्लियर करें',
  'settings.clearAppDataDesc': 'साइन आउट करें और सारा लोकल ऐप डेटा हमेशा के लिए मिटाएं',
  'settings.logOut': 'लॉग आउट',
  'settings.logOutDesc': 'अपने अकाउंट से साइन आउट करें',
  'settings.exitLocalSession': 'स्थानीय सत्र से बाहर निकलें',
  'settings.exitLocalSessionDesc': 'साइन-इन स्क्रीन पर वापस लौटें',
  'settings.language': 'भाषा',
  'settings.navGroups.general': 'सामान्य',
  'settings.navGroups.assistant': 'सहायक',
  'settings.navGroups.data': 'डेटा',
  'settings.navGroups.connections': 'कनेक्शन',
  'settings.navGroups.system': 'सिस्टम',
  'settings.betaBuild': 'बीटा बिल्ड - v{version}',
  'settings.languageDesc': 'ऐप इंटरफेस की डिस्प्ले भाषा',
  'settings.alerts': 'अलर्ट',
  'settings.alertsDesc': 'हाल के अलर्ट और इनबॉक्स एक्टिविटी देखें',
  'settings.account.profile': 'प्रोफ़ाइल',
  'settings.account.profileDesc': 'नाम, ईमेल और अवतार',
  'settings.account.devices': 'डिवाइस',
  'settings.account.devicesDesc': 'मोबाइल डिवाइस पेयर करें और प्रबंधित करें',
  'settings.account.teamMembers': 'टीम और सदस्य',
  'settings.account.teamMembersDesc': 'टीम एक्सेस और सदस्य भूमिकाएं प्रबंधित करें',
  'settings.account.dataMigration': 'डेटा और माइग्रेशन',
  'settings.account.dataMigrationDesc': 'दूसरे असिस्टेंट से मेमरी आयात करें',
  'settings.account.recoveryPhrase': 'रिकवरी फ्रेज़',
  'settings.account.recoveryPhraseDesc': 'अपना अकाउंट रिकवरी फ्रेज़ देखें और बैकअप लें',
  'settings.account.team': 'टीम',
  'settings.account.teamDesc': 'टीम मेंबर्स और परमिशन मैनेज करें',
  'settings.account.connections': 'कनेक्शन',
  'settings.account.connectionsDesc': 'लिंक्ड अकाउंट और सर्विसेज़ मैनेज करें',
  'settings.account.privacy': 'प्राइवेसी',
  'settings.account.privacyDesc': 'कंट्रोल करें कि आपके कंप्यूटर से क्या डेटा जाता है',
  'migration.title': 'किसी अन्य असिस्टेंट से इम्पोर्ट करें',
  'migration.description':
    'किसी अन्य लोकल असिस्टेंट से मेमोरी और नोट्स को इस वर्कस्पेस में माइग्रेट करें। पहले Preview से देखें कि क्या बदलेगा, फिर Apply से डेटा कॉपी करें। आपकी मौजूदा मेमोरी पहले बैकअप कर ली जाती है।',
  'migration.vendorLabel': 'सोर्स वेंडर',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': 'सोर्स वर्कस्पेस पाथ (वैकल्पिक)',
  'migration.sourcePlaceholder': 'ऑटो-डिटेक्ट के लिए खाली छोड़ें (जैसे ~/.openclaw/workspace)',
  'migration.sourcePlaceholderHermes': 'ऑटो-डिटेक्ट के लिए खाली छोड़ें (जैसे ~/.hermes)',
  'migration.sourceHint':
    'खाली होने पर वेंडर के डिफ़ॉल्ट लोकेशन का उपयोग होता है। अगर आपने वर्कस्पेस हटाया है तो स्पष्ट पाथ दें।',
  'migration.previewAction': 'प्रीव्यू',
  'migration.previewRunning': 'प्रीव्यू हो रहा है…',
  'migration.applyAction': 'इम्पोर्ट लागू करें',
  'migration.applyRunning': 'इम्पोर्ट हो रहा है…',
  'migration.applyDisclaimer':
    'उसी सोर्स के सफल Preview के बाद ही Apply अनलॉक होता है। किसी भी इम्पोर्ट से पहले मौजूदा मेमोरी का बैकअप लिया जाता है।',
  'migration.reportTitlePreview': 'प्रीव्यू: अभी कुछ इम्पोर्ट नहीं हुआ',
  'migration.reportTitleApplied': 'इम्पोर्ट पूरा',
  'migration.report.source': 'सोर्स वर्कस्पेस',
  'migration.report.target': 'टार्गेट वर्कस्पेस',
  'migration.report.fromSqlite': 'SQLite (brain.db) से',
  'migration.report.fromMarkdown': 'Markdown से',
  'migration.report.imported': 'इम्पोर्ट हुए',
  'migration.report.skippedUnchanged': 'छोड़े गए (अपरिवर्तित)',
  'migration.report.renamedConflicts': 'टकराव पर नाम बदला',
  'migration.report.warnings': 'चेतावनी',
  'migration.report.previewHint':
    'अभी तक कोई डेटा इम्पोर्ट नहीं हुआ है। कॉपी करने के लिए Apply पर क्लिक करें।',
  'migration.report.appliedHint':
    'इम्पोर्ट की गई एंट्रीज़ अब आपकी मेमोरी में हैं। दोबारा तुलना के लिए Preview फिर से चलाएँ।',
  'migration.confirmImport.singular':
    '{count} एंट्री को मौजूदा वर्कस्पेस में इम्पोर्ट करें?\n\nसोर्स: {source}\nटार्गेट: {target}\n\nइम्पोर्ट से पहले मौजूदा मेमोरी का बैकअप लिया जाएगा।',
  'migration.confirmImport.plural':
    '{count} एंट्रीज़ को मौजूदा वर्कस्पेस में इम्पोर्ट करें?\n\nसोर्स: {source}\nटार्गेट: {target}\n\nइम्पोर्ट से पहले मौजूदा मेमोरी का बैकअप लिया जाएगा।',
  'settings.notifications.doNotDisturb': 'डू नॉट डिस्टर्ब',
  'settings.notifications.doNotDisturbDesc': 'तय समय के लिए सभी नोटिफिकेशन रोकें',
  'settings.notifications.channelControls': 'चैनल-वाइज़ कंट्रोल',
  'settings.notifications.channelControlsDesc': 'हर चैनल के लिए नोटिफिकेशन प्रेफरेंस सेट करें',
  'settings.features.messaging': 'मैसेजिंग',
  'settings.features.messagingDesc': 'चैनल और मैसेजिंग इंटीग्रेशन सेटिंग्स',
  'settings.features.tools': 'टूल्स',
  'settings.features.toolsDesc': 'कनेक्टेड टूल्स और इंटीग्रेशन मैनेज करें',
  'settings.ai.localSetup': 'लोकल AI सेटअप',
  'settings.ai.localSetupDesc': 'लोकल AI मॉडल डाउनलोड और कॉन्फिगर करें',
  'settings.ai.llmProvider': 'LLM प्रोवाइडर',
  'settings.ai.llmProviderDesc': 'अपना AI प्रोवाइडर चुनें और कॉन्फिगर करें',
  'clearData.title': 'ऐप डेटा क्लियर करें',
  'clearData.warning':
    'इससे आप साइन आउट हो जाएंगे और नीचे दिया गया लोकल डेटा हमेशा के लिए मिट जाएगा:',
  'clearData.bulletSettings': 'ऐप सेटिंग्स और बातचीत',
  'clearData.bulletCache': 'सभी लोकल इंटीग्रेशन कैश डेटा',
  'clearData.bulletWorkspace': 'वर्कस्पेस डेटा',
  'clearData.bulletOther': 'बाकी सभी लोकल डेटा',
  'clearData.irreversible': 'यह कार्रवाई वापस नहीं हो सकती।',
  'clearData.clearing': 'ऐप डेटा क्लियर हो रहा है...',
  'clearData.failed': 'डेटा क्लियर करने और लॉगआउट में दिक्कत आई। दोबारा कोशिश करें।',
  'clearData.failedLogout': 'लॉग आउट नहीं हो पाया। दोबारा कोशिश करें।',
  'clearData.failedPersist': 'सेव्ड ऐप स्टेट क्लियर नहीं हो पाई। दोबारा कोशिश करें।',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': 'OpenHuman में आपका स्वागत है',
  'welcome.subtitle': 'आपकी पर्सनल AI सुपर इंटेलिजेंस। प्राइवेट, सिंपल और बेहद पावरफुल।',
  'welcome.connectPrompt': 'RPC URL कॉन्फिगर करें (एडवांस्ड)',
  'welcome.selectRuntime': 'एक रनटाइम चुनें',
  'welcome.clearingAppData': 'ऐप डेटा साफ़ किया जा रहा है...',
  'welcome.clearAppDataAndRestart': 'ऐप डेटा साफ़ करें और पुनरारंभ करें',
  'welcome.clearAppDataWarning':
    'यह इस डिवाइस पर स्थानीय रूप से संग्रहीत सीक्रेट और अकाउंट मिटा देता है। आपका क्लाउड अकाउंट प्रभावित नहीं होता: आप तुरंत बाद फिर से साइन इन कर सकते हैं।',
  'welcome.resetErrorFallback':
    'ऐप डेटा साफ़ नहीं हो सका। OpenHuman बंद करें और दोबारा खोलें, फिर पुनः प्रयास करें।',
  'welcome.signingIn': 'आपको साइन इन किया जा रहा है...',
  'welcome.termsIntro': 'जारी रखकर, आप इससे सहमत हैं',
  'welcome.termsOfUse': 'शर्तें',
  'welcome.termsJoiner': 'और',
  'welcome.privacyPolicy': 'गोपनीयता नीति',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': 'कृपया एक सही HTTP या HTTPS URL डालें',
  'welcome.connecting': 'टेस्टिंग',
  'welcome.connect': 'टेस्ट करें',
  'home.greeting': 'सुप्रभात',
  'home.greetingAfternoon': 'नमस्ते',
  'home.greetingEvening': 'शुभ संध्या',
  'home.askAssistant': 'असिस्टेंट से कुछ भी पूछें...',
  'home.statusOk': 'आपका सहायक तैयार है। शुरू करने के लिए नीचे कुछ लिखें।',
  'home.statusBackendOnly': 'बैकएंड से फिर से जुड़ रहे हैं… आपका एजेंट जल्द ही उपलब्ध होगा।',
  'home.statusCoreUnreachable':
    'लोकल कोर साइडकार रिस्पॉन्ड नहीं कर रहा। OpenHuman का बैकग्राउंड प्रोसेस क्रैश हो गया होगा या शुरू नहीं हो पाया।',
  'home.statusInternetOffline':
    'आपका डिवाइस अभी ऑफलाइन है। अपना नेटवर्क चेक करें या दोबारा कनेक्ट करने के लिए ऐप रीस्टार्ट करें।',
  'home.restartCore': 'कोर रीस्टार्ट करें',
  'home.restartingCore': 'कोर रीस्टार्ट हो रहा है…',
  'home.themeToggle.toLight': 'लाइट मोड पर स्विच करें',
  'home.themeToggle.toDark': 'डार्क मोड पर स्विच करें',
  'home.usageExhaustedTitle': 'आपका उपयोग समाप्त हो गया है',
  'home.usageExhaustedBody':
    'आपकी शामिल उपयोग सीमा अभी समाप्त हो चुकी है। अधिक निरंतर क्षमता अनलॉक करने के लिए सदस्यता शुरू करें।',
  'home.usageExhaustedCta': 'सदस्यता शुरू करें',
  'openrouterFree.cta': 'OpenRouter के मुफ्त मॉडल इस्तेमाल करें',
  'openrouterFree.saving': 'OpenRouter कनेक्ट हो रहा है...',
  'openrouterFree.error':
    'OpenRouter के मुफ्त मॉडल पर स्विच नहीं हो सका। अपना OpenRouter साइन-इन जांचें और फिर कोशिश करें।',
  'home.routinesCard': 'आपकी रूटीन',
  'home.routinesActive': '{count} सक्रिय',
  'routines.title': 'आपका दिनचर्या',
  'routines.subtitle': 'अपने सहायक को स्वचालित रूप से करने के लिए चीजें',
  'routines.loading': 'दिनचर्या लोड हो रहा है...',
  'routines.empty': 'अभी तक कोई दिनचर्या नहीं',
  'routines.emptyHint':
    'आपका सहायक एक अनुसूची पर कार्य चला सकता है - जैसे सुबह की ब्रीफिंग या दैनिक सारांश।',
  'routines.refresh': 'ताज़ा',
  'routines.nextRun': 'अगला',
  'routines.lastRunSuccess': 'अंतिम रन सफल',
  'routines.lastRunFailed': 'अंतिम रन असफल',
  'routines.notRunYet': 'अभी तक नहीं चला',
  'routines.runNow': 'अब चलायें',
  'routines.running': 'दौड़ना...',
  'routines.runNowTimedOut': 'चलाने में समय समाप्त: कृपया रिफ्रेश करें और पुनः प्रयास करें।',
  'routines.viewHistory': 'इतिहास देखें',
  'routines.loadingHistory': 'लोड...',
  'routines.noHistory': 'अभी तक कोई रन इतिहास नहीं है।',
  'routines.statusSuccess': 'सफलता',
  'routines.statusError': 'त्रुटि',
  'routines.showOutput': 'उत्पादन दिखाएँ',
  'routines.hideOutput': 'उत्पादन छुपाएं',
  'routines.toggleEnabled': 'इस दिनचर्या को सक्षम या अक्षम करें',
  'routines.typeAgent': 'एजेंट',
  'routines.typeCommand': 'कमान',
  'nav.routines': 'Routines',
  'chat.newThread': 'नई थ्रेड',
  'chat.newConversation': 'नई बातचीत',
  'chat.newWindowWelcome1': 'स्वागत है, {name} 👋',
  'chat.newWindowWelcome2': 'चलिए शुरू करें, {name} 🧑‍🍳.',
  'chat.newWindowWelcome3': 'ध्यान लगाने का समय 🧘🏻',
  'chat.typeMessage': 'आज मैं आपकी कैसे मदद कर सकता हूँ?',
  'chat.send': 'मैसेज भेजें',
  'chat.stopGeneration': 'जेनरेशन रोकें',
  'chat.stoppedByUser': 'रोक दिया गया',
  'chat.parallelBranchHint': 'समानांतर शाखा टाइप करें: भेजने के लिए ⌘/Ctrl+Enter',
  'chat.followupHint':
    'फ़ॉलो-अप कतार में लगाएँ: इस उत्तर के बाद भेजा जाएगा · समानांतर शाखा के लिए ⌘/Ctrl+Enter',
  'chat.queuedFollowups.label': 'कतारबद्ध फ़ॉलो-अप',
  'chat.queuedFollowups.clear': 'साफ़ करें',
  'chat.queuedFollowups.clearFailed': 'कतार साफ़ नहीं हो सकी: फिर से प्रयास करें।',
  'chat.createThreadFailed': 'नया थ्रेड नहीं बनाया जा सका: कृपया पुनः प्रयास करें।',
  'chat.parallelBranchLabel': 'समानांतर शाखा',
  'chat.thinking': 'सोच रहा है...',
  'chat.noMessages': 'अभी कोई मैसेज नहीं',
  'chat.startConversation': 'बातचीत शुरू करें',
  'chat.regenerate': 'फिर से बनाएं',
  'chat.copyResponse': 'जवाब कॉपी करें',
  'chat.citations': 'सोर्स',
  'chat.toolUsed': 'टूल इस्तेमाल हुआ',
  'scope.legacy': 'लीगेसी',
  'scope.user': 'यूज़र',
  'scope.project': 'प्रोजेक्ट',
  'skills.title': 'कनेक्शन',
  'skills.search': 'कनेक्शन सर्च करें...',
  'skills.noResults': 'कोई कनेक्शन नहीं मिला',
  'skills.loadingIntegrations': 'इंटीग्रेशन लोड हो रहे हैं…',
  'skills.connect': 'कनेक्ट करें',
  'skills.disconnect': 'डिसकनेक्ट करें',
  'skills.configure': 'मैनेज करें',
  'skills.connected': 'कनेक्टेड',
  'skills.available': 'उपलब्ध',
  'skills.addAccount': 'अकाउंट जोड़ें',
  'skills.channels': 'मैसेजिंग',
  'skills.explorer.emptyCta': 'URL से इंस्टॉल करें',
  'skills.explorer.emptyDescription':
    'SKILL.md पैकेज इंस्टॉल करें या Hermes-शैली फ़ोल्डर ~/.openhuman/skills में रखें।',
  'skills.explorer.emptyTitle': 'कोई स्किल नहीं मिली',
  'skills.explorer.installFromUrl': 'URL से इंस्टॉल करें',
  'skills.explorer.newSkill': 'नई स्किल',
  'skills.explorer.subtitle':
    'SKILL.md पैकेज ब्राउज़ करें, जिनमें Hermes-शैली markdown, scripts, references, templates, examples और prompts शामिल हैं।',
  'skills.explorer.title': 'स्किल एक्सप्लोरर',
  'skills.explorer.searchPlaceholder': 'स्किल खोजें...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': 'कोई विवरण नहीं दिया गया।',
  'skills.explorer.uninstallSuccess': 'स्किल सफलतापूर्वक अनइंस्टॉल हुई।',
  'skills.explorer.registryTab': 'रजिस्ट्री',
  'skills.explorer.installedTab': 'इंस्टॉल किए गए',
  'skills.explorer.allFormats': 'सभी प्रारूप',
  'skills.explorer.refreshRegistry': 'रजिस्ट्री ताज़ा करें',
  'skills.explorer.registryEmptyTitle': 'कोई रजिस्ट्री प्रविष्टियाँ नहीं',
  'skills.explorer.registryEmptyDescription':
    'कौशल रजिस्ट्री लोड नहीं हो सकी। अपना कनेक्शन जांचें और रिफ़्रेश करें।',
  'skills.explorer.showingOf':
    '{total} परिणामों में से {shown} दिखाए जा रहे हैं। अधिक देखने के लिए अपनी खोज को परिष्कृत करें।',
  'skills.explorer.installed': 'इंस्टॉल किया गया',
  'skills.explorer.install': 'इंस्टॉल करें',
  'skills.explorer.installing': 'इंस्टॉल हो रहा है…',
  'skills.integrations': 'Composio इंटीग्रेशन',
  'skills.integrationsSubtitle':
    'क्लाउड-आधारित OAuth कनेक्शन: अपने अकाउंट से साइन इन करें और Composio टोकन ब्रोकर करता है ताकि एजेंट आपकी ओर से पढ़ और कार्य कर सकें। कोई API कुंजी प्रबंधित नहीं करनी।',
  'skills.composio.noApiKeyTitle': 'कोई Composio API key कॉन्फ़िगर नहीं है',
  'skills.composio.noApiKeyDescription':
    'लोकल मोड आपकी अपनी Composio API key का उपयोग करता है। यहाँ integrations जोड़ने से पहले Settings → Advanced → Composio खोलकर key जोड़ें।',
  'skills.composio.noApiKeyCta': 'Settings में खोलें',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': 'चैनल',
  'skills.tabs.explorer': 'स्किल',
  'skills.tabs.meetings': 'Google Meet बैठकें',
  'skills.tabs.mcp': 'MCP सर्वर',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': 'चैनल',
  'connections.tabs.mcp': 'MCP सर्वर',
  'connections.tabs.skills': 'कौशल',
  'connections.tabs.meetings': 'मीटिंग',
  'connections.groups.integrations': 'इंटीग्रेशन',
  'connections.groups.desktop': 'डेस्कटॉप',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'API कुंजियाँ',
  'connections.groups.intelligence': 'इंटेलिजेंस',
  'memory.title': 'मेमोरी',
  'memory.search': 'मेमोरी सर्च करें...',
  'memory.noResults': 'कोई मेमोरी नहीं मिली',
  'memory.empty': 'अभी कोई मेमोरी नहीं है। बातचीत के दौरान मेमोरी अपने आप बनती है।',
  'memory.tab.memory': 'मेमोरी',
  'memory.tab.memoryTree': 'मेमोरी ट्री',
  'memory.tab.tasks': 'कार्य',
  'memory.tab.tasksDescription':
    'कार्य बनाएं और ट्रैक करें: आपके अपने टू-डू और साथ ही वे बोर्ड जो आपके एजेंट वार्तालापों में बनाते हैं।',
  'memory.tab.subconscious': 'सबकॉन्शस',
  'memory.tab.agentWork': 'एजेंट कार्य',
  'memory.tab.agentWorkDescription':
    'हर पृष्ठभूमि एजेंट रन के लिए एक कमांड सेंटर: इस आधार पर समूहित कि किसे आपकी जानकारी चाहिए, क्या चल रहा है और क्या पूरा हो चुका है।',
  'memory.tab.worktrees': 'वर्कट्री',
  'memory.tab.worktreesDescription':
    'समानांतर एजेंट वर्कर्स से पृथक git वर्कट्री: बदलावों का निरीक्षण करें, उन्हें खोलें या साफ़ करें।',
  'memory.tab.teams': 'टीमें',
  'memory.tab.teamsDescription':
    'समन्वित एजेंट टीमें: हर कार्य का स्वामी कौन है, क्या अवरुद्ध है, और सहयोगी एक-दूसरे से क्या कह रहे हैं।',
  'memory.tab.agents': 'लाइब्रेरी',
  'memory.tab.agentsDescription':
    'अपने उपलब्ध एजेंट ब्राउज़ करें और चलाएं: प्रत्येक के पास अपने टूल, क्षमताएं और फोकस क्षेत्र हैं।',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    'पुन: प्रयोज्य, चलाने योग्य प्रक्रियाएँ: एक लक्ष्य और उसे प्राप्त करने के चरण। एक बनाएँ, URL से इंस्टॉल करें, या चलाने के लिए वर्कफ़्लो खोलें।',
  'memory.tab.dreams': 'ड्रीम्स',
  'memory.tab.calls': 'कॉल्स',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': 'नेमस्पेस',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': 'सेटिंग्स',
  'memory.analyzeNow': 'अभी एनालाइज़ करें',
  'memoryTimeline.title': 'स्मृति समयरेखा',
  'memoryTimeline.intro':
    'सहायक ने आपके बारे में कब सीखा: तथ्य उस महीने के अनुसार समूहित जब उन्हें आखिरी बार सुदृढ़ किया गया। विकास, गतिविधि के उछाल और शांत अवधि दिखाता है।',
  'memoryTimeline.loading': 'समयरेखा बना रहे हैं…',
  'memoryTimeline.errorPrefix': 'ग्राफ़ लोड नहीं हो सका:',
  'memoryTimeline.retry': 'Retry',
  'memoryTimeline.namespaceLabel': 'Namespace',
  'memoryTimeline.namespaceAll': 'सभी नेमस्पेस',
  'memoryTimeline.empty': 'अभी तक कोई ज्ञान ग्राफ़ नहीं।',
  'memoryTimeline.emptyHint': 'जब सहायक आपके बारे में तथ्य दर्ज करेगा, तो समयरेखा यहाँ दिखेगी।',
  'memoryTimeline.metricTotal': 'Facts',
  'memoryTimeline.metricMonths': 'सक्रिय महीने',
  'memoryTimeline.metricRecent': 'पिछले 30 दिन',
  'memoryTimeline.heading': 'प्रति माह सीखे गए तथ्य',
  'memoryTimeline.busiestCaption': 'सबसे व्यस्त: {period} ({count})',
  'memoryTimeline.undatedNote': '{count} तथ्यों में कोई दर्ज तिथि नहीं है।',
  'memoryTimeline.truncated': '{total} महीनों में से सबसे हाल के {shown} दिखा रहे हैं।',
  'namespaceOverview.title': 'नेमस्पेस अवलोकन',
  'namespaceOverview.intro':
    'आपका ज्ञान संदर्भों में कैसे वितरित है: प्रत्येक नेमस्पेस में दर्ज तथ्यों और विशिष्ट इकाइयों की संख्या।',
  'namespaceOverview.loading': 'नेमस्पेस एकत्र किए जा रहे हैं…',
  'namespaceOverview.errorPrefix': 'ग्राफ़ लोड नहीं किया जा सका:',
  'namespaceOverview.retry': 'पुनः प्रयास करें',
  'namespaceOverview.empty': 'अभी तक कोई ज्ञान ग्राफ़ नहीं है।',
  'namespaceOverview.emptyHint':
    'जैसे-जैसे सहायक संदर्भों में तथ्य दर्ज करता है, प्रत्येक नेमस्पेस यहाँ दिखाई देगा।',
  'namespaceOverview.metricNamespaces': 'नेमस्पेस',
  'namespaceOverview.metricFacts': 'तथ्य',
  'namespaceOverview.metricEntities': 'इकाइयाँ',
  'namespaceOverview.heading': 'नेमस्पेस के अनुसार',
  'namespaceOverview.unnamespaced': '(बिना नेमस्पेस)',
  'namespaceOverview.factsLabel': '{count} तथ्य',
  'namespaceOverview.entitiesLabel': '{count} इकाइयाँ',
  'namespaceOverview.entitiesShort': '{count} इका.',
  'namespaceOverview.truncated': '{total} में से शीर्ष {shown} नेमस्पेस दिखाए जा रहे हैं।',
  'graphCentrality.title': 'ज्ञान ग्राफ केंद्रीयता',
  'graphCentrality.intro':
    'अपने मेमोरी ग्राफ़ पर पेजरैंक लोड-असर हब सतहों - और कनेक्टर इकाइयां जो अन्यथा अलग-अलग समूहों को जोड़ती हैं, जो एक कच्चे आवृत्ति गिनती प्रकट नहीं हो सकती हैं।',
  'graphCentrality.loading': 'संघटन',
  'graphCentrality.errorPrefix': 'ग्राफ को लोड नहीं कर सकता:',
  'graphCentrality.retry': 'रेस्त्री',
  'graphCentrality.empty': 'अभी तक कोई ज्ञान ग्राफ नहीं है।',
  'graphCentrality.emptyHint':
    'चूंकि सहायक आपके बारे में तथ्यों को रिकॉर्ड करता है, तो सबसे अधिक जुड़े संस्थाएं यहां सामने आएंगी।',
  'graphCentrality.namespaceLabel': 'Namespace',
  'graphCentrality.namespaceAll': 'सभी नामस्थान',
  'graphCentrality.metricEntities': 'संस्था',
  'graphCentrality.metricConnections': 'कनेक्शन',
  'graphCentrality.metricClusters': 'क्लस्टर',
  'graphCentrality.clustersCaption': '{components} क्लस्टर · सबसे बड़ा {largest} रखती है',
  'graphCentrality.approximateBadge': 'लगभग',
  'graphCentrality.approximateTitle': 'पूरी तरह से अभिसरण से पहले पुनरावृत्ति टोपी पर रुकना',
  'graphCentrality.rankedHeading': 'प्रभाव से शीर्ष संस्थाएं',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': 'संस्था',
  'graphCentrality.colInfluence': 'प्रभाव',
  'graphCentrality.colLinks': 'लिंक',
  'graphCentrality.bridgeBadge': 'कनेक्टर',
  'graphCentrality.bridgeTitle': 'कनेक्टर - इसके लिंक गिनती से अधिक प्रभावशाली सुझाव देते हैं',
  'graphCentrality.degreeTitle': '{in}',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': 'इकाई संबंध',
  'entityAssociations.intro':
    'जो इकाइयाँ कई समान कनेक्शन साझा करती हैं, वे संबंधित होती हैं, भले ही कोई एक तथ्य उन्हें सीधे न जोड़े। Jaccard समानता इन छिपे हुए संबंधों को उजागर करती है।',
  'entityAssociations.loading': 'संबंध स्कोर कर रहे हैं…',
  'entityAssociations.errorPrefix': 'ग्राफ़ लोड नहीं हो सका:',
  'entityAssociations.retry': 'Retry',
  'entityAssociations.empty': 'अभी तक कोई संबंध नहीं।',
  'entityAssociations.emptyHint':
    'जब इकाइयाँ कनेक्शन साझा करना शुरू करेंगी, तो सबसे मजबूत जोड़ियाँ यहाँ दिखेंगी।',
  'entityAssociations.namespaceLabel': 'Namespace',
  'entityAssociations.namespaceAll': 'सभी नेमस्पेस',
  'entityAssociations.metricEntities': 'Entities',
  'entityAssociations.metricPairs': 'Associations',
  'entityAssociations.rankedHeading': 'सबसे मजबूत संबंध',
  'entityAssociations.linkedBadge': 'linked',
  'entityAssociations.inferredBadge': 'inferred',
  'entityAssociations.linkedTitle': 'ये इकाइयाँ सीधे जुड़ी हैं।',
  'entityAssociations.inferredTitle':
    'कोई सीधा लिंक नहीं: केवल साझा कनेक्शन के माध्यम से जुड़े हैं।',
  'entityAssociations.sharedLabel': '{shared} साझा',
  'entityAssociations.pairTitle': '{jaccard}% समान · {shared}/{union} कनेक्शन साझा',
  'entityAssociations.truncated': '{shown}/{total} दिखा रहे हैं: सबसे मजबूत पहले।',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': 'ज्ञान ताज़गी',
  'memoryFreshness.intro':
    'जिन तथ्यों की सहायक ने हाल ही में पुनः पुष्टि नहीं की है, वे भूलने की वक्र के अनुसार क्षीण होते हैं। यह दिखाता है कि क्या पुराना हो रहा है और पुनः जाँच योग्य है, ताकि पुराने तथ्यों को अभी भी निश्चित न माना जाए।',
  'memoryFreshness.loading': 'ताज़गी स्कोर कर रहे हैं…',
  'memoryFreshness.errorPrefix': 'ग्राफ़ लोड नहीं हो सका:',
  'memoryFreshness.retry': 'Retry',
  'memoryFreshness.empty': 'अभी तक कोई ज्ञान ग्राफ़ नहीं।',
  'memoryFreshness.emptyHint':
    'जब सहायक आपके बारे में तथ्य दर्ज करेगा, तो उनकी ताज़गी यहाँ ट्रैक की जाएगी।',
  'memoryFreshness.namespaceLabel': 'Namespace',
  'memoryFreshness.namespaceAll': 'सभी नेमस्पेस',
  'memoryFreshness.metricFresh': 'Fresh',
  'memoryFreshness.metricFading': 'Fading',
  'memoryFreshness.metricStale': 'Stale',
  'memoryFreshness.recallCaption': '{total} तथ्यों में औसत रिकॉल {recall}%',
  'memoryFreshness.queueHeading': 'पुनः पुष्टि कतार',
  'memoryFreshness.queueTruncated': '{shown}/{total} दिखा रहे हैं: पहले इन्हें संबोधित करें।',
  'memoryFreshness.allFresh': 'सभी तथ्य अभी भी ताज़े हैं: पुनः पुष्टि की आवश्यकता नहीं।',
  'memoryFreshness.statusFading': 'fading',
  'memoryFreshness.statusStale': 'stale',
  'memoryFreshness.ageLabel': '{days} दिन पुराना',
  'memoryFreshness.recallTitle': '{recall}% रिकॉल · अर्ध-जीवन {halfLife} दिन',
  'memory.tab.path': 'पथ',
  'connectionPath.title': 'कनेक्शन पथ',
  'connectionPath.intro':
    'किन्हीं दो एंटिटीज़ को जोड़ने वाली संबंधों की सबसे छोटी श्रृंखला का पता लगाएँ: ग्राफ़ उन्हें कैसे जोड़ता है, चाहे कई हॉप्स के पार ही क्यों न हो।',
  'connectionPath.loading': 'ग्राफ़ लोड हो रहा है…',
  'connectionPath.errorPrefix': 'ग्राफ़ लोड नहीं हो सका:',
  'connectionPath.retry': 'पुनः प्रयास करें',
  'connectionPath.namespaceLabel': 'नेमस्पेस',
  'connectionPath.namespaceAll': 'सभी नेमस्पेस',
  'connectionPath.sourceLabel': 'से',
  'connectionPath.targetLabel': 'तक',
  'connectionPath.sourcePlaceholder': 'प्रारंभिक एंटिटी',
  'connectionPath.targetPlaceholder': 'अंतिम एंटिटी',
  'connectionPath.prompt': 'यह पता लगाने के लिए दो एंटिटीज़ चुनें कि वे कैसे जुड़ी हुई हैं।',
  'connectionPath.empty': 'अभी तक कोई नॉलेज ग्राफ़ नहीं है।',
  'connectionPath.emptyHint':
    'जब असिस्टेंट संबंधित तथ्य रिकॉर्ड कर लेगा, तो आप यहाँ कनेक्शनों का पता लगा सकते हैं।',
  'connectionPath.resultHeading': 'सबसे छोटा पथ',
  'connectionPath.pathSummary': '{length} हॉप(्स) की दूरी पर',
  'connectionPath.sameMessage': 'दो अलग-अलग एंटिटीज़ चुनें।',
  'connectionPath.missingSource': '"{entity}" ग्राफ़ में नहीं है।',
  'connectionPath.missingTarget': '"{entity}" ग्राफ़ में नहीं है।',
  'connectionPath.noPath': '"{source}" और "{target}" के बीच कोई कनेक्शन नहीं मिला।',
  'memoryTree.status.title': 'मेमोरी ट्री',
  'memoryTree.status.autoSyncLabel': 'ऑटो सिंक',
  'memoryTree.status.autoSyncDescription':
    'नए अंतर्ग्रहण को रोकने के लिए रोकें। मौजूदा विकि क्वेरी योग्य रहता है।',
  'memoryTree.status.statusTile': 'स्थिति',
  'memoryTree.status.lastSyncTile': 'अंतिम सिंक',
  'memoryTree.status.totalChunksTile': 'कुल अंक',
  'memoryTree.status.wikiSizeTile': 'विकी आकार',
  'memoryTree.status.statusRunning': 'दौड़ना',
  'memoryTree.status.statusPaused': 'दलित',
  'memoryTree.status.statusSyncing': 'सिंक करना',
  'memoryTree.status.statusError': 'त्रुटि',
  'memoryTree.status.statusIdle': 'आइडल',
  'memoryTree.status.never': 'कभी नहीं',
  'memoryTree.status.fetchError': 'स्मृति वृक्ष की स्थिति नहीं मिला',
  'memoryTree.status.retry': 'रेस्त्री',
  'memoryTree.status.retryFailed': 'विफल कार्य दोबारा चलाएँ',
  'memoryTree.status.retryFailedBusy': 'दोबारा चलाया जा रहा है...',
  'memoryTree.status.retryFailedDone': 'विफल कार्य फिर से कतार में डाले गए',
  'memoryTree.status.retryFailedCount': '{count} कार्य दोबारा चलने के लिए कतार में हैं।',
  'memoryTree.status.retryFailedError': 'विफल कार्यों को फिर से कतार में नहीं डाला जा सका',
  'memoryTree.status.toggleFailed': 'ऑटो सिंक को टॉगल नहीं कर सका',
  'memoryTree.status.justNow': 'अभी',
  'memoryTree.status.secondsAgo': '{count} पहले',
  'memoryTree.status.minuteAgo': '1 मिनट पहले',
  'memoryTree.status.minutesAgo': '{count} min पहले',
  'memoryTree.status.hourAgo': '1 घंटे पहले',
  'memoryTree.status.hoursAgo': '{count} hr पहले',
  'memoryTree.status.dayAgo': '1 दिन पहले',
  'memoryTree.status.daysAgo': '{count} दिन पहले',
  'memoryTree.status.integrationsTitle': 'प्रति-एकीकरण स्थिति',
  'memoryTree.status.integrationsEmpty': 'कोई एकीकरण कनेक्ट नहीं है',
  'memoryTree.status.integrationActive': 'सक्रिय',
  'memoryTree.status.integrationStale': 'पुराना',
  'memoryTree.status.integrationChunks': 'चंक्स: {count}',
  'alerts.title': 'अलर्ट',
  'alerts.empty': 'अभी कोई अलर्ट नहीं',
  'alerts.markAllRead': 'सभी पढ़ा हुआ मार्क करें',
  'alerts.unread': 'अनरीड',
  'rewards.title': 'रिवॉर्ड',
  'rewards.referrals': 'रेफरल',
  'rewards.coupons': 'रिडीम करें',
  'rewards.localUnavailable':
    'लोकल लॉगिन पर rewards, coupons या referral credit नहीं मिलते। rewards पाने के लिए लॉग आउट करें और OpenHuman खाते से साइन इन करें।',
  'rewards.localUnavailableCta': 'Account Settings खोलें',
  'rewards.credits': 'क्रेडिट',
  'rewards.referralCode': 'आपका रेफरल कोड',
  'rewards.copyCode': 'कोड कॉपी करें',
  'rewards.share': 'शेयर करें',
  'onboarding.welcome': 'नमस्ते। मैं OpenHuman हूँ।',
  'onboarding.welcomeDesc':
    'आपका सुपर-इंटेलिजेंट AI असिस्टेंट जो आपके कंप्यूटर पर चलता है। प्राइवेट, सिंपल और बेहद पावरफुल।',
  'onboarding.context': 'कॉन्टेक्स्ट गैदरिंग',
  'onboarding.contextDesc': 'अपने रोज़ इस्तेमाल के टूल्स और सर्विसेज़ कनेक्ट करें।',
  'onboarding.localAI': 'लोकल AI',
  'onboarding.localAIDesc': 'अपनी मशीन पर चलने वाला लोकल AI मॉडल सेट करें।',
  'onboarding.chatProvider': 'चैट प्रोवाइडर',
  'onboarding.chatProviderDesc': 'चुनें कि असिस्टेंट से कैसे बात करनी है।',
  'onboarding.referral': 'रेफरल',
  'onboarding.referralDesc': 'अगर आपके पास रेफरल कोड है तो लगाएं।',
  'onboarding.finish': 'सेटअप पूरा करें',
  'onboarding.finishDesc': 'सब तैयार है! OpenHuman इस्तेमाल शुरू करें।',
  'onboarding.skip': 'स्किप करें',
  'onboarding.getStarted': 'शुरू करें',
  'onboarding.runtimeChoice.title': 'OpenHuman कैसे चलाना चाहते हैं?',
  'onboarding.runtimeChoice.subtitle':
    'अपने लिए सही सेटअप चुनें। बाद में Settings में बदल सकते हैं।',
  'onboarding.runtimeChoice.cloud.title': 'सिंपल',
  'onboarding.runtimeChoice.cloud.tagline': 'OpenHuman सब कुछ मैनेज करेगा।',
  'onboarding.runtimeChoice.cloud.f1': 'बिल्ट-इन सिक्योरिटी',
  'onboarding.runtimeChoice.cloud.f2': 'ज़्यादा उपयोग के लिए टोकन कम्प्रेशन',
  'onboarding.runtimeChoice.cloud.f3': 'एक सब्सक्रिप्शन, हर मॉडल शामिल',
  'onboarding.runtimeChoice.cloud.f4': 'कोई API keys मैनेज नहीं करनी',
  'onboarding.runtimeChoice.cloud.f5': 'सेटअप बेहद आसान',
  'onboarding.runtimeChoice.custom.title': 'कस्टम रन करें',
  'onboarding.runtimeChoice.custom.tagline': 'अपनी keys लाएं। पूरा कंट्रोल आपके हाथ में।',
  'onboarding.runtimeChoice.custom.f1': 'लगभग हर चीज़ के लिए API keys चाहिए होंगी',
  'onboarding.runtimeChoice.custom.f2': 'जो सर्विसेज़ आप पहले से पे करते हैं उन्हें रियूज़ करता है',
  'onboarding.runtimeChoice.custom.f3': 'सब लोकल चलाएं तो फ्री हो सकता है',
  'onboarding.runtimeChoice.custom.f4': 'ज़्यादा सेटअप, ज़्यादा कंट्रोल',
  'onboarding.runtimeChoice.custom.f5': 'पावर यूज़र्स और डेवलपर्स के लिए बेस्ट',
  'onboarding.runtimeChoice.cloud.creditHighlight': 'साइन अप करने पर मुफ्त क्रेडिट',
  'onboarding.runtimeChoice.continueCloud': 'सिंपल के साथ जारी रखें',
  'onboarding.runtimeChoice.continueCustom': 'कस्टम के साथ जारी रखें',
  'onboarding.runtimeChoice.recommended': 'सुझावित',
  'onboarding.runtimeChoice.exitError': 'ऑनबोर्डिंग पूरी नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'onboarding.apiKeys.title': 'अपनी API Keys जोड़ें',
  'onboarding.apiKeys.subtitle':
    'अभी पेस्ट करें या बाद में कनेक्शन › API कुंजियाँ में जोड़ें। Keys इस डिवाइस पर एन्क्रिप्टेड रहती हैं।',
  'onboarding.apiKeys.openaiLabel': 'OpenAI API कुंजी',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    'चैटजीपीटी प्लस/प्रो (सदस्यता) या OpenAI API कुंजी का उपयोग करें - दोनों की आवश्यकता नहीं है।',
  'onboarding.apiKeys.openaiOauthOpening': 'साइन-इन खुल रहा है...',
  'onboarding.apiKeys.openaiOauthConnect': 'ChatGPT से साइन इन करें',
  'onboarding.apiKeys.openaiOauthConnected': 'ChatGPT से कनेक्ट किया गया',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    'साइन इन करने के बाद, अपने ब्राउज़र से पूरा रीडायरेक्ट URL पेस्ट करें ({url} से शुरू होता है)।',
  'onboarding.apiKeys.oauthDesktopOnly': 'ChatGPT साइन-इन केवल डेस्कटॉप ऐप में उपलब्ध है।',
  'onboarding.apiKeys.oauthStartFailed':
    'ChatGPT साइन-इन शुरू नहीं किया जा सका। पुनः प्रयास करें या API कुंजी का उपयोग करें।',
  'onboarding.apiKeys.oauthPasteRedirect':
    'साइन इन करने के बाद अपने ब्राउज़र से रीडायरेक्ट URL पेस्ट करें।',
  'onboarding.apiKeys.oauthCompleteFailed':
    'ChatGPT साइन-इन पूरा नहीं हुआ। रीडायरेक्ट URL जांचें और पुनः प्रयास करें।',
  'onboarding.apiKeys.finishSignIn': 'चैटजीपीटी साइन-इन समाप्त करें',
  'onboarding.apiKeys.orApiKey': 'या API कुंजी',
  'onboarding.apiKeys.anthropicLabel': 'Anthropic API कुंजी',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError': 'वह key सेव नहीं हो पाई। दोबारा चेक करके कोशिश करें।',
  'onboarding.apiKeys.skipForNow': 'अभी के लिए स्किप करें',
  'onboarding.apiKeys.continue': 'सेव करें और जारी रखें',
  'onboarding.apiKeys.saving': 'सेव हो रहा है…',
  'onboarding.custom.stepperInference': 'इनफरेंस',
  'onboarding.custom.stepperVoice': 'वॉइस',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': 'सर्च',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': 'मेमोरी',
  'onboarding.custom.stepCounter': 'स्टेप {n} / {total}',
  'onboarding.custom.defaultTitle': 'डिफ़ॉल्ट',
  'onboarding.custom.defaultSubtitle': 'OpenHuman खुद मैनेज करेगा।',
  'onboarding.custom.configureTitle': 'कॉन्फिगर करें',
  'onboarding.custom.configureSubtitle': 'मैं खुद चुनूँगा।',
  'onboarding.custom.progressAriaLabel': 'ऑनबोर्डिंग प्रोग्रेस',
  'onboarding.custom.continue': 'जारी रखें',
  'onboarding.custom.back': 'वापस',
  'onboarding.custom.finish': 'सेटअप पूरा करें',
  'onboarding.custom.configureLater':
    'ऑनबोर्डिंग के बाद यह सेट कर सकते हैं। हो जाने पर आपको सही Settings पेज पर ले जाएंगे।',
  'onboarding.custom.openSettings': 'Settings में खोलें',
  'onboarding.custom.inference.title': 'इनफरेंस (टेक्स्ट)',
  'onboarding.custom.inference.subtitle':
    'कौन सा लैंग्वेज मॉडल आपके सवाल जवाब देगा और एजेंट चलाएगा?',
  'onboarding.custom.inference.defaultDesc':
    'OpenHuman हर वर्कलोड के लिए खुद सही मॉडल चुनता है। कोई key नहीं, कोई सेटअप नहीं।',
  'onboarding.custom.inference.configureDesc':
    'अपनी OpenAI या Anthropic key लाएं। हर टेक्स्ट वर्कलोड के लिए इस्तेमाल होगी।',
  'onboarding.custom.voice.title': 'वॉइस',
  'onboarding.custom.voice.subtitle': 'वॉइस मोड के लिए स्पीच-टू-टेक्स्ट और टेक्स्ट-टू-स्पीच।',
  'onboarding.custom.voice.defaultDesc':
    'OpenHuman में मैनेज्ड STT/TTS है जो बस काम करता है। कुछ सेट नहीं करना।',
  'onboarding.custom.voice.configureDesc':
    'अपना ElevenLabs / OpenAI Whisper / आदि इस्तेमाल करें। Settings › Voice में कॉन्फिगर करें।',
  'onboarding.custom.oauth.title': 'कनेक्शन (OAuth)',
  'onboarding.custom.oauth.subtitle': 'Gmail, Slack, Notion और OAuth ज़रूरी सर्विसेज़।',
  'onboarding.custom.oauth.defaultDesc':
    'OpenHuman मैनेज्ड Composio वर्कस्पेस चलाता है। हर सर्विस एक क्लिक में कनेक्ट होती है।',
  'onboarding.custom.oauth.configureDesc':
    'अपना Composio अकाउंट / API key लाएं। Settings › Connections में कॉन्फिगर करें।',
  'onboarding.custom.search.title': 'वेब सर्च',
  'onboarding.custom.search.subtitle': 'OpenHuman आपकी तरफ से वेब कैसे सर्च करता है।',
  'onboarding.custom.search.defaultDesc':
    'OpenHuman मैनेज्ड सर्च बैकएंड इस्तेमाल करता है। कोई key नहीं चाहिए।',
  'onboarding.custom.search.configureDesc':
    'अपनी सर्च प्रोवाइडर key लाएं (Tavily, Brave, आदि)। Settings › Tools में कॉन्फिगर करें।',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle':
    'OpenHuman सिमेंटिक मेमोरी खोज के लिए वेक्टर एम्बेडिंग कैसे बनाता है।',
  'onboarding.custom.embeddings.defaultDesc':
    'OpenHuman एक प्रबंधित एम्बेडिंग सेवा का उपयोग करता है। कोई API कुंजी आवश्यक नहीं।',
  'onboarding.custom.embeddings.configureDesc':
    'अपना खुद का एम्बेडिंग प्रोवाइडर लाएं (OpenAI, Voyage, Ollama, आदि)।',
  'onboarding.custom.memory.title': 'मेमोरी',
  'onboarding.custom.memory.subtitle':
    'OpenHuman आपका कॉन्टेक्स्ट, पसंद और पुरानी बातें कैसे याद रखता है।',
  'onboarding.custom.memory.defaultDesc':
    'OpenHuman मेमोरी स्टोरेज और रिट्रीवल अपने आप मैनेज करता है। कुछ सेट नहीं करना।',
  'onboarding.custom.memory.configureDesc':
    'मेमोरी खुद देखें, एक्सपोर्ट करें या मिटाएं। Settings › Memory में कॉन्फिगर करें।',
  'accounts.addAccount': 'अकाउंट जोड़ें',
  'accounts.addApps': 'ऐप्स जोड़ें',
  'accounts.manageAccounts': 'अकाउंट मैनेज करें',
  'accounts.noAccounts': 'कोई अकाउंट कनेक्ट नहीं है',
  'accounts.connectAccount': 'शुरू करने के लिए एक अकाउंट कनेक्ट करें',
  'accounts.agent': 'एजेंट',
  'accounts.respondQueue': 'रिस्पॉन्ड क्यू',
  'accounts.disconnect': 'डिसकनेक्ट करें',
  'accounts.disconnectConfirm': 'क्या आप वाकई इस अकाउंट को डिसकनेक्ट करना चाहते हैं?',
  'accounts.disconnectClearMemory': 'इस स्रोत की मेमोरी भी हटाएं',
  'accounts.disconnectClearMemoryHint':
    'इस कनेक्शन से जुड़े स्थानीय मेमोरी खंड स्थायी रूप से हटा दिए जाएंगे।',
  'accounts.searchAccounts': 'अकाउंट सर्च करें...',
  'channels.title': 'चैनल',
  'channels.configure': 'चैनल कॉन्फिगर करें',
  'channels.setup': 'सेटअप',
  'channels.noChannels': 'कोई चैनल कॉन्फिगर नहीं है',
  'channels.localManagedUnavailable': 'लोकल उपयोगकर्ताओं के लिए managed channels उपलब्ध नहीं हैं।',
  'channels.addChannel': 'चैनल जोड़ें',
  'channels.status.connected': 'कनेक्टेड',
  'channels.status.disconnected': 'डिसकनेक्टेड',
  'channels.status.error': 'एरर',
  'channels.status.configuring': 'कॉन्फिगर हो रहा है',
  'channels.defaultMessaging': 'डिफ़ॉल्ट मैसेजिंग चैनल',
  'channels.setAsDefault': 'डिफ़ॉल्ट के रूप में सेट करें',
  'channels.defaultBadge': 'डिफ़ॉल्ट',
  'webhooks.title': 'वेबहुक्स',
  'webhooks.create': 'Webhook बनाएं',
  'webhooks.noWebhooks': 'कोई webhook कॉन्फिगर नहीं है',
  'webhooks.url': 'URL',
  'webhooks.secret': 'सीक्रेट',
  'webhooks.events': 'इवेंट्स',
  'webhooks.archiveDirectory': 'आर्काइव डायरेक्टरी',
  'webhooks.todayFile': 'आज की फाइल',
  'invites.title': 'इनवाइट्स',
  'invites.create': 'इनवाइट बनाएं',
  'invites.noInvites': 'कोई पेंडिंग इनवाइट नहीं',
  'invites.code': 'इनवाइट कोड',
  'invites.copyLink': 'लिंक कॉपी करें',
  'invites.generate': 'आमंत्रण जनरेट करें',
  'invites.generating': 'उत्पन्न हो रहा है...',
  'invites.refreshing': 'ताज़ा आमंत्रण...',
  'invites.loading': 'आमंत्रण लोड हो रहे हैं...',
  'invites.copyCodeAria': 'आमंत्रण कोड कॉपी करें',
  'invites.revokeAria': 'आमंत्रण रद्द करें',
  'invites.usedUp': 'उपयोग किया गया',
  'invites.uses': 'उपयोग: {current}{max}',
  'invites.expiresOn': 'समाप्त {date}',
  'invites.empty': 'अभी तक कोई निमंत्रण नहीं',
  'invites.emptyHint': 'दूसरों के साथ साझा करने के लिए एक आमंत्रण कोड जनरेट करें',
  'invites.revokeTitle': 'आमंत्रण कोड निरस्त करें',
  'invites.revokePromptPrefix': 'क्या आप वाकई आमंत्रण कोड रद्द करना चाहते हैं?',
  'invites.revokeWarning':
    'यह इनवाइट कोड अब मान्य नहीं रहेगा और टीम में शामिल होने के लिए उपयोग नहीं किया जा सकेगा।',
  'invites.revoking': 'निरस्त किया जा रहा है...',
  'invites.revokeAction': 'आमंत्रण निरस्त करें',
  'invites.failedGenerate': 'आमंत्रण जनरेट करने में विफल',
  'invites.failedRevoke': 'आमंत्रण रद्द करने में विफल',
  'team.refreshingMembers': 'सदस्यों को ताज़ा किया जा रहा है...',
  'team.loadingMembers': 'सदस्य लोड हो रहे हैं...',
  'team.memberCount': '{count} सदस्य',
  'team.memberCountPlural': '{count} सदस्य',
  'team.you': '(आप)',
  'team.removeAria': '{name} हटाएं',
  'team.noMembers': 'कोई सदस्य नहीं मिला',
  'team.removeTitle': 'टीम सदस्य को हटाएँ',
  'team.removePromptPrefix': 'क्या आप वाकई हटाना चाहते हैं',
  'team.removePromptSuffix': 'टीम से?',
  'team.removeWarning': 'वे टीम और सभी टीम संसाधनों तक पहुंच खो देंगे।',
  'team.removing': 'हटाया जा रहा है...',
  'team.removeAction': 'सदस्य हटाएँ',
  'team.changeRoleTitle': 'सदस्य भूमिका बदलें',
  'team.changeRolePrompt': '{name} की भूमिका {oldRole} से {newRole} में बदलें?',
  'team.changeRoleAdminGrant':
    'इससे उन्हें टीम सदस्य प्रबंधन की क्षमता सहित पूर्ण एडमिन अनुमतियां मिल जाएंगी।',
  'team.changeRoleAdminRemove':
    'इससे उनकी एडमिन अनुमतियां हट जाएंगी और वे अब टीम प्रबंधित नहीं कर पाएंगे।',
  'team.changing': 'बदल रहा है...',
  'team.changeRoleAction': 'भूमिका बदलें',
  'team.failedChangeRole': 'भूमिका बदलने में विफल',
  'team.failedRemoveMember': 'सदस्य को हटाने में विफल',
  'devOptions.title': 'एडवांस्ड',
  'devOptions.titleDiagnostics': 'डेवलपर और डायग्नोस्टिक्स',
  'devOptions.diagnostics': 'डायग्नोस्टिक्स',
  'devOptions.diagnosticsDesc': 'सिस्टम हेल्थ, लॉग्स और परफॉर्मेंस मेट्रिक्स',
  'devOptions.toolPolicyDiagnosticsDesc':
    'उपकरण सूची, नीति मुद्रा, MCP अनुमतिसूची, और हाल के ब्लॉक',
  'devOptions.toolPolicyDiagnostics.loading': 'लोड...',
  'devOptions.toolPolicyDiagnostics.unavailable': 'अनुपलब्ध',
  'devOptions.toolPolicyDiagnostics.posture.title': 'नीति',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': 'स्वायत्तता:',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': 'केवल कार्यक्षेत्र:',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour': 'अधिकतम क्रियाएँ/घंटा:',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': 'स्वीकृति (मध्यम जोखिम):',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': 'ब्लॉक उच्च जोखिम:',
  'devOptions.toolPolicyDiagnostics.inventory.title': 'सूची',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': 'कुल उपकरण',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': 'सक्षम उपकरण',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'MCP stdio उपकरण',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools': 'JSON',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'MCP',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary':
    'सक्षम: {enabled} · सर्वर: {enabledCount} / {totalCount}',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': '<अनाम>',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny':
    'अनुमति = {allowCount} इनकार = {denyCount}',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'MCP',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary': 'सक्षम: {enabled}',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': 'हाल ही में अवरुद्ध कॉल',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': 'कोई अवरुद्ध कॉल दर्ज नहीं किया गया।',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': 'निष्क्रिय सतहों',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary': 'लेखक: {writeCount}',
  'devOptions.debugPanels': 'डिबग पैनल',
  'devOptions.debugPanelsDesc': 'फीचर फ्लैग्स, स्टेट इंस्पेक्शन और डिबगिंग टूल्स',
  'devOptions.webhooks': 'वेबहुक्स',
  'devOptions.webhooksDesc': 'Webhook इंटीग्रेशन कॉन्फिगर और टेस्ट करें',
  'devOptions.memoryInspection': 'मेमोरी इंस्पेक्शन',
  'devOptions.memoryInspectionDesc': 'मेमोरी एंट्रीज़ ब्राउज़, क्वेरी और मैनेज करें',
  'voice.pushToTalk': 'पुश टू टॉक',
  'voice.recording': 'रिकॉर्डिंग हो रही है...',
  'voice.processing': 'प्रोसेस हो रहा है...',
  'voice.languageHint': 'भाषा',
  'misc.rehydrating': 'आपका डेटा लोड हो रहा है...',
  'misc.checkingServices': 'सर्विसेज़ चेक हो रही हैं...',
  'misc.serviceUnavailable': 'सर्विस उपलब्ध नहीं है',
  'misc.somethingWentWrong': 'कुछ गड़बड़ हो गई',
  'misc.tryAgainLater': 'कृपया बाद में कोशिश करें।',
  'misc.restartApp': 'ऐप रीस्टार्ट करें',
  'misc.updateAvailable': 'अपडेट उपलब्ध है',
  'misc.updateNow': 'अभी अपडेट करें',
  'misc.updateLater': 'बाद में',
  'misc.downloading': 'डाउनलोड हो रहा है...',
  'misc.installing': 'इन्स्टॉल हो रहा है...',
  'misc.beta':
    'OpenHuman अभी अर्ली बीटा में है। फीडबैक शेयर करें या कोई बग मिले तो रिपोर्ट करें: हर रिपोर्ट हमें तेज़ी से काम करने में मदद करती है।',
  'misc.betaFeedback': 'फीडबैक भेजें',
  'mnemonic.title': 'रिकवरी फ्रेज़',
  'mnemonic.warning': 'इन शब्दों को क्रम में लिखें और किसी सुरक्षित जगह रखें।',
  'mnemonic.copyWarning':
    'रिकवरी फ्रेज़ कभी किसी से शेयर न करें। इन शब्दों से कोई भी आपका अकाउंट एक्सेस कर सकता है।',
  'mnemonic.copied': 'रिकवरी फ्रेज़ क्लिपबोर्ड पर कॉपी हो गया',
  'mnemonic.reveal': 'फ्रेज़ दिखाएं',
  'mnemonic.revealPhrase': 'रिकवरी वाक्यांश दिखाएं',
  'mnemonic.hidden': 'रिकवरी फ्रेज़ छुपी हुई है',
  'privacy.title': 'प्राइवेसी और सिक्योरिटी',
  'privacy.description': 'बाहरी सर्विसेज़ को भेजे गए डेटा की ट्रांसपेरेंसी रिपोर्ट।',
  'privacy.empty': 'कोई बाहरी डेटा ट्रांसफर नहीं मिला।',
  'privacy.whatLeavesComputer': 'आपके कंप्यूटर से क्या जाता है',
  'privacy.loading': 'प्राइवेसी डिटेल्स लोड हो रही हैं...',
  'privacy.loadError':
    'लाइव प्राइवेसी लिस्ट लोड नहीं हो पाई। नीचे के एनालिटिक्स कंट्रोल अभी भी काम करते हैं।',
  'privacy.noCapabilities': 'अभी कोई कैपेबिलिटी डेटा मूवमेंट नहीं दिखा रही।',
  'privacy.sentTo': 'भेजा गया',
  'privacy.leavesDevice': 'डिवाइस से बाहर जाता है',
  'privacy.staysLocal': 'लोकल रहता है',
  'privacy.anonymizedAnalytics': 'प्रोडक्ट एनालिटिक्स',
  'privacy.shareAnonymizedData': 'प्रोडक्ट एनालिटिक्स और डायग्नॉस्टिक्स शेयर करें',
  'privacy.shareAnonymizedDataDesc':
    'प्राइवेसी-लिमिटेड क्रैश रिपोर्ट और यूसेज इवेंट शेयर करके OpenHuman को बेहतर बनाने में मदद करें, जिनमें स्थिर अकाउंट ID और ऐप वर्ज़न मेटाडेटा शामिल होता है। मैसेज, वॉलेट keys, API keys और सेशन tokens कभी कलेक्ट नहीं होते।',
  'privacy.meetingFollowUps': 'मीटिंग फॉलो-अप',
  'privacy.autoHandoffMeet': 'Google Meet ट्रांसक्रिप्ट ऑटो-हैंडऑफ ऑर्केस्ट्रेटर को करें',
  'privacy.autoHandoffMeetDesc':
    'Google Meet कॉल खत्म होने पर, OpenHuman का ऑर्केस्ट्रेटर ट्रांसक्रिप्ट पढ़ सकता है और मैसेज ड्राफ्ट करना, फॉलो-अप शेड्यूल करना या Slack पर सारांश पोस्ट करना जैसे काम कर सकता है। डिफ़ॉल्ट रूप से बंद है।',
  'privacy.analyticsDisclaimer':
    'चालू होने पर, प्रोडक्ट एनालिटिक्स और डायग्नॉस्टिक्स में प्राइवेसी-लिमिटेड क्रैश रिपोर्ट, यूसेज इवेंट, स्थिर अकाउंट ID और ऐप वर्ज़न मेटाडेटा शामिल हो सकते हैं। मैसेज, वॉलेट keys, API keys और सेशन tokens कभी कलेक्ट नहीं होते। यह सेटिंग कभी भी बदल सकते हैं।',
  'settings.about.version': 'वर्जन',
  'settings.about.updateAvailable': 'उपलब्ध है',
  'settings.about.softwareUpdates': 'सॉफ्टवेयर अपडेट',
  'settings.about.lastChecked': 'आखिरी बार चेक किया',
  'settings.about.checking': 'चेक हो रहा है...',
  'settings.about.checkForUpdates': 'अपडेट चेक करें',
  'settings.about.releases': 'रिलीज़',
  'settings.about.releasesDesc': 'GitHub पर रिलीज़ नोट्स और पुराने बिल्ड देखें।',
  'settings.about.openReleases': 'GitHub रिलीज़ खोलें',
  'settings.about.starCta.title': 'OpenHuman पसंद आ रहा है?',
  'settings.about.starCta.body': 'GitHub पर हमें स्टार दें। इससे और लोग हमें खोज पाते हैं।',
  'settings.about.starCta.star': 'GitHub पर स्टार करें',
  'settings.about.starCta.dismiss': 'अभी नहीं',
  'settings.about.connection': 'कनेक्शन',
  'settings.about.connectionMode': 'मोड',
  'settings.about.connectionModeLocal': 'स्थानीय',
  'settings.about.connectionModeCloud': 'बादल',
  'settings.about.connectionModeUnset': 'चयनित नहीं',
  'settings.about.serverUrl': 'सर्वर URL',
  'settings.about.serverUrlUnavailable': 'अनुपलब्ध',
  'settings.about.connectionHelperLocal':
    'ऐप लॉन्च पर Tauri शेल द्वारा इन-प्रोसेस का आयोजन किया गया। बंदरगाह को स्टार्टअप पर चुना जाता है, इसलिए प्रक्षेपण के बीच यह URL परिवर्तन होता है।',
  'settings.about.connectionHelperCloud':
    'एक दूरस्थ कोर से जुड़ा हुआ है। इसे बूट चेक या क्लाउड मोड पिकर में बदलें।',
  'settings.heartbeat.title': 'दिल की धड़कन और लूप',
  'settings.usage.title': 'उपयोग और सीमाएँ',
  'settings.usage.menuDesc': 'लागत, टोकन उपयोग, बजट और पृष्ठभूमि गतिविधि',
  'settings.costDashboard.title': 'कॉस्ट डैशबोर्ड',
  'settings.costDashboard.sevenDayCost': '7 दिन दैनिक लागत',
  'settings.costDashboard.sevenDayTokens': '7 दिन टोकन उपयोग',
  'settings.costDashboard.totalSpend': '7 दिन कुल',
  'settings.costDashboard.monthlyPace': 'मासिक गति',
  'settings.costDashboard.budgetLimit': 'बजट सीमा',
  'settings.costDashboard.utilization': 'उपयोगिता',
  'settings.costDashboard.modelBreakdown': 'प्रति मॉडल ब्रेकडाउन',
  'settings.costDashboard.model': 'मॉडल',
  'settings.costDashboard.provider': 'प्रदाता',
  'settings.costDashboard.cost': 'लागत',
  'settings.costDashboard.tokens': 'टोकन',
  'settings.costDashboard.requests': 'अनुरोध',
  'settings.costDashboard.percentOfTotal': 'कुल का%',
  'settings.costDashboard.inputTokens': 'इनपुट',
  'settings.costDashboard.outputTokens': 'उत्पादन',
  'settings.costDashboard.budgetNormal': 'ट्रैक पर',
  'settings.costDashboard.budgetWarning': 'चेतावनी',
  'settings.costDashboard.budgetExceeded': 'बजट',
  'settings.costDashboard.noBudget': 'कोई सीमा नहीं',
  'settings.costDashboard.noData': 'पिछले 7 दिनों के लिए अभी तक कोई लागत दर्ज नहीं हुई है।',
  'settings.costDashboard.noModels': 'पिछले 7 दिनों में कोई मॉडल गतिविधि नहीं।',
  'settings.costDashboard.loading': 'लागत डैशबोर्ड लोड हो रहा है...',
  'settings.costDashboard.disabledHint':
    'लागत डैशबोर्ड विन्यास में अक्षम है। सेट [cost.dashboard] सक्षम = config.toml में फिर से सक्षम करने के लिए सही।',
  'settings.costDashboard.subtitle':
    'लाइव खर्च और टोकन पूरे झुंड में जलाते हैं। बार्स ऑटो रिफ्रेश हर कुछ सेकंड - कोई पेज पुनः लोड की जरूरत है।',
  'settings.costDashboard.summaryAriaLabel': 'लागत सारांश मीट्रिक',
  'settings.costDashboard.lastSevenDays': 'पिछले 7 दिनों',
  'settings.costDashboard.utilizationOf': 'of',
  'settings.costDashboard.thisMonth': 'इस माह',
  'settings.costDashboard.monthlyPaceHint':
    'वर्तमान दैनिक रन-रेट (avg × 30) पर अनुमानित मासिक खर्च।',
  'settings.costDashboard.budgetLimitHint':
    'config.toml में cost.monthly_limit_usd से मासिक बजट पढ़ा गया।',
  'settings.costDashboard.dailyTarget': 'दैनिक लक्ष्य',
  'settings.costDashboard.today': 'आज',
  'settings.costDashboard.todayBadge': 'TODAY',
  'settings.costDashboard.unknownProvider': 'कोई नहीं',
  'settings.costDashboard.justNow': 'अभी',
  'settings.costDashboard.secondsAgo': '{value} पहले',
  'settings.costDashboard.minutesAgo': '{value} m पहले',
  'settings.costDashboard.hoursAgo': '{value} h पहले',
  'settings.costDashboard.daysAgo': '{value} d पहले',
  'settings.costDashboard.updated': 'अद्यतन',
  'settings.costDashboard.refresh': 'ताज़ा',
  'settings.costDashboard.utcNote': 'UTC में दिन की बाल्टी',
  'settings.costDashboard.stackedNote': 'इनपुट + आउटपुट स्टैक्ड',
  'settings.costDashboard.modelBreakdownHint': 'पिछले 7 दिनों में एकत्र हुआ।',
  'settings.costDashboard.categoryDistribution': 'श्रेणी के अनुसार खर्च',
  'settings.costDashboard.categoryDistributionHint':
    'हाल के चैट, एम्बेडिंग, वॉइस, इमेज और री-रैंकिंग कॉल रिकॉर्ड से अनुमानित।',
  'settings.costDashboard.noCategories': 'अभी तक कोई श्रेणी खर्च दर्ज नहीं है।',
  'settings.costDashboard.categoryMeta': '{requests} अनुरोध • {tokens} टोकन',
  'settings.costDashboard.usageLog': 'उपयोग लॉग',
  'settings.costDashboard.usageLogHint':
    'पिछले {days} दिनों के नवीनतम रिकॉर्ड, {limit} पंक्तियों तक सीमित।',
  'settings.costDashboard.logTotal': '{requests} अनुरोध • {cost}',
  'settings.costDashboard.noUsageLog': 'इस अवधि के लिए कोई उपयोग रिकॉर्ड नहीं मिला।',
  'settings.costDashboard.when': 'कब',
  'settings.costDashboard.category': 'श्रेणी',
  'settings.costDashboard.session': 'सत्र',
  'settings.costDashboard.noDataHint':
    'एक एजेंट संदेश भेजें - अगले प्रदाता कॉल से टोकन का उपयोग ~ 10 सेकंड के भीतर चार्ट को पॉप्युलेट करेगा।',
  'settings.search.title': 'खोज इंजन',
  'settings.search.menuDesc':
    'डिफ़ॉल्ट to OpenHuman -एक API कुंजी के साथ अपने स्वयं के प्रदाता को प्रबंधित खोज या तार करना।',
  'settings.search.description':
    'एजेंट द्वारा उपयोग किए जाने वाले सर्च इंजन को चुनें, या सर्च टूल्स को पूरी तरह बंद करें। Managed, OpenHuman के बैकएंड का उपयोग करता है (कोई सेटअप नहीं)। Parallel, Brave, Querit, और Exa आपकी API key का उपयोग करके सीधे आपकी मशीन से चलते हैं।',
  'settings.search.engineAria': 'खोज इंजन',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc': 'एजेंट संदर्भ और उपलब्ध टूल सूची से खोज टूल हटाएं।',
  'settings.search.engineManagedLabel': 'OpenHuman प्रबंधित',
  'settings.search.engineManagedDesc':
    'डिफ़ॉल्ट। OpenHuman बैक-एंड के माध्यम से रूट किया जाता है, वर्तमान में Exa द्वारा संचालित: किसी API key की आवश्यकता नहीं।',
  'settings.search.localManagedUnavailable':
    'लोकल उपयोगकर्ताओं के लिए OpenHuman Managed search उपलब्ध नहीं है। वेब सर्च चालू करने के लिए अपनी Parallel, Brave, Querit या Exa API key जोड़ें।',
  'settings.search.engineParallelLabel': 'Parallel',
  'settings.search.engineParallelDesc':
    'डायरेक्ट Parallel API: खोज, निकालने, चैट, अनुसंधान, समृद्ध, डेटासेट उपकरण।',
  'settings.search.engineBraveLabel': 'Brave खोजें',
  'settings.search.engineBraveDesc': 'प्रत्यक्ष Brave खोजें API: वेब, समाचार, छवि और वीडियो उपकरण।',
  'settings.search.engineQueritLabel': 'क्वेर्ट',
  'settings.search.engineQueritDesc':
    'प्रत्यक्ष Querit API: साइट, समय सीमा, देश और भाषा फिल्टर के साथ वेब खोज।',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    'Exa द्वारा संचालित न्यूरल सर्च। इसके लिए आपकी अपनी Exa API key आवश्यक है। सर्च, मिलते-जुलते पेज खोजने और पेज सामग्री लाने के टूल जोड़ता है।',
  'settings.search.statusConfigured': 'विन्यस्त',
  'settings.search.statusNeedsKey': 'API कुंजी की आवश्यकता है',
  'settings.search.fallbackToManaged':
    'कोई कुंजी विन्यस्त - खोज एक कुंजी सहेजा जाता है जब तक प्रबंधित करने के लिए वापस गिर जाएगा।',
  'settings.search.getApiKey': 'API कुंजी प्राप्त करें',
  'settings.search.save': 'सहेजें',
  'settings.search.clear': 'स्पष्ट',
  'settings.search.show': 'दिखाओ',
  'settings.search.hide': 'छिपाओ',
  'settings.search.statusSaving': 'सहेजा जा रहा है...',
  'settings.search.statusSaved': 'सहेजा गया.',
  'settings.search.statusError': 'असफल',
  'settings.search.parallelKeyLabel': 'Parallel API कुंजी',
  'settings.search.braveKeyLabel': 'Brave API कुंजी खोजें',
  'settings.search.queritKeyLabel': 'क्वेरिट API कुंजी',
  'settings.search.exaKeyLabel': 'Exa API कुंजी',
  'settings.search.placeholderStored': '•••••••• (संग्रहीत)',
  'settings.search.placeholderParallel': 'पीके_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'क्वेरिट API कुंजी',
  'settings.search.placeholderExa': 'अपनी Exa API कुंजी पेस्ट करें…',
  'settings.search.allowedSitesLabel': 'अनुमत वेबसाइटों',
  'settings.search.allowedSitesHint':
    'उन होस्ट को सूचीबद्ध करें जिन्हें असिस्टेंट खोल और पढ़ सकता है (वेब फ़ेच और ब्राउज़र टूल के माध्यम से), प्रति पंक्ति एक, जैसे reuters.com। एक होस्ट में उसके सभी सबडोमेन भी शामिल होते हैं। वेब सर्च स्वयं इस सूची से प्रतिबंधित नहीं है।',
  'settings.search.allowedSitesAllOn':
    'सहायक किसी भी सार्वजनिक वेबसाइट को खोल सकता है। स्थानीय और निजी पते अवरुद्ध रहते हैं।',
  'settings.search.allowedSitesPlaceholder': 'reuters.com\napnews.com\ngithub.com',
  'settings.search.allowedSitesSave': 'वेबसाइट सहेजें',
  'settings.search.accessModeAria': 'वेब एक्सेस मोड',
  'settings.search.accessAllowAll': 'सभी को अनुमति दें',
  'settings.search.accessCustom': 'कस्टम',
  'settings.search.accessBlockAll': 'सभी को ब्लॉक करें',
  'settings.search.accessBlockAllHint':
    'सभी वेब एक्सेस अवरुद्ध है - सहायक किसी भी वेबसाइट को खोल या पढ़ नहीं सकता है।',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': 'सेटिंग खोजें…',
  'settings.settingsSearch.ariaLabel': 'सेटिंग खोजें',
  'settings.settingsSearch.clear': 'खोज साफ़ करें',
  'settings.settingsSearch.resultsLabel': 'खोज परिणाम',
  'settings.settingsSearch.noResults': '“{query}” के लिए कोई सेटिंग नहीं मिली',
  'settings.embeddings.title': 'एम्बेडिंग्स',
  'settings.embeddings.description':
    'चुनें कि कौन सा एम्बेडिंग प्रदाता मेमोरी को सिमेंटिक सर्च के लिए वेक्टर में बदलता है। प्रदाता, मॉडल या आयाम बदलने से संग्रहीत वेक्टर अमान्य हो जाते हैं और पूर्ण मेमरी रीसेट की आवश्यकता होती है।',
  'settings.embeddings.providerAria': 'एम्बेडिंग प्रदाता',
  'settings.embeddings.statusConfigured': 'कॉन्फ़िगर किया गया',
  'settings.embeddings.statusNeedsKey': 'API कुंजी चाहिए',
  'settings.embeddings.requiresSignIn': 'OpenHuman साइन-इन आवश्यक',
  'settings.embeddings.managedLoginRequired':
    'प्रबंधित एम्बेडिंग के लिए OpenHuman साइन-इन आवश्यक है। OpenHuman बैकएंड का उपयोग करने के लिए साइन इन करें।',
  'settings.embeddings.managedBannerIntro':
    'प्रबंधित एम्बेडिंग OpenHuman बैकएंड से होकर चलते हैं और OpenHuman खाता सत्र की आवश्यकता होती है।',
  'settings.embeddings.managedBannerLocalSession':
    'इस प्रदाता का उपयोग करने के लिए स्थानीय सत्र से बाहर निकलें और साइन इन करें, या स्थानीय/अपनी-कुंजी वाले एम्बेडिंग प्रदाता पर स्विच करें।',
  'settings.embeddings.managedBannerRemoteSession':
    'अपने OpenHuman सत्र को रीफ़्रेश करने के लिए फिर से साइन इन करें, या स्थानीय/अपनी-कुंजी वाले एम्बेडिंग प्रदाता पर स्विच करें।',
  'settings.embeddings.signInAgain': 'फिर से साइन इन करें',
  'settings.embeddings.apiKeyLabel': '{provider} API कुंजी',
  'settings.embeddings.apiKeyLabelGeneric': 'API कुंजी',
  'settings.embeddings.placeholderStored': '•••••••• (संग्रहीत)',
  'settings.embeddings.placeholderKey': 'अपनी API कुंजी पेस्ट करें…',
  'settings.embeddings.keyStoredEncrypted':
    'आपकी API कुंजी इस डिवाइस पर एन्क्रिप्टेड स्टोर की गई है।',
  'settings.embeddings.show': 'दिखाएँ',
  'settings.embeddings.hide': 'छिपाएँ',
  'settings.embeddings.save': 'सहेजें',
  'settings.embeddings.clear': 'साफ़ करें',
  'settings.embeddings.model': 'मॉडल',
  'settings.embeddings.dimensions': 'आयाम',
  'settings.embeddings.customEndpoint': 'कस्टम एंडपॉइंट',
  'settings.embeddings.customModelPlaceholder': 'मॉडल का नाम',
  'settings.embeddings.customDimsPlaceholder': 'आयाम',
  'settings.embeddings.applyCustom': 'लागू करें',
  'settings.embeddings.testConnection': 'कनेक्शन परीक्षण',
  'settings.embeddings.testing': 'परीक्षण हो रहा है…',
  'settings.embeddings.testSuccess': 'कनेक्ट: {dims} आयाम',
  'settings.embeddings.connectionTestFailed': 'परीक्षण विफल',
  'settings.embeddings.verifyFallback':
    'एम्बेडिंग एंडपॉइंट सत्यापित नहीं किया जा सका। सुनिश्चित करें कि यह चल रहा है और एक एम्बेडिंग मॉडल प्रदान कर रहा है, फिर दोबारा सहेजें।',
  'settings.embeddings.testFailed': 'विफल: {error}',
  'settings.embeddings.saving': 'सहेजा जा रहा है…',
  'settings.embeddings.saved': 'सहेजा गया।',
  'settings.embeddings.errorPrefix': 'विफल',
  'settings.embeddings.wipeTitle': 'मेमोरी वेक्टर रीसेट करें?',
  'settings.embeddings.wipeBody':
    'एम्बेडिंग प्रदाता, मॉडल या आयाम बदलने से सभी संग्रहीत मेमोरी वेक्टर मिट जाएंगे। पुनर्प्राप्ति फिर से काम करने से पहले मेमोरी को फिर से बनाना होगा। यह पूर्ववत नहीं किया जा सकता।',
  'settings.embeddings.cancel': 'रद्द करें',
  'settings.embeddings.confirmWipe': 'मिटाएँ और लागू करें',
  'settings.embeddings.setupTitle': '{provider} सेटअप',
  'settings.embeddings.saveAndSwitch': 'सहेजें और बदलें',
  'settings.embeddings.optional': 'वैकल्पिक',
  'settings.embeddings.vectorSearchDisabled':
    'वेक्टर खोज अक्षम है। मेमोरी रिकॉल केवल कीवर्ड मेलिंग और रीसेंसी का उपयोग करेगा - कोई सेमैनेटिक रैंकिंग नहीं।',
  'settings.embeddings.clearKey': 'API कुंजी साफ़ करें',
  'pages.settings.ai.embeddings': 'एम्बेडिंग्स',
  'pages.settings.ai.embeddingsDesc': 'मेमोरी पुनर्प्राप्ति के लिए वेक्टर एन्कोडिंग मॉडल',
  'mcp.alphaBadge': 'अल्फ़ा',
  'mcp.alphaBannerText':
    'MCP सर्वर समर्थन प्रारंभिक अल्फा में है। स्मिथरी रजिस्ट्री, प्रवाह स्थापित करने और उपकरण तारों को रिलीज के बीच आकार बदलने या बदल सकता है।',
  'mcp.toolList.noTools': 'कोई उपकरण उपलब्ध नहीं.',
  'mcp.setup.secretDialog.title': 'MCP सेटअप - गुप्त दर्ज करें',
  'mcp.setup.secretDialog.bodyPrefix': 'MCP सेटअप एजेंट की आवश्यकता है',
  'mcp.setup.secretDialog.bodySuffix':
    '। आपका मान सीधे कोर प्रक्रिया को भेजा जाता है और AI वार्तालाप में कभी नहीं जाता।',
  'mcp.setup.secretDialog.inputLabel': 'मूल्य',
  'mcp.setup.secretDialog.inputPlaceholder': 'यहाँ चिपकाएँ',
  'mcp.setup.secretDialog.show': 'दिखाओ',
  'mcp.setup.secretDialog.hide': 'छिपाओ',
  'mcp.setup.secretDialog.submit': 'सबमिट करें',
  'mcp.setup.secretDialog.cancel': 'रद्द करें',
  'mcp.setup.secretDialog.submitting': 'सबमिट किया जा रहा है...',
  'mcp.setup.secretDialog.errorPrefix': 'सबमिट करने में विफल:',
  'mcp.setup.secretDialog.privacyNote':
    'स्थानीय MCP रहस्य तालिका में संग्रहीत एन्क्रिप्टेड। कभी लॉग किया या एक मॉडल के लिए भेजा।',
  'devices.betaBadge': 'बीटा',
  'devices.betaText':
    'यह सुविधा अभी बीटा में है। इस OpenHuman से iOS फ़ोन जोड़ें और उन्हें रिमोट क्लाइंट के रूप में उपयोग करें।',
  'devices.comingSoonDescription':
    'डिवाइस पेयरिंग जल्द आ रही है। यह पेज iPhone पेयर करने और जुड़े हुए डिवाइस प्रबंधित करने का स्थान होगा।',
  'devices.title': 'उपकरण',
  'devices.pairIphone': 'iPhone युग्मित करें',
  'devices.noPaired': 'कोई युग्मित डिवाइस नहीं',
  'devices.emptyState': 'अपने iPhone पर QR कोड स्कैन करें और इसे इस OpenHuman सत्र से जोड़ें।',
  'devices.devicePairedTitle': 'डिवाइस युग्मित',
  'devices.devicePairedMessage': 'iPhone सफलतापूर्वक कनेक्ट हुआ.',
  'devices.deviceRevokedTitle': 'डिवाइस निरस्त कर दिया गया',
  'devices.deviceRevokedMessage': '{label} हटा दिया गया.',
  'devices.revokeFailedTitle': 'निरस्त करना विफल रहा',
  'devices.online': 'ऑनलाइन',
  'devices.offline': 'ऑफ़लाइन',
  'devices.lastSeenNever': 'कभी नहीं',
  'devices.lastSeenNow': 'अभी अभी',
  'devices.lastSeenMinutes': '{count}m पहले',
  'devices.lastSeenHours': '{count}h पहले',
  'devices.lastSeenDays': '{count}d पहले',
  'devices.revoke': 'निरस्त करें',
  'devices.revokeAria': 'निरस्त करें{label}',
  'devices.confirmRevokeTitle': 'डिवाइस निरस्त करें?',
  'devices.confirmRevokeBody': '{label} अब कनेक्ट नहीं कर पाएगा। इसे वापस नहीं किया जा सकता।',
  'devices.loadFailed': 'डिवाइस लोड करने में विफल: {message}',
  'devices.pairModal.title': 'iPhone युग्मित करें',
  'devices.pairModal.loading': 'युग्मन कोड जनरेट किया जा रहा है...',
  'devices.pairModal.instructions': 'अपने iPhone पर OpenHuman ऐप खोलें और इस कोड को स्कैन करें।',
  'devices.pairModal.expiresIn': 'कोड ~{count} मिनट में समाप्त हो जाता है',
  'devices.pairModal.expiresInPlural': 'कोड ~{count} मिनट में समाप्त हो जाता है',
  'devices.pairModal.showDetails': 'विवरण दिखाएँ',
  'devices.pairModal.hideDetails': 'विवरण छिपाएँ',
  'devices.pairModal.channelId': 'चैनल आईडी',
  'devices.pairModal.pairingUrl': 'जोड़ना URL',
  'devices.pairModal.expiredTitle': 'QR code समाप्त हो गया',
  'devices.pairModal.expiredBody': 'युग्मन जारी रखने के लिए एक नया कोड जनरेट करें.',
  'devices.pairModal.generateNewCode': 'नया कोड जनरेट करें',
  'devices.pairModal.successTitle': 'iPhone के साथ युग्मित',
  'devices.pairModal.autoClose': 'स्वचालित रूप से बंद हो रहा है...',
  'devices.pairModal.errorPrefix': 'युग्मन बनाने में विफल: {message}',
  'devices.pairModal.errorTitle': 'कुछ ग़लत हो गया',
  'devices.pairModal.copyUrl': 'प्रतिलिपि',
  'mcp.catalog.searchAria': 'स्मिथेरी कैटलॉग खोजें',
  'mcp.catalog.searchPlaceholder': 'स्मिथरी कैटलॉग खोजें...',
  'mcp.catalog.loadFailed': 'कैटलॉग लोड करने में विफल',
  'mcp.registry.error.notFound':
    'रजिस्ट्री में सर्वर नहीं मिला। सर्वर का नाम जांचकर फिर कोशिश करें, उपलब्ध MCP सर्वर ब्राउज करें, या URL से सर्वर को मैन्युअल रूप से जोड़ें।',
  'mcp.registry.error.network':
    'MCP रजिस्ट्री तक नहीं पहुंचा जा सका। अपना कनेक्शन जांचकर फिर कोशिश करें, या URL से सर्वर को मैन्युअल रूप से जोड़ें।',
  'mcp.registry.error.unavailable':
    'MCP रजिस्ट्री अभी उपलब्ध नहीं है। बाद में फिर कोशिश करें, उपलब्ध MCP सर्वर ब्राउज करें, या URL से सर्वर को मैन्युअल रूप से जोड़ें।',
  'mcp.catalog.noResults': 'कोई सर्वर नहीं मिला.',
  'mcp.catalog.noResultsFor': '"{query}" के लिए कोई सर्वर नहीं मिला।',
  'mcp.catalog.loadMore': 'और अधिक लोड करें',
  'mcp.configAssistant.title': 'कॉन्फ़िगरेशन सहायक',
  'mcp.configAssistant.empty': 'कॉन्फ़िगरेशन, आवश्यक एनवी वर्र्स या सेटअप चरणों के बारे में पूछें।',
  'mcp.configAssistant.autoPromptCta': 'चरण-दर-चरण सेटअप सहायता प्राप्त करें',
  'mcp.configAssistant.suggestedValues': 'सुझाए गए मान:',
  'mcp.configAssistant.valueHidden': '(मूल्य छिपा हुआ)',
  'mcp.configAssistant.applySuggested': 'सुझाए गए मान लागू करें',
  'mcp.configAssistant.reinstallHint': 'इन्हें लागू करने के लिए इन मानों के साथ पुनः स्थापित करें।',
  'mcp.configAssistant.thinking': 'सोच रहा हूँ...',
  'mcp.configAssistant.inputPlaceholder': 'एक सवाल पूछो (Enter to send, Shift+Enter for newline)',
  'mcp.configAssistant.send': 'भेजें',
  'mcp.configAssistant.failedResponse': 'प्रतिक्रिया प्राप्त करने में विफल',
  'mcp.toolList.availableSingular': '{count} उपकरण उपलब्ध है',
  'mcp.toolList.availablePlural': '{count} उपकरण उपलब्ध हैं',
  'mcp.toolList.tryTool': 'कोशिश करो',
  'mcp.toolList.tryToolAria': '{name} के लिए खुला निष्पादन खेल का मैदान',
  'mcp.playground.title': 'रन {name}',
  'mcp.playground.close': 'खेल का मैदान बंद',
  'mcp.playground.inputSchema': 'इनपुट स्कीमा',
  'mcp.playground.argsLabel': 'तर्क (JSON)',
  'mcp.playground.argsHelp':
    'टाइप JSON इनपुट स्कीमा से मेल खाते हैं। खाली इनपुट को {} के रूप में माना जाता है।',
  'mcp.playground.runShortcut': '⌘/Ctrl + Enter चलाने के लिए',
  'mcp.playground.format': 'प्रारूप',
  'mcp.playground.invalidJson': 'JSON',
  'mcp.playground.run': 'रन टूल',
  'mcp.playground.running': 'दौड़ना...',
  'mcp.playground.result': 'परिणाम',
  'mcp.playground.resultError': 'टूल एक त्रुटि लौटा',
  'mcp.playground.copyResult': 'कॉपी परिणाम',
  'mcp.playground.copied': 'Copied',
  'mcp.playground.history': 'इतिहास',
  'mcp.playground.historyEmpty': 'इस सत्र में अभी तक कोई चालान नहीं है।',
  'mcp.playground.historyLoad': 'लोड',
  'mcp.playground.unexpectedError': 'अनपेक्षित त्रुटि चालान उपकरण।',
  'mcp.catalog.deployed': 'तैनात',
  'mcp.catalog.installCount': '{count} इंस्टॉल होता है',
  'app.update.dismissNotification': 'अद्यतन अधिसूचना ख़ारिज करें',
  'bootCheck.rpcAuthSuffix': 'प्रत्येक RPC पर।',
  'app.localAiDownload.expandAria': 'डाउनलोड प्रगति का विस्तार करें',
  'app.localAiDownload.collapseAria': 'डाउनलोड प्रगति को संक्षिप्त करें',
  'app.localAiDownload.dismissAria': 'डाउनलोड अधिसूचना ख़ारिज करें',
  'mobile.nav.ariaLabel': 'मोबाइल नेविगेशन',
  'progress.stepsAria': 'प्रगति के चरण',
  'progress.stepAria': '{total} का चरण {current}',
  'workspace.vaultsTitle': 'ज्ञान भंडार',
  'workspace.vaultsDesc':
    'किसी स्थानीय फ़ोल्डर पर इंगित करें; फ़ाइलें खंडित हो जाती हैं और स्मृति में प्रतिबिंबित हो जाती हैं।',
  'calls.title': 'कॉल',
  'calls.comingSoonBody': 'एआई-सहायक कॉल जल्द ही आ रही हैं। बने रहें।',
  'art.rotatingTetrahedronAria': 'घूमता हुआ उलटा टेट्राहेड्रोन अंतरिक्ष यान',
  'mcp.installed.title': 'स्थापित',
  'mcp.installed.browseCatalog': 'कैटलॉग ब्राउज़ करें',
  'mcp.installed.empty': 'अभी तक कोई MCP सर्वर स्थापित नहीं है।',
  'mcp.installed.toolSingular': '{count} उपकरण',
  'mcp.installed.toolPlural': '{count} उपकरण',
  'mcp.health.title': 'स्वास्थ्य',
  'mcp.health.summaryAria': 'MCP कनेक्शन स्वास्थ्य सारांश',
  'mcp.health.connectedCount': '{count} कनेक्ट',
  'mcp.health.connectingCount': '{count} कनेक्ट',
  'mcp.health.errorCount': '{count} त्रुटि',
  'mcp.health.disconnectedCount': '{count} निष्क्रिय',
  'mcp.health.retryAll': 'सभी ({count})',
  'mcp.health.retryAllAria': 'Retry सभी {count} त्रुटि MCP सर्वर',
  'mcp.health.disconnectAll': 'सभी को अलग करें ({count})',
  'mcp.health.disconnectAllAria': 'सभी {count} कनेक्ट किए गए MCP सर्वर को डिस्कनेक्ट करें',
  'mcp.health.disconnectConfirm.title': 'सभी MCP सर्वर को डिस्कनेक्ट करें?',
  'mcp.health.disconnectConfirm.body':
    'यह वर्तमान में कनेक्टेड MCP सर्वर को डिस्कनेक्ट करेगा। स्थापित विन्यास और रहस्यों को रखा जाता है; आप बाद में किसी भी सर्वर को फिर से कनेक्ट कर सकते हैं।',
  'mcp.health.disconnectConfirm.cancel': 'रद्द करना',
  'mcp.health.disconnectConfirm.confirm': 'सभी को अलग करें',
  'mcp.health.opErrorGeneric': 'थोक ऑपरेशन विफल रहा। लॉग देखें',
  'mcp.health.bulkPartialFailure': '{total} में से {failed} सर्वर विफल हुए। लॉग देखें।',
  'mcp.installed.search.landmarkAria': 'खोज स्थापित MCP सर्वर',
  'mcp.installed.search.inputAria': 'नाम से फ़िल्टर स्थापित MCP सर्वर',
  'mcp.installed.search.placeholder': 'फिल्टर सर्वर...',
  'mcp.installed.search.clearAria': 'साफ़ फिल्टर',
  'mcp.installed.search.countMatches': '{total} सर्वर के {shown}',
  'mcp.installed.search.noMatches': 'कोई सर्वर "{query}" से मेल खाता है।',
  'mcp.inventory.openButton': 'सूची',
  'mcp.inventory.openAria': 'Sharable MCP सूची पैनल खोलें',
  'mcp.inventory.title': 'Sharable MCP इन्वेंटरी',
  'mcp.inventory.subtitle':
    'अपने स्थापित MCP सर्वर को पोर्टेबल, गुप्त-मुक्त प्रकटन के रूप में निर्यात करें, या एक टीममेट से आयात करें। गुप्त env मूल्यों को कभी भी शामिल या आयात नहीं किया जाता है।',
  'mcp.inventory.close': 'बंद सूची पैनल',
  'mcp.inventory.tablistAria': 'सूची',
  'mcp.inventory.tab.export': 'निर्यात',
  'mcp.inventory.tab.import': 'आयात',
  'mcp.inventory.export.empty':
    'नहीं MCP सर्वर अभी तक स्थापित - निर्यात करने के लिए कुछ भी नहीं। पहले सूची में से एक स्थापित करें।',
  'mcp.inventory.export.privacyTitle': 'यह क्या है',
  'mcp.inventory.export.privacyBody':
    'सर्वर नाम, योग्य नाम, env-variable KEY NAMES, और गैर-secret config केवल। गुप्त मूल्य, आपकी मशीन पहचानकर्ता, और प्रति-स्थापित टाइमस्टैम्प जानबूझकर छीन रहे हैं।',
  'mcp.inventory.export.serverCount': 'इस घोषणा में {count} सर्वर',
  'mcp.inventory.export.copy': 'कॉपी',
  'mcp.inventory.export.copied': 'Copied',
  'mcp.inventory.export.copyAria': 'JSON को क्लिपबोर्ड पर कॉपी करें',
  'mcp.inventory.export.download': 'डाउनलोड',
  'mcp.inventory.export.downloadAria': 'JSON फ़ाइल के रूप में प्रकट होने को डाउनलोड करें',
  'mcp.inventory.import.trustTitle': 'आयातित मेनिफेस्ट को अविश्वसनीय कोड के रूप में मानें',
  'mcp.inventory.import.trustBody':
    'एक MCP सर्वर एक ऐसा उपकरण है जिसे आप अपना एजेंट देते हैं। केवल आयात उन स्रोतों से प्रकट होता है जिन्हें आप rust कहते हैं। प्रत्येक स्थापना के लिए आपके स्पष्ट क्लिक की आवश्यकता होती है; कोई भी ऑटो-इंस्टॉल नहीं है।',
  'mcp.inventory.import.pasteLabel': 'पेस्ट करें प्रकटन JSON',
  'mcp.inventory.import.pastePlaceholder':
    'यहाँ एक प्रकट पेस्ट करें, या नीचे एक.json फ़ाइल अपलोड करें।',
  'mcp.inventory.import.preview': 'पूर्वावलोकन',
  'mcp.inventory.import.clear': 'स्पष्ट',
  'mcp.inventory.import.uploadFile': 'फ़ाइल अपलोड करें',
  'mcp.inventory.import.uploadFileAria': 'एक प्रकटन फ़ाइल अपलोड करें',
  'mcp.inventory.import.fileTooLarge': 'फ़ाइल बहुत बड़ी है (1 MB से अधिक)। लोड हो रहा है।',
  'mcp.inventory.import.fileReadFailed': 'फ़ाइल नहीं पढ़ा जा सकता।',
  'mcp.inventory.import.parseErrorPrefix': 'प्रकट नहीं हो सकता:',
  'mcp.inventory.import.previewHeading': 'पूर्वावलोकन',
  'mcp.inventory.import.previewCounts': '{total} सर्वर - {newly} नया, {already} पहले से ही स्थापित',
  'mcp.inventory.import.previewEmpty': 'मैनिफेस्ट में कोई सर्वर नहीं है।',
  'mcp.inventory.import.exportedFrom': '{exporter}',
  'mcp.inventory.import.exportedAt': '{when}',
  'mcp.inventory.import.statusNew': 'नया',
  'mcp.inventory.import.statusAlreadyInstalled': 'पहले से ही स्थापित',
  'mcp.inventory.import.envKeysLabel': 'एनवी कुंजी',
  'mcp.inventory.import.install': 'स्थापित करना',
  'mcp.inventory.import.installAria': 'इस घोषणा से {name} स्थापित करें',
  'mcp.inventory.import.skipped': 'छीनना',
  'mcp.inventory.parseError.empty': 'मैनिफेस्ट खाली है।',
  'mcp.inventory.parseError.invalidJson': 'अमान्य JSON।',
  'mcp.inventory.parseError.rootNotObject': 'Manifest रूट पर एक JSON वस्तु होना चाहिए।',
  'mcp.inventory.parseError.unsupportedSchema':
    'अनसमर्थित घोषणा स्कीमा - यह फ़ाइल एक संगत निर्यातक द्वारा उत्पादित नहीं की गई थी।',
  'mcp.inventory.parseError.missingExportedAt': 'मिसिंग या अमान्य `exported_at` क्षेत्र।',
  'mcp.inventory.parseError.missingExportedBy': 'मिसिंग या अमान्य `exported_by` क्षेत्र।',
  'mcp.inventory.parseError.invalidServers': 'मिसिंग या अवैध `servers` सरणी।',
  'mcp.inventory.parseError.serverNotObject': 'सर्वर प्रविष्टि एक वस्तु नहीं है।',
  'mcp.inventory.parseError.serverMissingQualifiedName':
    'एक सर्वर प्रविष्टि अपने योग्य नाम लापता है।',
  'mcp.inventory.parseError.serverMissingDisplayName':
    'सर्वर प्रविष्टि अपने display name लापता है।',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    'सर्वर प्रविष्टि में एक env keys क्षेत्र है जो स्ट्रिंग्स की एक सरणी नहीं है।',
  'mcp.inventory.parseError.serverContainsEnv':
    'सर्वर प्रविष्टि में `env` मान मानचित्र होता है। आयात करने के लिए इनकार - प्रकट होता है केवल env keys (नाम) लेना चाहिए, कभी गुप्त मान नहीं होना चाहिए।',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'डुप्लिकेट योग्य नाम प्रकट होने में पाया गया। प्रत्येक सर्वर को एक बार में प्रदर्शित होना चाहिए।',
  'mcp.tab.loading': 'MCP सर्वर लोड हो रहा है...',
  'mcp.tab.emptyDetail': 'एक सर्वर चुनें या कैटलॉग ब्राउज़ करें।',
  'mcp.tab.filter.all': 'सभी',
  'mcp.tab.filter.installed': 'इंस्टॉल किए गए ({count})',
  'mcp.tab.filter.registry': 'रजिस्ट्री',
  'mcp.tab.column.name': 'नाम',
  'mcp.tab.column.description': 'विवरण',
  'mcp.tab.column.type': 'प्रकार',
  'mcp.tab.column.author': 'लेखक',
  'mcp.tab.column.action': 'क्रिया',
  'mcp.tab.transport.hosted': 'होस्टेड',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': 'प्रकार',
  'mcp.tab.transportFilter.aria': 'ट्रांसपोर्ट के अनुसार सर्वर फ़िल्टर करें',
  'mcp.tab.link.website': 'वेबसाइट',
  'mcp.tab.link.repo': 'रिपॉज़िटरी',
  'mcp.tab.transport.hostedHint':
    'दूरस्थ सर्वर पर चलता है: इंस्टॉल करते समय साइन-इन या टोकन सेट किया जाता है',
  'mcp.tab.transport.localHint':
    'आपके डिवाइस पर चलता है: इंस्टॉल करते समय टोकन की ज़रूरत हो सकती है',
  'mcp.tab.officialBadge': 'आधिकारिक',
  'mcp.tab.officialHint': 'वेंडर का आधिकारिक सर्वर',
  'mcp.tab.badge.installed': 'इंस्टॉल किया गया',
  'mcp.tab.badge.registry': 'रजिस्ट्री',
  'mcp.tab.action.manage': 'प्रबंधित करें',
  'mcp.tab.aria.viewDetails': '{name} के विवरण देखें',
  'mcp.tab.aria.installServer': '{name} इंस्टॉल करें',
  'mcp.install.loadingDetail': 'सर्वर विवरण लोड हो रहा है...',
  'mcp.install.back': 'वापस जाओ',
  'mcp.install.title': '{name} स्थापित करें',
  'mcp.install.requiredEnv': 'आवश्यक पर्यावरण चर',
  'mcp.install.enterValue': '{key} दर्ज करें',
  'mcp.install.show': 'दिखाओ',
  'mcp.install.hide': 'छिपाओ',
  'mcp.install.configLabel': 'कॉन्फ़िगरेशन (वैकल्पिक JSON)',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': '"{key}" आवश्यक है',
  'mcp.install.invalidJson': 'कॉन्फ़िग JSON मान्य JSON नहीं है',
  'mcp.install.failedDetail': 'सर्वर विवरण लोड करने में विफल',
  'mcp.install.failedInstall': 'इंस्टॉल विफल',
  'mcp.install.button': 'स्थापित करें',
  'mcp.install.installing': 'स्थापित किया जा रहा है...',
  'mcp.install.by': 'द्वारा',
  'mcp.install.useCount': '{count} इंस्टॉलेशन',
  'mcp.install.connections': 'उपलब्ध कनेक्शन',
  'mcp.install.published': 'प्रकाशित',
  'mcp.install.configureAndInstall': 'कॉन्फ़िगर करें और इंस्टॉल करें',
  'mcp.install.configureTitle': '{name} कॉन्फ़िगर करें',
  'mcp.install.advancedConfig': 'उन्नत कॉन्फ़िगरेशन',
  'mcp.detail.suggestedEnvReady': 'सुझाए गए पर्यावरण मूल्य तैयार हैं',
  'mcp.detail.suggestedEnvBody':
    'इस सर्वर को फिर से स्थापित करने के लिए सुझाए गए मूल्यों के साथ उन्हें लागू करने के लिए: {keys}',
  'mcp.detail.connect': 'कनेक्ट करें',
  'mcp.detail.connecting': 'कनेक्ट हो रहा है...',
  'mcp.detail.authenticate': 'साइन इन करें',
  'mcp.detail.authRequired':
    'कनेक्ट होने से पहले इस सर्वर के लिए आपको साइन इन करना होगा या एक एक्सेस टोकन जोड़ना होगा। प्रमाणित करने के लिए “साइन इन करें” पर क्लिक करें।',
  'mcp.detail.disconnect': 'डिस्कनेक्ट करें',
  'mcp.detail.hideAssistant': 'सहायक छिपाएँ',
  'mcp.detail.helpConfigure': 'कॉन्फ़िगर करने में मेरी सहायता करें',
  'mcp.detail.confirmUninstall': 'अनइंस्टॉल की पुष्टि करें?',
  'mcp.detail.confirmUninstallAction': 'हाँ, अनइंस्टॉल करें',
  'mcp.detail.uninstall': 'अनइंस्टॉल करें',
  'mcp.detail.envVars': 'पर्यावरण चर',
  'mcp.detail.reconfigure': 'पुन: कॉन्फ़िगर करें',
  'mcp.detail.reconfigureHint':
    'हर वेरिएबल के लिए नए मान दर्ज करें, फिर पुन: कनेक्ट करें। यह संग्रहीत मानों को बदल देता है।',
  'mcp.detail.saveReconnect': 'सहेजें और पुन: कनेक्ट करें',
  'mcp.detail.reconfigureSaving': 'सहेजा जा रहा है…',
  'mcp.detail.reconfigureSuccess': 'एनवायरनमेंट अपडेट हो गया और पुन: कनेक्ट हो गया।',
  'mcp.detail.reconfigureReconnectFailed':
    'सहेजा गया, लेकिन नए मानों के साथ पुन: कनेक्ट करना विफल रहा।',
  'mcp.detail.enable': 'सक्षम करें',
  'mcp.detail.disable': 'अक्षम करें',
  'mcp.status.disabled': 'अक्षम',
  'mcp.status.unauthorized': 'साइन इन आवश्यक',
  'mcp.detail.tools': 'उपकरण',
  'mcp.connectAuth.title': '{name} कनेक्ट करें',
  'mcp.connectAuth.hint':
    'इस सर्वर के लिए आवश्यक कोई भी प्रमाणीकरण जोड़ें, फिर कनेक्ट करें। टोकन एन्क्रिप्टेड रूप में संग्रहीत किए जाते हैं। जिन सर्वरों को प्रमाणीकरण की आवश्यकता नहीं है, उनके लिए इसे खाली छोड़ें।',
  'mcp.connectAuth.requiredLabel': 'आवश्यक',
  'mcp.connectAuth.customHeadersLabel': 'कस्टम हेडर',
  'mcp.connectAuth.customHeadersEmpty':
    'कोई कस्टम हेडर नहीं। यदि इस सर्वर को कोई प्रमाणीकरण हेडर चाहिए जिसे रजिस्ट्री ने घोषित नहीं किया, तो एक जोड़ें।',
  'mcp.connectAuth.addHeader': '+ हेडर जोड़ें',
  'mcp.connectAuth.headerName': 'हेडर का नाम',
  'mcp.connectAuth.headerValue': 'मान',
  'mcp.connectAuth.removeHeader': 'हेडर हटाएं',
  'mcp.connectAuth.howToGetToken': 'सहायता और कॉन्फ़िगर करें',
  'mcp.connectAuth.tokenProvider': 'टोकन यहाँ से लें:',
  'mcp.connectAuth.findToken': 'टोकन कहाँ से मिलेगा?',
  'mcp.connectAuth.hideHelp': 'सहायता छिपाएं',
  'mcp.connectAuth.schemeLabel': 'मान को कैसे भेजें',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': 'कोई नहीं',
  'mcp.connectAuth.reconnectFailed': 'क्रेडेंशियल सहेजे गए, लेकिन कनेक्ट होने में विफल रहे।',
  'mcp.connectAuth.oauthHint':
    'यह सर्वर OAuth का उपयोग करता है। OpenHuman को अधिकृत करने के लिए अपने ब्राउज़र से साइन इन करें।',
  'mcp.connectAuth.signIn': 'ब्राउज़र से साइन इन करें',
  'mcp.connectAuth.oauthWaiting': 'साइन-इन की प्रतीक्षा हो रही है…',
  'mcp.connectAuth.oauthOrToken':
    'क्या आपके पास पहले से एक एक्सेस टोकन है? इसके बजाय इसे नीचे Authorization हेडर के रूप में पेस्ट करें।',
  'mcp.connectAuth.oauthTimeout':
    'ब्राउज़र साइन-इन की प्रतीक्षा का समय समाप्त हो गया। पुनः प्रयास करें।',
  'mcp.connectAuth.authError.oauthRequired':
    'यह सर्वर OAuth का उपयोग करता है। “ब्राउज़र से साइन इन करें” का उपयोग करें: पेस्ट किया गया टोकन स्वीकार नहीं किया जाएगा।',
  'mcp.connectAuth.authError.tokenRejected':
    'सर्वर ने इस टोकन को अस्वीकार कर दिया। जाँचें कि यह सही है और इसकी समय-सीमा समाप्त नहीं हुई है।',
  'mcp.connectAuth.authError.credentialRequired':
    'इस सर्वर के लिए प्रमाणीकरण आवश्यक है। एक टोकन जोड़ें, या साइन इन करें।',
  'onboarding.skipForNow': 'अभी के लिए छोड़ें',
  'onboarding.localAI.continueWithCloud': 'बादल के साथ जारी रखें',
  'onboarding.localAI.useLocalAnyway':
    'फिर भी स्थानीय AI उपयोग करें (आपके डिवाइस के लिए अनुशंसित नहीं)',
  'onboarding.localAI.useLocalInstead':
    'इसके बजाय स्थानीय AI उपयोग करें (अभी Ollama से कनेक्ट करें)',
  'onboarding.localAI.setupIssue': 'स्थानीय AI सेटअप में एक समस्या आई',
  'autonomy.title': 'एजेंट की स्वायत्तता',
  'autonomy.maxActionsLabel': 'प्रति घंटे अधिकतम क्रियाएं',
  'autonomy.maxActionsHelp':
    'प्रति रोलिंग घंटे में एजेंट अधिकतम कितने टूल एक्शन चला सकता है। नया मान अगली चैट पर लागू होगा। Cron जॉब्स और चैनल लिसनर OpenHuman को पुनः आरंभ करने तक अपनी मौजूदा सीमा बनाए रखते हैं।',
  'autonomy.statusSaving': 'सहेजा जा रहा है...',
  'autonomy.statusSaved': 'सहेजा गया.',
  'autonomy.statusFailed': 'असफल',
  'autonomy.unlimitedNote': 'असीमित - दर सीमित करना अक्षम।',
  'autonomy.invalidIntegerMsg':
    'एक धनात्मक पूर्णांक होना चाहिए (कोई सीमा न रखने के लिए Unlimited प्रीसेट उपयोग करें)।',
  'autonomy.presetUnlimited': 'असीमित (डिफ़ॉल्ट)',
  'triggers.toggleFailed': '{action} {trigger} के लिए विफल: {message}',
  'settings.ai.overview': 'AI सिस्टम ओवरव्यू',
  'settings.ai.configStatus': 'कॉन्फिगरेशन स्टेटस',
  'settings.ai.fallbackMode': 'फ़ॉलबैक मोड',
  'settings.ai.loadedFromRuntime': 'रनटाइम से लोड हुआ',
  'settings.ai.loadingDuration': 'लोडिंग में लगा समय',
  'settings.ai.localRuntime': 'लोकल मॉडल रनटाइम',
  'settings.ai.openManager': 'मैनेजर खोलें',
  'settings.ai.retryDownload': 'डाउनलोड फिर से करें',
  'settings.ai.state': 'स्टेट',
  'settings.ai.targetModel': 'टार्गेट मॉडल',
  'settings.ai.download': 'डाउनलोड करें',
  'settings.ai.localModelUnavailable': 'लोकल मॉडल स्टेटस उपलब्ध नहीं।',
  'settings.ai.soulConfig': 'SOUL पर्सोना कॉन्फिगरेशन',
  'settings.ai.refreshing': 'रिफ्रेश हो रहा है...',
  'settings.ai.refreshSoul': 'SOUL रिफ्रेश करें',
  'settings.ai.loadingSoul': 'SOUL कॉन्फिगरेशन लोड हो रही है...',
  'settings.ai.identity': 'आइडेंटिटी',
  'settings.ai.personality': 'पर्सनैलिटी',
  'settings.ai.safetyRules': 'सेफ्टी रूल्स',
  'settings.ai.source': 'सोर्स',
  'settings.ai.loaded': 'लोड हुआ',
  'settings.ai.toolsConfig': 'TOOLS कॉन्फिगरेशन',
  'settings.ai.refreshTools': 'TOOLS रिफ्रेश करें',
  'settings.ai.toolsAvailable': 'उपलब्ध टूल्स',
  'settings.ai.tools': 'टूल्स',
  'settings.ai.activeSkills': 'एक्टिव स्किल्स',
  'settings.ai.skills': 'स्किल्स',
  'settings.ai.skillsOverview': 'स्किल्स ओवरव्यू',
  'settings.ai.refreshingAll': 'सभी रिफ्रेश हो रहे हैं...',
  'settings.ai.refreshAll': 'सभी AI कॉन्फिगरेशन रिफ्रेश करें',
  'settings.notifications.suppressAll': 'सभी नोटिफिकेशन बंद करें',
  'settings.notifications.suppressAllDesc':
    'फोकस स्टेट चाहे कुछ भी हो, एम्बेडेड ऐप्स के सभी OS नोटिफिकेशन टोस्ट ब्लॉक करें।',
  'settings.notifications.toggleDnd': 'डू नॉट डिस्टर्ब टॉगल करें',
  'settings.notifications.categories': 'कैटेगरीज़',
  'settings.notifications.categoryFooter':
    'किसी कैटेगरी को डिसेबल करने से उस टाइप के नए नोटिफिकेशन नोटिफिकेशन सेंटर में नहीं आएंगे। पुराने नोटिफिकेशन तब तक रहेंगे जब तक क्लियर न हों।',
  'settings.billing.movedToWeb': 'बिलिंग वेब पर चली गई है',
  'settings.billing.openDashboard': 'बिलिंग डैशबोर्ड खोलें',
  'settings.billing.movedToWebDesc':
    'सब्सक्रिप्शन बदलाव, पेमेंट तरीके, क्रेडिट और इनवॉयस अब वेब पर TinyHumans में मैनेज होते हैं।',
  'settings.billing.backToSettings': 'Settings पर वापस',
  'settings.billing.openingBrowser': 'ब्राउज़र खुल रहा है...',
  'settings.billing.browserNotOpen': 'अगर ब्राउज़र नहीं खुला तो ऊपर वाला बटन इस्तेमाल करें।',
  'settings.billing.browserOpenFailed':
    'ब्राउज़र ऑटोमेटिकली नहीं खुल पाया। ऊपर वाला बटन इस्तेमाल करें।',
  'settings.tools.chooseCapabilities':
    'चुनें कि OpenHuman आपकी तरफ से कौन सी कैपेबिलिटीज़ इस्तेमाल कर सकता है।',
  'settings.tools.saveChanges': 'बदलाव सेव करें',
  'settings.tools.preferencesSaved': 'प्रेफरेंस सेव हो गई',
  'settings.tools.saveFailed': 'प्रेफरेंस सेव नहीं हो पाई। दोबारा कोशिश करें।',
  'connections.comingSoon': 'जल्द आ रहा है',
  'connections.setUp': 'सेट अप करें',
  'connections.configured': 'कॉन्फिगर हो गया',
  'connections.unavailable': 'उपलब्ध नहीं',
  'connections.checking': 'चेक हो रहा है…',
  'connections.walletConfigured':
    'रिकवरी फ्रेज़ से लोकल EVM, BTC, Solana और Tron आइडेंटिटी कॉन्फिगर हो गई हैं।',
  'connections.walletReady':
    'एक रिकवरी फ्रेज़ से लोकल EVM, BTC, Solana और Tron आइडेंटिटी सेट करें।',
  'connections.walletError':
    'वॉलेट स्टेटस चेक नहीं हो पाई। रिकवरी फ्रेज़ पैनल से फिर से कोशिश करें।',
  'connections.walletChecking': 'वॉलेट स्टेटस चेक हो रही है...',
  'connections.walletIdentities': 'वॉलेट आइडेंटिटी',
  'connections.walletDerived':
    'रिकवरी फ्रेज़ से लोकल रूप से डिराइव हुई और केवल सेफ मेटाडेटा के रूप में स्टोर।',
  'connections.privacySecurity': 'प्राइवेसी और सिक्योरिटी',
  'connections.privacySecurityDesc':
    'सभी डेटा और क्रेडेंशियल ज़ीरो-डेटा रिटेंशन पॉलिसी के साथ लोकल रूप से स्टोर हैं। आपकी जानकारी एन्क्रिप्टेड है और तीसरे पक्ष से कभी शेयर नहीं होती।',
  'channels.status.connecting': 'कनेक्ट हो रहा है',
  'channels.status.notConfigured': 'कॉन्फिगर नहीं हुआ',
  'channels.noActiveRoute': 'कोई एक्टिव रूट नहीं',
  'channels.activeRoute': 'एक्टिव रूट',
  'channels.loadingDefinitions': 'चैनल डेफिनिशन लोड हो रही हैं...',
  'channels.channelConnections': 'चैनल कनेक्शन',
  'channels.configureAuthModes': 'हर मैसेजिंग चैनल के लिए auth modes कॉन्फिगर करें।',
  'channels.configNotAvailable': 'कॉन्फिगरेशन उपलब्ध नहीं है',
  'channels.channel': 'चैनल',
  'devOptions.coreModeNotSet': 'कोर मोड: सेट नहीं है',
  'devOptions.coreModeNotSetDesc':
    'बूट-चेक पिकर अभी कन्फर्म नहीं हुआ। Local या Cloud चुनने के लिए पिकर पर Switch mode इस्तेमाल करें।',
  'devOptions.local': 'लोकल',
  'devOptions.embeddedCoreSidecar': 'एम्बेडेड कोर साइडकार',
  'devOptions.sidecarSpawned': 'ऐप लॉन्च पर Tauri shell द्वारा इन-प्रोसेस स्पॉन किया गया।',
  'devOptions.cloud': 'क्लाउड',
  'devOptions.remoteCoreRpc': 'रिमोट कोर RPC',
  'devOptions.token': 'टोकन',
  'devOptions.tokenNotSet': 'सेट नहीं: RPC 401 देगा',
  'devOptions.triggerSentryTest': 'Sentry टेस्ट ट्रिगर करें (staging)',
  'devOptions.triggerSentryTestDesc':
    'Sentry पाइपलाइन वेरिफाई करने के लिए टैग्ड एरर फायर करता है। Issue #1072: वेरिफिकेशन के बाद हटाएं।',
  'devOptions.sendTestEvent': 'टेस्ट इवेंट भेजें',
  'devOptions.sending': 'भेज रहे हैं…',
  'devOptions.eventSent': 'इवेंट भेज दिया गया',
  'devOptions.sentryDisabled': '(कोई आईडी नहीं - इस बिल्ड में संतरी अक्षम है)',
  'devOptions.failed': 'विफल',
  'devOptions.appLogs': 'ऐप लॉग्स',
  'devOptions.appLogsDesc':
    'रोज़ाना के रोलिंग लॉग फाइल्स वाला फोल्डर खोलें। इश्यू रिपोर्ट करते समय सबसे नई फाइल अटैच करें।',
  'devOptions.openLogsFolder': 'लॉग्स फोल्डर खोलें',
  'mnemonic.phraseSaved': 'रिकवरी फ्रेज़ सेव हो गया',
  'mnemonic.walletReady': 'मल्टी-चेन वॉलेट आइडेंटिटी तैयार हैं। Settings पर वापस जा रहे हैं...',
  'mnemonic.writeDownWords': 'ये',
  'mnemonic.wordsInOrder':
    'शब्द क्रम में लिखें और किसी सुरक्षित जगह रखें। यह फ्रेज़ आपकी लोकल एन्क्रिप्शन key और EVM, BTC, Solana तथा Tron वॉलेट आइडेंटिटी सुरक्षित रखता है।',
  'mnemonic.cannotRecover':
    'यह फ्रेज़ खो जाए तो कभी रिकवर नहीं हो सकता: इसे पूरी तरह अपने डिवाइस पर ही रखें।',
  'mnemonic.copyToClipboard': 'क्लिपबोर्ड पर कॉपी करें',
  'mnemonic.alreadyHavePhrase': 'मेरे पास पहले से रिकवरी फ्रेज़ है',
  'mnemonic.consentSaved':
    'मैंने यह फ्रेज़ सेव कर लिया है और लोकल वॉलेट सेटअप के लिए इसे इस्तेमाल करने की अनुमति देता हूँ',
  'mnemonic.enterPhraseToRestore':
    'अपना लोकल वॉलेट रिस्टोर करने के लिए नीचे रिकवरी फ्रेज़ डालें, या पूरा फ्रेज़ किसी भी फील्ड में पेस्ट करें (नए बैकअप के लिए 12 शब्द; पुराने वर्जन के 24 शब्द भी काम करते हैं)।',
  'mnemonic.words': 'शब्द',
  'mnemonic.validPhrase': 'सही रिकवरी फ्रेज़',
  'mnemonic.generateNewPhrase': 'नया रिकवरी फ्रेज़ जनरेट करें',
  'mnemonic.securingData': 'आपका डेटा सुरक्षित हो रहा है...',
  'mnemonic.saveRecoveryPhrase': 'रिकवरी फ्रेज़ सेव करें',
  'mnemonic.userNotLoaded': 'यूज़र लोड नहीं हुआ। दोबारा साइन इन करें या पेज रिफ्रेश करें।',
  'mnemonic.invalidPhrase': 'गलत रिकवरी फ्रेज़। अपने शब्द चेक करके दोबारा कोशिश करें।',
  'mnemonic.somethingWentWrong': 'कुछ गड़बड़ हो गई। दोबारा कोशिश करें।',
  'mnemonic.walletAlreadyConfigured': 'आपका वॉलेट पहले से सेट अप है।',
  'mnemonic.walletSource': 'स्रोत',
  'mnemonic.walletWordCount': 'रिकवरी फ्रेज़ की लंबाई',
  'mnemonic.walletLastUpdated': 'अंतिम अपडेट',
  'mnemonic.replaceWallet': 'वॉलेट बदलें',
  'mnemonic.replaceWalletWarning':
    'यह आपके मौजूदा वॉलेट को स्थायी रूप से बदल देगा। आगे बढ़ने से पहले सुनिश्चित करें कि आपने अपनी रिकवरी फ्रेज़ का बैकअप ले लिया है।',
  'mnemonic.replaceWalletConfirm': 'मैं समझता/समझती हूँ, मेरा वॉलेट बदलें',
  'mnemonic.loadingWalletStatus': 'वॉलेट की स्थिति जाँची जा रही है...',
  'mnemonic.viewAccounts': 'वॉलेट खाते',
  'mnemonic.revealRecoveryPhrase': 'रिकवरी वाक्यांश प्रकट करें',
  'mnemonic.hidePhrase': 'वाक्यांश छुपाएं',
  'team.failedToCreate': 'टीम नहीं बन पाई',
  'team.invalidInviteCode': 'गलत या एक्सपायर्ड इनवाइट कोड',
  'team.failedToSwitch': 'टीम स्विच नहीं हो पाई',
  'team.failedToLeave': 'टीम छोड़ने में दिक्कत आई',
  'team.role.owner': 'ओनर',
  'team.role.admin': 'एडमिन',
  'team.role.billingManager': 'बिलिंग मैनेजर',
  'team.role.member': 'मेंबर',
  'team.active': 'एक्टिव',
  'team.personalTeam': 'पर्सनल टीम',
  'team.manageTeam': 'टीम मैनेज करें',
  'team.switching': 'स्विच हो रहा है...',
  'team.switch': 'स्विच करें',
  'team.leaving': 'छोड़ रहे हैं...',
  'team.leave': 'छोड़ें',
  'team.yourTeams': 'आपकी टीम्स',
  'team.createNewTeam': 'नई टीम बनाएं',
  'team.teamName': 'टीम का नाम',
  'team.creating': 'बन रही है...',
  'team.joinExistingTeam': 'मौजूदा टीम जॉइन करें',
  'team.personalAutoCreatedNote':
    'आपकी व्यक्तिगत टीम स्वतः बन जाती है। सहयोग के लिए, नीचे आमंत्रण कोड के साथ किसी मौजूदा टीम में शामिल हों।',
  'team.inviteCode': 'इनवाइट कोड',
  'team.joining': 'जॉइन हो रहे हैं...',
  'team.join': 'जॉइन करें',
  'team.leaveTeam': 'टीम छोड़ें',
  'team.confirmLeave': 'क्या आप वाकई छोड़ना चाहते हैं',
  'team.leaveWarning':
    'आप टीम और सभी टीम रिसोर्स का एक्सेस खो देंगे। दोबारा जॉइन करने के लिए नया इनवाइट चाहिए होगा।',
  'team.management': 'टीम मैनेजमेंट',
  'team.notFound': 'टीम नहीं मिली',
  'team.accessDenied': 'एक्सेस नहीं मिला',
  'team.members': 'मेंबर्स',
  'team.membersDesc': 'टीम के सदस्यों और भूमिकाओं को प्रबंधित करें',
  'team.invites': 'आमंत्रित करता है',
  'team.invitesDesc': 'आमंत्रण कोड बनाएं और प्रबंधित करें',
  'team.settings': 'टीम सेटिंग्स',
  'team.settingsDesc': 'टीम का नाम और सेटिंग संपादित करें',
  'team.editSettings': 'टीम सेटिंग संपादित करें',
  'team.enterName': 'टीम का नाम दर्ज करें',
  'team.saving': 'सहेजा जा रहा है...',
  'team.saveChanges': 'परिवर्तन सहेजें',
  'team.delete': 'टीम हटाएँ',
  'team.deleteDesc': 'इस टीम को स्थायी रूप से हटा दें',
  'team.deleting': 'हटाया जा रहा है...',
  'team.failedToUpdate': 'टीम को अद्यतन करने में विफल',
  'team.failedToDelete': 'टीम को हटाने में विफल',
  'team.manageTitle': '{name} प्रबंधित करें',
  'team.planCreated': '{plan} योजना • बनाई गई {date}',
  'team.confirmDelete': 'क्या आप वाकई {name} को हटाना चाहते हैं?',
  'team.deleteWarning':
    'यह कार्य पूर्ववत नहीं किया जा सकता। सभी टीम डेटा स्थायी रूप से हटा दिया जाएगा।',
  'voice.title': 'वॉइस डिक्टेशन',
  'voice.settings': 'वॉइस सेटिंग्स',
  'voice.settingsDesc': 'डिक्टेट करने और एक्टिव फील्ड में टेक्स्ट डालने के लिए hotkey दबाकर रखें।',
  'voice.hotkey': 'हॉटकी',
  'voice.activationMode': 'एक्टिवेशन मोड',
  'voice.tapToToggle': 'टॉगल के लिए टैप करें',
  'voice.writingStyle': 'राइटिंग स्टाइल',
  'voice.verbatimTranscription': 'जैसा बोला वैसा ट्रांसक्रिप्शन',
  'voice.naturalCleanup': 'नैचुरल क्लीनअप',
  'voice.autoStart': 'कोर के साथ वॉइस सर्वर ऑटोमेटिकली शुरू करें',
  'voice.customDictionary': 'कस्टम डिक्शनरी',
  'voice.customDictionaryDesc':
    'रिकग्निशन एक्युरेसी बढ़ाने के लिए नाम, टेक्निकल टर्म और डोमेन शब्द जोड़ें।',
  'voice.addWord': 'एक शब्द जोड़ें...',
  'voice.sttDisabled': 'लोकल STT मॉडल डाउनलोड और तैयार होने तक वॉइस डिक्टेशन बंद है।',
  'voice.openLocalAiModel': 'लोकल AI मॉडल खोलें',
  'voice.serverRestarted': 'नई सेटिंग्स के साथ वॉइस सर्वर रीस्टार्ट हो गया।',
  'voice.settingsSaved': 'वॉइस सेटिंग्स सेव हो गईं।',
  'voice.serverStarted': 'वॉइस सर्वर शुरू हो गया।',
  'voice.serverStopped': 'वॉइस सर्वर बंद हो गया।',
  'voice.saveVoiceSettings': 'वॉइस सेटिंग्स सेव करें',
  'voice.startVoiceServer': 'वॉइस सर्वर शुरू करें',
  'voice.stopVoiceServer': 'वॉइस सर्वर बंद करें',
  'voice.debugTitle': 'वॉइस डिबग',
  'voice.failedToLoadSettings': 'ध्वनि सेटिंग लोड करने में विफल',
  'voice.failedToSaveSettings': 'ध्वनि सेटिंग सहेजने में विफल',
  'voice.failedToStartServer': 'वॉइस सर्वर प्रारंभ करने में विफल',
  'voice.failedToStopServer': 'वॉइस सर्वर को रोकने में विफल',
  'voice.sttDisabledPrefix': 'स्थानीय STT मॉडल डाउनलोड होने तक वॉयस डिक्टेशन अक्षम है। उपयोग करें',
  'voice.sttDisabledSuffix': 'व्हिस्पर स्थापित करने के लिए उपरोक्त अनुभाग।',
  'voice.debug.failedToLoadVoiceDebugData': 'ध्वनि डिबग डेटा लोड करने में विफल',
  'voice.debug.settingsSaved': 'डीबग सेटिंग सहेजी गईं.',
  'voice.debug.failedToSaveSettings': 'ध्वनि सेटिंग सहेजने में विफल',
  'voice.debug.runtimeStatus': 'रनटाइम स्थिति',
  'voice.debug.runtimeStatusDesc':
    'वॉयस सर्वर और स्पीच-टू-टेक्स्ट इंजन के लिए लाइव डायग्नोस्टिक्स।',
  'voice.debug.server': 'सर्वर',
  'voice.debug.unavailable': 'अनुपलब्ध',
  'voice.debug.ready': 'तैयार',
  'voice.debug.notReady': 'तैयार नहीं',
  'voice.debug.hotkey': 'हॉटकी',
  'voice.debug.notAvailable': 'एन/ए',
  'voice.debug.mode': 'मोड',
  'voice.debug.transcriptions': 'प्रतिलेखन',
  'voice.debug.serverError': 'सर्वर त्रुटि',
  'voice.debug.advancedSettings': 'उन्नत सेटिंग्स',
  'voice.debug.advancedSettingsDesc':
    'रिकॉर्डिंग और साइलेंस डिटेक्शन के लिए निम्न-स्तरीय ट्यूनिंग पैरामीटर।',
  'voice.debug.minimumRecordingSeconds': 'न्यूनतम रिकॉर्डिंग सेकंड',
  'voice.debug.silenceThreshold': 'साइलेंस थ्रेशोल्ड (आरएमएस)',
  'voice.debug.silenceThresholdDesc':
    'इससे कम ऊर्जा वाली रिकॉर्डिंग को साइलेंस माना जाता है और छोड़ दिया जाता है। कम = अधिक संवेदनशील।',
  'voice.debug.alwaysOn': 'हमेशा-चालू सुनना',
  'voice.debug.alwaysOnDesc':
    'माइक्रोफ़ोन खुला रखें और आप जो कहते हैं वह बिना हॉटकी के स्वचालित रूप से एजेंट को भेजें। स्क्रीन लॉक होने पर रुक जाता है।',
  'voice.providers.saved': 'ध्वनि प्रदाता सहेजे गए.',
  'voice.providers.failedToSave': 'ध्वनि प्रदाताओं को सहेजने में विफल',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': 'स्थापित करना',
  'voice.providers.installingBusy': 'इंस्टाल किया जा रहा है...',
  'voice.providers.reinstallLocally': 'स्थानीय रूप से पुनः स्थापित करें',
  'voice.providers.repair': 'मरम्मत',
  'voice.providers.retryLocally': 'स्थानीय स्तर पर पुनः प्रयास करें',
  'voice.providers.installLocally': 'स्थानीय रूप से स्थापित करें',
  'voice.providers.whisperReady': 'व्हिस्पर तैयार है.',
  'voice.providers.whisperInstallStarted': 'व्हिस्पर इंस्टॉल प्रारंभ हुआ',
  'voice.providers.queued': 'पंक्तिबद्ध',
  'voice.providers.failedToInstallWhisper': 'व्हिस्पर स्थापित करने में विफल',
  'voice.providers.piperReady': 'पाइपर तैयार है.',
  'voice.providers.piperInstallStarted': 'पाइपर स्थापित करना प्रारंभ हो गया',
  'voice.providers.failedToInstallPiper': 'पाइपर स्थापित करने में विफल',
  'voice.mode.title': 'वॉइस मोड',
  'voice.mode.desc': 'चुनें कि Human टैब में असिस्टेंट कैसे बात करे।',
  'voice.mode.realtime': 'रियलटाइम वॉइस (बीटा)',
  'voice.mode.realtimeDesc': 'बारी-बारी के बजाय सीधे लाइव बातचीत करें।',
  'voice.mode.start': 'वॉइस चैट शुरू करें',
  'voice.mode.stop': 'वॉइस चैट समाप्त करें',
  'voice.mode.connecting': 'कनेक्ट हो रहा है…',
  'voice.mode.listening': 'सुन रहा है',
  'voice.mode.speaking': 'बोल रहा है',
  'voice.providers.title': 'आवाज प्रदाता',
  'voice.providers.desc':
    'चुनें कि ट्रांसक्रिप्शन और सिंथेसिस कहाँ चलें। बाइनरी और मॉडल डाउनलोड करने के लिए Install locally बटन उपयोग करें। स्थानीय प्रोवाइडर इंस्टॉल पूरा होने से पहले भी सहेजे जा सकते हैं: कोई मैन्युअल WHISPER_BIN या PIPER_BIN सेटअप आवश्यक नहीं।',
  'voice.providers.sttProvider': 'वाक्-से-पाठ प्रदाता',
  'voice.providers.sttProviderAria': 'एसटीटी प्रदाता',
  'voice.providers.cloudWhisperProxy': 'बादल (कानाफूसी प्रॉक्सी)',
  'voice.providers.localWhisper': 'स्थानीय कानाफूसी',
  'voice.providers.installRequired': ' (इंस्टॉल आवश्यक)',
  'voice.providers.whisperInstalledTitle':
    'Whisper इंस्टॉल है। पुनः इंस्टॉल करने के लिए क्लिक करें।',
  'voice.providers.whisperDownloadTitle':
    'whisper.cpp और GGML मॉडल को अपने वर्कस्पेस में डाउनलोड करें।',
  'voice.providers.installed': 'स्थापित',
  'voice.providers.installFailed': 'इंस्टॉल विफल',
  'voice.providers.notInstalled': 'स्थापित नहीं',
  'voice.providers.whisperModel': 'व्हिस्पर मॉडल',
  'voice.providers.whisperModelAria': 'कानाफूसी मॉडल',
  'voice.providers.whisperModelTiny': 'छोटा (39 एमबी, सबसे तेज़)',
  'voice.providers.whisperModelBase': 'आधार (74 एमबी)',
  'voice.providers.whisperModelSmall': 'छोटा (244 एमबी)',
  'voice.providers.whisperModelMedium': 'मध्यम (769 एमबी, अनुशंसित)',
  'voice.providers.whisperModelLargeTurbo': 'बड़ा v3 टर्बो (1.5 जीबी, सर्वोत्तम सटीकता)',
  'voice.providers.ttsProvider': 'पाठ से वाक् प्रदाता',
  'voice.providers.ttsProviderAria': 'टीटीएस प्रदाता',
  'voice.providers.cloudElevenLabsProxy': 'क्लाउड (इलेवनलैब्स प्रॉक्सी)',
  'voice.providers.localPiper': 'स्थानीय पाइपर',
  'voice.providers.piperInstalledTitle': 'पाइपर लगा हुआ है. पुनः स्थापित करने के लिए क्लिक करें.',
  'voice.providers.piperDownloadTitle':
    'Piper और बंडल की गई en_US-lessac-medium वॉयस को अपने वर्कस्पेस में डाउनलोड करें।',
  'voice.providers.piperVoice': 'पाइपर आवाज',
  'voice.providers.piperVoiceAria': 'पाइपर आवाज',
  'voice.providers.customVoiceOption': 'अन्य (नीचे टाइप करें)…',
  'voice.providers.customVoiceAria': 'पाइपर वॉयस आईडी (कस्टम)',
  'voice.providers.customVoicePlaceholder': 'en_US-lessac-मध्यम',
  'voice.providers.piperVoicesDesc':
    'वॉयस huggingface.co/rhasspy/piper-voices से आती हैं। वॉयस बदलने पर नई .onnx डाउनलोड करने के लिए Install/Reinstall क्लिक करना पड़ सकता है।',
  'voice.providers.mascotVoice': 'शुभंकर आवाज',
  'voice.providers.mascotVoiceDescPrefix':
    'ElevenLabs की वह आवाज़ जो मेसकॉट बोली प्रतिक्रियाओं के लिए उपयोग करता है, यहाँ कॉन्फ़िगर की गई है',
  'voice.providers.mascotSettings': 'शुभंकर सेटिंग',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'एफ.एन',
  'voice.providers.piperPreset.lessacMedium': 'यूएस · लेसैक (तटस्थ, अनुशंसित)',
  'voice.providers.piperPreset.lessacHigh': 'यूएस · लेसैक (उच्च गुणवत्ता, बड़ा)',
  'voice.providers.piperPreset.ryanMedium': 'यूएस · रयान (पुरुष)',
  'voice.providers.piperPreset.amyMedium': 'यूएस · एमी (महिला)',
  'voice.providers.piperPreset.librittsHigh': 'यूएस · लिब्रिटीटीएस (मल्टी-स्पीकर)',
  'voice.providers.piperPreset.alanMedium': 'जीबी · एलन (पुरुष)',
  'voice.providers.piperPreset.jennyDiocoMedium': 'जीबी · जेनी डिओको (महिला)',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'जीबी · उत्तरी अंग्रेजी (पुरुष)',
  'voice.providers.chip.cloud': 'OpenHuman (प्रबंधित)',
  'voice.providers.chip.cloudAria': 'OpenHuman प्रबंधित प्रोवाइडर हमेशा सक्षम रहता है',
  'voice.providers.chip.whisper': 'Whisper (स्थानीय)',
  'voice.providers.chip.enableWhisper': 'स्थानीय Whisper STT सक्षम करें',
  'voice.providers.chip.disableWhisper': 'स्थानीय Whisper STT अक्षम करें',
  'voice.providers.chip.piper': 'Piper (स्थानीय)',
  'voice.providers.chip.enablePiper': 'स्थानीय Piper TTS सक्षम करें',
  'voice.providers.chip.disablePiper': 'स्थानीय Piper TTS अक्षम करें',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'API कुंजी',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': 'जल्द आ रहा है',
  'voice.modal.title': 'Configure',
  'voice.modal.desc':
    'इस प्रोवाइडर को सक्षम करने के लिए अपनी API कुंजी दर्ज करें। सहेजने से पहले कनेक्शन परीक्षण कर सकते हैं।',
  'voice.modal.testKey': 'कुंजी परीक्षण करें',
  'voice.modal.testing': 'परीक्षण हो रहा है…',
  'voice.modal.saveAndEnable': 'सहेजें और सक्षम करें',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    'एक मॉडल आकार चुनें और Whisper बाइनरी तथा GGML मॉडल अपने वर्कस्पेस में इंस्टॉल करें। बड़े मॉडल अधिक सटीक लेकिन धीमे होते हैं।',
  'voice.modal.piperDesc':
    'एक वॉयस चुनें और Piper बाइनरी तथा ONNX मॉडल अपने वर्कस्पेस में इंस्टॉल करें। Piper पूरी तरह ऑफलाइन और कम विलंबता के साथ चलता है।',
  'voice.routing.title': 'वॉयस रूटिंग',
  'voice.routing.desc':
    'चुनें कि कौन से सक्षम प्रोवाइडर स्पीच-टू-टेक्स्ट और टेक्स्ट-टू-स्पीच संभालें।',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': 'STT परीक्षण करें',
  'voice.routing.testTts': 'TTS परीक्षण करें',
  'voice.routing.elevenlabsVoice': 'ElevenLabs वॉयस',
  'voice.routing.elevenlabsVoiceAria': 'ElevenLabs वॉयस चयन',
  'voice.routing.elevenlabsVoiceIdAria': 'ElevenLabs वॉयस ID (कस्टम)',
  'voice.routing.elevenlabsVoiceDesc':
    'एक क्यूरेटेड वॉयस चुनें या अपने ElevenLabs डैशबोर्ड से कस्टम वॉयस ID पेस्ट करें।',
  'voice.externalProviders.title': 'बाहरी वॉयस प्रोवाइडर',
  'voice.externalProviders.desc':
    'Deepgram, ElevenLabs या OpenAI जैसे तृतीय-पक्ष STT/TTS API सीधे कनेक्ट करें।',
  'voice.externalProviders.keySet': 'कुंजी सेट है',
  'voice.externalProviders.noKey': 'कोई API कुंजी नहीं',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': 'परीक्षण हो रहा है…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': 'एक प्रोवाइडर चुनें…',
  'voice.externalProviders.apiKey': 'API कुंजी',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': 'दबाकर बोलें',
  'pttSettings.description':
    'जब आप किसी दूसरे ऐप में हों तब OpenHuman से बात करने के लिए कोई कुंजी दबाए रखें। कुंजी छोड़ने पर रिकॉर्डिंग भेजी जाती है; अगर «उत्तर बोलकर सुनाएँ» चालू है तो OpenHuman उत्तर बोलकर सुनाता है।',
  'pttSettings.shortcutLabel': 'हॉटकी',
  'pttSettings.shortcutPlaceholder': 'कोई कुंजी दबाएँ (जैसे F13)',
  'pttSettings.shortcutUnsetHint': 'दबाकर बोलें बंद है: चालू करने के लिए कोई हॉटकी चुनें।',
  'pttSettings.speakRepliesLabel': 'एजेंट के उत्तर ज़ोर से सुनाएँ',
  'pttSettings.showOverlayLabel': 'दबाए रखने के दौरान ओवरले दिखाएँ',
  'pttSettings.errorConflictsWithDictation':
    'यह शॉर्टकट पहले से डिक्टेशन में उपयोग हो रहा है। कोई दूसरी कुंजी चुनें।',
  'pttSettings.errorModifierOnly':
    'कोई सामान्य कुंजी चुनें (जैसे F13): केवल मॉडिफ़ायर वाले शॉर्टकट दबाकर बोलें के लिए काम नहीं करते।',
  'pttSettings.errorEmpty': 'बाँधने के लिए कोई कुंजी चुनें।',
  'pttSettings.errorAccessibility':
    'इस शॉर्टकट के लिए macOS को एक्सेसिबिलिटी अनुमति चाहिए। System Settings → Privacy & Security → Accessibility खोलें और OpenHuman को सक्षम करें।',
  'pttSettings.errorShortcutInUse':
    'कोई दूसरा ऐप पहले से इस शॉर्टकट का उपयोग कर रहा है। कोई दूसरा चुनें।',
  'pttSettings.errorUnsupportedWayland':
    'Wayland सत्र अभी OpenHuman में ग्लोबल शॉर्टकट का समर्थन नहीं करते: X11 सत्र पर जाएँ या ऐप के अंदर डिक्टेशन टॉगल का उपयोग करें।',
  'pttSettings.exclusiveFullscreenHint':
    'एक्सक्लूसिव फुलस्क्रीन गेम्स में ओवरले प्रदर्शित नहीं होगा: आपको केवल चाइम सुनाई देगा। ओवरले देखने के लिए बॉर्डरलेस फुलस्क्रीन पर जाएँ।',
  'pttOverlay.listening': 'सुन रहा है…',
  'pttOverlay.idle': 'निष्क्रिय',
  'chat.agentChat': 'एजेंट चैट',
  'chat.overrides': 'ओवरराइड्स',
  'chat.model': 'मॉडल',
  'chat.temperature': 'टेम्परेचर',
  'chat.conversation': 'बातचीत',
  'chat.startAgentConversation': 'एजेंट से बातचीत शुरू करें।',
  'chat.you': 'आप',
  'chat.agent': 'एजेंट',
  'chat.askAgent': 'एजेंट से कुछ भी पूछें...',
  'chat.sendMessage': 'मैसेज भेजें',
  'composio.triageTitle': 'इंटीग्रेशन ट्रिगर',
  'composio.triageDesc':
    'एक्टिव होने पर, हर आने वाला Composio ट्रिगर AI triage स्टेप से गुज़रता है जो इवेंट क्लासीफाई करता है और ऑटोमेटेड एक्शन शुरू कर सकता है: प्रति ट्रिगर एक लोकल LLM टर्न। मैन्युअल रिव्यू पसंद हो तो ग्लोबली या per-integration डिसेबल करें। अगर एनवायरनमेंट वेरिएबल',
  'composio.disableAllTriage': 'सभी ट्रिगर के लिए AI triage बंद करें',
  'composio.triggersStillRecorded':
    'ट्रिगर हिस्ट्री में रिकॉर्ड होते रहते हैं: कोई LLM टर्न नहीं चलता।',
  'composio.disableSpecificIntegrations': 'खास इंटीग्रेशन के लिए AI triage बंद करें',
  'composio.settingsSaved': 'सेटिंग्स सहेजी गईं',
  'composio.saveFailed': 'सेव नहीं हो पाया। दोबारा कोशिश करें।',
  'cron.title': 'क्रॉन जॉब्स',
  'cron.scheduledJobs': 'शेड्यूल्ड जॉब्स',
  'cron.manageCronJobs': 'कोर शेड्यूलर से cron jobs मैनेज करें।',
  'cron.refreshCronJobs': 'Cron Jobs रिफ्रेश करें',
  'localModel.modelStatus': 'मॉडल स्टेटस',
  'localModel.downloadModels': 'मॉडल डाउनलोड करें',
  'localModel.usage': 'उपयोग',
  'localModel.usageDesc':
    'चुनें कि कौन से सबसिस्टम लोकल मॉडल पर चलें। बंद होने पर क्लाउड इस्तेमाल होगा।',
  'localModel.enableRuntime': 'लोकल AI रनटाइम चालू करें',
  'localModel.enableRuntimeDesc':
    'मास्टर स्विच। डिफ़ॉल्ट रूप से बंद: Ollama आइडल रहता है। चालू होने पर tree summarizer और autocomplete हमेशा लोकल मॉडल इस्तेमाल करते हैं।',
  'localModel.advancedSettings': 'एडवांस्ड सेटिंग्स',
  'localModel.debugTitle': 'लोकल मॉडल डिबग',
  'memory.debugTitle': 'मेमोरी डिबग',
  'memory.documents': 'दस्तावेज़',
  'memory.filterByNamespace': 'नामस्थान के अनुसार फ़िल्टर करें...',
  'memory.refresh': 'ताज़ा करें',
  'memory.noDocumentsFound': 'कोई दस्तावेज़ नहीं मिला.',
  'memory.delete': 'हटाएँ',
  'memory.rawResponse': 'कच्ची प्रतिक्रिया',
  'memory.namespaces': 'नामस्थान',
  'memory.noNamespacesFound': 'कोई नामस्थान नहीं मिला.',
  'memory.queryRecall': 'प्रश्न और स्मरण',
  'memory.namespace': 'नामस्थान',
  'memory.queryText': 'क्वेरी पाठ...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': 'अधिकतम टुकड़े',
  'memory.query': 'प्रश्न',
  'memory.recall': 'स्मरण करो',
  'memory.queryLabel': 'प्रश्न',
  'memory.recallLabel': 'स्मरण करो',
  'memory.queryResult': 'क्वेरी परिणाम',
  'memory.recallResult': 'परिणाम याद करें',
  'memory.clearNamespace': 'नामस्थान साफ़ करें',
  'memory.clearNamespaceDescription': 'किसी नेमस्पेस के सभी दस्तावेज़ स्थायी रूप से हटाएं।',
  'memory.selectNamespace': 'नामस्थान चुनें...',
  'memory.exampleNamespace': 'जैसे कौशल:gmail:user@example.com',
  'memory.clear': 'स्पष्ट',
  'memory.deleteConfirm': 'नामस्थान "{namespace}" में दस्तावेज़ "{documentId}" हटाएं?',
  'memory.clearNamespaceConfirm':
    'यह "{namespace}" नेमस्पेस के सभी दस्तावेज़ स्थायी रूप से हटा देगा। जारी रखें?',
  'memory.clearNamespaceSuccess': 'नेमस्पेस "{namespace}" साफ़ किया गया।',
  'memory.clearNamespaceEmpty': '"{namespace}" में साफ़ करने के लिए कुछ भी नहीं है।',
  'webhooks.debugTitle': 'Webhooks डिबग',
  'webhooks.failedToLoadDebugData': 'वेबहुक डिबग डेटा लोड करने में विफल',
  'webhooks.clearLogsConfirm': 'सभी कैप्चर किए गए वेबहुक डीबग लॉग साफ़ करें?',
  'webhooks.failedToClearLogs': 'वेबहुक लॉग साफ़ करने में विफल',
  'webhooks.loading': 'लोड हो रहा है...',
  'webhooks.refresh': 'ताज़ा करें',
  'webhooks.clearing': 'समाशोधन...',
  'webhooks.clearLogs': 'लॉग साफ़ करें',
  'webhooks.registered': 'पंजीकृत',
  'webhooks.captured': 'कब्जा कर लिया',
  'webhooks.live': 'जीना',
  'webhooks.disconnected': 'विच्छेदित',
  'webhooks.lastEvent': 'आखिरी घटना',
  'webhooks.at': 'पर',
  'webhooks.registeredWebhooks': 'पंजीकृत वेबहुक',
  'webhooks.noActiveRegistrations': 'कोई सक्रिय पंजीकरण नहीं.',
  'webhooks.resolvingBackendUrl': 'बैकएंड का समाधान URL…',
  'webhooks.capturedRequests': 'कैप्चर किए गए अनुरोध',
  'webhooks.noRequestsCaptured': 'अभी तक कोई वेबहुक अनुरोध कैप्चर नहीं किया गया।',
  'webhooks.unrouted': 'अनियंत्रित',
  'webhooks.pending': 'लंबित',
  'webhooks.requestHeaders': 'शीर्षलेखों का अनुरोध करें',
  'webhooks.queryParams': 'क्वेरी पैरामीटर',
  'webhooks.requestBody': 'अनुरोध निकाय',
  'webhooks.responseHeaders': 'प्रतिक्रिया शीर्षलेख',
  'webhooks.responseBody': 'प्रतिक्रिया निकाय',
  'webhooks.rawPayload': 'कच्चा पेलोड',
  'webhooks.empty': '[खाली]',
  'providerSetup.error.defaultDetails': 'प्रदाता सेटअप विफल रहा.',
  'providerSetup.error.providerFallback': 'प्रदाता',
  'providerSetup.error.credentialsRejected':
    '{provider} ने क्रेडेंशियल अस्वीकार कर दिए। API कुंजी जांचें और पुनः प्रयास करें।',
  'providerSetup.error.endpointNotRecognized':
    '{provider} ने एंडपॉइंट नहीं पहचाना। बेस URL जांचें और पुनः प्रयास करें।',
  'providerSetup.error.providerUnavailable':
    '{provider} अभी उपलब्ध नहीं है। पुनः प्रयास करें या प्रोवाइडर स्थिति जांचें।',
  'providerSetup.error.unreachable':
    '{provider} से संपर्क नहीं हो सका। एंडपॉइंट URL और नेटवर्क कनेक्शन जांचें, फिर पुनः प्रयास करें।',
  'providerSetup.error.couldNotReachWithMessage': '{provider} तक नहीं पहुंच सका: {message}',
  'providerSetup.error.technicalDetails': 'तकनीकी विवरण',
  'notifications.routingTitle': 'नोटिफिकेशन रूटिंग',
  'notifications.routing.pipelineStats': 'पाइपलाइन आँकड़े',
  'notifications.routing.total': 'कुल',
  'notifications.routing.unread': 'अपठित',
  'notifications.routing.unscored': 'अंकरहित',
  'notifications.routing.intelligenceTitle': 'अधिसूचना खुफिया',
  'notifications.routing.intelligenceDesc':
    'आपके कनेक्टेड अकाउंट्स की हर सूचना को स्थानीय AI मॉडल द्वारा स्कोर किया जाता है। उच्च-महत्व की सूचनाएं स्वतः आपके ऑर्केस्ट्रेटर एजेंट को भेज दी जाती हैं ताकि कोई महत्वपूर्ण बात छूट न जाए।',
  'notifications.routing.howItWorks': 'यह कैसे काम करता है',
  'notifications.routing.level.drop': 'गिराओ',
  'notifications.routing.level.dropDesc': 'शोर / स्पैम - संग्रहीत लेकिन सामने नहीं आया',
  'notifications.routing.level.acknowledge': 'स्वीकार करें',
  'notifications.routing.level.acknowledgeDesc':
    'निम्न-प्राथमिकता: नोटिफिकेशन सेंटर में दिखाया गया',
  'notifications.routing.level.react': 'प्रतिक्रिया',
  'notifications.routing.level.reactDesc':
    'मध्यम-प्राथमिकता: केंद्रित एजेंट प्रतिक्रिया ट्रिगर करता है',
  'notifications.routing.level.escalate': 'आगे बढ़ें',
  'notifications.routing.level.escalateDesc':
    'उच्च-प्राथमिकता: ऑर्केस्ट्रेटर एजेंट को अग्रेषित किया गया',
  'notifications.routing.perProvider': 'प्रति-प्रदाता रूटिंग',
  'notifications.routing.threshold': 'देहली',
  'notifications.routing.routeToOrchestrator': 'ऑर्केस्ट्रेटर के लिए मार्ग',
  'notifications.routing.loadSettingsError':
    'सेटिंग्स लोड करने में विफल। पुनः प्रयास करने के लिए यह पैनल फिर से खोलें।',
  'common.reload': 'रिलोड करें',
  'common.skip': 'स्किप करें',
  'common.disable': 'बंद करें',
  'common.enable': 'चालू करें',
  'chat.safetyTimeout':
    '2 मिनट बाद भी एजेंट से कोई जवाब नहीं मिला। दोबारा कोशिश करें या अपना कनेक्शन चेक करें।',
  'chat.filter.general': 'सामान्य',
  'chat.filter.subconscious': 'सबकॉन्शस',
  'chat.filter.meetings': 'मीटिंग',
  'chat.filter.tasks': 'टास्क',
  'chat.selectThread': 'एक थ्रेड चुनें',
  'chat.threads': 'थ्रेड्स',
  'chat.noThreads': 'अभी कोई थ्रेड नहीं',
  'chat.noLabelThreads': 'कोई "{label}" थ्रेड नहीं',
  'chat.deleteThread': 'थ्रेड डिलीट करें',
  'chat.deleteThreadConfirm': 'क्या आप वाकई "{title}" डिलीट करना चाहते हैं?',
  'chat.untitledThread': 'बिना शीर्षक की थ्रेड',
  'chat.editThreadTitle': 'थ्रेड शीर्षक संपादित करें',
  'chat.hideSidebar': 'साइडबार छुपाएं',
  'chat.showSidebar': 'साइडबार दिखाएं',
  'chat.searchThreads': 'बातचीत खोजें',
  'layout.resizeSidebar': 'साइडबार का आकार बदलें',
  'layout.showSidebar': 'साइडबार दिखाएं',
  'chat.newThreadShortcut': 'नई थ्रेड (/new)',
  'chat.new': 'नई',
  'chat.failedToLoadMessages': 'मैसेज लोड नहीं हो पाए',
  'chat.thinkingIteration': 'सोच रहा है... ({n})',
  'chat.thinkingDots': 'सोच रहा है...',
  'chat.approachingLimit': 'उपयोग सीमा के करीब',
  'chat.approachingLimitMsg': 'आपने अपने उपलब्ध कोटे का {pct}% इस्तेमाल कर लिया है।',
  'chat.upgrade': 'अपग्रेड करें',
  'chat.weeklyLimitHit': 'आपकी साप्ताहिक सीमा पूरी हो गई।',
  'chat.resets': 'रीसेट होता है',
  'chat.topUpToContinue': 'जारी रखने के लिए टॉप अप करें।',
  'chat.budgetComplete': 'आपका बजट पूरा हो गया। जारी रखने के लिए क्रेडिट जोड़ें या अपग्रेड करें।',
  'chat.topUp': 'टॉप अप करें',
  'chat.cycle': 'चक्र',
  'chat.cycleSpent': 'इस चक्र में खर्च',
  'chat.cycleRemaining': 'शेष',
  'chat.left': 'बचा हुआ',
  'chat.setup': 'सेट अप करें',
  'chat.switchToText': 'टेक्स्ट पर स्विच करें',
  'chat.superContext.label': 'सुपर कॉन्टेक्स्ट',
  'chat.superContext.hint':
    'सुपर कॉन्टेक्स्ट OpenHuman को उन सभी डेटा से संदर्भ इकट्ठा और तैयार करने देता है जिन तक उसकी पहुँच है, ताकि वह अत्यधिक प्रासंगिक उत्तर दे सके। सुपर कॉन्टेक्स्ट प्रारंभिक बीटा में है।',
  'chat.transcribing': 'ट्रांसक्राइब हो रहा है...',
  'chat.stopAndSend': 'रोकें और भेजें',
  'chat.startTalking': 'बोलना शुरू करें',
  'chat.playingVoiceReply': 'वॉइस रिप्लाई चल रहा है',
  'chat.voiceHint': 'बोलने के लिए माइक इस्तेमाल करें',
  'chat.micUnavailable': 'माइक्रोफोन उपलब्ध नहीं',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': 'अपने असिस्टेंट से बात करें',
  'chat.mascot.collapse': 'चैट पर वापस जाएँ',
  'chat.mascot.speakReplies': 'जवाब बोलकर सुनाएँ',
  'chat.mascot.speakRepliesHint':
    'मैस्कॉट खुला रहने तक जवाब बोलकर सुनाए जाते हैं। बातचीत को शांत रखने के लिए इसे बंद कर दें।',
  'chat.mascot.dismiss': 'Tiny छिपाएँ',
  'chat.mascot.dismissTitle': 'Tiny छिपाएँ?',
  'chat.mascot.dismissBody':
    'अगर आप मैसेज बॉक्स अपने पास ही रखना चाहते हैं तो कोई बात नहीं। Tiny को कभी भी सेटिंग्स › दिखावट › चैट से वापस ला सकते हैं।',
  'chat.mascot.dismissConfirm': 'Tiny छिपाएँ',
  'chat.mascot.dismissCancel': 'Tiny रहने दें',
  'chat.turn': 'टर्न',
  'chat.turns': 'टर्न्स',
  'chat.openWorkerThread': 'वर्कर थ्रेड खोलें',
  'chat.attachment.attach': 'छवि संलग्न करें',
  'chat.attachment.remove': '{name} हटाएं',
  'chat.attachment.tooMany': 'प्रति संदेश अधिकतम {max} छवियां',
  'chat.attachment.tooManyFiles': 'प्रति संदेश अधिकतम {max} फ़ाइलें',
  'chat.attachment.tooManyVideos': 'प्रति संदेश अधिकतम {max} वीडियो',
  'chat.attachment.videoNotSupported':
    'यह मॉडल वीडियो नहीं पढ़ सकता। अपना वीडियो संलग्न करने के लिए आप OpenHuman तर्क टियर का उपयोग कर सकते हैं।',
  'chat.attachment.dropToAttach': 'संलग्न करने के लिए फ़ाइलें छोड़ें',
  'chat.attachment.tooLarge': 'छवि {max} आकार सीमा से अधिक है',
  'chat.attachment.unsupportedType':
    'असमर्थित फ़ाइल प्रकार। कोई छवि (PNG, JPEG, WebP, GIF, BMP) या PDF, TXT, या Markdown फ़ाइल का उपयोग करें।',
  'chat.attachment.imageNotSupported':
    'यह मॉडल छवियाँ नहीं पढ़ सकता। अपनी छवि संलग्न करने के लिए आप OpenHuman तर्क टियर का उपयोग कर सकते हैं।',
  'chat.attachment.readFailed': 'फ़ाइल पढ़ नहीं सकी',
  'memory.searchAria': 'मेमोरी सर्च करें',
  'memory.searchPlaceholder': 'मेमोरी एंट्रीज़ सर्च करें...',
  'memory.sourceFilter.all': 'सभी सोर्स',
  'memory.sourceFilter.email': 'ईमेल',
  'memory.sourceFilter.calendar': 'कैलेंडर',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'AI इनसाइट',
  'memory.sourceFilter.system': 'सिस्टम',
  'memory.sourceFilter.trading': 'ट्रेडिंग',
  'memory.sourceFilter.security': 'सिक्योरिटी',
  'memory.ingestionActivity': 'इन्जेशन एक्टिविटी',
  'memory.events': 'इवेंट्स',
  'memory.event': 'इवेंट',
  'memory.overTheLast': 'पिछले',
  'memory.months': 'महीने',
  'memory.peak': 'पीक',
  'memory.perDay': '/दिन',
  'memory.less': 'कम',
  'memory.more': 'ज़्यादा',
  'memory.on': 'पर',
  'memory.loading': 'मेमोरी लोड हो रही है',
  'memory.fetching': 'आपकी मेमोरी एंट्रीज़ फेच हो रही हैं...',
  'memory.analyzing': 'मेमोरी एनालाइज़ हो रही है',
  'memory.analyzingHint': 'इनसाइट निकालने के लिए मेमोरी प्रोसेस हो रही है...',
  'memory.noMatches': 'कोई मिलान नहीं मिला',
  'memory.noMatchesHint': 'सर्च टर्म या फिल्टर बदलकर देखें।',
  'memory.allCaughtUp': 'सब अप-टू-डेट है',
  'memory.allCaughtUpHint': 'कोई नई मेमोरी एंट्री प्रोसेस करने के लिए नहीं।',
  'memory.noAnalysis': 'अभी कोई एनालिसिस नहीं',
  'memory.noAnalysisHint': 'अपनी मेमोरी में पैटर्न देखने के लिए एनालिसिस चलाएं।',
  'memory.emptyHint': 'अपनी पहली मेमोरी बनाने के लिए बातचीत शुरू करें।',
  'mic.unavailable': 'माइक्रोफोन उपलब्ध नहीं है',
  'mic.permissionDenied': 'माइक्रोफोन की अनुमति नहीं मिली',
  'mic.failedToStartRecorder': 'रिकॉर्डर शुरू नहीं हो पाया',
  'mic.deviceUnavailable': 'चयनित माइक्रोफ़ोन उपलब्ध नहीं है: कोई दूसरा डिवाइस आज़माएँ।',
  'mic.deviceInUse': 'माइक्रोफ़ोन किसी अन्य एप्लिकेशन द्वारा उपयोग में है।',
  'mic.error': 'माइक्रोफ़ोन त्रुटि',
  'mic.transcribing': 'ट्रांसक्राइब हो रहा है...',
  'mic.retryingTranscription': 'पुनः प्रयास कर रहे हैं… ({attempt}/{max})',
  'mic.tapToSend': 'भेजने के लिए टैप करें',
  'mic.waitingForAgent': 'एजेंट का इंतज़ार है...',
  'mic.tapAndSpeak': 'टैप करें और बोलें',
  'mic.stopRecording': 'रिकॉर्डिंग रोकें और भेजें',
  'mic.startRecording': 'रिकॉर्डिंग शुरू करें',
  'mic.deviceSelector': 'माइक्रोफोन डिवाइस',
  'mic.tapToSendCountdown': 'भेजने के लिए टैप करें ({seconds}स)',
  'token.usageLimitReached': 'उपयोग सीमा पहुँच गई',
  'token.approachingLimit': 'सीमा के करीब',
  'token.planClickForDetails': 'प्लान - डिटेल्स के लिए क्लिक करें',
  'token.sessionTokens': 'इन: {in} | आउट: {out} | टर्न: {turns}',
  'token.limit': 'सीमा पहुँच गई',
  'token.inLabel': 'इन',
  'token.outLabel': 'आउट',
  'token.inputTokens': 'इस सत्र में इनपुट टोकन',
  'token.outputTokens': 'इस सत्र में आउटपुट टोकन',
  'token.turnsCount': 'इस सत्र में अनुमान चक्र',
  'token.turn': 'चक्र',
  'token.turns': 'चक्र',
  'token.ctxLabel': 'CTX',
  'token.contextWindow': 'संदर्भ विंडो उपयोग (अंतिम चक्र)',
  'token.cachedLabel': 'कैश्ड',
  'token.costLabel': 'लागत',
  'token.costTitle': 'इस सत्र की अनुमानित लागत (USD)',
  'token.sessionUsageTitle': 'सत्र उपयोग',
  'token.subAgentsHeading': 'उप-एजेंट उपयोग',
  'token.byAgentHeading': 'एजेंट अनुसार',
  'token.orchestrator': 'ऑर्केस्ट्रेटर',
  'token.noSubAgents': 'अभी तक कोई उप-एजेंट उपयोग नहीं',
  'token.popInput': 'इनपुट टोकन',
  'token.popOutput': 'आउटपुट टोकन',
  'token.popCacheHit': 'कैश हिट',
  'token.popContext': 'संदर्भ विंडो',
  'token.tipInput': 'इस सत्र में मॉडल को भेजे गए टोकन: आपके प्रॉम्प्ट और बातचीत का इतिहास।',
  'token.tipOutput': 'इस सत्र में मॉडल द्वारा उत्पन्न टोकन।',
  'token.tipCacheHit': 'कैश किए गए प्रॉम्प्ट प्रिफ़िक्स से दिए गए इनपुट टोकन, कम दर पर बिल किए गए।',
  'token.clickForDetails': 'सत्र उपयोग विवरण के लिए क्लिक करें',
  'catalog.noCapabilityBinding': 'कोई कैपेबिलिटी बाइंडिंग नहीं',
  'catalog.downloadFailed': 'डाउनलोड विफल',
  'catalog.active': 'एक्टिव',
  'catalog.installed': 'इन्स्टॉल्ड',
  'catalog.notDownloaded': 'डाउनलोड नहीं हुआ',
  'catalog.inUse': 'इस्तेमाल हो रहा है',
  'catalog.use': 'इस्तेमाल करें',
  'catalog.deleteModel': 'मॉडल डिलीट करें',
  'catalog.download': 'डाउनलोड करें',
  'navigator.recent': 'हाल का',
  'navigator.today': 'आज',
  'navigator.thisWeek': 'इस हफ्ते',
  'navigator.sources': 'सोर्स',
  'navigator.email': 'ईमेल',
  'navigator.slack': 'Slack',
  'navigator.chat': 'चैट',
  'navigator.documents': 'दस्तावेज़',
  'navigator.people': 'लोग',
  'navigator.topics': 'विषय',
  'dreams.description':
    'ड्रीम्स AI-जेनरेटेड रिफ्लेक्शन हैं जो आपकी मेमोरी के पैटर्न को सिंथेसाइज़ करते हैं।',
  'dreams.comingSoon': 'जल्द आ रहा है',
  'assignment.memoryLlm': 'मेमोरी LLM',
  'assignment.memoryLlmAria': 'मेमोरी LLM सिलेक्शन',
  'assignment.embedder': 'एम्बेडर',
  'assignment.loaded': 'लोड हुआ',
  'assignment.notDownloaded': 'डाउनलोड नहीं हुआ',
  'assignment.usedForExtractSummarise': 'एक्सट्रैक्शन और समरीज़ेशन के लिए इस्तेमाल',
  'insights.knownFacts': 'जानी-मानी बातें',
  'insights.preferences': 'पसंद',
  'insights.relationships': 'रिश्ते',
  'insights.skills': 'स्किल्स',
  'insights.opinions': 'राय',
  'insights.other': 'अन्य',
  'insights.title': 'इनसाइट्स',
  'insights.empty': 'अभी कोई इनसाइट नहीं। मेमोरी बढ़ने पर इनसाइट्स बनती हैं।',
  'insights.description': 'आपके मेमोरी ग्राफ में {count} रिलेशन के आधार पर।',
  'insights.items': 'आइटम्स',
  'insights.more': 'और',
  'calls.joiningCall': 'कॉल जॉइन हो रही है',
  'calls.meetWindowOpening': 'Meet विंडो खुल रही है...',
  'calls.failedToStart': 'Meet कॉल शुरू नहीं हो पाई',
  'calls.couldNotStart': 'कॉल शुरू नहीं हो पाई',
  'calls.failedToClose': 'कॉल बंद नहीं हो पाई',
  'calls.couldNotClose': 'कॉल बंद नहीं हो पाई',
  'calls.joinMeet': 'Google Meet कॉल जॉइन करें',
  'calls.joinMeetDescription': 'जॉइन करने के लिए Google Meet लिंक डालें।',
  'calls.meetLink': 'Meet लिंक',
  'calls.displayName': 'डिस्प्ले नाम',
  'calls.openingMeet': 'Meet खुल रहा है...',
  'calls.joinCall': 'कॉल जॉइन करें',
  'calls.activeCalls': 'एक्टिव कॉल्स',
  'calls.leave': 'छोड़ें',
  'workspace.wipeConfirm': 'क्या आप वाकई सारी मेमोरी मिटाना चाहते हैं? यह वापस नहीं होगा।',
  'workspace.resetTreeConfirm': 'क्या आप वाकई मेमोरी ट्री रीबिल्ड करना चाहते हैं?',
  'workspace.wipeTitle': 'मेमोरी मिटाएं',
  'workspace.resetting': 'रीसेट हो रहा है...',
  'workspace.resetMemory': 'मेमोरी रीसेट करें',
  'workspace.resetTreeTitle': 'मेमोरी ट्री रीबिल्ड करें',
  'workspace.rebuilding': 'रीबिल्ड हो रहा है...',
  'workspace.resetMemoryTree': 'मेमोरी ट्री रीसेट करें',
  'workspace.building': 'बन रहा है...',
  'workspace.buildSummaryTrees': 'समरी ट्री बनाएं',
  'workspace.viewVault': 'वॉल्ट देखें',
  'workspace.openingVaultTitle': 'ओब्सीडियन में तिजोरी खोलना',
  'workspace.openingVaultMessage':
    'यदि Obsidian नहीं खुलता, तो obsidian.md से इंस्टॉल करें या Reveal Folder उपयोग करें। वॉल्ट पथ:',
  'workspace.openVaultFailedTitle': 'Obsidian में वॉल्ट नहीं खुल सका',
  'workspace.openVaultFailedMessage':
    'वॉल्ट निर्देशिका को सीधे खोलने के लिए रिवील फोल्डर का उपयोग करें। तिजोरी पथ:',
  'workspace.revealVaultFailed': 'वॉल्ट फ़ोल्डर नहीं दिखाया जा सका',
  'workspace.revealFolder': 'फ़ोल्डर प्रकट करें',
  'workspace.checkingVault': 'जाँच हो रही है…',
  'workspace.vaultNotRegisteredHelp':
    'Obsidian केवल वे फ़ोल्डर खोलता है जो आपने वॉल्ट के रूप में जोड़े हैं। Obsidian में "Open folder as vault" चुनें और नीचे दिया फ़ोल्डर चुनें: यह एक बार करना है। फिर View Vault पर क्लिक करें।',
  'workspace.obsidianNotFoundHelp':
    'इस डिवाइस पर Obsidian नहीं मिला। इसे इंस्टॉल करें, या (यदि यह किसी गैर-मानक स्थान पर इंस्टॉल है) Advanced में इसका कॉन्फ़िग फ़ोल्डर सेट करें।',
  'workspace.openAnyway': 'फिर भी Obsidian में खोलें',
  'workspace.installObsidian': 'Obsidian इंस्टॉल करें',
  'workspace.obsidianAdvanced': 'Obsidian किसी और जगह इंस्टॉल है?',
  'workspace.obsidianConfigDirLabel': 'Obsidian कॉन्फ़िग फ़ोल्डर',
  'workspace.obsidianConfigDirHint':
    'obsidian.json वाले फ़ोल्डर का पथ (जैसे ~/.config/obsidian)। ऑटो-डिटेक्ट के लिए खाली छोड़ें।',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': 'मेमोरी ग्राफ लोड नहीं हो पाया',
  'workspace.loadingGraph': 'मेमोरी ग्राफ लोड हो रहा है...',
  'workspace.graphViewMode': 'मेमोरी ग्राफ व्यू मोड',
  'workspace.trees': 'ट्रीज़',
  'workspace.contacts': 'कॉन्टैक्ट्स',
  'graph.noContactMentions': 'कोई कॉन्टैक्ट मेंशन नहीं',
  'graph.noMemory': 'कोई मेमोरी नहीं',
  'graph.source': 'सोर्स',
  'graph.topic': 'विषय',
  'graph.global': 'ग्लोबल',
  'graph.document': 'दस्तावेज़',
  'graph.contact': 'कॉन्टैक्ट',
  'graph.nodes': 'नोड्स',
  'graph.parentChild': 'पेरेंट-चाइल्ड',
  'graph.documentContact': 'दस्तावेज़-कॉन्टैक्ट',
  'graph.link': 'लिंक',
  'graph.links': 'लिंक्स',
  'graph.children': 'चाइल्ड',
  'graph.clickToOpenObsidian': 'Obsidian में खोलने के लिए क्लिक करें',
  'graph.person': 'व्यक्ति',
  'graph.resetView': 'व्यू रीसेट करें',
  'modal.dontShowAgain': 'ऐसे सुझाव फिर न दिखाएं',
  'reflections.loading': 'रिफ्लेक्शन लोड हो रहे हैं...',
  'reflections.empty': 'अभी कोई रिफ्लेक्शन नहीं',
  'reflections.title': 'रिफ्लेक्शन',
  'reflections.proposedAction': 'प्रस्तावित एक्शन',
  'reflections.act': 'करें',
  'reflections.dismiss': 'हटाएं',
  'reflections.viewConversation': 'देखें',
  'subconscious.mode.label': 'अवचेतन मोड',
  'subconscious.mode.off.title': 'बंद',
  'subconscious.mode.off.desc': 'अवचेतन अक्षम है।',
  'subconscious.mode.simple.title': 'सरल',
  'subconscious.mode.simple.desc': 'केवल-पठन अवलोकन। केवल मेमोरी और फ़ाइल एक्सेस।',
  'subconscious.mode.aggressive.title': 'आक्रामक',
  'subconscious.mode.aggressive.desc':
    'पूर्ण टूल एक्सेस। लिख सकता है, एजेंट बना सकता है और कार्य सौंप सकता है।',
  'subconscious.mode.aggressiveWarning':
    'आक्रामक मोड अवचेतन को लेखन और उप-एजेंट निर्माण सहित पूर्ण टूल एक्सेस देता है।',
  'subconscious.interval.label': 'आवृत्ति',
  'subconscious.interval.minutes': '{n} मि',
  'subconscious.interval.hours': '{n} घं',
  'subconscious.interval.oneHour': '1 घंटा',
  'subconscious.interval.oneDay': '24 घंटे',
  'whatsapp.chatsSynced': 'चैट्स सिंक हुईं',
  'whatsapp.chatSynced': 'चैट सिंक हुई',
  'sync.active': 'एक्टिव',
  'sync.recent': 'हाल का',
  'sync.idle': 'आइडल',
  'sync.memorySources': 'मेमोरी सोर्स',
  'sync.noConnectedSources': 'कोई कनेक्टेड सोर्स नहीं',
  'sync.chunks': 'चंक्स',
  'sync.lastChunk': 'आखिरी चंक:',
  'sync.pending': 'पेंडिंग',
  'sync.processed': 'प्रोसेस्ड',
  'sync.syncing': 'सिंक हो रहा है…',
  'sync.sync': 'सिंक करें',
  'sync.failedToLoad': 'सिंक स्टेटस लोड नहीं हो पाई',
  'sync.noContent':
    'अभी कोई कॉन्टेंट मेमोरी में सिंक नहीं हुआ। शुरू करने के लिए कोई इंटीग्रेशन कनेक्ट करें।',
  'memorySyncInterval.title': 'सिंक शेड्यूल',
  'memorySyncInterval.lastSynced': 'अंतिम सिंक',
  'memorySyncInterval.never': 'कभी नहीं',
  'memorySyncInterval.everyHours': 'हर {h} घंटे',
  'memorySyncInterval.everyMinutes': 'हर {m} मिनट',
  'memorySyncInterval.manual': 'केवल मैन्युअल',
  'memorySyncInterval.saveFailed': 'सिंक शेड्यूल अपडेट करने में विफल',
  'memorySources.title': 'मेमोरी स्रोत',
  'memorySources.empty':
    'अभी तक कोई स्मृति स्रोत नहीं है। एक को खिला मेमोरी शुरू करने के लिए जोड़ें।',
  'memorySources.customSources': 'कस्टम स्रोत',
  'memorySources.addSource': 'स्रोत जोड़ें',
  'memorySources.noCustomSources':
    'अभी तक कोई कस्टम स्रोत नहीं है। एक फ़ोल्डर जोड़ें, GitHub रेपो, RSS फीड, या वेब पेज शुरू करने के लिए।',
  'memorySources.loadingConnections': 'कनेक्शन लोड हो रहा है...',
  'memorySources.noConnections': 'कोई सक्रिय Composio कनेक्शन नहीं मिला। पहले एकीकरण कनेक्ट करें।',
  'memorySources.pickConnection': 'कनेक्शन चुनें',
  'memorySources.selectConnection': '- एक कनेक्शन चुनें -',
  'memorySources.comingSoon': 'जल्द आ रहा है',
  'memorySources.composioListFailed': 'Composio कनेक्शन लोड करने में विफल रहा।',
  'memorySources.browse': 'ब्राउज़ करें',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '**',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'से:उपयोगकर्ता AI सुरक्षा',
  'memorySources.kind.composio': 'एकीकरण',
  'memorySources.kind.conversation': 'वार्तालाप',
  'memorySources.kind.folder': 'स्थानीय फ़ोल्डर',
  'memorySources.kind.github_repo': 'GitHub रेपो',
  'memorySources.kind.twitter_query': 'Twitter खोज',
  'memorySources.kind.rss_feed': 'RSS फ़ीड',
  'memorySources.kind.web_page': 'वेब पेज',
  'memorySources.sync.successTitle': 'सिंक करना',
  'memorySources.sync.successMessage': 'प्रगति शीघ्र ही दिखाई देगी।',
  'memorySources.sync.failedTitle': 'सिंक विफल:',
  'memorySources.sync.completeTitle': 'सिंक हो गया',
  'memorySources.sync.itemsSynced': 'आइटम सिंक हुए',
  'memorySources.sync.upToDate': 'अद्यतित',
  'memorySources.sync.failedLabel': 'विफल',
  'time.justNow': 'अभी',
  'time.secondsAgoSuffix': 'सेकंड पहले',
  'time.minutesAgoSuffix': 'मिनट पहले',
  'time.hoursAgoSuffix': 'घंटे पहले',
  'time.daysAgoSuffix': 'दिन पहले',
  'memorySources.pickKind': 'आप किस तरह के स्रोत को जोड़ना चाहते हैं?',
  'memorySources.backToKinds': 'स्रोत प्रकार वापस',
  'memorySources.label': 'लेबल',
  'memorySources.labelPlaceholder': 'मेरा शोध नोट',
  'memorySources.add': 'जोड़ें',
  'memorySources.adding': 'जोड़ना...',
  'memorySources.added': 'स्रोत जोड़ा',
  'memorySources.removed': 'स्रोत हटाया',
  'memorySources.remove': 'निकालें',
  'memorySources.enable': 'सक्षम',
  'memorySources.disable': 'अक्षम',
  'memorySources.toggleFailed': 'Toggle विफल',
  'memorySources.removeFailed': 'असफल',
  'memorySources.folderPath': 'फ़ोल्डर पथ',
  'memorySources.globPattern': 'ग्लोब पैटर्न',
  'memorySources.repoUrl': 'रिपॉजिटरी URL',
  'memorySources.branch': 'शाखा',
  'memorySources.feedUrl': 'URL',
  'memorySources.pageUrl': 'पृष्ठ URL',
  'memorySources.cssSelector': 'CSS चयनकर्ता (वैकल्पिक)',
  'memorySources.searchQuery': 'खोज क्वेरी',
  'memorySources.build.title': 'बनाएं',
  'memorySources.build.building': 'बना रहा है…',
  'memorySources.build.successTitle': 'ट्री बन गई',
  'memorySources.build.failedTitle': 'निर्माण विफल',
  'memorySources.build.sealsMessage': 'सील पूर्ण हुई',
  'memorySources.allIn.button': 'सब चालू',
  'memorySources.allIn.title': 'सब कुछ सक्रिय करें?',
  'memorySources.allIn.message':
    'यह सभी मेमोरी स्रोत सक्रिय करेगा और सभी सिंक सीमाएं हटा देगा। यह सबसे समृद्ध मेमोरी ग्राफ बनाता है, लेकिन अधिक क्रेडिट उपयोग कर सकता है।',
  'memorySources.allIn.confirm': 'हाँ',
  'memorySources.allIn.cancel': 'नहीं',
  'memorySources.allIn.success': 'सभी स्रोत बिना सीमा के सक्रिय हुए। सिंक शुरू हो गई।',
  'memorySources.allIn.failed': 'सब चालू नहीं किया जा सका। कृपया पुनः प्रयास करें।',
  'memorySources.settings.button': 'सेटिंग',
  'memorySources.settings.title': 'सिंक सेटिंग',
  'memorySources.settings.maxPrs': 'अधिकतम पुल रिक्वेस्ट',
  'memorySources.settings.maxIssues': 'अधिकतम इश्यू',
  'memorySources.settings.maxCommits': 'अधिकतम कमिट',
  'memorySources.settings.maxItems': 'अधिकतम आइटम',
  'memorySources.settings.sinceDays': 'पिछले दिन (दिनों में)',
  'memorySources.settings.syncDepthDays': 'सिंक गहराई (दिनों में)',
  'memorySources.settings.maxTokens': 'प्रति सिंक अधिकतम टोकन',
  'memorySources.settings.maxCost': 'प्रति सिंक अधिकतम लागत (USD)',
  'memorySources.settings.unlimited': 'असीमित',
  'memorySources.settings.unlimitedTooltip':
    'आपने {toolkit} के लिए अधिकतम सिंक करना चुना है। आप यहाँ सीमाएँ बदल सकते हैं।',
  'memorySources.settings.maxed': 'पूर्ण',
  'memorySources.settings.save': 'सहेजें',
  'memorySources.settings.saving': 'सहेजा जा रहा है…',
  'memorySources.settings.saved': 'सेटिंग सहेजी गई',
  'memorySources.settings.saveFailed': 'सेटिंग सहेजी नहीं जा सकी',
  'backend.aiBackend': 'AI बैकएंड',
  'backend.cloud': 'क्लाउड',
  'backend.recommended': 'सुझावित',
  'backend.cloudDescription': 'हमारे सर्वर पर तेज़ और पावरफुल मॉडल। तुरंत इस्तेमाल के लिए तैयार।',
  'backend.privacyNote': 'कोई पर्सनल डेटा, मैसेज या keys हमारे सर्वर पर कभी नहीं जाते।',
  'backend.local': 'लोकल',
  'backend.advanced': 'एडवांस्ड',
  'backend.localDescription':
    'Ollama का इस्तेमाल करके अपनी मशीन पर मॉडल चलाएं। पूरी प्राइवेसी, सेटअप ज़रूरी।',
  'backend.ramRecommended': '16GB+ RAM सुझावित',
  'subconscious.tasks': 'टास्क',
  'subconscious.ticks': 'टिक्स',
  'subconscious.last': 'आखिरी',
  'subconscious.failed': 'विफल',
  'subconscious.tickInterval': 'टिक इंटरवल',
  'subconscious.runNow': 'अभी चलाएं',
  'subconscious.instance.on': 'चालू',
  'subconscious.instance.off': 'बंद',
  'subconscious.instance.memory.title': 'आपकी दुनिया',
  'subconscious.instance.memory.subtitle': 'जुड़े हुए मेमोरी स्रोत',
  'subconscious.instance.tinyplace.title': 'ऑर्केस्ट्रेशन स्टीयरिंग',
  'subconscious.instance.tinyplace.subtitle': 'tiny.place सत्र समीक्षा',
  'subconscious.instance.tinyplace.disabledHint':
    'रैप किए गए सत्रों को नियंत्रित करने के लिए ऑर्केस्ट्रेशन सक्षम करें।',
  'subconscious.instance.tinyplace.viewDirectives': 'निर्देश देखें →',
  'subconscious.runReviewNow': 'अभी समीक्षा चलाएँ',
  'tinyplaceOrchestration.subconsciousBadge': 'अवचेतन · स्टीयरिंग',
  'tinyplaceOrchestration.steeringHeader.current': 'सक्रिय निर्देश',
  'tinyplaceOrchestration.steeringHeader.none': 'कोई सक्रिय निर्देश नहीं',
  'tinyplaceOrchestration.steeringHeader.expires': '{n} चक्रों के बाद समाप्त',
  'tinyplaceOrchestration.steeringHeader.lastReview': 'अंतिम समीक्षा',
  'tinyplaceOrchestration.steeringHeader.runReview': 'अभी समीक्षा चलाएँ',
  'tinyplaceOrchestration.steeringHeader.running': 'चल रहा है…',
  'subconscious.providerUnavailableTitle': 'Subconscious रुका हुआ है',
  'subconscious.providerSettings': 'AI सेटिंग्स',
  'subconscious.scratchpadInfo':
    'हर टिक पर सबकॉन्शस जाँचता है कि आपके जुड़े हुए स्रोतों में क्या बदला, फिर आपकी कार्य-सूची में फॉलो-अप दर्ज करता है, आपके लक्ष्य अपडेट करता है, या जब किसी चीज़ पर ध्यान देने की ज़रूरत हो तो आपको सूचित करता है। मोड और आवृत्ति कॉन्फ़िगर करने के लिए सेटिंग्स → एजेंट एक्सेस देखें।',
  'subconscious.approvalNeeded': 'अनुमति चाहिए',
  'subconscious.requiresApproval': 'अनुमति ज़रूरी है',
  'subconscious.fixInConnections': 'Connections में ठीक करें',
  'subconscious.goAhead': 'आगे बढ़ें',
  'subconscious.activeTasks': 'एक्टिव टास्क',
  'subconscious.noActiveTasks': 'कोई एक्टिव टास्क नहीं',
  'subconscious.default': 'डिफ़ॉल्ट',
  'subconscious.addTaskPlaceholder': 'नया टास्क जोड़ें...',
  'subconscious.activityLog': 'एक्टिविटी लॉग',
  'subconscious.noActivity': 'अभी कोई एक्टिविटी नहीं',
  'subconscious.decision.nothingNew': 'कुछ नया नहीं',
  'subconscious.decision.completed': 'पूरा हुआ',
  'subconscious.decision.evaluating': 'एवैल्यूएट हो रहा है',
  'subconscious.decision.waitingApproval': 'अनुमति का इंतज़ार है',
  'subconscious.decision.failed': 'विफल',
  'subconscious.decision.cancelled': 'रद्द हुआ',
  'subconscious.decision.skipped': 'स्किप हुआ',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': 'अवचेतन ट्रिगर',
  'subconsciousTriggers.subtitle': 'इवेंट-संचालित बैकग्राउंड ऑर्केस्ट्रेटर',
  'subconsciousTriggers.pipeline': 'पाइपलाइन',
  'subconsciousTriggers.mode': 'मोड',
  'subconsciousTriggers.orchestrator': 'ऑर्केस्ट्रेटर',
  'subconsciousTriggers.running': 'चल रहा है',
  'subconsciousTriggers.stopped': 'रुका हुआ',
  'subconsciousTriggers.promotionsPerHour': 'प्रमोशन / घंटा',
  'subconsciousTriggers.queueDepth': 'क़तार की गहराई',
  'subconsciousTriggers.orchestratorThread': 'ऑर्केस्ट्रेटर थ्रेड',
  'subconsciousTriggers.userThread': 'उपयोगकर्ता थ्रेड',
  'subconsciousTriggers.disabledHint': 'पाइपलाइन सक्रिय करने के लिए इवेंट-संचालित मोड सक्षम करें।',
  'subconsciousTriggers.enable': 'सक्षम करें',
  'subconsciousTriggers.disable': 'अक्षम करें',
  'actionable.complete': 'पूरा करें',
  'actionable.dismiss': 'हटाएं',
  'actionable.snooze': 'स्नूज़ करें',
  'actionable.new': 'नया',
  'stats.storage': 'स्टोरेज',
  'stats.files': 'फाइल्स',
  'stats.documents': 'दस्तावेज़',
  'stats.today': 'आज',
  'stats.namespaces': 'नेमस्पेस',
  'stats.relations': 'रिलेशन',
  'stats.firstMemory': 'पहली मेमोरी',
  'stats.latest': 'सबसे नया',
  'stats.sessions': 'सेशन',
  'stats.tokens': 'टोकन',
  'bootCheck.invalidUrl': 'कृपया एक रनटाइम URL डालें।',
  'bootCheck.urlMustStartWith': 'URL को http:// या https:// से शुरू होना चाहिए',
  'bootCheck.validUrlRequired': 'यह सही URL नहीं लगता (कोशिश करें https://core.example.com/rpc)',
  'bootCheck.tokenRequired': 'कनेक्ट करने के लिए एक auth टोकन चाहिए।',
  'bootCheck.httpPublicWarning':
    'यह किसी सार्वजनिक होस्ट पर सादा HTTP URL है: ट्रैफ़िक एन्क्रिप्ट नहीं होगा। जब तक आपको इस नेटवर्क पर भरोसा न हो, HTTPS का उपयोग करें।',
  'bootCheck.chooseCoreMode': 'रनटाइम चुनें',
  'bootCheck.connectToCore': 'अपने रनटाइम से कनेक्ट करें',
  'bootCheck.desktopDescription':
    'OpenHuman को सोचने के लिए एक रनटाइम चाहिए। चुनें कि यह कहाँ रहे।',
  'bootCheck.webDescription':
    'वेब पर, OpenHuman आपके कंट्रोल के रनटाइम से कनेक्ट होता है। नीचे URL और auth टोकन डालें, या अपनी मशीन पर चलाने के लिए डेस्कटॉप ऐप लें।',
  'bootCheck.preferDesktop': 'सब अपने डिवाइस पर रखना चाहते हैं?',
  'bootCheck.downloadDesktop': 'डेस्कटॉप ऐप पाएं',
  'bootCheck.localRecommended': 'लोकल रन करें (सुझावित)',
  'bootCheck.localDescription':
    'आपके कंप्यूटर पर ही चलता है। सबसे तेज़, पूरी तरह प्राइवेट, कुछ सेट नहीं करना।',
  'bootCheck.cloudMode': 'क्लाउड पर चलाएं (जटिल)',
  'bootCheck.cloudDescription':
    'कहीं और होस्ट किए रनटाइम से कनेक्ट करें। 24×7 ऑनलाइन रहता है, डिवाइस चलाते रहने की ज़रूरत नहीं।',
  'bootCheck.coreRpcUrl': 'रनटाइम URL',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': 'Auth टोकन',
  'bootCheck.bearerTokenPlaceholder': 'आपके रिमोट रनटाइम का bearer टोकन',
  'bootCheck.storedLocally': 'केवल इस डिवाइस पर रखा जाता है। भेजा जाता है ',
  'bootCheck.testing': 'टेस्ट हो रहा है…',
  'bootCheck.testConnection': 'कनेक्शन टेस्ट करें',
  'bootCheck.connectedOk': 'कनेक्ट हो गया। आप तैयार हैं।',
  'bootCheck.authFailed': 'वह टोकन काम नहीं किया। दोबारा चेक करके कोशिश करें।',
  'bootCheck.unreachablePrefix': 'नहीं पहुँच पाए:',
  'bootCheck.checkingCore': 'आपका रनटाइम जगा रहे हैं…',
  'bootCheck.cannotReach': 'रनटाइम तक नहीं पहुँच पाए',
  'bootCheck.cannotReachDesc':
    'आपके रनटाइम से कनेक्ट नहीं हो पाया। कोई और रनटाइम ट्राई करना चाहते हैं?',
  'bootCheck.switchMode': 'कोई और रनटाइम चुनें',
  'bootCheck.quit': 'बंद करें',
  'bootCheck.legacyDetected': 'पुराना बैकग्राउंड रनटाइम मिला',
  'bootCheck.legacyDescription':
    'इस डिवाइस पर अलग से इन्स्टॉल किया OpenHuman daemon पहले से चल रहा है। बिल्ट-इन रनटाइम शुरू होने से पहले इसे हटाना होगा।',
  'bootCheck.removing': 'हटाया जा रहा है…',
  'bootCheck.removeContinue': 'हटाएं और जारी रखें',
  'bootCheck.localNeedsRestart': 'लोकल रनटाइम को रीस्टार्ट चाहिए',
  'bootCheck.localNeedsRestartDesc':
    'आपका लोकल रनटाइम इस ऐप से अलग वर्जन पर है। एक जल्दी रीस्टार्ट से दोनों सिंक हो जाएंगे।',
  'bootCheck.restarting': 'रीस्टार्ट हो रहा है…',
  'bootCheck.restartCore': 'रनटाइम रीस्टार्ट करें',
  'bootCheck.cloudNeedsUpdate': 'क्लाउड रनटाइम को अपडेट चाहिए',
  'bootCheck.cloudNeedsUpdateDesc':
    'आपका क्लाउड रनटाइम इस ऐप से अलग वर्जन पर है। अपडेटर चलाएं ताकि दोनों सिंक हो जाएं।',
  'bootCheck.updating': 'अपडेट हो रहा है…',
  'bootCheck.updateCloudCore': 'क्लाउड रनटाइम अपडेट करें',
  'bootCheck.versionCheckFailed': 'रनटाइम वर्जन चेक विफल',
  'bootCheck.versionCheckFailedDesc':
    'आपका रनटाइम चल रहा है लेकिन वर्जन रिपोर्ट नहीं कर रहा। शायद पुराना हो। जारी रखने के लिए रीस्टार्ट या अपडेट करें।',
  'bootCheck.working': 'काम हो रहा है…',
  'bootCheck.restartUpdateCore': 'रनटाइम रीस्टार्ट / अपडेट करें',
  'bootCheck.unexpectedError': 'अनपेक्षित बूट-चेक एरर',
  'bootCheck.actionFailed': 'कुछ गड़बड़ हो गई। दोबारा कोशिश करें।',
  'bootCheck.portConflictTitle': 'ऐप इंजन शुरू नहीं हो सका',
  'bootCheck.portConflictBody':
    'कोई अन्य प्रक्रिया उस नेटवर्क पोर्ट का उपयोग कर रही है जो OpenHuman को चाहिए। हम इसे स्वचालित रूप से ठीक करने का प्रयास करेंगे।',
  'bootCheck.portConflictFixButton': 'स्वचालित रूप से ठीक करें',
  'bootCheck.portConflictFixing': 'ठीक हो रहा है…',
  'bootCheck.portConflictFixFailed':
    'स्वचालित सुधार काम नहीं आया। कृपया अपना कंप्यूटर पुनः आरंभ करें और पुनः प्रयास करें।',
  'bootCheck.portConflictOwner':
    '{name} (PID {pid}) उस नेटवर्क पोर्ट का उपयोग कर रहा है जिसकी OpenHuman को ज़रूरत है।',
  'bootCheck.portConflictGuidance':
    'पोर्ट खाली करने के लिए उस प्रोग्राम को बंद करें, या नीचे से उसे ज़बरदस्ती बंद करें, फिर पुनः प्रयास करें।',
  'bootCheck.portConflictForceQuit': '{name} को ज़बरदस्ती बंद करें',
  'bootCheck.portConflictForceQuitting': '{name} बंद हो रहा है…',
  'bootCheck.portConflictForceQuitFailed':
    'वह प्रोग्राम बंद नहीं किया जा सका। आपको इसे मैन्युअल रूप से बंद करके पुनः प्रयास करना पड़ सकता है।',
  'notifications.justNow': 'अभी-अभी',
  'notifications.minAgo': '{n}मि. पहले',
  'notifications.hrAgo': '{n}घं. पहले',
  'notifications.dayAgo': '{n}दि. पहले',
  'notifications.category.messages': 'मैसेज',
  'notifications.category.agents': 'एजेंट',
  'notifications.category.skills': 'स्किल्स',
  'notifications.category.system': 'सिस्टम',
  'notifications.category.meetings': 'मीटिंग',
  'notifications.category.reminders': 'रिमाइंडर',
  'notifications.category.important': 'महत्वपूर्ण',
  'notifications.filterAll': 'सभी',
  'notifications.filterEmpty': 'इस श्रेणी में कोई सूचना नहीं',
  'about.update.status.checking': 'चेक हो रहा है...',
  'about.update.status.available': 'v{version} उपलब्ध है',
  'about.update.status.availableNoVersion': 'अपडेट उपलब्ध है',
  'about.update.status.downloading': 'डाउनलोड हो रहा है...',
  'about.update.status.readyToInstall': 'v{version} इन्स्टॉल के लिए तैयार',
  'about.update.status.readyToInstallNoVersion':
    'नया वर्जन डाउनलोड हो गया और तैयार है। लागू करने के लिए रीस्टार्ट करें।',
  'about.update.status.installing': 'इन्स्टॉल हो रहा है...',
  'about.update.status.restarting': 'रीस्टार्ट हो रहा है...',
  'about.update.status.upToDate': 'आप लेटेस्ट वर्जन चला रहे हैं।',
  'about.update.status.error': 'अपडेट चेक विफल',
  'about.update.status.default': 'अपडेट चेक करें',
  'welcome.connectionFailed': 'कनेक्शन विफल: {status} {statusText}',
  'welcome.connectionFailedMsg': 'कनेक्शन विफल: {message}',
  'welcome.continueLocally': 'स्थानीय स्तर पर जारी रखें',
  'welcome.continueLocallyExperimental': 'लोकल रूप से जारी रखें (प्रायोगिक)',
  'welcome.localSessionStarting': 'स्थानीय सत्र प्रारंभ हो रहा है...',
  'welcome.coreConfigUnreadable':
    'रनटाइम अपनी कॉन्फ़िगरेशन फ़ाइल नहीं पढ़ सका। हो सकता है config.toml किसी दूसरे उपयोगकर्ता खाते का हो, या किसी अन्य कारण से रनटाइम प्रक्रिया के लिए दुर्गम हो। रनटाइम को पुनः आरंभ करें, और यदि इससे मदद न मिले तो वर्कस्पेस का स्वामित्व ठीक करें या उसका वॉल्यूम दोबारा बनाएँ।',
  'welcome.localSessionErrorFallback': 'स्थानीय सत्र शुरू नहीं किया जा सका।',
  'welcome.localSessionDesc':
    'ऑफ़लाइन स्थानीय प्रोफ़ाइल का उपयोग करता है और TinyHumans OAuth को छोड़ देता है।',
  'chat.agentChatDesc': 'एजेंट के साथ डायरेक्ट चैट सेशन खोलें।',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{channel} द्वारा {authMode}',
  'privacy.dataKind.messages': 'मैसेज',
  'privacy.dataKind.agents': 'एजेंट',
  'privacy.dataKind.skills': 'स्किल्स',
  'privacy.dataKind.system': 'सिस्टम',
  'privacy.dataKind.meetings': 'मीटिंग',
  'privacy.dataKind.reminders': 'रिमाइंडर',
  'privacy.dataKind.important': 'महत्वपूर्ण',
  'onboarding.enableLocalAI': 'लोकल AI चालू करें',
  'onboarding.skills.status.available': 'उपलब्ध',
  'onboarding.skills.status.connected': 'कनेक्टेड',
  'onboarding.skills.status.connecting': 'कनेक्ट हो रहा है',
  'onboarding.skills.status.error': 'एरर',
  'onboarding.skills.status.unavailable': 'उपलब्ध नहीं',
  'composio.statusUnavailable': 'स्टेटस उपलब्ध नहीं',
  'composio.authExpired': 'प्रमाणीकरण समाप्त',
  'composio.reconnect': 'पुनः कनेक्ट करें',
  'composio.expiredAuthorization': '{name} प्राधिकरण समाप्त हो गया',
  'composio.expiredDescription':
    '{name} टूल को पुनः सक्षम करने के लिए पुनः कनेक्ट करें। OpenHuman इस एकीकरण को तब तक अनुपलब्ध रखेगा जब तक आप OAuth पहुंच को ताज़ा नहीं करते।',
  'composio.envVarOverrides': 'सेट है तो यह सेटिंग ओवरराइड होती है।',
  'composio.previewBadge': 'पूर्वावलोकन',
  'composio.previewTooltip':
    'एजेंट एकीकरण जल्द ही आ रहा है - आप कनेक्ट कर सकते हैं, लेकिन एजेंट अभी तक इस टूलकिट का उपयोग नहीं कर सकता है।',
  'memory.day.sun': 'रवि',
  'memory.day.mon': 'सोम',
  'memory.day.tue': 'मंगल',
  'memory.day.wed': 'बुध',
  'memory.day.thu': 'गुरु',
  'memory.day.fri': 'शुक्र',
  'memory.day.sat': 'शनि',
  'memory.ingesting': 'इन्जेस्ट हो रहा है',
  'memory.ingestionQueued': 'क्यू में है',
  'memory.ingestingTitle': '{title} इन्जेस्ट हो रहा है',
  'mic.noAudioCaptured': 'कोई ऑडियो कैप्चर नहीं हुआ',
  'mic.noSpeechDetected': 'कोई बोलना नहीं मिला',
  'mic.lowConfidenceResult': 'ऑडियो स्पष्ट रूप से समझ नहीं आया: कृपया पुनः प्रयास करें',
  'mic.failedToStopRecording': 'रिकॉर्डिंग रोकने में दिक्कत: {message}',
  'mic.transcriptionFailed': 'ट्रांसक्रिप्शन विफल: {message}',
  'mic.voiceNotCompiled':
    'इस ऐप संस्करण में वॉइस ट्रांसक्रिप्शन शामिल नहीं है। इसे चालू करने के लिए OpenHuman को अपडेट करें।',
  'reflections.kind.retrospective': 'रेट्रोस्पेक्टिव',
  'reflections.kind.derivedFact': 'डिराइव्ड फैक्ट',
  'reflections.kind.moodInsight': 'मूड इनसाइट',
  'reflections.kind.relationshipInsight': 'रिलेशनशिप इनसाइट',
  'graph.tooltip.summary': 'सारांश',
  'graph.tooltip.contact': 'कॉन्टैक्ट',
  'localModel.usage.never': 'कभी नहीं',
  'localModel.usage.mediumLoad': 'मीडियम लोड',
  'localModel.usage.lowLoad': 'लो लोड',
  'localModel.usage.idleMode': 'आइडल मोड',
  'localModel.rebootstrapComplete': 'मॉडल री-बूटस्ट्रैप पूरा हुआ।',
  'localModel.modelsVerified': 'लोकल मॉडल वेरिफाई हो गए।',
  'accounts.addModal.allConnected': 'सब कनेक्टेड',
  'accounts.addModal.title': 'अकाउंट जोड़ें',
  'accounts.respondQueue.empty': 'खाली है',
  'accounts.respondQueue.hide': 'उत्तर कतार छिपाएँ',
  'accounts.respondQueue.loadFailed': 'रिस्पॉन्ड क्यू लोड नहीं हो पाई',
  'accounts.respondQueue.loading': 'क्यू लोड हो रही है…',
  'accounts.respondQueue.pending': 'पेंडिंग',
  'accounts.respondQueue.show': 'उत्तर कतार दिखाएँ',
  'accounts.respondQueue.title': 'रिस्पॉन्ड क्यू',
  'accounts.webviewHost.almostReady': 'लगभग तैयार है...',
  'accounts.webviewHost.loadTimeout': 'Webview लोड टाइमआउट',
  'accounts.webviewHost.loading': '{providerName} लोड हो रहा है...',
  'accounts.webviewHost.loadingAccount': 'अकाउंट लोड हो रहा है',
  'accounts.webviewHost.restoringSession': 'सेशन रिस्टोर हो रहा है...',
  'accounts.webviewHost.retryLoading': 'दोबारा लोड करें',
  'accounts.webviewHost.takingLonger': '{providerName} उम्मीद से ज़्यादा समय ले रहा है।',
  'accounts.webviewHost.timeoutHint': 'टाइमआउट हिंट',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': 'मैसेजिंग',
  'app.connectionIndicator.connected': 'OpenHuman AI से कनेक्टेड 🚀',
  'app.connectionIndicator.connecting': 'कनेक्ट हो रहा है',
  'app.connectionIndicator.coreOffline': 'कोर ऑफलाइन',
  'app.connectionIndicator.disconnected': 'डिसकनेक्टेड',
  'app.connectionIndicator.offline': 'ऑफलाइन',
  'app.connectionIndicator.reconnecting': 'पुनः कनेक्ट हो रहा है…',
  'app.errorFallback.componentStack': 'कम्पोनेंट स्टैक',
  'app.errorFallback.contactSupport': 'सहायता से संपर्क करें',
  'app.errorFallback.copyEventId': 'कॉपी करें',
  'app.errorFallback.eventIdCopied': 'कॉपी हो गया',
  'app.errorFallback.eventIdLabel': 'त्रुटि आईडी',
  'app.errorFallback.revealLogs': 'लॉग दिखाएं',
  'app.errorFallback.downloadLatest': 'लेटेस्ट डाउनलोड करें',
  'app.errorFallback.heading': 'शीर्षक',
  'app.errorFallback.hint': 'संकेत',
  'app.errorFallback.reloadApp': 'ऐप रिलोड करें',
  'app.errorFallback.subheading': 'उपशीर्षक',
  'app.errorFallback.tryRecover': 'रिकवर करने की कोशिश करें',
  'app.localAiDownload.installing': 'इन्स्टॉल हो रहा है...',
  'app.localAiDownload.preparing': 'तैयार हो रहा है...',
  'app.openhumanLink.accounts.continueWith': '{label} साइन-इन के साथ जारी रखें',
  'app.openhumanLink.accounts.done': 'हो गया',
  'app.openhumanLink.accounts.intro': 'परिचय',
  'app.openhumanLink.accounts.webviewNote': 'वेबव्यू नोट',
  'app.openhumanLink.billing.openDashboard': 'डैशबोर्ड खोलें',
  'app.openhumanLink.billing.stayOnTrial': 'ट्रायल पर रहें',
  'app.openhumanLink.billing.trialCredit': 'साइनअप क्रेडिट',
  'app.openhumanLink.billing.trialDesc':
    'क्रेडिट ऑफ़र प्रमोशन और खाते की पात्रता के अनुसार अलग हो सकते हैं।',
  'app.openhumanLink.defaultBody':
    'पॉपअप में अभी तैयार नहीं है। जब आवश्यकता हो तो पूर्ण सेटिंग्स पृष्ठ खोलें।',
  'app.openhumanLink.discord.intro': 'परिचय',
  'app.openhumanLink.discord.openInvite': 'इनवाइट खोलें',
  'app.openhumanLink.discord.perk1': 'लाभ 1',
  'app.openhumanLink.discord.perk2': 'लाभ 2',
  'app.openhumanLink.discord.perk3': 'लाभ 3',
  'app.openhumanLink.discord.perk4': 'लाभ 4',
  'app.openhumanLink.discordReport.intro':
    'माफ करें: हमारी तरफ से कुछ गड़बड़ हुई। हम इन्हें स्वचालित रूप से लॉग करने की कोशिश करते हैं, लेकिन Discord पर विवरण साझा करने से हमें इसे जल्दी ठीक करने में मदद मिलती है।',
  'app.openhumanLink.discordReport.openDiscord': 'Discord खोलें',
  'app.openhumanLink.done': 'हो गया',
  'app.openhumanLink.notifications.desktopOnly':
    'मूल सूचनाएँ केवल डेस्कटॉप ऐप में उपलब्ध हैं (`pnpm dev:app` चलाएँ)।',
  'app.openhumanLink.notifications.permissionOff':
    'सूचना अनुमति बंद है। सिस्टम सेटिंग्स → सूचनाएँ में OpenHuman को सक्षम करें, फिर पुनः प्रयास करें।',
  'app.openhumanLink.notifications.triggerFailed':
    'OpenHuman सिस्टम सूचना ट्रिगर नहीं कर सका। OS की सूचना सेटिंग्स जाँचें और पुनः प्रयास करें।',
  'app.openhumanLink.notifications.welcomeBody':
    'जब किसी चीज़ पर आपका ध्यान चाहिए होगा, तो आपको यहाँ अलर्ट मिलेंगे।',
  'app.openhumanLink.notifications.welcomeTitle': 'OpenHuman उपयोग के लिए तैयार है',
  'app.openhumanLink.status.closed': 'बंद',
  'app.openhumanLink.status.connected': 'कनेक्टेड',
  'app.openhumanLink.status.error': 'त्रुटि',
  'app.openhumanLink.status.loading': 'लोड हो रहा है…',
  'app.openhumanLink.status.needsSignIn': 'साइन-इन आवश्यक',
  'app.openhumanLink.status.timedOut': 'समय समाप्त',
  'app.openhumanLink.loadingChannelSetup': 'चैनल सेटअप लोड हो रहा है',
  'app.openhumanLink.maybeLater': 'शायद बाद में',
  'app.openhumanLink.notifications.asking': 'OS से पूछ रहे हैं…',
  'app.openhumanLink.notifications.blocked': 'ब्लॉक्ड',
  'app.openhumanLink.notifications.blockedStep1': 'ब्लॉक्ड चरण 1',
  'app.openhumanLink.notifications.blockedStep2': 'ब्लॉक्ड चरण 2',
  'app.openhumanLink.notifications.blockedStep3': 'ब्लॉक्ड चरण 3',
  'app.openhumanLink.notifications.intro': 'परिचय',
  'app.openhumanLink.notifications.promptHint': 'प्रॉम्प्ट संकेत',
  'app.openhumanLink.notifications.retry': 'टेस्ट नोटिफिकेशन फिर भेजें',
  'app.openhumanLink.notifications.send': 'टेस्ट नोटिफिकेशन भेजें',
  'app.openhumanLink.notifications.sendFailed': 'भेजा नहीं जा सका: {error}',
  'app.openhumanLink.notifications.sent':
    'टेस्ट नोटिफ़िकेशन भेज दिया गया। यदि आपको प्राप्त नहीं हुआ, तो System Settings → Notifications → OpenHuman पर जाएँ, Allow Notifications चालू करें, और Banner Style को Persistent पर सेट करें।',
  'app.openhumanLink.skipForNow': 'अभी के लिए स्किप करें',
  'app.openhumanLink.telegramUnavailable': 'Telegram उपलब्ध नहीं',
  'app.openhumanLink.title.accounts': 'अपने ऐप्स कनेक्ट करें',
  'app.openhumanLink.title.billing': 'बिलिंग और क्रेडिट',
  'app.openhumanLink.title.discord': 'कम्युनिटी जॉइन करें',
  'app.openhumanLink.title.discordReport': 'इस त्रुटि की रिपोर्ट करें',
  'app.openhumanLink.title.messaging': 'चैट चैनल कनेक्ट करें',
  'app.openhumanLink.title.notifications': 'नोटिफिकेशन की अनुमति दें',
  'app.persistRehydration.body': 'विवरण',
  'app.persistRehydration.heading': 'शीर्षक',
  'app.persistRehydration.resetCta': 'रीसेट हो रहा है…',
  'app.persistRehydration.resetting': 'रीसेट हो रहा है…',
  'app.routeLoading.initializing': 'OpenHuman आरंभ हो रहा है...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': 'अपडेट के दौरान कुछ गड़बड़ हो गई।',
  'app.update.header.default': 'अपडेट',
  'app.update.header.error': 'अपडेट विफल',
  'app.update.header.installing': 'अपडेट इन्स्टॉल हो रहा है',
  'app.update.header.readyToInstall': 'अपडेट इन्स्टॉल के लिए तैयार',
  'app.update.header.restarting': 'रीस्टार्ट हो रहा है…',
  'app.update.later': 'बाद में',
  'app.update.newVersionReady': 'नया वर्जन इन्स्टॉल के लिए तैयार है।',
  'app.update.progress.downloaded': '{amount} डाउनलोड हुआ',
  'app.update.progress.installing': 'नया वर्जन इन्स्टॉल हो रहा है…',
  'app.update.progress.restarting': 'ऐप फिर से लॉन्च हो रहा है…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': 'पुनः आरंभ नोट',
  'app.update.restartNow': 'अभी रीस्टार्ट करें',
  'app.update.versionReady': 'वर्जन {newVersion} इन्स्टॉल के लिए तैयार है।',
  'channels.discord.accountLinked': 'अकाउंट लिंक हो गया',
  'channels.discord.connect': 'कनेक्ट करें',
  'channels.discord.linkTokenExpired': 'लिंक टोकन एक्सपायर हो गया। दोबारा कोशिश करें।',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': 'लिंक टोकन लेबल',
  'channels.discord.linkTokenOnce': 'लिंक टोकन एक बार',
  'channels.discord.picker.allPermissionsOk': 'बॉट के पास इस चैनल में सभी ज़रूरी परमिशन हैं।',
  'channels.discord.picker.botNotInServers': 'बॉट किसी सर्वर में नहीं है',
  'channels.discord.picker.category': 'श्रेणी',
  'channels.discord.picker.channel': 'चैनल',
  'channels.discord.picker.checkingPermissions': 'परमिशन चेक हो रही हैं',
  'channels.discord.picker.loadingChannels': 'चैनल लोड हो रहे हैं...',
  'channels.discord.picker.loadingServers': 'सर्वर लोड हो रहे हैं...',
  'channels.discord.picker.missingPermissions': 'परमिशन नहीं हैं',
  'channels.discord.picker.noChannels': 'कोई टेक्स्ट चैनल नहीं मिला',
  'channels.discord.picker.noServers': 'कोई सर्वर नहीं मिला',
  'channels.discord.picker.selectChannel': 'एक चैनल चुनें',
  'channels.discord.picker.selectServer': 'एक सर्वर चुनें',
  'channels.discord.picker.server': 'सर्वर',
  'channels.discord.picker.serverChannelSelection': 'सर्वर और चैनल चयन',
  'channels.discord.savedRestartRequired':
    'चैनल सेव हो गया। एक्टिवेट करने के लिए ऐप रीस्टार्ट करें।',
  'channels.telegram.connect': 'कनेक्ट करें',
  'channels.telegram.managedDmConnecting': 'मैनेज्ड DM कनेक्ट हो रहा है',
  'channels.telegram.managedDmTimeout': 'मैनेज्ड DM टाइमआउट',
  'channels.telegram.reconnect': 'फिर से कनेक्ट करें',
  'channels.telegram.savedRestartRequired':
    'चैनल सेव हो गया। एक्टिवेट करने के लिए ऐप रीस्टार्ट करें।',
  'channels.web.alwaysAvailable': 'हमेशा उपलब्ध',
  'chat.approval.approve': 'स्वीकृति',
  'chat.approval.alwaysAllow': 'हमेशा अनुमति दें',
  'chat.approval.alwaysAllowHint':
    'इस उपकरण के लिए पूछना बंद करो - इसे अपने हमेशा की अनुमति सूची में जोड़ें',
  'chat.approval.deciding': 'कार्य...',
  'chat.approval.deny': 'डेनी',
  'chat.approval.error': 'अपने निर्णय को रिकॉर्ड नहीं कर सकता - फिर से प्रयास करें।',
  'chat.approval.fallback': 'एजेंट अपने अनुमोदन की जरूरत है कि एक कार्रवाई चलाने के लिए चाहता है।',
  'chat.approval.title': 'आवश्यक अनुमोदन',
  'chat.approval.tool': 'उपकरण:',
  'chat.flowApproval.title': 'वर्कफ़्लो को अनुमोदन की आवश्यकता है',
  'chat.flowApproval.fallback': 'एक वर्कफ़्लो रन आपकी अनुमति चाहने वाली एक क्रिया करना चाहता है।',
  'chat.flowApproval.tool': 'उपकरण:',
  'chat.flowApproval.flow': 'फ़्लो:',
  'chat.flowApproval.approve': 'एक बार स्वीकृति दें',
  'chat.flowApproval.approveAlways': 'हमेशा स्वीकृति दें',
  'chat.flowApproval.approveAlwaysHint': 'इस फ़्लो के भविष्य के रन के लिए इस चेकपॉइंट को छोड़ें',
  'chat.flowApproval.deny': 'अस्वीकार करें',
  'chat.flowApproval.deciding': 'कार्य प्रगति पर…',
  'chat.flowApproval.error': 'अपने निर्णय को रिकॉर्ड नहीं कर सकता - फिर से प्रयास करें।',
  'chat.flowProposal.title': 'वर्कफ़्लो प्रस्ताव',
  'chat.flowProposal.subtitle': 'सहेजने से पहले इस स्वचालन की समीक्षा करें।',
  'chat.flowProposal.triggerLabel': 'ट्रिगर',
  'chat.flowProposal.stepsLabel': 'चरण',
  'chat.flowProposal.noSteps': 'कोई अतिरिक्त चरण नहीं।',
  'chat.flowProposal.requireApprovalHint': 'हर बाहरी कार्रवाई के लिए आपकी स्वीकृति आवश्यक होगी।',
  'chat.flowProposal.save': 'सहेजें और सक्षम करें',
  'chat.flowProposal.saving': 'सहेजा जा रहा है…',
  'chat.flowProposal.openInCanvas': 'कैनवास में खोलें',
  'chat.flowProposal.dismiss': 'खारिज करें',
  'chat.flowProposal.error': 'वर्कफ़्लो सहेजा नहीं जा सका। कृपया फिर से प्रयास करें।',
  'chat.flowProposal.enableError':
    'वर्कफ़्लो सहेजा गया, लेकिन सक्षम नहीं किया जा सका। फिर से प्रयास करें, या Workflows पेज से इसे सक्षम करें।',
  'chat.flowProposal.savedConfirmation': 'सहेजा गया',
  'chat.flowProposal.viewWorkflow': 'वर्कफ़्लो देखें',
  'chat.flowProposal.stepKind.agent': 'एजेंट',
  'chat.flowProposal.stepKind.toolCall': 'कार्रवाई',
  'chat.flowProposal.stepKind.httpRequest': 'वेब अनुरोध',
  'chat.flowProposal.stepKind.code': 'कोड चलाएं',
  'chat.flowProposal.stepKind.condition': 'शर्त',
  'chat.flowProposal.stepKind.switch': 'स्विच',
  'chat.flowProposal.stepKind.merge': 'मर्ज करें',
  'chat.flowProposal.stepKind.splitOut': 'विभाजित करें',
  'chat.flowProposal.stepKind.transform': 'रूपांतरित करें',
  'chat.flowProposal.stepKind.outputParser': 'आउटपुट पार्स करें',
  'chat.flowProposal.stepKind.subWorkflow': 'सब-वर्कफ़्लो',
  'channels.authMode.managed_dm': 'OpenHuman से लॉगिन करें',
  'channels.authMode.oauth': 'OAuth साइन-इन करें',
  'channels.authMode.bot_token': 'अपने स्वयं के बॉट टोकन का उपयोग करें',
  'channels.authMode.api_key': 'अपनी स्वयं की API कुंजी का उपयोग करें',
  'channels.fieldRequired': '{field} आवश्यक है',
  'channels.mcp.title': 'MCP सर्वर',
  'channels.mcp.description':
    'AI को नए टूल्स से विस्तारित करने वाले Model Context Protocol सर्वर ब्राउज़ और प्रबंधित करें।',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': 'Discord के माध्यम से संदेश भेजें और प्राप्त करें।',
  'channels.discord.authMode.bot_token.description': 'अपना स्वयं का Discord बॉट टोकन प्रदान करें।',
  'channels.discord.authMode.oauth.description':
    'OpenHuman बॉट को OAuth के माध्यम से अपने Discord सर्वर पर स्थापित करें।',
  'channels.discord.authMode.managed_dm.description':
    'अपने व्यक्तिगत Discord खाते को OpenHuman बॉट से लिंक करें।',
  'channels.discord.fields.bot_token.label': 'बॉट टोकन',
  'channels.discord.fields.bot_token.placeholder': 'आपका Discord बॉट टोकन',
  'channels.discord.fields.guild_id.label': 'सर्वर (गिल्ड) आईडी',
  'channels.discord.fields.guild_id.placeholder': 'वैकल्पिक: एक विशिष्ट सर्वर तक सीमित रखें',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': 'Telegram के माध्यम से संदेश भेजें और प्राप्त करें।',
  'channels.telegram.authMode.managed_dm.description':
    'OpenHuman Telegram बॉट को सीधे संदेश भेजें।',
  'channels.telegram.authMode.bot_token.description':
    '@BotFather से अपना स्वयं का Telegram बॉट टोकन प्रदान करें।',
  'channels.telegram.fields.bot_token.label': 'बॉट टोकन',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': 'अनुमत उपयोगकर्ता',
  'channels.telegram.fields.allowed_users.placeholder':
    'अल्पविराम से अलग किए गए Telegram उपयोक्तानाम',
  'channels.telegram.remoteControlTitle': 'रिमोट कंट्रोल (Telegram)',
  'channels.telegram.remoteControlBody':
    'अनुमत Telegram चैट से, /स्थिति, /सत्र, /नया, या /सहायता भेजें। मॉडल रूटिंग अभी भी /मॉडल और /मॉडल का उपयोग करती है।',
  'channels.connectHelp.title': 'कैसे कनेक्ट करें',
  'channels.connectHelp.discord':
    'नीचे एक तरीका चुनें: OpenHuman के ज़रिए अपना अकाउंट लिंक करें, OAuth से बॉट इंस्टॉल करें, या Discord डेवलपर पोर्टल से अपना खुद का बॉट टोकन पेस्ट करें।',
  'channels.connectHelp.telegram':
    'नीचे एक तरीका चुनें: लिंक करने के लिए मैनेज्ड OpenHuman बॉट को मैसेज करें, या @BotFather से अपना खुद का बॉट टोकन पेस्ट करें।',
  'channels.connectHelp.slackNote':
    'Slack ढूँढ रहे हैं? Slack यहाँ मैसेजिंग चैनल के रूप में नहीं, बल्कि कनेक्शन → OAuth में एक ऐप के रूप में कनेक्ट होता है।',
  'channels.web.displayName': 'वेब',
  'channels.web.description': 'अंतर्निहित वेब यूआई के माध्यम से चैट करें।',
  'channels.web.authMode.managed_dm.description':
    'एम्बेडेड वेब चैट का उपयोग करें - किसी सेटअप की आवश्यकता नहीं है।',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': 'कनेक्ट हो रहा है…',
  'channels.yuanbao.fieldRequired': '{field} आवश्यक है',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired':
    'चैनल सहेजा गया। इसे सक्रिय करने के लिए ऐप पुनः आरंभ करें।',
  'channels.yuanbao.unexpectedStatus': 'अप्रत्याशित कनेक्शन स्थिति: {status}',
  'chat.unsubscribeApproval.approve': 'स्वीकृत करें और सदस्यता समाप्त करें',
  'chat.unsubscribeApproval.approved': '✓ सफलतापूर्वक सदस्यता समाप्त की गई।',
  'chat.unsubscribeApproval.denied': '✕ रिक्वेस्ट नामंज़ूर।',
  'chat.unsubscribeApproval.deny': 'नामंज़ूर करें',
  'chat.unsubscribeApproval.processing': 'प्रोसेस हो रहा है...',
  'chat.unsubscribeApproval.title': 'सदस्यता समाप्ति अनुरोध',
  'commandPalette.ariaLabel': 'कमांड पैलेट',
  'commandPalette.description': 'विवरण',
  'commandPalette.label': 'कमांड',
  'commandPalette.noResults': 'कोई रिज़ल्ट नहीं',
  'commandPalette.placeholder': 'कोई कमांड टाइप करें या सर्च करें…',
  'commandPalette.searchAria': 'कमांड सर्च करें',
  'commandPalette.shortcutHint': 'सभी शॉर्टकट के लिए ? दबाएँ',
  'commandPalette.title': 'कमांड पैलेट',
  'kbd.ariaLabel': 'कीबोर्ड शॉर्टकट: {shortcut}',
  'shortcuts.title': 'कीबोर्ड शॉर्टकट',
  'shortcuts.subtitle': 'इन कीबोर्ड शॉर्टकट से अपने काम को तेज़ करें।',
  'shortcuts.menuDesc': 'ऐप के सभी कीबोर्ड शॉर्टकट देखें।',
  'shortcuts.empty': 'अभी कोई कीबोर्ड शॉर्टकट उपलब्ध नहीं है।',
  'shortcuts.openHint': 'इस सूची को कभी भी इससे खोलें',
  'shortcuts.group.navigation': 'नेविगेशन',
  'shortcuts.group.profiles': 'प्रोफ़ाइल',
  'shortcuts.group.chat': 'चैट',
  'shortcuts.group.view': 'व्यू',
  'shortcuts.group.general': 'सामान्य',
  'shortcuts.group.help': 'सहायता',
  'shortcuts.action.home': 'होम पर जाएं',
  'shortcuts.action.chat': 'चैट पर जाएं',
  'shortcuts.action.knowledge': 'ज्ञान और मेमोरी पर जाएं',
  'shortcuts.action.connections': 'कनेक्शन पर जाएं',
  'shortcuts.action.activity': 'गतिविधि पर जाएं',
  'shortcuts.action.settings': 'सेटिंग्स खोलें',
  'shortcuts.action.newChat': 'नई चैट',
  'shortcuts.action.toggleSidebar': 'साइडबार टॉगल करें',
  'shortcuts.action.commandPalette': 'कमांड पैलेट',
  'iosMascot.connectedTo': 'से जुड़ा हुआ है',
  'iosMascot.defaultPairedLabel': 'डेस्कटॉप',
  'iosMascot.disconnect': 'डिस्कनेक्ट करें',
  'iosMascot.error.generic': 'कुछ ग़लत हो गया. कृपया पुन: प्रयास करें।',
  'iosMascot.error.sendFailed': 'भेजने में विफल. अपना कनेक्शन जांचें.',
  'iosMascot.pushToTalk': 'बात करने के लिए दबाव डालें',
  'iosMascot.sendMessage': 'संदेश भेजें',
  'iosMascot.thinking': 'सोच रहा हूँ...',
  'iosMascot.typeMessage': 'एक संदेश टाइप करें...',
  'iosPair.connectedLoading': 'जुड़ा हुआ! लोड हो रहा है...',
  'iosPair.connecting': 'डेस्कटॉप से कनेक्ट हो रहा है...',
  'iosPair.desktopLabel': 'डेस्कटॉप',
  'iosPair.error.camera': 'कैमरा स्कैन विफल रहा. कैमरा अनुमतियाँ जाँचें और पुनः प्रयास करें।',
  'iosPair.error.connectionFailed':
    'कनेक्शन विफल। सुनिश्चित करें कि डेस्कटॉप ऐप चल रहा है और पुनः प्रयास करें।',
  'iosPair.error.invalidQr':
    'अमान्य QR कोड। सुनिश्चित करें कि आप OpenHuman पेयरिंग कोड स्कैन कर रहे हैं।',
  'iosPair.error.unreachableDesktop':
    'डेस्कटॉप से संपर्क नहीं हो सका। सुनिश्चित करें कि दोनों डिवाइस ऑनलाइन हैं और पुनः प्रयास करें।',
  'iosPair.expired': 'QR code समाप्त हो गया. डेस्कटॉप से ​​कोड पुनः जनरेट करने के लिए कहें।',
  'iosPair.instructions':
    'अपने डेस्कटॉप पर OpenHuman खोलें, Settings > Devices पर जाएं, और QR कोड दिखाने के लिए "Pair phone" टैप करें।',
  'iosPair.retryScan': 'पुनः स्कैन करने का प्रयास करें',
  'iosPair.scanQrCode': 'स्कैन QR code',
  'iosPair.scannerOpening': 'स्कैनर खुल रहा है...',
  'iosPair.step.openDesktop': 'डेस्कटॉप पर OpenHuman खोलें',
  'iosPair.step.openSettings': 'सेटिंग्स > डिवाइसेस पर जाएँ',
  'iosPair.step.showQr': 'QR दिखाने के लिए "फ़ोन जोड़ें" पर टैप करें',
  'iosPair.title': 'अपने डेस्कटॉप के साथ युग्मित करें',
  'composio.connect.additionalConfigRequired': 'अतिरिक्त कॉन्फिग ज़रूरी है',
  'composio.connect.atlassianSubdomainHint': 'एक्मे',
  'composio.connect.atlassianSubdomainLabel': 'Atlassian सबडोमेन लेबल',
  'composio.connect.connect': 'कनेक्ट करें',
  'composio.connect.connectedAccounts': 'कनेक्टेड अकाउंट',
  'composio.connect.defaultLabel': 'डिफ़ॉल्ट',
  'composio.connect.disconnectAccount': 'हटाएं',
  'composio.connect.addAnotherAccount': 'एक और अकाउंट जोड़ें',
  'composio.connect.dynamicsOrgNameHint':
    'उदाहरण के लिए, myorg.crm.dynamics.com के लिए "myorg"। केवल छोटा संगठन नाम दर्ज करें, पूरा URL नहीं।',
  'composio.connect.dynamicsOrgNameLabel': 'Dynamics 365 संगठन का नाम',
  'composio.connect.connectionFailed': 'कनेक्शन विफल (स्थिति: {status})।',
  'composio.connect.disconnectFailed': 'डिसकनेक्ट विफल: {msg}',
  'composio.connect.disconnecting': 'डिसकनेक्ट हो रहा है…',
  'composio.connect.idleDescription': 'अपना कनेक्ट करें',
  'composio.connect.idleDescriptionSuffix':
    'खाता। हम एक ब्राउज़र विंडो खोलेंगे, आप वहाँ एक्सेस स्वीकृत करते हैं, और यह ऐप कनेक्शन को स्वचालित रूप से पहचान लेगा।',
  'composio.connect.isConnected': 'कनेक्ट है।',
  'composio.connect.manage': 'प्रबंधित करें',
  'composio.connect.needsFieldsPrefix': 'कनेक्ट करने के लिए',
  'composio.connect.needsFieldsSuffix':
    'हमें कुछ अतिरिक्त जानकारी चाहिए। नीचे लापता फ़ील्ड भरें और फिर से प्रयास करें।',
  'composio.connect.needsSubdomain': 'कनेक्ट करने के लिए',
  'composio.connect.needsSubdomainSuffix':
    'अपना Atlassian सबडोमेन दर्ज करें (जैसे acme.atlassian.net के लिए acme) और पुनः प्रयास करें।',
  'composio.connect.oauthComplete': 'OAuth पूरा करने के लिए…',
  'composio.connect.oauthTimeout': 'OAuth टाइमआउट',
  'composio.connect.permissions': 'परमिशन',
  'composio.connect.permissionsDefault': 'Read + Write डिफ़ॉल्ट रूप से चालू',
  'composio.connect.permissionsNote': 'उजागर कर सकता है',
  'composio.connect.permissionsNoteSuffix':
    'OpenHuman की अपनी एजेंट अनुमतियाँ नीचे पढ़ें, लिखें और एडमिन टॉगल के रूप में नियंत्रित होती हैं।',
  'composio.connect.reopenBrowser': 'ब्राउज़र फिर से खोलें',
  'composio.connect.requestingUrl': 'कनेक्ट URL माँगा जा रहा है…',
  'composio.connect.requiredFieldEmpty': 'यह फ़ील्ड आवश्यक है।',
  'composio.connect.retryConnection': 'कनेक्शन फिर से करें',
  'composio.connect.scopeLoadError': 'स्कोप प्रेफरेंस लोड नहीं हो पाई: {msg}',
  'composio.connect.scopeSaveError': '{key} स्कोप सेव नहीं हो पाया: {msg}',
  'composio.connect.scope.read': 'पढ़ें',
  'composio.connect.scope.readHint': 'एजेंट को इस कनेक्शन से डेटा पढ़ने की अनुमति दें।',
  'composio.connect.scope.write': 'लिखो',
  'composio.connect.scope.writeHint':
    'एजेंट को इस कनेक्शन के माध्यम से डेटा बनाने या संशोधित करने की अनुमति दें।',
  'composio.connect.scope.admin': 'व्यवस्थापक',
  'composio.connect.scope.adminHint':
    'एजेंट को सेटिंग्स, अनुमतियाँ, या विनाशकारी कार्रवाइयां प्रबंधित करने की अनुमति दें।',
  'composio.connect.subdomainInvalid':
    'केवल छोटा सबडोमेन दर्ज करें (जैसे "acme"), पूर्ण URL नहीं। इसमें केवल अक्षर, संख्याएँ और हाइफ़न होने चाहिए।',
  'composio.connect.subdomainRequired': 'जारी रखने के लिए अपना Atlassian subdomain डालें।',
  'composio.connect.wabaIdHint':
    'अपने Meta एक्सेस टोकन का उपयोग करके GET /me/businesses फिर GET /{business_id}/owned_whatsapp_business_accounts के माध्यम से इसे प्राप्त करें।',
  'composio.connect.wabaIdLabel': 'Waba आईडी लेबल',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired':
    'जारी रखने के लिए अपना WhatsApp Business Account ID (WABA ID) डालें।',
  'composio.connect.waitingFor': 'प्रतीक्षा कर रहा है',
  'composio.connect.waitingHint': 'प्रतीक्षा संकेत',
  'composio.triggers.heading': 'ट्रिगर',
  'composio.triggers.listenFrom': 'से इवेंट्स सुनें',
  'composio.triggers.loadError': 'ट्रिगर्स लोड नहीं हो सके',
  'composio.triggers.sessionExpired':
    'आपका OpenHuman सत्र समाप्त हो गया है। ट्रिगर्स लोड करने के लिए फिर से साइन इन करें।',
  'composio.triggers.needsConfiguration': 'कॉन्फिगरेशन ज़रूरी है',
  'composio.triggers.noneAvailable': 'वर्तमान में कोई ट्रिगर उपलब्ध नहीं है',
  'conversations.taskKanban.moveLeft': 'बाएं ले जाएं',
  'conversations.taskKanban.moveRight': 'दाएं ले जाएं',
  'conversations.taskKanban.title': 'टास्क',
  'conversations.threadTodo.title': 'योजना',
  'conversations.planReview.title': 'योजना की समीक्षा करें',
  'conversations.planReview.subtitle':
    'इसे चलाने के लिए स्वीकृत करें, हटाने के लिए अस्वीकार करें, या संशोधित करने के लिए प्रतिक्रिया भेजें।',
  'conversations.planReview.approve': 'स्वीकृत करें और चलाएँ',
  'conversations.planReview.reject': 'अस्वीकार करें',
  'conversations.planReview.feedbackLabel': 'बदलाव का अनुरोध करें',
  'conversations.planReview.feedbackPlaceholder': 'वर्णन करें कि क्या बदलना है…',
  'conversations.planReview.sendFeedback': 'प्रतिक्रिया भेजें',
  'conversations.threadGoal.label': 'लक्ष्य',
  'conversations.threadGoal.setCta': 'लक्ष्य सेट करें',
  'conversations.threadGoal.placeholder': 'इस थ्रेड को क्या हासिल करना चाहिए?',
  'conversations.threadGoal.save': 'सहेजें',
  'conversations.threadGoal.cancel': 'रद्द करें',
  'conversations.threadGoal.edit': 'लक्ष्य संपादित करें',
  'conversations.threadGoal.clear': 'लक्ष्य हटाएँ',
  'conversations.threadGoal.complete': 'पूर्ण के रूप में चिह्नित करें',
  'conversations.threadGoal.pause': 'रोकें',
  'conversations.threadGoal.resume': 'फिर शुरू करें',
  'conversations.threadGoal.tokensSuffix': 'टोकन',
  'conversations.threadGoal.status.active': 'सक्रिय',
  'conversations.threadGoal.status.paused': 'रुका हुआ',
  'conversations.threadGoal.status.budget_limited': 'बजट समाप्त',
  'conversations.threadGoal.status.complete': 'पूर्ण',
  'conversations.taskKanban.approval.default': 'डिफ़ॉल्ट',
  'conversations.taskKanban.approval.notRequired': 'आवश्यकता नहीं',
  'conversations.taskKanban.approval.notRequiredBadge': 'कोई अनुमोदन नहीं',
  'conversations.taskKanban.approval.required': 'आवश्यक',
  'conversations.taskKanban.approval.requiredBadge': 'अनुमोदन',
  'conversations.taskKanban.approval.requiredBeforeExecution': 'निष्पादन से पहले आवश्यक',
  'conversations.taskKanban.briefButton': 'कार्य संक्षिप्त',
  'conversations.taskKanban.briefTitle': 'कार्य संक्षिप्त',
  'conversations.taskKanban.closeBrief': 'बंद कार्य संक्षिप्त',
  'conversations.taskKanban.field.acceptanceCriteria': 'स्वीकृति मानदंड',
  'conversations.taskKanban.field.allowedTools': 'अनुमति उपकरण',
  'conversations.taskKanban.field.approval': 'स्वीकृति',
  'conversations.taskKanban.field.assignedAgent': 'असाइन एजेंट',
  'conversations.taskKanban.field.blocker': 'ब्लॉकर',
  'conversations.taskKanban.field.evidence': 'प्रमाण',
  'conversations.taskKanban.field.notes': 'नोट',
  'conversations.taskKanban.field.objective': 'उद्देश्य',
  'conversations.taskKanban.field.plan': 'योजना',
  'conversations.taskKanban.field.status': 'स्थिति',
  'conversations.taskKanban.field.title': 'शीर्षक',
  'conversations.taskKanban.saveChanges': 'परिवर्तन सहेजें',
  'conversations.taskKanban.deleteCard': 'Delete',
  'conversations.taskKanban.workTask': 'कार्य शुरू करें',
  'conversations.taskKanban.viewWork': 'कार्य देखें',
  'conversations.taskKanban.startingTask': 'शुरू हो रहा है…',
  'conversations.taskKanban.updateFailed': 'कार्य अद्यतन नहीं कर सका; परिवर्तन बचाया नहीं गया।',
  'conversations.taskKanban.sourcesButton': 'स्रोत',
  'conversations.taskKanban.source.openExternal': 'बाहरी कार्य खोलें',
  'conversations.taskKanban.source.openExternalShort': 'खोलें',
  'conversations.taskKanban.source.unknownProvider': 'अज्ञात स्रोत',
  'conversations.taskKanban.source.urgencyValue': 'तात्कालिकता {percent}%',
  'conversations.taskKanban.sources.desktopOnly':
    'कार्य स्रोत नियंत्रण डेस्कटॉप ऐप में उपलब्ध हैं।',
  'conversations.taskKanban.sources.title': 'कार्य स्रोत',
  'conversations.taskKanban.sources.statusEnabled': 'स्वचालित पोलिंग चालू है',
  'conversations.taskKanban.sources.manage': 'स्रोत प्रबंधित करें',
  'conversations.taskKanban.source.title': 'स्रोत',
  'conversations.taskKanban.source.sourceId': 'स्रोत ID',
  'conversations.taskKanban.source.externalId': 'बाहरी ID',
  'conversations.taskKanban.source.repo': 'रिपॉज़िटरी',
  'conversations.taskKanban.source.urgency': 'तात्कालिकता',
  'conversations.toolTimeline.turn': 'टर्न',
  'conversations.toolTimeline.step': 'चरण',
  'conversations.toolTimeline.workerThread': 'वर्कर थ्रेड',
  'conversations.subagent.viewProcessing': 'पूरी प्रोसेसिंग देखें',
  'conversations.subagent.parent': 'मूल',
  'conversations.subagent.thinking': 'सोच रहा है',
  'conversations.subagent.thoughts': 'विचार',
  'conversations.subagent.response': 'प्रतिक्रिया',
  'conversations.subagent.toolCalls': 'टूल कॉल',
  'conversations.subagent.working': 'काम कर रहा है…',
  'conversations.subagent.noOutputYet': 'अभी तक कोई आउटपुट नहीं',
  'conversations.subagent.input': 'इनपुट',
  'conversations.subagent.output': 'आउटपुट',
  'conversations.subagent.noOutput': 'कोई आउटपुट नहीं मिला',
  'conversations.subagent.close': 'बंद करें',
  'conversations.subagent.cancel': 'कार्य रद्द करें',
  'conversations.subagent.cancelling': 'रद्द किया जा रहा है…',
  'conversations.subagent.cancelFailed': 'कार्य रद्द नहीं किया जा सका। पुनः प्रयास करें।',
  'conversations.subagent.statusRunning': 'चल रहा है',
  'conversations.subagent.statusCompleted': 'पूर्ण',
  'conversations.subagent.statusFailed': 'विफल',
  'conversations.subagent.statusAwaitingUser': 'उपयोगकर्ता की प्रतीक्षा',
  'conversations.subagent.statusCancelled': 'रद्द किया गया',
  'conversations.agentTaskInsights.title': 'एजेंट कार्य अंतर्दृष्टि',
  'conversations.agentTaskInsights.response': 'प्रतिक्रिया',
  'conversations.agentTaskInsights.processSourceTitle': 'एजेंट प्रक्रिया स्रोत',
  'conversations.agentTaskInsights.stepsHeading': 'चरण',
  'conversations.agentTaskInsights.sourcesHeading': 'स्रोत',
  'conversations.agentTaskInsights.noSteps': 'कोई चरण दर्ज नहीं किया गया',
  'conversations.agentTaskInsights.viewProcessSource': 'पूर्ण एजेंट प्रक्रिया स्रोत देखें',
  'conversations.agentTaskInsights.processing': 'प्रोसेसिंग',
  'conversations.agentTaskInsights.done': 'पूर्ण',
  'conversations.agentTaskInsights.failed': 'विफल',
  'conversations.agentTaskInsights.running': 'चल रहा है',
  'conversations.agentTaskInsights.cancelled': 'रद्द किया गया',
  'conversations.agentTaskInsights.awaitingUser': 'इनपुट की प्रतीक्षा',
  'conversations.agentTaskInsights.viewDetails': 'विवरण देखें',
  'conversations.agentTaskInsights.subagentsHeading': 'सब-एजेंट',
  'daemon.serviceBlockingGate.body': 'विवरण',
  'daemon.serviceBlockingGate.downloadHint': 'डाउनलोड संकेत',
  'daemon.serviceBlockingGate.downloadLatest': 'नवीनतम संस्करण डाउनलोड करें',
  'daemon.serviceBlockingGate.retryCore': 'कोर पुनः प्रयास करें',
  'daemon.serviceBlockingGate.retryFailed':
    'फिर से कोशिश विफल। लेटेस्ट ऐप बिल्ड डाउनलोड करके दोबारा कोशिश करें।',
  'daemon.serviceBlockingGate.retrying': 'फिर से कोशिश हो रही है...',
  'daemon.serviceBlockingGate.title': 'OpenHuman कोर उपलब्ध नहीं है',
  'home.banners.discordSubtitle': 'Discord उपशीर्षक',
  'home.banners.discordTitle': 'हमारा Discord जॉइन करें',
  'home.banners.earlyBirdDismiss': 'अर्ली बर्ड बैनर हटाएं',
  'home.banners.earlyBirdFirstSub': 'पहली सदस्यता।',
  'home.banners.earlyBirdOn': 'अर्ली बर्ड चालू',
  'home.banners.earlyBirdTitle': 'पहले 1,000 उपयोगकर्ताओं को 60% की छूट मिलती है।',
  'home.banners.earlyBirdUseCode': 'अर्ली बर्ड कोड का उपयोग करें',
  'home.banners.getSubscription': 'सदस्यता लें',
  'home.banners.promoCreditsBody': 'आपके पास {amount} प्रोमो क्रेডিट हैं। आप',
  'home.banners.promoCreditsUsage': 'प्रोमो क्रेडिट उपयोग',
  'intelligence.memoryChunk.detail.chunk': 'चंक',
  'intelligence.memoryChunk.detail.copyChunkId': 'Chunk ID कॉपी करें',
  'intelligence.memoryChunk.detail.embeddingInfo': 'बीजीई-एम3 1024डिम',
  'intelligence.memoryChunk.detail.noEmbedding': 'कोई एम्बेडिंग नहीं',
  'intelligence.memoryChunk.letterhead.from': 'से',
  'intelligence.memoryChunk.letterhead.to': 'को',
  'intelligence.memoryChunk.mentioned.chunkOne': '1 चंक',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count} चंक',
  'intelligence.memoryChunk.mentioned.heading': 'उल्लेखित',
  'intelligence.memoryChunk.scoreBars.ariaScore': '{name} स्कोर {pct} प्रतिशत',
  'intelligence.memoryChunk.scoreBars.atThreshold': '{threshold} पर',
  'intelligence.memoryChunk.scoreBars.dropped': 'हटाया गया',
  'intelligence.memoryChunk.scoreBars.heading': 'क्यों रखा',
  'intelligence.memoryChunk.scoreBars.kept': 'रखा गया',
  'intelligence.diagram.title': 'आर्किटेक्चर डायग्राम',
  'intelligence.diagram.description':
    'कॉन्फ़िगर किए गए डायग्राम एंडपॉइंट से नवीनतम स्थानीय आर्किटेक्चर आउटपुट।',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': 'डायग्राम रीफ्रेश करें',
  'intelligence.diagram.emptyTitle': 'अभी कोई डायग्राम उपलब्ध नहीं है',
  'intelligence.diagram.emptyDescription':
    'ऑर्केस्ट्रेटर से एक आर्किटेक्चर डायग्राम बनाएं और यह पैनल कॉन्फ़िगर किए गए स्थानीय एंडपॉइंट से स्वयं अपडेट हो जाएगा।',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample':
    'डार्क टर्मिनल स्टाइल में वर्तमान स्वार्म का आर्किटेक्चर डायग्राम बनाएं',
  'intelligence.diagram.imageAlt': 'OpenHuman का नवीनतम जेनरेटेड आर्किटेक्चर डायग्राम',
  'intelligence.diagram.refreshesEvery': 'हर {seconds}s पर रीफ्रेश होता है',
  'intelligence.memoryText.entityTypePrefix': 'इकाई प्रकार',
  'intelligence.tasks.activeBoardOne': 'बातचीतों में 1 सक्रिय बोर्ड',
  'intelligence.tasks.activeBoardOther': 'बातचीतों में {count} सक्रिय बोर्ड',
  'intelligence.tasks.empty': 'अभी कोई एजेंट टास्क बोर्ड नहीं',
  'intelligence.tasks.emptyHint': 'खाली संकेत',
  'intelligence.tasks.failedToLoad': 'लोड नहीं हो पाया',
  'intelligence.tasks.live': 'लाइव',
  'intelligence.tasks.loadingBoards': 'टास्क बोर्ड लोड हो रहे हैं…',
  'intelligence.tasks.threadPrefix': 'थ्रेड {thread}',
  'intelligence.tasks.subtitle': 'कार्यस्थल पर आपके कार्य और एजेंट कार्य बोर्ड।',
  'intelligence.tasks.newTask': 'नया कार्य',
  'intelligence.tasks.personalBoardTitle': 'एजेंट कार्य',
  'intelligence.tasks.personalEmpty': 'अभी तक कोई व्यक्तिगत कार्य नहीं',
  'intelligence.tasks.composer.title': 'नया कार्य',
  'intelligence.tasks.composer.titleLabel': 'शीर्षक',
  'intelligence.tasks.composer.titlePlaceholder': 'क्या करना चाहिए?',
  'intelligence.tasks.composer.statusLabel': 'स्थिति',
  'intelligence.tasks.composer.attachLabel': 'बातचीत करने के लिए संलग्न',
  'intelligence.tasks.composer.attachNone': 'व्यक्तिगत (कोई बातचीत नहीं)',
  'intelligence.tasks.composer.objectiveLabel': 'उद्देश्य',
  'intelligence.tasks.composer.objectivePlaceholder': 'वैकल्पिक - वांछित परिणाम',
  'intelligence.tasks.composer.notesLabel': 'नोट',
  'intelligence.tasks.composer.notesPlaceholder': 'वैकल्पिक नोट्स',
  'intelligence.tasks.composer.create': 'कार्य',
  'intelligence.tasks.composer.creating': 'बनाना',
  'intelligence.tasks.composer.createFailed': 'काम नहीं कर सका',
  'intelligence.tasks.composer.assignAgentLabel': 'किसी एजेंट को इसे स्वचालित रूप से करने दें',
  'intelligence.tasks.composer.assignAgentHint':
    'टास्क बोर्ड इसे उठाकर आपके लिए चला देगा। सामान्य निजी कार्य के लिए इसे बंद रखें।',
  'intelligence.tasks.sourceList.subtitle': 'एजेंट कार्य बनने की प्रतीक्षा कर रहे स्रोत कार्य।',
  'intelligence.tasks.sourceList.empty': 'कोई स्रोत कार्य प्रतीक्षा में नहीं है।',
  'intelligence.tasks.sourceList.queued': 'कतार में',
  'intelligence.tasks.sourceList.workOnTask': 'कार्य पर काम करें',
  'intelligence.tasks.sourcePlan.title': 'स्रोत कार्य को परिष्कृत करें',
  'intelligence.tasks.sourcePlan.subtitle':
    'एजेंट कार्य बनाने से पहले शोध ड्राफ्ट की समीक्षा करें।',
  'intelligence.tasks.sourcePlan.researchAgent': 'शोध एजेंट ड्राफ्ट',
  'intelligence.tasks.sourcePlan.approve': 'योजना स्वीकृत करें',
  'intelligence.tasks.sourcePlan.creating': 'कार्य बनाया जा रहा है…',
  'intelligence.tasks.sourcePlan.createFailed': 'एजेंट कार्य नहीं बन सका',
  'intelligence.tasks.workTaskFailed': 'कार्य पर काम शुरू नहीं हो सका',
  'intelligence.workTask.sourceTaskHeading': 'स्रोत कार्य:',
  'intelligence.workTask.repositoryLine': '- रिपॉज़िटरी: {repo}',
  'intelligence.workTask.externalIdLine': '- बाहरी आईडी: {externalId}',
  'intelligence.workTask.urlLine': '- यूआरएल: {url}',
  'intelligence.workTask.closingInstruction':
    'पहले ठोस कार्यान्वयन योजना को संक्षेप में दोहराएँ, फिर उसे निष्पादित करें। इस थ्रेड में प्रगति दिखती रहे और कार्य की स्थिति बदलने पर कार्य बोर्ड अपडेट करें।',
  'intelligence.agentWork.subtitle': 'हर पृष्ठभूमि एजेंट रन, जीवनचक्र स्थिति के अनुसार समूहित।',
  'intelligence.agentWork.loading': 'एजेंट कार्य लोड हो रहा है…',
  'intelligence.agentWork.failedToLoad': 'एजेंट कार्य लोड नहीं हो सका',
  'intelligence.agentWork.empty': 'अभी तक कोई पृष्ठभूमि एजेंट रन नहीं।',
  'intelligence.agentWork.bucket.needsInput': 'इनपुट चाहिए',
  'intelligence.agentWork.bucket.working': 'काम जारी',
  'intelligence.agentWork.bucket.completed': 'पूरा हुआ',
  'intelligence.agentWork.bucket.failed': 'विफल',
  'intelligence.agentWork.bucket.stopped': 'रुका हुआ',
  'intelligence.agentWork.column.agent': 'एजेंट',
  'intelligence.agentWork.column.status': 'स्टेटस',
  'intelligence.agentWork.column.elapsed': 'बीता समय',
  'intelligence.agentWork.column.cost': 'लागत',
  'intelligence.agentWork.column.tokens': 'टोकन',
  'intelligence.agentWork.status.pending': 'लंबित',
  'intelligence.agentWork.status.running': 'चल रहा है',
  'intelligence.agentWork.status.awaitingUser': 'इनपुट चाहिए',
  'intelligence.agentWork.status.paused': 'रुका हुआ',
  'intelligence.agentWork.status.completed': 'पूरा हुआ',
  'intelligence.agentWork.status.failed': 'विफल',
  'intelligence.agentWork.status.cancelled': 'रद्द हुआ',
  'intelligence.agentWork.status.interrupted': 'बाधित',
  'intelligence.agentWork.kind.subagent': 'सब-एजेंट',
  'intelligence.agentWork.kind.workerThread': 'वर्कर थ्रेड',
  'intelligence.agentWork.kind.backgroundAgent': 'बैकग्राउंड एजेंट',
  'intelligence.agentWork.kind.teamMember': 'टीम सदस्य',
  'intelligence.agentWork.kind.workflowChild': 'वर्कफ़्लो चाइल्ड',
  'intelligence.agentWork.openThread': 'थ्रेड खोलें',
  'intelligence.agentWork.openWorker': 'वर्कर खोलें',
  'worktree.label': 'वर्कट्री',
  'worktree.dirty': 'बिना कमिट किए बदलाव',
  'worktree.clean': 'साफ़',
  'worktree.changedFile': 'बदली गई फ़ाइल',
  'worktree.changedFiles': 'बदली गई फ़ाइलें',
  'worktree.removing': 'हटाया जा रहा है…',
  'worktree.removeFailed': 'वर्कट्री हटाने में विफल',
  'worktree.diffFailed': 'डिफ़ लोड करने में विफल',
  'worktree.diffLoading': 'डिफ़ लोड हो रहा है…',
  'worktree.diffEmpty': 'HEAD की तुलना में कोई बदलाव नहीं।',
  'worktree.dirtyConfirm':
    'इस वर्कट्री में बिना कमिट किए बदलाव हैं। इसे हटाने पर वह काम छूट जाएगा। वर्कर ब्रांच बनी रहती है।',
  'worktree.action.open': 'फ़ोल्डर खोलें',
  'worktree.action.diff': 'डिफ़',
  'worktree.action.hideDiff': 'डिफ़ छिपाएँ',
  'worktree.action.remove': 'हटाएँ',
  'worktree.action.removeAnyway': 'छोड़ें और हटाएँ',
  'worktree.action.preserve': 'सुरक्षित रखें',
  'worktree.panel.subtitle': 'समानांतर एजेंट वर्कर्स द्वारा बनाए गए पृथक git वर्कट्री।',
  'worktree.panel.loading': 'वर्कट्री लोड हो रही हैं…',
  'worktree.panel.failedToLoad': 'वर्कट्री लोड करने में विफल',
  'worktree.panel.empty':
    'कोई पृथक वर्कट्री नहीं। वर्कट्री पृथक्करण वाले समानांतर वर्कर्स यहाँ दिखाई देंगे।',
  'worktree.panel.overlapsTitle': 'ओवरलैपिंग बदलाव',
  'worktree.panel.overlapHint':
    'ये फ़ाइलें एक से अधिक वर्कट्री द्वारा बदली गई थीं: मर्ज करने से पहले समाधान करें।',
  'intelligence.agentWork.action.stop': 'रोकें',
  'intelligence.agentWork.action.retry': 'फिर से प्रयास करें',
  'intelligence.agentWork.action.continue': 'जारी रखें',
  'intelligence.agentWork.action.followUp': 'फ़ॉलो अप',
  'intelligence.agentWork.action.send': 'भेजें',
  'intelligence.agentWork.action.cancel': 'रद्द करें',
  'intelligence.agentWork.action.continuePlaceholder': 'इस एजेंट को अनब्लॉक करने के लिए उत्तर दें…',
  'intelligence.agentWork.action.followUpPlaceholder': 'फ़ॉलो-अप निर्देश भेजें…',
  'intelligence.agentWork.action.failed': 'कार्रवाई विफल रही',
  'intelligence.teams.subtitle': 'समन्वित एजेंट टीमें और वे कार्य जो वे साझा करती हैं।',
  'intelligence.teams.loading': 'टीमें लोड हो रही हैं…',
  'intelligence.teams.failedToLoad': 'टीमें लोड करने में विफल',
  'intelligence.teams.empty': 'अभी तक कोई एजेंट टीम नहीं',
  'intelligence.teams.emptyHint':
    'जब कोई एजेंट किसी लक्ष्य को साझा करने के लिए समन्वित सब-एजेंट बनाता है, तब टीमें यहाँ दिखाई देती हैं।',
  'intelligence.teams.refresh': 'रिफ्रेश करें',
  'intelligence.teams.backToList': 'सभी टीमें',
  'intelligence.teams.status.active': 'सक्रिय',
  'intelligence.teams.status.closed': 'बंद',
  'intelligence.teams.header.lead': 'लीड',
  'intelligence.teams.header.taskCount': '{count} कार्य',
  'intelligence.teams.header.memberCount': '{count} सदस्य',
  'intelligence.teams.member.active': 'सक्रिय',
  'intelligence.teams.member.pending': 'लंबित',
  'intelligence.teams.member.idle': 'निष्क्रिय',
  'intelligence.teams.member.stopped': 'रुका हुआ',
  'intelligence.teams.column.todo': 'करना है',
  'intelligence.teams.column.ready': 'तैयार',
  'intelligence.teams.column.inProgress': 'प्रगति पर',
  'intelligence.teams.column.blocked': 'अवरुद्ध',
  'intelligence.teams.column.done': 'पूर्ण',
  'intelligence.teams.emptyColumn': 'खाली',
  'intelligence.teams.unclaimed': 'अनिर्दिष्ट',
  'intelligence.teams.pickedUpBy': '{name} ने लिया',
  'intelligence.teams.depLockTitle': '{count} अधूरी निर्भरताएँ',
  'intelligence.teams.gate.pending': 'गेट लंबित',
  'intelligence.teams.gate.passed': 'गेट पास',
  'intelligence.teams.gate.failed': 'गेट विफल',
  'intelligence.teams.gate.label': 'गेट: {status}',
  'intelligence.teams.activity.title': 'टीम गतिविधि',
  'intelligence.teams.activity.empty': 'अभी कोई संदेश नहीं',
  'intelligence.teams.activity.toTeam': 'टीम',
  'intelligence.teams.member.start': 'शुरू करें',
  'intelligence.teams.composer.placeholder': 'साथी को संदेश…',
  'intelligence.teams.composer.send': 'भेजें',
  'intelligence.teams.composer.recipient': 'प्राप्तकर्ता',
  'intelligence.teams.composer.toTeam': 'पूरी टीम',
  'intelligence.teams.action.blocked': 'निर्भरताओं की प्रतीक्षा',
  'intelligence.teams.action.alreadyClaimed': 'किसी अन्य साथी ने पहले ही ले लिया',
  'intelligence.teams.action.alreadyActive': 'साथी पहले से चल रहा है',
  'intelligence.teams.action.noClaimableTask': 'इस साथी के लिए कोई कार्य तैयार नहीं',
  'intelligence.teams.action.unknownTask': 'कार्य नहीं मिला',
  'intelligence.refine.objectiveDefault':
    'स्रोत कार्य को कार्यान्वयन के लिए तैयार एजेंट कार्य में बदलें: {title}',
  'intelligence.refine.sourceLine': 'स्रोत: {url}',
  'intelligence.refine.sourceIntake': 'स्रोत: कार्य स्रोत प्रविष्टि',
  'intelligence.refine.repositoryLine': 'रिपॉज़िटरी: {repo}',
  'intelligence.refine.externalTaskLine': 'बाहरी कार्य: {externalId}',
  'intelligence.refine.planStep1':
    'जुड़े हुए स्रोत कार्य को पढ़ें और अनुरोधित सटीक व्यवहार की पुष्टि करें।',
  'intelligence.refine.planStep2':
    'संबंधित कोड पथों का निरीक्षण करें और सबसे छोटी कार्यान्वयन सीमा पहचानें।',
  'intelligence.refine.planStep3':
    'उपयोगकर्ता-दृश्य व्यवहार के इर्द-गिर्द केंद्रित परीक्षणों के साथ परिवर्तन लागू करें।',
  'intelligence.refine.planStep4':
    'लक्षित सत्यापन चलाएँ और किसी भी शेष जोखिम या अनुवर्ती कार्य को दर्ज करें।',
  'intelligence.refine.acceptance1':
    'स्रोत कार्य की आवश्यकताएँ अंतिम कार्यान्वयन में दर्शाई गई हैं।',
  'intelligence.refine.acceptance2':
    'संबंधित यूनिट या इंटीग्रेशन परीक्षण बदले हुए व्यवहार को कवर करते हैं।',
  'intelligence.refine.acceptance3':
    'सत्यापन परिणाम और कोई भी अनसुलझा जोखिम पूर्ण होने पर दर्ज किया जाता है।',
  'notifications.card.dismiss': 'नोटिफिकेशन हटाएं',
  'notifications.card.importanceTitle': 'महत्व: {pct}%',
  'notifications.center.empty': 'अभी कोई नोटिफिकेशन नहीं',
  'notifications.center.emptyHint': 'खाली संकेत',
  'notifications.center.filterAll': 'सभी फिल्टर',
  'notifications.center.markAllRead': 'सभी पढ़ा हुआ मार्क करें',
  'notifications.center.title': 'नोटिफिकेशन',
  'notifications.meeting.joinListen': 'शामिल हों (केवल सुनें)',
  'notifications.meeting.joinActive': 'शामिल हों और जवाब दें',
  'notifications.meeting.skip': 'यह नहीं',
  'notifications.meeting.alwaysJoin': 'हमेशा शामिल हों',
  'notifications.meeting.actionError': 'यह क्रिया पूरी नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'notifications.flow.approveTitle': 'वर्कफ़्लो को अनुमोदन की आवश्यकता है',
  'notifications.flow.approve': 'अनुमोदित करें',
  'notifications.flow.approving': 'अनुमोदित किया जा रहा है…',
  'notifications.flow.dismiss': 'खारिज करें',
  'notifications.flow.error': 'वर्कफ़्लो फिर से शुरू नहीं हो सका। कृपया पुनः प्रयास करें।',
  'notifications.flow.gateCount': '{count} अनुमोदन गेट लंबित हैं',
  'notifications.flow.approveHint': 'इस चेकपॉइंट के बाद वर्कफ़्लो फिर से शुरू करें',
  'notifications.flow.dismissHint': 'वर्कफ़्लो को फिर से शुरू किए बिना यह संकेत छिपाएं',
  'notifications.flow.viewRun': 'रन देखें',
  'notifications.flowGate.title': 'वर्कफ़्लो को अनुमोदन की आवश्यकता है',
  'notifications.flowGate.tool': 'उपकरण:',
  'notifications.flowGate.approve': 'एक बार स्वीकृति दें',
  'notifications.flowGate.approveAlways': 'हमेशा स्वीकृति दें',
  'notifications.flowGate.approveAlwaysHint':
    'इस फ़्लो के भविष्य के रन के लिए इस चेकपॉइंट को छोड़ें',
  'notifications.flowGate.deny': 'अस्वीकार करें',
  'notifications.flowGate.deciding': 'कार्य प्रगति पर…',
  'notifications.flowGate.error': 'अपने निर्णय को रिकॉर्ड नहीं कर सकता - फिर से प्रयास करें।',
  'flowRuns.inspector.title': 'रन विवरण',
  'flowRuns.inspector.startedAt': 'शुरू हुआ',
  'flowRuns.inspector.finishedAt': 'समाप्त हुआ',
  'flowRuns.inspector.running': 'चल रहा है…',
  'flowRuns.inspector.error': 'त्रुटि',
  'flowRuns.inspector.pendingApprovals': 'लंबित अनुमोदन',
  'flowRuns.inspector.pendingApprovalsCount': '{count} नोड अनुमोदन की प्रतीक्षा में',
  'flowRuns.inspector.approval.tool': 'उपकरण:',
  'flowRuns.inspector.approval.approve': 'एक बार स्वीकृति दें',
  'flowRuns.inspector.approval.approveAlways': 'हमेशा स्वीकृति दें',
  'flowRuns.inspector.approval.approveAlwaysHint':
    'इस फ़्लो के भविष्य के रन के लिए इस चेकपॉइंट को छोड़ें',
  'flowRuns.inspector.approval.deny': 'अस्वीकार करें',
  'flowRuns.inspector.approval.deciding': 'कार्य प्रगति पर…',
  'flowRuns.inspector.approval.loadError': 'इस रन के लिए लंबित अनुमोदन लोड नहीं किए जा सके।',
  'flowRuns.inspector.steps': 'चरण',
  'flowRuns.inspector.noSteps': 'अभी तक कोई चरण दर्ज नहीं किया गया है।',
  'flowRuns.inspector.output': 'कच्चा आउटपुट दिखाएं',
  'flowRuns.inspector.summary.failedPrefix': 'पूरा नहीं हो सका:',
  'flowRuns.inspector.summary.unknownError': 'कुछ गड़बड़ हो गई',
  'flowRuns.inspector.summary.itemsFetched': '{count} आइटम प्राप्त हुए',
  'flowRuns.inspector.summary.completed': 'चरण पूरा हुआ',
  'flowRuns.inspector.summary.noOutput': 'कोई आउटपुट नहीं बना',
  'flowRuns.inspector.port': 'पोर्ट',
  'flowRuns.inspector.loading': 'रन लोड हो रहा है…',
  'flowRuns.inspector.loadError': 'यह रन लोड नहीं हो सका',
  'flowRuns.inspector.fixWithAgent': 'एजेंट से ठीक करें',
  'flowRuns.inspector.dataTable': 'तालिका',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': 'आउटपुट दृश्य',
  'flowRuns.inspector.itemCount': '{count} आइटम',
  'flowRuns.inspector.noItems': 'कोई आउटपुट आइटम नहीं',
  'flowRuns.inspector.emptyValue': '(खाली)',
  'flowRuns.inspector.binaryLabel': 'बाइनरी',
  'flowRuns.inspector.showSource': 'स्रोत',
  'flowRuns.inspector.hideSource': 'स्रोत छिपाएँ',
  'flowRuns.inspector.sourceInputTitle': 'स्रोत इनपुट आइटम',
  'flowRuns.status.running': 'चल रहा है',
  'flowRuns.status.completed': 'पूर्ण',
  'flowRuns.status.completed_with_warnings': 'चेतावनियों के साथ पूर्ण',
  'flowRuns.status.pending_approval': 'अनुमोदन की प्रतीक्षा में',
  'flowRuns.status.failed': 'विफल',
  'flowRuns.status.cancelled': 'रद्द किया गया',
  'flowRuns.status.interrupted': 'बाधित',

  'flows.page.title': 'वर्कफ़्लो',
  'flows.page.description': 'सहेजे गए ऑटोमेशन जिन्हें आप सक्षम, चला और मॉनिटर कर सकते हैं।',
  'flows.page.emptyTitle': 'अभी तक कोई वर्कफ़्लो नहीं',
  'flows.page.emptyDescription': 'कैनवास से एक बनाने के बाद सहेजे गए वर्कफ़्लो यहां दिखाई देंगे।',
  'flows.page.loading': 'वर्कफ़्लो लोड हो रहे हैं…',
  'flows.page.loadError': 'वर्कफ़्लो लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
  'flows.page.newWorkflow': 'नया वर्कफ़्लो',
  'flows.list.lastRun': 'अंतिम रन',
  'flows.list.neverRun': 'कभी नहीं चला',
  'flows.list.justNow': 'अभी अभी',
  'flows.discoveries.title': 'वर्कफ़्लो खोजें',
  'flows.discoveries.description':
    'आप कैसे काम करते हैं, उसके आधार पर Flow Scout द्वारा सुझाए गए ऑटोमेशन।',
  'flows.allRuns.title': 'वर्कफ़्लो रन',
  'flows.allRuns.description': 'आपके वर्कस्पेस के सभी वर्कफ़्लो रन, नवीनतम पहले।',
  'flows.allRuns.loading': 'रन लोड हो रहे हैं…',
  'flows.allRuns.empty': 'अभी तक कोई वर्कफ़्लो रन नहीं।',
  'flows.allRuns.unknownWorkflow': 'अज्ञात वर्कफ़्लो',
  'flows.allRuns.status.running': 'चल रहा है',
  'flows.allRuns.status.completed': 'पूर्ण',
  'flows.allRuns.status.completed_with_warnings': 'चेतावनियों के साथ पूर्ण',
  'flows.allRuns.status.pending_approval': 'अनुमोदन लंबित',
  'flows.allRuns.status.failed': 'विफल',
  'flows.allRuns.status.cancelled': 'रद्द',
  'flows.allRuns.status.interrupted': 'बाधित',
  'flows.list.minutesAgo': '{count} मिनट पहले',
  'flows.list.hoursAgo': '{count} घंटे पहले',
  'flows.list.daysAgo': '{count} दिन पहले',
  'flows.list.runNow': 'चलाएं',
  'flows.list.running': 'चल रहा है…',
  'flows.list.viewRuns': 'रन देखें',
  'flows.list.toggleEnabled': 'वर्कफ़्लो सक्षम करें',
  'flows.list.enabled': 'सक्षम',
  'flows.list.paused': 'रोका गया',
  'flows.list.runStarted': 'वर्कफ़्लो शुरू हुआ',
  'flows.runs.title': '{name} के लिए रन',
  'flows.runs.titleFallback': 'वर्कफ़्लो रन',
  'flows.runs.loading': 'रन लोड हो रहे हैं…',
  'flows.runs.loadError': 'रन लोड नहीं हो सके',
  'flows.runs.empty': 'अभी तक कोई रन नहीं',
  'flows.promptBar.label': 'एक वर्कफ़्लो का वर्णन करें',
  'flows.promptBar.placeholder': 'अपने वर्कफ़्लो का वर्णन करें',
  'flows.promptBar.copilotTitle': 'कोपायलट',
  'flows.promptBar.submit': 'बनाएँ',
  'flows.promptBar.startBuilding': 'बनाना शुरू करें',
  'flows.promptBar.disclaimer':
    'कोपायलट एआई है और गलतियाँ कर सकता है। कृपया उत्तरों की दोबारा जाँच करें।',
  'flows.promptBar.thinking': 'बनाया जा रहा है…',
  'flows.promptBar.heroTitle': 'एक वर्कफ़्लो का वर्णन करें',
  'flows.promptBar.heroSubtitle':
    'बिल्डर को बताएँ कि क्या स्वचालित करना है और उसके प्रस्ताव की समीक्षा करें।',
  'flows.promptBar.error': 'वर्कफ़्लो बिल्डर तक नहीं पहुँच सके। कृपया फिर से प्रयास करें।',
  'flows.promptBar.offline': 'आप ऑफ़लाइन हैं। वर्कफ़्लो बनाने के लिए फिर से कनेक्ट करें।',
  'flows.suggest.title': 'आपके लिए सुझाए गए',
  'flows.suggest.subtitle':
    'आप कैसे काम करते हैं, इसके आधार पर Flow Scout जिन ऑटोमेशन को मददगार मानता है।',
  'flows.suggest.discover': 'खोजें',
  'flows.suggest.rediscover': 'रीफ़्रेश करें',
  'flows.suggest.discovering': 'ऑटोमेशन खोजे जा रहे हैं…',
  'flows.suggest.empty':
    'अभी कोई सुझाव नहीं है। खोज चलाएँ और Flow Scout आपके काम में सेट अप करने लायक ऑटोमेशन खोजेगा।',
  'flows.suggest.error': 'खोज नहीं चल सकी। कृपया फिर से प्रयास करें।',
  'flows.suggest.why': 'क्यों',
  'flows.suggest.build': 'इसे बनाएँ',
  'flows.suggest.opening': 'खोला जा रहा है…',
  'flows.suggest.dismiss': 'खारिज करें',
  'flows.suggest.uses': 'उपयोग करता है',
  'flows.suggest.trigger.schedule': 'निर्धारित',
  'flows.suggest.trigger.app_event': 'इवेंट पर',
  'flows.suggest.trigger.manual': 'मांग पर',
  'flows.copilot.open': 'सहपायलट',
  'flows.copilot.title': 'वर्कफ़्लो सहपायलट',
  'flows.copilot.subtitle': 'बदलाव माँगें और लागू करने से पहले हर प्रस्ताव की समीक्षा करें।',
  'flows.copilot.close': 'सहपायलट बंद करें',
  'flows.copilot.placeholder': 'एक बदलाव माँगें…',
  'flows.copilot.send': 'भेजें',
  'flows.copilot.thinking': 'सोच रहे हैं…',
  'flows.copilot.error': 'वर्कफ़्लो बिल्डर तक नहीं पहुँच सके। कृपया फिर से प्रयास करें।',
  'flows.copilot.offline': 'आप ऑफ़लाइन हैं। सहपायलट का उपयोग करने के लिए फिर से कनेक्ट करें।',
  'flows.copilot.emptyState': 'इस वर्कफ़्लो में बदलाव का वर्णन करें और बिल्डर एक अपडेट सुझाएगा।',
  'flows.copilot.proposalTitle': 'प्रस्तावित बदलाव',
  'flows.copilot.added': '{count} जोड़े गए',
  'flows.copilot.removed': '{count} हटाए गए',
  'flows.copilot.noChanges': 'यह प्रस्ताव किसी नोड को नहीं बदलता।',
  'flows.copilot.accept': 'ड्राफ़्ट पर लागू करें',
  'flows.copilot.acceptAndSave': 'स्वीकार करें और सहेजें',
  'flows.copilot.saveAndEnable': 'सहेजें और सक्रिय करें',
  'flows.copilot.saving': 'सहेजा जा रहा है…',
  'flows.copilot.enabling': 'सक्रिय किया जा रहा है…',
  'flows.copilot.enableError':
    'सहेज लिया गया है, लेकिन वर्कफ़्लो सक्रिय नहीं हो सका। सूची से इसे चालू करने का प्रयास करें।',
  'flows.copilot.reject': 'रद्द करें',
  'flows.copilot.previewHint':
    'एक प्रस्तावित ड्राफ़्ट की समीक्षा हो रही है: अभी कुछ सहेजा नहीं गया।',
  'flows.copilot.repairDisplay': 'एक रन विफल हुआ; उसे देखें और सुधार सुझाएँ।',
  'flows.copilot.tool.proposing': 'वर्कफ़्लो प्रस्तावित किया जा रहा है…',
  'flows.copilot.tool.dryRunning': 'वर्कफ़्लो का ड्राई-रन किया जा रहा है…',
  'flows.copilot.tool.saving': 'वर्कफ़्लो सहेजा जा रहा है…',
  'flows.copilot.tool.usingTools': 'टूल का उपयोग किया जा रहा है…',
  'flows.copilot.cappedNotice':
    'यह वर्कफ़्लो पूरा होने से पहले बिल्डर अपनी पुनरावृत्ति सीमा तक पहुँच गया। जारी रखने पर यह मौजूदा ड्राफ़्ट से आगे निर्माण करेगा।',
  'flows.copilot.continueBuilding': 'निर्माण जारी रखें',
  'flows.list.view': 'वर्कफ़्लो देखें',
  'flows.list.export': 'निर्यात',
  'flows.list.exported': 'वर्कफ़्लो निर्यात किया गया',
  'flows.page.import': 'आयात',
  'flows.import.invalidFile': 'यह फ़ाइल मान्य वर्कफ़्लो JSON नहीं है।',
  'flows.import.error': 'इस वर्कफ़्लो को आयात नहीं किया जा सका। फ़ाइल जाँचें और पुनः प्रयास करें।',
  'flows.import.warningTitle': 'आयात चेतावनी',
  'flows.canvas.title': 'वर्कफ़्लो',
  'flows.canvas.loading': 'वर्कफ़्लो लोड हो रहा है…',
  'flows.canvas.loadError': 'यह वर्कफ़्लो लोड नहीं हो सका। कृपया पुनः प्रयास करें।',
  'flows.canvas.notFound': 'यह वर्कफ़्लो नहीं मिला।',
  'flows.canvas.draftMissing':
    'खोलने के लिए कोई वर्कफ़्लो ड्राफ़्ट नहीं है। पहले चैट से एक प्रस्तावित करें।',
  'flows.canvas.backToList': 'वर्कफ़्लो सूची पर वापस जाएं',
  'flows.nodeKind.trigger': 'ट्रिगर',
  'flows.nodeKind.agent': 'एजेंट',
  'flows.nodeKind.tool_call': 'टूल कॉल',
  'flows.nodeKind.http_request': 'HTTP अनुरोध',
  'flows.nodeKind.code': 'कोड',
  'flows.nodeKind.condition': 'शर्त',
  'flows.nodeKind.switch': 'स्विच',
  'flows.nodeKind.merge': 'मर्ज करें',
  'flows.nodeKind.split_out': 'स्प्लिट आउट',
  'flows.nodeKind.transform': 'रूपांतरण',
  'flows.nodeKind.output_parser': 'आउटपुट पार्सर',
  'flows.nodeKind.sub_workflow': 'सब-वर्कफ़्लो',
  'flows.nodeKind.memory': 'मेमोरी',
  'flows.nodeKind.dedup': 'डुप्लिकेट हटाएं',
  'flows.nodeKind.loop': 'लूप',
  'flows.nodeSummary.trigger.manual': 'मांग पर चलता है',
  'flows.nodeSummary.trigger.webhook': 'आने वाले वेबहुक पर चलता है',
  'flows.nodeSummary.trigger.appEventOn': '{parts} पर',
  'flows.nodeSummary.trigger.appEvent': 'ऐप इवेंट पर चलता है',
  'flows.nodeSummary.trigger.unknownKind': 'ट्रिगर: {kind}',
  'flows.nodeSummary.agent.defaultModel': 'डिफ़ॉल्ट मॉडल',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': '{model} से पूछता है',
  'flows.nodeSummary.toolCall.runsNative': '{name} चलाता है',
  'flows.nodeSummary.toolCall.pickNative': 'एक OpenHuman टूल चलाता है (एक चुनें)',
  'flows.nodeSummary.toolCall.runs': '{slug} चलाता है',
  'flows.nodeSummary.toolCall.pick': 'एक ऐप एक्शन चलाता है (एक चुनें)',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': '{method} अनुरोध (एक URL सेट करें)',
  'flows.nodeSummary.code.runs': '{lang} कोड चलाता है',
  'flows.nodeSummary.condition.withField': 'यदि {field} → सही / गलत',
  'flows.nodeSummary.condition.default': 'सही / गलत में शाखा बनाता है',
  'flows.nodeSummary.switch.byExpr': '{expr} के अनुसार रूट करता है',
  'flows.nodeSummary.switch.byExprWithRoutes': '{expr} के अनुसार रूट करता है ({count} मार्ग)',
  'flows.nodeSummary.switch.byValue': 'एक मान के अनुसार रूट करता है',
  'flows.nodeSummary.switch.byValueWithRoutes': 'एक मान के अनुसार रूट करता है ({count} मार्ग)',
  'flows.nodeSummary.merge': 'समानांतर शाखाओं को मर्ज करता है',
  'flows.nodeSummary.splitOut.withPath': 'हर {path} को विभाजित करता है',
  'flows.nodeSummary.splitOut.default': 'एक सूची को आइटम में विभाजित करता है',
  'flows.nodeSummary.transform.default': 'हर आइटम को फिर से आकार देता है',
  'flows.nodeSummary.transform.setFieldsSingular': 'हर आइटम पर {n} फ़ील्ड सेट करता है',
  'flows.nodeSummary.transform.setFieldsPlural': 'हर आइटम पर {n} फ़ील्ड सेट करता है',
  'flows.nodeSummary.outputParser': 'पिछले आउटपुट को पार्स करता है',
  'flows.nodeSummary.subWorkflow': 'एक नेस्टेड वर्कफ़्लो चलाता है',
  'flows.nodeSummary.memory.flavourWith': '"{flavour}" शैली पढ़ता है',
  'flows.nodeSummary.memory.flavour': 'एक मेमोरी शैली पढ़ता है',
  'flows.nodeSummary.memory.people': 'लोगों की मेमोरी खोजता है',
  'flows.nodeSummary.memory.remember': 'इस वर्कफ़्लो में एक मान याद रखता है',
  'flows.nodeSummary.memory.forget': 'इस वर्कफ़्लो से एक मान भूल जाता है',
  'flows.nodeSummary.memory.searchScoped': 'मेमोरी खोजता है ({scope})',
  'flows.nodeSummary.memory.search': 'मेमोरी खोजता है',
  'flows.nodeSummary.memory.recallScoped': 'मेमोरी से याद करता है ({scope})',
  'flows.nodeSummary.memory.recall': 'मेमोरी से याद करता है',
  'flows.nodeSummary.dedup.withKey': '{key} के अनुसार पहले से देखे गए आइटम छोड़ता है',
  'flows.nodeSummary.dedup.default': 'पहले से प्रोसेस किए गए आइटम छोड़ता है',
  'flows.nodeSummary.loop.upTo': 'अधिकतम {max} बार दोहराता है',
  'flows.nodeSummary.loop.whileCondition': 'जब तक {condition} है, अधिकतम {max} बार दोहराता है',
  'flows.palette.title': 'नोड',
  'flows.palette.addNode': '{kind} नोड जोड़ें',
  'flows.editor.save': 'सहेजें',
  'flows.editor.deleteSelected': 'चयनित हटाएं',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': 'सहेजा जा रहा है…',
  'flows.editor.run': 'चलाएं',
  'flows.editor.running': 'चल रहा है…',
  'flows.editor.runFailed': 'रन शुरू नहीं हो सका',
  'flows.editor.validate': 'सत्यापित करें',
  'flows.editor.validating': 'सत्यापित किया जा रहा है…',
  'flows.editor.discard': 'परिवर्तन रद्द करें',
  'flows.editor.confirm.runTitle': 'वर्कफ़्लो चलाएँ?',
  'flows.editor.confirm.runBody': 'यह अभी वर्कफ़्लो चलाएगा।',
  'flows.editor.confirm.saveTitle': 'बदलाव सहेजें?',
  'flows.editor.confirm.saveBody': 'यह वर्कफ़्लो में आपके बदलाव सहेजेगा।',
  'flows.editor.confirm.discardTitle': 'बदलाव रद्द करें?',
  'flows.editor.confirm.discardBody':
    'यह सभी बिना सहेजे बदलावों को पूर्ववत करता है और इसे वापस नहीं किया जा सकता।',
  'flows.editor.confirm.confirm': 'पुष्टि करें',
  'flows.editor.confirm.cancel': 'रद्द करें',
  'flows.editor.unsaved': 'बिना सहेजे परिवर्तन',
  'flows.editor.saveBlocked': 'सहेजने से पहले नीचे दी गई त्रुटियाँ ठीक करें।',
  'flows.editor.errorsTitle': 'त्रुटियाँ',
  'flows.editor.warningsTitle': 'चेतावनियाँ',
  'flows.editor.saveFailedTitle': 'सहेजा नहीं जा सका',
  'flows.editor.leaveTitle': 'बिना सहेजे छोड़ें?',
  'flows.editor.leaveBody':
    'इस वर्कफ़्लो में आपके बिना सहेजे परिवर्तन हैं। अभी छोड़ने पर वे खो जाएँगे।',
  'flows.editor.leaveStay': 'रुकें',
  'flows.editor.leaveDiscard': 'छोड़ें',
  // ── Node config drawer (issue B5b / Phase 3b): per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': 'अभिव्यक्ति चेतावनियाँ',
  'flowRuns.inspector.diagnosticResolvedNull': 'null में बदला',
  'flows.runs.sidebarTitle': 'रन',
  'flows.runs.refresh': 'रन रीफ़्रेश करें',
  'flows.palette.appAction': 'ऐप क्रिया',
  'flows.palette.ohTool': 'टूल',
  'flows.editor.deleteNode': 'हटाएँ',
  'flows.nodeConfig.connections.title': 'कनेक्शन',
  'flows.nodeConfig.connections.inputs': 'इनपुट',
  'flows.nodeConfig.connections.outputs': 'आउटपुट',
  'flows.nodeConfig.connections.none': 'अभी किसी दूसरे नोड से जुड़ा नहीं है।',
  'flows.nodeConfig.connections.remove': 'कनेक्शन हटाएँ',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'Cron अभिव्यक्ति',
  'flows.nodeConfig.trigger.scheduleFreqLabel': 'आवृत्ति',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': 'हर N मिनट',
  'flows.nodeConfig.trigger.scheduleFreq_hours': 'हर N घंटे',
  'flows.nodeConfig.trigger.scheduleFreq_daily': 'हर दिन एक समय पर',
  'flows.nodeConfig.trigger.scheduleEvery': 'हर',
  'flows.nodeConfig.trigger.scheduleInterval': 'अंतराल',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': 'मिनट',
  'flows.nodeConfig.trigger.scheduleUnit_hours': 'घंटे',
  'flows.nodeConfig.trigger.scheduleAt': 'पर',
  'flows.nodeConfig.trigger.scheduleTime': 'दिन का समय',
  'flows.nodeConfig.trigger.scheduleDays': 'दिनों पर (वैकल्पिक: हर दिन के लिए खाली छोड़ें)',
  'flows.nodeConfig.trigger.scheduleAdvanced': 'उन्नत (cron संपादित करें)',
  'flows.nodeConfig.trigger.scheduleSimple': 'सरल शेड्यूल पर वापस',
  'flows.cron.customSchedule': 'कस्टम शेड्यूल ({expr})',
  'flows.cron.noScheduleSet': 'कोई शेड्यूल सेट नहीं है',
  'flows.cron.weekdays': 'कार्यदिवस',
  'flows.cron.weekends': 'सप्ताहांत',
  'flows.cron.everyMinute': 'हर मिनट',
  'flows.cron.everyMinuteOnDays': '{days} को हर मिनट',
  'flows.cron.everyNMinutes': 'हर {n} मिनट',
  'flows.cron.everyNMinutesOnDays': '{days} को हर {n} मिनट',
  'flows.cron.everyHour': 'हर घंटे',
  'flows.cron.everyHourOnDays': '{days} को हर घंटे',
  'flows.cron.everyNHours': 'हर {n} घंटे',
  'flows.cron.everyNHoursOnDays': '{days} को हर {n} घंटे',
  'flows.cron.everyDayAtTime': 'हर दिन {time} बजे',
  'flows.cron.atTimeOnDays': '{days} को {time} बजे',
  'flows.cron.invalidInterval': 'अमान्य अंतराल',
  'flows.cron.dailyEvery24h': 'दैनिक (हर 24 घंटे)',
  'flows.cron.everyNDays': 'हर {n} दिन',
  'flows.cron.everyNHoursShort': 'हर {n} घंटे',
  'flows.cron.everyNMinutesShort': 'हर {n} मिनट',
  'flows.cron.everySecond': 'हर सेकंड',
  'flows.cron.everyNSeconds': 'हर {n} सेकंड',
  'flows.cron.onceAtRaw': '{at} पर एक बार',
  'flows.cron.onceAt': '{at} पर एक बार',
  'flows.nodeConfig.trigger.pickApp': 'पहले कोई जुड़ा हुआ ऐप चुनें।',
  'flows.nodeConfig.tool.pickConnection': 'पहले कोई कनेक्शन चुनें।',
  'flows.nodeConfig.composio.noConnections':
    'अभी कोई ऐप जुड़ा नहीं है। Settings → Apps में एक जोड़ें, फिर यहाँ चुनें।',
  'flows.nodeConfig.composio.selectApp': 'ऐप चुनें…',
  'flows.nodeConfig.composio.select': 'चुनें…',
  'flows.nodeConfig.composio.loading': 'लोड हो रहा है…',
  'flows.nodeConfig.composio.custom': 'मैन्युअल दर्ज करें…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint': 'क्षमता स्तर चुनें: वर्कस्पेस मॉडल तय करेगा।',
  'flows.nodeConfig.agent.modelInherit': 'डिफ़ॉल्ट (विरासत में)',
  'flows.nodeConfig.agent.agentRefLabel': 'एजेंट',
  'flows.nodeConfig.agent.agentRefHint':
    'इस नोड को एक पंजीकृत एजेंट के रूप में चलाएँ: इसके उपकरण और सुरक्षा उपाय लागू होते हैं।',
  'flows.nodeConfig.agent.agentRefInherit': 'डिफ़ॉल्ट (वर्कफ़्लो बिल्डर)',
  'flows.nodeConfig.agent.modelManagedTiers': 'प्रबंधित स्तर',
  'flows.nodeConfig.agent.modelHints': 'मॉडल संकेत',
  'flows.nodeConfig.agent.modelCustom': 'कस्टम मॉडल…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': 'जैसे gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': 'आवश्यक',
  'flows.nodeConfig.tool.requiredMissing': 'आवश्यक: वायर नहीं किया गया',
  'flows.nodeConfig.tool.argsAdvancedLabel': 'सभी आर्ग्युमेंट (उन्नत)',
  'flows.nodeConfig.upstream.insert': 'डालें…',
  'flows.nodeConfig.upstream.insertLabel': 'पिछले चरण से मान डालें',
  'flows.nodeConfig.native.toolLabel': 'टूल',
  'flows.nodeConfig.native.toolHint': 'सहायक के बिल्ट-इन टूल में से एक (खोज, मीडिया, फ़ाइलें, …)।',
  'flows.nodeConfig.native.select': 'टूल चुनें…',
  'flows.nodeConfig.native.loading': 'टूल लोड हो रहे हैं…',
  'flows.nodeConfig.close': 'सेटिंग बंद करें',
  'flows.nodeConfig.nameLabel': 'नाम',
  'flows.nodeConfig.namePlaceholder': 'नोड नाम',
  'flows.nodeConfig.editForm': 'फ़ॉर्म के रूप में संपादित करें',
  'flows.nodeConfig.editJson': 'JSON के रूप में संपादित करें',
  'flows.nodeConfig.rawJsonLabel': 'कॉन्फ़िगरेशन (JSON)',
  'flows.nodeConfig.rawJsonHint': 'इस नोड के लिए मुक्त कॉन्फ़िगरेशन।',
  'flows.nodeConfig.rawJsonInvalid': 'अमान्य JSON: पार्स होने तक बदलाव लागू नहीं होते।',
  'flows.nodeConfig.expressionHint':
    'नोड इनपुट से मान की गणना के लिए = से शुरू करें, जैसे =item.url',
  'flows.nodeConfig.expressionBadge': 'अभिव्यक्ति',
  'flows.nodeConfig.keymapKeyPlaceholder': 'कुंजी',
  'flows.nodeConfig.keymapValuePlaceholder': 'मान',
  'flows.nodeConfig.keymapRemove': 'पंक्ति हटाएँ',
  'flows.nodeConfig.keymapAdd': 'पंक्ति जोड़ें',
  'flows.nodeConfig.credentialLabel': 'क्रेडेंशियल',
  'flows.nodeConfig.credentialHint': 'इस नोड के लिए एक कनेक्टेड खाता या क्रेडेंशियल चुनें।',
  'flows.nodeConfig.credentialEmpty': 'कोई कनेक्टेड क्रेडेंशियल उपलब्ध नहीं।',
  'flows.nodeConfig.credentialNone': 'कोई नहीं',
  'flows.nodeConfig.trigger.kindLabel': 'ट्रिगर प्रकार',
  'flows.nodeConfig.trigger.kind_manual': 'मैनुअल',
  'flows.nodeConfig.trigger.kind_schedule': 'शेड्यूल',
  'flows.nodeConfig.trigger.kind_webhook': 'वेबहुक',
  'flows.nodeConfig.trigger.kind_app_event': 'ऐप इवेंट',
  'flows.nodeConfig.trigger.scheduleLabel': 'क्रॉन शेड्यूल',
  'flows.nodeConfig.trigger.scheduleHint': 'क्रॉन एक्सप्रेशन: मिनट घंटा दिन महीना सप्ताह का दिन।',
  'flows.nodeConfig.trigger.toolkitLabel': 'टूलकिट',
  'flows.nodeConfig.trigger.triggerSlugLabel': 'ट्रिगर स्लग',
  'flows.nodeConfig.trigger.webhookHint':
    'वेबहुक ट्रिगर सहेजे जाते हैं पर अभी स्वचालित रूप से नहीं चलते।',
  'flows.nodeConfig.http.methodLabel': 'विधि',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': 'हेडर',
  'flows.nodeConfig.http.bodyLabel': 'बॉडी (JSON)',
  'flows.nodeConfig.agent.promptLabel': 'प्रॉम्प्ट',
  'flows.nodeConfig.agent.promptPlaceholder': 'एजेंट के लिए निर्देश…',
  'flows.nodeConfig.agent.modelLabel': 'मॉडल',
  'flows.nodeConfig.tool.slugLabel': 'टूल स्लग',
  'flows.nodeConfig.tool.argsLabel': 'तर्क (JSON)',
  'flows.nodeConfig.condition.fieldLabel': 'फ़ील्ड',
  'flows.nodeConfig.condition.fieldHint':
    'सत्यता जाँचने के लिए इनपुट आइटम की कुंजी। true या false की ओर रूट करता है।',
  'flows.nodeConfig.switch.expressionLabel': 'अभिव्यक्ति',
  'flows.nodeConfig.switch.hint':
    'परिणामी मान मिलान वाला आउटपुट पोर्ट चुनता है; null default पर जाता है।',
  'flows.nodeConfig.switch.fieldLabel': 'फ़ील्ड (वैकल्पिक)',
  'flows.nodeConfig.transform.setLabel': 'फ़ील्ड सेट करें',
  'flows.nodeConfig.transform.setHint':
    'प्रत्येक मान प्रति आइटम मूल्यांकित एक अभिव्यक्ति है, जैसे =item.name',
  'flows.nodeConfig.code.languageLabel': 'भाषा',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': 'सोर्स कोड',
  'flows.nodeConfig.memory.operationLabel': 'ऑपरेशन',
  'flows.nodeConfig.memory.operation_recall': 'याद करें',
  'flows.nodeConfig.memory.operation_search': 'खोजें',
  'flows.nodeConfig.memory.operation_flavour': 'शैली',
  'flows.nodeConfig.memory.operation_people': 'लोग',
  'flows.nodeConfig.memory.operation_remember': 'याद रखें',
  'flows.nodeConfig.memory.operation_forget': 'भूल जाएँ',
  'flows.nodeConfig.memory.scopeLabel': 'दायरा',
  'flows.nodeConfig.memory.scopeHint': 'यह मेमोरी कहाँ खोजनी है।',
  'flows.nodeConfig.memory.scopeWriteHint':
    'लिखने की अनुमति केवल इसी वर्कफ़्लो के भीतर है, आपकी निजी मेमोरी में कभी नहीं।',
  'flows.nodeConfig.memory.scope_user': 'आप (केवल पढ़ने के लिए)',
  'flows.nodeConfig.memory.scope_flow': 'यह वर्कफ़्लो',
  'flows.nodeConfig.memory.scope_flows': 'सभी वर्कफ़्लो (केवल पढ़ने के लिए)',
  'flows.nodeConfig.memory.queryLabel': 'क्वेरी',
  'flows.nodeConfig.memory.queryOptionalHint': 'वैकल्पिक: लोगों की खोज को सीमित करता है।',
  'flows.nodeConfig.memory.flavourLabel': 'शैली',
  'flows.nodeConfig.memory.flavourHint': 'कौन सा व्यक्तित्व पहलू पढ़ना है, जैसे communication।',
  'flows.nodeConfig.memory.flavour_communication': 'संचार',
  'flows.nodeConfig.memory.flavour_coding_style': 'कोडिंग शैली',
  'flows.nodeConfig.memory.flavour_stack': 'तकनीकी स्टैक',
  'flows.nodeConfig.memory.flavour_workflow': 'वर्कफ़्लो',
  'flows.nodeConfig.memory.flavour_environment': 'वातावरण',
  'flows.nodeConfig.memory.flavour_directives': 'निर्देश',
  'flows.nodeConfig.memory.flavour_anti_preferences': 'नापसंद',
  'flows.nodeConfig.memory.keyLabel': 'कुंजी',
  'flows.nodeConfig.memory.valueLabel': 'मान',
  'flows.nodeConfig.memory.limitLabel': 'सीमा',
  'flows.nodeConfig.memory.limitHint': 'अधिकतम परिणामों की संख्या।',
  'flows.nodeConfig.memory.minScoreLabel': 'न्यूनतम स्कोर',
  'flows.nodeConfig.memory.minScoreHint': '0 से 1 तक की प्रासंगिकता सीमा।',
  'flows.nodeConfig.dedup.keyLabel': 'कुंजी',
  'flows.nodeConfig.dedup.keyHint':
    'प्रति आइटम एक स्थिर आईडी एक्सप्रेशन, जैसे =item.id। जिन आइटम की कुंजी पहले देखी जा चुकी है उन्हें छोड़ दिया जाता है।',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': 'अधिकतम पुनरावृत्तियाँ',
  'flows.nodeConfig.loop.maxIterationsHint':
    'लूप रुकने से पहले बॉडी कितनी बार चल सकती है। हमेशा सीमित।',
  'flows.nodeConfig.loop.onExceededLabel': 'सीमा पर पहुँचने पर',
  'flows.nodeConfig.loop.onExceededHint':
    'रन को विफल करें, या लूप रोककर अंतिम चक्र की वस्तुओं के साथ done पोर्ट से आगे बढ़ें।',
  'flows.nodeConfig.loop.onExceeded_error': 'रन को विफल करें',
  'flows.nodeConfig.loop.onExceeded_continue': 'आंशिक परिणामों के साथ जारी रखें',
  'flows.nodeConfig.loop.conditionLabel': 'जब तक जारी रखें',
  'flows.nodeConfig.loop.conditionHint':
    'वैकल्पिक। जब तक यह सत्य है लूप चलता रहता है; पहला असत्य परिणाम done पोर्ट से बाहर निकलता है।',

  'flows.enableApproval.title': 'क्या इस वर्कफ़्लो को काम करने की अनुमति दें?',
  'flows.enableApproval.intro':
    'इस वर्कफ़्लो को नीचे दिए गए कार्यों के लिए आपकी अनुमति चाहिए। स्वीकृति केवल इसी वर्कफ़्लो पर लागू होती है।',
  'flows.enableApproval.approveAll': 'सभी को अनुमति दें',
  'flows.enableApproval.deny': 'अस्वीकार करें',
  'flows.enableApproval.enableAnyway': 'फिर भी चालू करें',
  'flows.enableApproval.granting': 'स्वीकृत किया जा रहा है…',
  'flows.enableApproval.error': 'स्वीकृतियाँ सहेजी नहीं जा सकीं। कृपया फिर से प्रयास करें।',
  'flows.enableApproval.blockedHint': 'आपकी एजेंट पहुँच सेटिंग्स द्वारा अवरुद्ध।',
  'flows.enableApproval.dynamicHint': 'वर्कफ़्लो चलते समय तय होता है; ज़रूरत पड़ने पर आपसे पूछेगा।',
  'flows.enableApproval.agentHint': 'यह AI चरण अपने कार्यों के लिए अलग से अनुमति माँग सकता है।',
  'flows.enableApproval.deniedDisabled': 'सहेजा गया, लेकिन वर्कफ़्लो बंद ही रखा गया।',
  'flows.chooser.title': 'वर्कफ़्लो बनाएँ',
  'flows.chooser.subtitle': 'चुनें कि आप कैसे शुरू करना चाहते हैं।',
  'flows.chooser.scratchTitle': 'शुरू से शुरू करें',
  'flows.chooser.scratchDescription': 'एक खाली कैनवास और एकल मैन्युअल ट्रिगर के साथ शुरू करें।',
  'flows.chooser.templateTitle': 'टेम्पलेट से',
  'flows.chooser.templateDescription': 'तैयार उदाहरण से शुरू करें और उसे अनुकूलित करें।',
  'flows.chooser.describeTitle': 'इसका वर्णन करें',
  'flows.chooser.describeDescription':
    'सहायक को बताएँ कि आप क्या चाहते हैं और उसे वर्कफ़्लो का मसौदा बनाने दें।',
  'flows.chooser.creating': 'वर्कफ़्लो बनाया जा रहा है…',
  'flows.chooser.createError': 'वर्कफ़्लो नहीं बनाया जा सका। कृपया पुनः प्रयास करें।',
  'flows.templates.title': 'टेम्पलेट से शुरू करें',
  'flows.templates.subtitle': 'एक प्रारंभिक बिंदु चुनें और संपादक में उसे अनुकूलित करें।',
  'flows.templates.use': 'टेम्पलेट उपयोग करें',
  'flows.templates.back': 'वापस',
  'flows.templates.empty': 'कोई टेम्पलेट उपलब्ध नहीं।',
  'flows.templates.category.scheduled': 'निर्धारित',
  'flows.templates.category.triggered': 'ट्रिगर किया गया',
  'flows.templates.category.onDemand': 'माँग पर',
  'flows.templates.daily-digest.name': 'चैनल पर दैनिक सारांश',
  'flows.templates.daily-digest.description':
    'एक शेड्यूल पर, एजेंट एक छोटा सारांश लिखता है और उसे चैनल पर पोस्ट करता है।',
  'flows.templates.scheduled-scrape.name': 'निर्धारित स्क्रैप मेमोरी में',
  'flows.templates.scheduled-scrape.description':
    'शेड्यूल पर एक स्रोत प्राप्त करें, परिणामों को पुनः आकार दें, और उन्हें मेमोरी में संग्रहीत करें।',
  'flows.templates.webhook-triage.name': 'वेबहुक ट्राइएज और सूचना',
  'flows.templates.webhook-triage.description':
    'आने वाले वेबहुक को एक एजेंट द्वारा छाँटा जाता है, फिर आपको सूचित किया जाता है।',
  'flows.templates.app-event-route.name': 'ऐप इवेंट से सशर्त क्रिया',
  'flows.templates.app-event-route.description':
    'किसी जुड़े ऐप की घटना एक जाँच चलाती है, फिर मिलान होने पर कार्रवाई करती है।',
  'flows.templates.http-fetch-parse.name': 'API प्राप्त करें और पार्स करें',
  'flows.templates.http-fetch-parse.description':
    'माँग पर एक HTTP एंडपॉइंट को कॉल करें और प्रतिक्रिया को उपयोगी रूप में पार्स करें।',
  'flows.templates.ask-agent.name': 'एजेंट से पूछें',
  'flows.templates.ask-agent.description':
    'एक सरल मैन्युअल ट्रिगर जो किसी कार्य को एजेंट को सौंपता है।',
  'flows.templates.opus-sonnet-brief.name':
    'शोध सारांश (Opus योजना बनाता है, Sonnet मसौदा तैयार करता है)',
  'flows.templates.opus-sonnet-brief.description':
    'एक रीज़निंग-टियर एजेंट सारांश की योजना बनाता है, एक चैट-टियर एजेंट उसका मसौदा तैयार करता है, फिर परिणाम आपके लिए आकार दिया जाता है।',

  'oauth.button.connecting': 'कनेक्ट हो रहा है...',
  'oauth.button.loopbackTimeout':
    'साइन-इन का समय समाप्त हो गया: ब्राउज़र ने OAuth पुनर्निर्देशन पूरा नहीं किया। कृपया पुनः प्रयास करें।',
  'oauth.login.continueWith': 'के साथ जारी रखें',
  'onboarding.contextGathering.buildingDesc': 'बिल्डिंग विवरण',
  'onboarding.contextGathering.buildingProfile': 'आपकी प्रोफ़ाइल बन रही है...',
  'onboarding.contextGathering.continueToChat': 'चैट पर जाएं',
  'onboarding.contextGathering.coreAlive':
    'कोर पहुँच योग्य है: पहली बार लॉन्च करने में एक मिनट लग सकता है।',
  'onboarding.contextGathering.coreAliveProbing': 'कोर कनेक्शन की जाँच की जा रही है…',
  'onboarding.contextGathering.coreUnreachable':
    'कोर प्रतिक्रिया नहीं दे रहा है। आप जारी रख सकते हैं और बाद में पुनः प्रयास कर सकते हैं।',
  'onboarding.contextGathering.errorDesc':
    'हम अभी आपकी पूरी प्रोफ़ाइल नहीं बना सके, लेकिन कोई बात नहीं: आप जारी रख सकते हैं और आपकी प्रोफ़ाइल समय के साथ बनती जाएगी।',
  'onboarding.contextGathering.stillWorkingDesc':
    'हम आपके स्थानीय मॉडल और टूल्स को तैयार कर रहे हैं, पहली बार लॉन्च करने में 30–60 सेकंड लग सकते हैं। आप कभी भी चैट पर जा सकते हैं: प्रोफ़ाइल पृष्ठभूमि में बनती रहेगी।',
  'onboarding.contextGathering.stillWorkingTitle': 'आपकी प्रोफ़ाइल पर अब भी काम चल रहा है…',
  'onboarding.contextGathering.title': 'कॉन्टेक्स्ट गैदरिंग',
  'openhuman.team_list_teams': 'टीम सूची टीमें',
  'overlay.ariaAttention': 'ध्यान संदेश',
  'overlay.ariaCompanion': 'कंपैनियन सक्रिय',
  'overlay.ariaOrb': 'OpenHuman ओवरले',
  'overlay.ariaVoiceActive': 'वॉइस इनपुट एक्टिव',
  'overlay.companion.error': 'त्रुटि',
  'overlay.companion.listening': 'सुन रहा है…',
  'overlay.companion.speaking': 'बोल रहा है…',
  'overlay.companion.thinking': 'सोच रहा है…',
  'overlay.orbTitle': 'मूव करने के लिए खींचें · पोज़िशन रीसेट के लिए डबल-क्लिक करें',
  'pages.settings.account.connections': 'कनेक्शन',
  'pages.settings.account.connectionsDesc': 'कनेक्शन विवरण',
  'pages.settings.account.migration': 'किसी अन्य असिस्टेंट से इम्पोर्ट करें',
  'pages.settings.account.migrationDesc':
    'OpenClaw (और जल्द ही Hermes) से मेमोरी और नोट्स इस वर्कस्पेस में माइग्रेट करें।',
  'pages.settings.account.privacy': 'प्राइवेसी',
  'pages.settings.account.privacyDesc': 'गोपनीयता विवरण',
  'pages.settings.account.recoveryPhrase': 'रिकवरी फ्रेज़',
  'pages.settings.account.recoveryPhraseDesc': 'रिकवरी फ़्रेज़ विवरण',
  'pages.settings.account.team': 'टीम',
  'pages.settings.account.teamDesc': 'टीम विवरण',
  'pages.settings.accountSection.description': 'रिकवरी फ्रेज़, टीम, कनेक्शन और प्राइवेसी सेटिंग्स।',
  'pages.settings.accountSection.title': 'अकाउंट',
  'pages.settings.ai.llm': 'LLM',
  'pages.settings.ai.llmDesc': 'LLM विवरण',
  'pages.settings.ai.voice': 'वॉइस',
  'pages.settings.ai.voiceDesc': 'वॉइस विवरण',
  'pages.settings.aiSection.description':
    'लैंग्वेज मॉडल प्रोवाइडर, लोकल Ollama और वॉइस (STT / TTS)।',
  'pages.settings.aiSection.title': 'AI',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc': 'रूटिंग मोड, एकीकरण ट्रिगर, और ट्रिगर इतिहास संग्रह।',
  'pages.settings.features.messagingChannels': 'मैसेजिंग चैनल',
  'pages.settings.features.messagingChannelsDesc': 'मैसेजिंग चैनल विवरण',
  'pages.settings.features.notifications': 'नोटिफिकेशन',
  'pages.settings.features.notificationsDesc': 'नोटिफ़िकेशन विवरण',
  'pages.settings.features.tools': 'टूल्स',
  'pages.settings.features.toolsDesc': 'टूल्स विवरण',
  'pages.settings.featuresSection.title': 'फीचर्स',
  'privacy.dataKind.credentials': 'क्रेडेंशियल',
  'privacy.dataKind.derived': 'डिराइव्ड',
  'privacy.dataKind.diagnostics': 'डायग्नोस्टिक्स',
  'privacy.dataKind.metadata': 'मेटाडेटा',
  'privacy.dataKind.raw': 'रॉ',
  'privacy.whatLeaves.link.label': 'मेरे कंप्यूटर से क्या जाता है?',
  'rewards.community.achievementsUnlocked': '{total} में से {unlocked} उपलब्धियाँ अनलॉक हुईं',
  'rewards.community.activityStreakHint': 'OpenHuman पर लगातार सक्रिय रहने के दिन।',
  'rewards.community.activityTitle': 'आपकी गतिविधि',
  'rewards.community.claimCredited': 'आपके बैलेंस में {amount} जोड़े गए',
  'rewards.community.claimError': 'दावा नहीं किया जा सका। कृपया फिर से प्रयास करें।',
  'rewards.community.claimTokens': '{tokens} टोकन का दावा करें',
  'rewards.community.claimed': 'दावा किया गया',
  'rewards.community.claiming': 'दावा किया जा रहा है…',
  'rewards.community.connectDiscord': 'Discord कनेक्ट करें',
  'rewards.community.connectDiscordError':
    'Discord कनेक्शन शुरू नहीं हो सका। कृपया फिर से प्रयास करें।',
  'rewards.community.connectingDiscord': 'कनेक्ट हो रहा है…',
  'rewards.community.cumulativeTokens': 'कुल टोकन',
  'rewards.community.currentStreak': 'गतिविधि स्ट्रीक',
  'rewards.community.disconnectDiscord': 'डिस्कनेक्ट करें',
  'rewards.community.disconnectDiscordError':
    'Discord डिस्कनेक्ट नहीं हो सका। कृपया पुनः प्रयास करें।',
  'rewards.community.disconnectingDiscord': 'डिस्कनेक्ट हो रहा है…',
  'rewards.community.discordAccount': 'Discord खाता',
  'rewards.community.discordConnected': 'Discord कनेक्ट हो गया',
  'rewards.community.discordConnectedAs': '{username} के रूप में कनेक्टेड',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': 'Discord लिंक्ड, Guild में नहीं',
  'rewards.community.discordMember': 'सर्वर में शामिल हुए',
  'rewards.community.discordNotLinked': 'Discord लिंक्ड नहीं',
  'rewards.community.discordServer': 'Discord सर्वर',
  'rewards.community.discordStatusUnavailable': 'Discord स्टेटस उपलब्ध नहीं',
  'rewards.community.discordWaiting': 'Discord का इंतज़ार',
  'rewards.community.heroSubtitle': 'हीरो उपशीर्षक',
  'rewards.community.heroTitle': 'हीरो शीर्षक',
  'rewards.community.joinDiscord': 'Discord से जुड़ें',
  'rewards.community.loadingRewards': 'रिवॉर्ड लोड हो रहे हैं…',
  'rewards.community.locked': 'अनलॉक्ड',
  'rewards.community.longestStreak': 'सबसे लंबी स्ट्रीक',
  'rewards.community.retrying': 'फिर से कोशिश हो रही है…',
  'rewards.community.rewardTokens': '+{tokens} टोकन',
  'rewards.community.rewardTokensMonthly': '+{tokens} टोकन/माह',
  'rewards.community.roleAssigned': 'रोल असाइन हो गया',
  'rewards.community.roleAssignmentCount': '{unlocked} में से {assigned} रोल असाइन किए गए',
  'rewards.community.roleClaimDesc':
    'आपने Discord रोल अनलॉक किए हैं लेकिन अभी तक OpenHuman सर्वर में शामिल नहीं हुए हैं। शामिल हों ताकि वे अपने-आप असाइन हो जाएँ।',
  'rewards.community.roleClaimTitle': 'अपने Discord रोल क्लेम करें',
  'rewards.community.roleJoinToClaim': 'क्लेम करने के लिए सर्वर जॉइन करें',
  'rewards.community.rolePending': 'रोल सिंक हो रहा है…',
  'rewards.community.rolesAndRewards': 'रोल्स और रिवॉर्ड',
  'rewards.community.streakDays': '{n} दिन',
  'rewards.community.syncPending': 'रिवॉर्ड सिंक पेंडिंग',
  'rewards.community.syncPendingDesc': 'सिंक लंबित विवरण',
  'rewards.community.syncUnavailable': 'सिंक उपलब्ध नहीं',
  'rewards.community.tryAgain': 'फिर से कोशिश हो रही है…',
  'rewards.community.unknown': 'अज्ञात',
  'rewards.community.unlocked': 'अनलॉक्ड',
  'rewards.community.yourProgress': 'आपकी प्रगति',
  'rewards.coupon.colCode': 'कोड',
  'rewards.coupon.colRedeemed': 'रिडीम हुआ',
  'rewards.coupon.colReward': 'रिवॉर्ड',
  'rewards.coupon.colStatus': 'स्टेटस',
  'rewards.coupon.loadingHistory': 'रिवॉर्ड हिस्ट्री लोड हो रही है…',
  'rewards.coupon.noCodes': 'अभी तक कोई रिवॉर्ड कोड रिडीम नहीं किया गया।',
  'rewards.coupon.pending': 'पेंडिंग',
  'rewards.coupon.placeholder': 'कूपन कोड',
  'rewards.coupon.promoCredits': 'प्रोमो क्रेडिट',
  'rewards.coupon.recentRedemptions': 'हाल के रिडेम्प्शन',
  'rewards.coupon.redeemAccepted':
    '{code} स्वीकृत। आवश्यक कार्रवाई पूरी होने के बाद {amount} अनलॉक होगा।',
  'rewards.coupon.redeemButton': 'कोड रिडीम करें',
  'rewards.coupon.redeemSuccess': '{code} रिडीम किया गया। {amount} आपके क्रेडिट में जोड़ा गया।',
  'rewards.coupon.redeemedCodes': 'रिडीम हुए कोड',
  'rewards.coupon.redeeming': 'रिडीम हो रहा है...',
  'rewards.coupon.statusApplied': 'लागू',
  'rewards.coupon.statusPendingAction': 'कार्रवाई लंबित',
  'rewards.coupon.statusRedeemed': 'रिडीम किया गया',
  'rewards.coupon.subtitle': 'उपशीर्षक',
  'rewards.coupon.title': 'कूपन कोड रिडीम करें',
  'rewards.referralSection.activity': 'रेफरल एक्टिविटी',
  'rewards.referralSection.apply': 'लागू हो रहा है…',
  'rewards.referralSection.applying': 'लागू हो रहा है…',
  'rewards.referralSection.colReferredUser': 'रेफर किया यूज़र',
  'rewards.referralSection.colReward': 'रिवॉर्ड',
  'rewards.referralSection.colStatus': 'स्टेटस',
  'rewards.referralSection.colUpdated': 'अपडेट हुआ',
  'rewards.referralSection.completed': 'पूरा हुआ',
  'rewards.referralSection.copyCode': 'कोड कॉपी करें',
  'rewards.referralSection.copyFailed': 'कॉपी विफल',
  'rewards.referralSection.haveCode': 'रेफरल कोड है?',
  'rewards.referralSection.haveCodeDesc': 'कोड है विवरण',
  'rewards.referralSection.linked': 'लिंक्ड',
  'rewards.referralSection.linkedCode': '(कोड {code})',
  'rewards.referralSection.loading': 'रेफरल प्रोग्राम लोड हो रहा है…',
  'rewards.referralSection.retry': 'पुनः प्रयास करें',
  'rewards.referralSection.noReferrals': 'कोई रेफरल नहीं',
  'rewards.referralSection.pendingReferrals': 'पेंडिंग रेफरल',
  'rewards.referralSection.placeholder': 'रेफरल कोड',
  'rewards.referralSection.share': 'शेयर करें',
  'rewards.referralSection.statusCompleted': 'पूरा हुआ',
  'rewards.referralSection.statusExpired': 'एक्सपायर हो गया',
  'rewards.referralSection.statusJoined': 'जॉइन हुआ',
  'rewards.referralSection.subtitle': 'उपशीर्षक',
  'rewards.referralSection.title': 'दोस्तों को इनवाइट करें, क्रेडिट कमाएं',
  'rewards.referralSection.totalEarned': 'कुल कमाया',
  'rewards.referralSection.yourCode': 'आपका कोड',
  'settings.ai.addCloudProvider': 'क्लाउड प्रदाता जोड़ें',
  'settings.ai.addProvider': 'सेव हो रहा है…',
  'settings.ai.apiKeyFieldLabel': 'API key फील्ड लेबल',
  'settings.ai.apiKeyRequired': 'जारी रखने के लिए अपनी API key पेस्ट करें।',
  'settings.ai.apiKeyStoredEncrypted': 'API key एन्क्रिप्टेड रूप में स्टोर है',
  'settings.ai.apiKeysEncrypted': 'xqx',
  'settings.ai.clearStoredKey': 'स्टोर्ड key क्लियर करें',
  'settings.ai.connectProvider': 'प्रदाता कनेक्ट करें',
  'settings.ai.customRouting': 'कस्टम रूटिंग',
  'settings.ai.defaultResolvesTo': 'डिफ़ॉल्ट इसमें हल होता है',
  'settings.ai.discard': 'रद्द करें',
  'settings.ai.editProvider': 'प्रदाता संपादित करें',
  'settings.ai.llmProviders': 'LLM प्रोवाइडर',
  'settings.ai.llmProvidersDesc': 'भाषा मॉडल प्रदाता जोड़ें और कॉन्फ़िगर करें।',
  'settings.ai.localOllama': 'लोकल (Ollama)',
  'settings.ai.modelLabel': 'मॉडल',
  'settings.ai.noCustomProviders': 'कोई कस्टम प्रोवाइडर नहीं',
  'settings.ai.openAiCompat.authHeaderExample': 'Authorization: Bearer <आपकी कुंजी>',
  'settings.ai.openAiCompat.authHeaderLabel': 'प्रामाणिक शीर्षलेख',
  'settings.ai.openAiCompat.baseUrlLabel': 'आधार URL',
  'settings.ai.openAiCompat.baseUrlUnavailable': 'अनुपलब्ध',
  'settings.ai.openAiCompat.clearKey': 'साफ़ कुंजी',
  'settings.ai.openAiCompat.description':
    'इस / v1 सर्वर पर पॉइंट स्थानीय harnesses को नीचे कॉन्फ़िगर किए गए प्रदाताओं के माध्यम से रूट करने के लिए। प्रमाणीकरण एक स्थिर कुंजी का उपयोग करता है जिसे आप यहां सेट करते हैं, ऐप का आंतरिक कोर बियरर नहीं।',
  'settings.ai.openAiCompat.keyConfigured': 'कुंजी कॉन्फ़िगर की गई',
  'settings.ai.openAiCompat.keyRequired': 'कुंजी आवश्यक है',
  'settings.ai.openAiCompat.rotateKey': 'कुंजी घुमाएँ',
  'settings.ai.openAiCompat.setKey': 'कुंजी सेट करें',
  'settings.ai.openAiCompat.title': 'OpenAI-संगत समापन बिंदु',
  'settings.ai.providerLabel': 'प्रोवाइडर',
  'skills.mcpComingSoon.title': 'MCP सर्वर',
  'skills.mcpComingSoon.description':
    'MCP सर्वर प्रबंधन जल्द आ रहा है। यह टैब आपके MCP सर्वर इंटीग्रेशन खोजने, कनेक्ट करने और मॉनिटर करने का केंद्र होगा।',
  'settings.ai.routing': 'रूटिंग',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected':
    'कनेक्ट नहीं: चैट को आपके स्थानीय Claude Code CLI के माध्यम से रूट करता है।',
  'settings.ai.claudeCode.checkingSignIn': 'साइन-इन जाँचा जा रहा है…',
  'settings.ai.claudeCode.inlineConnected': 'कनेक्टेड।',
  'settings.ai.claudeCode.signedInAs': 'इस रूप में साइन इन',
  'settings.ai.claudeCode.subscriptionFallback': 'Claude सदस्यता',
  'settings.ai.claudeCode.usingApiKeyEnv': 'ANTHROPIC_API_KEY का उपयोग',
  'settings.ai.claudeCode.cliNotInstalled': 'CLI इंस्टॉल नहीं है',
  'settings.ai.claudeCode.signInUnknown': 'साइन-इन स्थिति अज्ञात',
  'settings.ai.claudeCode.connectedNotSignedIn': 'कनेक्टेड · साइन इन नहीं',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'ऐसी मॉडल आईडी जिसे claude CLI स्वीकार करता है: एक उपनाम (sonnet, opus) या पूरा नाम (claude-sonnet-4-5)। इसे ज्यों का त्यों claude --model को भेजा जाता है, इसलिए sonnet-4-5 जैसे मार्केटिंग नाम अस्वीकार हो जाते हैं।',
  'settings.ai.claudeCode.modalDescription':
    'चैट, एजेंटिक और रीज़निंग कार्यभार को आपके स्थानीय रूप से इंस्टॉल किए गए Claude Code CLI के माध्यम से रूट करता है। कोई API कुंजी नहीं: यह CLI के अपने लॉगिन का उपयोग करता है।',
  'settings.ai.claudeCode.close': 'बंद करें',
  'settings.ai.claudeCode.connection': 'कनेक्शन',
  'settings.ai.claudeCode.enabled': 'सक्षम',
  'settings.ai.claudeCode.notEnabled': 'सक्षम नहीं',
  'settings.ai.claudeCode.disconnect': 'डिस्कनेक्ट करें',
  'settings.ai.claudeCode.disconnecting': 'डिस्कनेक्ट किया जा रहा है…',
  'settings.ai.claudeCode.enable': 'Claude Code सक्षम करें',
  'settings.ai.claudeCode.enabling': 'सक्षम किया जा रहा है…',
  'settings.ai.claudeCode.authentication': 'प्रमाणीकरण',
  'settings.ai.claudeCode.recheck': 'फिर से जाँचें',
  'settings.ai.claudeCode.checking': 'जाँचा जा रहा है…',
  'settings.ai.claudeCode.openingTerminal': 'टर्मिनल खोला जा रहा है…',
  'settings.ai.claudeCode.signIn': 'Claude से साइन इन करें',
  'settings.ai.claudeCode.reconnect': 'फिर से कनेक्ट करें',
  'settings.ai.claudeCode.loginHint':
    'claude login चलाने वाला एक टर्मिनल खोलता है। पूरा होने के बाद, फिर से जाँचें पर क्लिक करें।',
  'settings.ai.claudeCode.loginError': 'लॉगिन टर्मिनल नहीं खोला जा सका। कृपया पुनः प्रयास करें।',
  'settings.ai.claudeCode.fullAccess': 'पूर्ण पहुँच',
  'settings.ai.claudeCode.fullAccessOn':
    'Claude Code कमांड चला सकता है, नेटवर्क का उपयोग कर सकता है और सब-एजेंट बना सकता है।',
  'settings.ai.claudeCode.fullAccessOff':
    'केवल संपादन स्वीकारें: फ़ाइल संपादन स्वतः लागू करता है, कमांड और नेटवर्क को सीमित करता है।',
  'settings.ai.claudeCode.sandboxNoteMac':
    'macOS पर, दोनों मोड में ~/.openhuman सैंडबॉक्स द्वारा सुरक्षित रहता है।',
  'settings.ai.claudeCode.sandboxNoteOther':
    'इस प्लेटफ़ॉर्म पर पूर्ण पहुँच असीमित है: केवल तभी सक्षम करें जब आप वर्कस्पेस पर भरोसा करते हों।',
  'settings.ai.claudeCode.enableToCheck': 'साइन-इन जाँचने के लिए Claude Code सक्षम करें।',
  'settings.ai.claudeCode.usingApiKeyEnvDetail':
    'पर्यावरण से ANTHROPIC_API_KEY का उपयोग कर रहा है।',
  'settings.ai.claudeCode.notFoundInstall':
    'Claude Code CLI नहीं मिला: इससे इंस्टॉल करें: npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    'साइन-इन स्थिति निर्धारित नहीं हो सकी। आपका claude CLI auth status समर्थन से पुराना हो सकता है: फिर से कनेक्ट करें, फिर फिर से जाँचें।',
  'settings.ai.claudeCode.notSignedIn': 'साइन इन नहीं।',
  'settings.ai.routingCustom': 'कस्टम रूटिंग',
  'settings.ai.routingDefault': 'डिफ़ॉल्ट',
  'settings.ai.routingDesc': 'रूटिंग विवरण',
  'settings.ai.saveChanges': 'सेव हो रहा है…',
  'settings.ai.saving': 'सेव हो रहा है…',
  'settings.ai.unsavedChange': 'असहेजा परिवर्तन',
  'settings.ai.unsavedChanges': 'असहेजे परिवर्तन',
  'settings.ai.workloadGroupBackground': 'बैकग्राउंड वर्कलोड ग्रुप',
  'settings.ai.workloadGroupChat': 'चैट वर्कलोड ग्रुप',
  'settings.ai.disconnectProvider': 'डिस्कनेक्ट करें {label}',
  'settings.ai.connectProviderLabel': 'कनेक्ट करें {label}',
  'settings.ai.editProviderEndpoint': '{label} समापन बिंदु संपादित करें',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': 'समापन बिंदु संपादित करें',
  'settings.ai.endpointUrlLabel': 'समापन बिंदु URL',
  'settings.ai.localRuntimeHelper':
    'जहां {label} पहुंच योग्य है। डिफ़ॉल्ट स्थानीयहोस्ट है; इसे रिमोट होस्ट पर इंगित करें (उदाहरण के लिए, http://10.0.0.4:11434/v1) एक साझा उदाहरण का उपयोग करने के लिए)।',
  'settings.ai.endpointUrlRequired': 'समापन बिंदु URL आवश्यक है.',
  'settings.ai.endpointProtocolRequired': 'समापन बिंदु http:// या https://. से शुरू होना चाहिए',
  'settings.ai.connectProviderDialog': 'कनेक्ट करें {label}',
  'settings.ai.getProviderApiKey': 'API Key प्राप्त करें',
  'settings.ai.or': 'या',
  'settings.ai.codexOauthMissingAuthUrl':
    'Codex OAuth ने कोई प्राधिकरण URL नहीं लौटाया। फिर से साइन इन करने का प्रयास करें।',
  'settings.ai.codexOauthMissingCallbackUrl':
    'साइन इन करने के बाद अपने ब्राउज़र से रीडायरेक्ट URL पेस्ट करें।',
  'settings.ai.openRouterOauthDescription':
    'OpenRouter के साथ साइन इन करें और PKCE का उपयोग करके उपयोगकर्ता नियंत्रित API कुंजी आयात करें।',
  'settings.ai.connecting': 'कनेक्ट हो रहा है...',
  'settings.ai.codexAuthButton': 'Codex कनेक्ट करें',
  'settings.ai.codexAuthHelper': '~/.codex/auth.json से मौजूदा Codex CLI लॉगिन का उपयोग करता है।',
  'settings.ai.backgroundLoops': 'पृष्ठभूमि लूप',
  'settings.ai.backgroundLoopsDesc':
    'क्या एक चैट संदेश के बिना चलाता है, दिल की धड़कन काम को रोकें, और हाल ही में क्रेडिट लेजर पंक्तियों का निरीक्षण करें।',
  'settings.ai.heartbeatControls': 'दिल की धड़कन नियंत्रित होती है',
  'settings.ai.heartbeatControlsDesc':
    'डिफ़ॉल्ट। सक्षम करने से लूप शुरू होता है; निष्क्रिय करने से चलने का कार्य समाप्त हो जाता है।',
  'settings.ai.heartbeatLoop': 'दिल की धड़कन का लूप',
  'settings.ai.heartbeatLoopDesc': 'प्लानर + वैकल्पिक अवचेतन उपस्थिति के लिए मास्टर शेड्यूलर।',
  'settings.ai.subconsciousInference': 'अवचेतन अनुमान',
  'settings.ai.subconsciousInferenceDesc':
    'हार्टबीट टिक पर मॉडल समर्थित task/reflection मूल्यांकन चलाता है।',
  'settings.ai.calendarMeetingChecks': 'कैलेंडर मीटिंग की जाँच',
  'settings.ai.calendarMeetingChecksDesc':
    'सक्रिय Google कैलेंडर कनेक्शन के लिए कैलेंडर इवेंट सूची बुलाता है।',
  'settings.ai.calendarCap': 'कैलेंडर कैप',
  'settings.ai.connectionsPerTick': '{count} कॉन/टिक',
  'settings.ai.meetingLookahead': 'बैठक आगे की ओर देख रही है',
  'settings.ai.minutesShort': '{count} मि',
  'settings.ai.reminderLookahead': 'आगे देखने का अनुस्मारक',
  'settings.ai.cronReminderChecks': 'क्रॉन अनुस्मारक जाँच करता है',
  'settings.ai.cronReminderChecksDesc':
    'स्कैन ने रिमाइंडर जैसी आगामी वस्तुओं के लिए क्रोन नौकरियों को सक्षम किया।',
  'settings.ai.relevantNotificationChecks': 'प्रासंगिक अधिसूचना जाँच',
  'settings.ai.relevantNotificationChecksDesc':
    'तत्काल स्थानीय सूचनाएं सक्रिय अलर्ट में बढ़ावा देता है।',
  'settings.ai.externalDelivery': 'बाह्य वितरण',
  'settings.ai.externalDeliveryDesc':
    'दिल की धड़कन अलर्ट बाहरी चैनलों को सक्रिय संदेश भेज देता है।',
  'settings.ai.interval': 'अंतराल',
  'settings.ai.running': 'चल रहा है...',
  'settings.ai.plannerTickNow': 'प्लानर अभी टिक करें',
  'settings.ai.loadingHeartbeatControls': 'दिल की धड़कन नियंत्रण लोड हो रहा है...',
  'settings.ai.heartbeatControlsUnavailable': 'दिल की धड़कन नियंत्रण अनुपलब्ध है.',
  'settings.ai.loopMap': 'लूप मानचित्र',
  'settings.ai.plannerSummary':
    'योजनाकार: {sourceEvents} स्रोत घटनाएँ, {sent} भेजा गया, {deduped} काटा गया।',
  'settings.ai.routeLabel': 'मार्ग: {route}',
  'settings.ai.on': 'पर',
  'settings.ai.off': 'बंद',
  'settings.ai.recentUsageLedger': 'हालिया उपयोग खाता बही',
  'settings.ai.recentUsageLedgerDesc':
    'बैकएंड पंक्तियां आज action/time को उजागर करती हैं; स्रोत टैग को बैकेंड समर्थन की आवश्यकता होती है।',
  'settings.ai.latestSpend': 'नवीनतम खर्च: {amount} पर {time} ({action})',
  'settings.ai.topActions': 'शीर्ष क्रियाएं',
  'settings.ai.noSpendRows': 'कोई व्यय पंक्तियाँ लोड नहीं की गईं.',
  'settings.ai.topHours': 'शीर्ष घंटे',
  'settings.ai.noHourlySpend': 'अभी तक कोई प्रति घंटा खर्च नहीं.',
  'settings.ai.openhumanDefault': 'OpenHuman (डिफ़ॉल्ट)',
  'settings.ai.localModelResolved': 'Ollama',
  'settings.ai.customRoutingForWorkload': '{label} के लिए कस्टम रूटिंग',
  'settings.ai.loadingModels': 'मॉडल लोड हो रहे हैं...',
  'settings.ai.enterModelIdManually': 'या मैन्युअल रूप से मॉडल आईडी दर्ज करें:',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} मॉडल आईडी',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': 'एक मॉडल चुनें...',
  'settings.ai.deploymentNameLabel': 'परिनियोजन नाम',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp':
    'Azure AI Foundry में आपके द्वारा सेट किया गया परिनियोजन नाम दर्ज करें। यह मॉडल आईडी नहीं है।',
  'settings.ai.deploymentNameLegacyHint':
    'यह मान प्रदाता सूची की आधार मॉडल आईडी से मेल खाता है। Azure अनुरोधों को परिनियोजन नाम से भेजता है, इसलिए पुष्टि करें कि यह आपके परिनियोजन का नाम है।',
  'settings.ai.deploymentNameProviderHint':
    'Azure एंडपॉइंट मिला। यह प्रदाता चुनने के बाद मॉडल फ़ील्ड में अपना परिनियोजन नाम दर्ज करें।',
  'settings.ai.chooseModelFromList': 'सूची से चुनें',
  'settings.ai.enterModelIdManuallyAction': 'मॉडल आईडी मैन्युअल रूप से दर्ज करें',
  'settings.ai.enterDeploymentNameManuallyAction': 'डिप्लॉयमेंट नाम मैन्युअल रूप से दर्ज करें',
  'settings.ai.probeFailedHint':
    'हम इस प्रदाता की मॉडल सूची नहीं पढ़ सके। वह सूची केवल ड्रॉपडाउन भरती है, इसलिए आप प्रदाता को फिर भी जोड़ सकते हैं और मॉडल या डिप्लॉयमेंट का नाम खुद लिख सकते हैं।',
  'settings.ai.probeFailedAddAnyway': 'सत्यापन के बिना जोड़ें',
  'settings.ai.azureV1EndpointHint':
    'Azure के लिए v1 बेस URL का उपयोग करें: https://YOUR-RESOURCE.openai.azure.com/openai/v1. पुराना रिसोर्स URL मॉडल सूची नहीं देता और अलग प्रमाणीकरण हेडर की अपेक्षा करता है।',
  'settings.ai.temperatureOverride': 'तापमान ओवरराइड',
  'settings.ai.temperatureOverrideSlider': 'तापमान ओवरराइड (स्लाइडर)',
  'settings.ai.temperatureOverrideValue': 'तापमान ओवरराइड (मान)',
  'settings.ai.temperatureOverrideDesc':
    'लोअर = अधिक नियतिवादी। प्रदाता डिफ़ॉल्ट का उपयोग करने के लिए अनचेक छोड़ दें।',
  'settings.ai.modelVision': 'विज़न समर्थित है (छवि इनपुट)',
  'settings.ai.modelVisionDesc':
    'यदि यह मॉडल छवियाँ स्वीकार करता है तो सक्षम करें। यह मॉडल चुने जाने पर चैट में छवियाँ संलग्न करने देता है।',
  'settings.ai.testFailed': 'परीक्षण विफल रहा',
  'settings.ai.providerTest.authRejected':
    "कुंजी सहेज दी गई, लेकिन '{slug}' ने इसे अस्वीकार कर दिया। जाँचें कि आपने पूरी कुंजी चिपकाई है और वह प्रदाता के डैशबोर्ड में अब भी सक्रिय है।",
  'settings.ai.providerTest.modelNotRecognized':
    "कुंजी सहेजी और स्वीकार की गई, लेकिन '{slug}' चयनित मॉडल को नहीं पहचानता। ऐसा मॉडल आईडी चुनें जो यह प्रदाता वास्तव में देता है (इसका डिफ़ॉल्ट मॉडल प्रदाता प्रविष्टि में सेट होता है)।",
  'settings.ai.providerTest.quotaOrBilling':
    "कुंजी सहेजी और स्वीकार की गई, लेकिन '{slug}' ने कोटा या बिलिंग कारणों से अनुरोध ठुकरा दिया। प्रदाता के पास अपना खाता शेष और उपयोग सीमाएँ देखें।",
  'settings.ai.providerTest.endpointNotFound':
    "कुंजी सहेज दी गई, लेकिन '{slug}' के लिए कॉन्फ़िगर किए गए एंडपॉइंट ने 404 लौटाया। बेस URL जाँचें: OpenAI-संगत प्रदाता को आम तौर पर '/v1' प्रत्यय चाहिए (जैसे https://api.openai.com/v1)।",
  'settings.ai.providerTest.timeout':
    "कुंजी सहेज दी गई, लेकिन '{slug}' ने समय पर उत्तर नहीं दिया। एंडपॉइंट URL और अपना नेटवर्क जाँचें, फिर दोबारा परीक्षण करें।",
  'settings.ai.providerTest.emptyReply':
    "कुंजी सहेज दी गई, लेकिन '{slug}' ने परीक्षण संकेत पर खाली उत्तर लौटाया। इस प्रदाता के लिए कॉन्फ़िगर किया गया मॉडल आईडी जाँचें।",
  'settings.ai.providerTest.unknown':
    "कुंजी सहेज दी गई, लेकिन '{slug}' पर परीक्षण कॉल विफल रही। प्रदाता का स्थिति पृष्ठ और एंडपॉइंट URL जाँचें, फिर दोबारा परीक्षण करें।",
  'settings.ai.testingModel': 'परीक्षण मॉडल...',
  'settings.ai.modelResponse': 'मॉडल प्रतिक्रिया',
  'settings.ai.providerWithValue': 'प्रदाता: {value}',
  'settings.ai.noneDash': 'कोई नहीं',
  'settings.ai.promptHelloWorld': 'संकेत: नमस्ते विश्व',
  'settings.ai.startedAt': 'प्रारंभ: {value}',
  'settings.ai.waitingForModelResponse': 'चयनित मॉडल से प्रतिक्रिया की प्रतीक्षा है...',
  'settings.ai.response': 'प्रतिक्रिया',
  'settings.ai.testing': 'परीक्षण...',
  'settings.ai.test': 'परीक्षण',
  'settings.ai.slugMissingError': 'स्लग उत्पन्न करने के लिए प्रदाता का नाम दर्ज करें।',
  'settings.ai.slugInUseError': 'वह प्रदाता नाम पहले से ही उपयोग में है.',
  'settings.ai.slugReservedError': 'कोई भिन्न प्रदाता नाम चुनें.',
  'settings.ai.providerNamePlaceholder': 'मेरा प्रदाता',
  'settings.ai.slugLabel': 'स्लग:',
  'settings.ai.openAiUrlLabel': 'xxxxxxxxxxxx',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': 'मौजूदा कुंजी रखने के लिए खाली छोड़ दें',
  'settings.ai.reindexingMemory': 'स्मृति को पुनः अनुक्रमित करना',
  'settings.ai.reindexingMemoryMessage':
    'एम्बेडिंग को फिर से संसाधित किया जा रहा है। {pending} मेमोरी आइटम (s) को वर्तमान मॉडल के तहत फिर से एम्बेड किया जा रहा है - इस खत्म होने तक शब्दकोष वापस कम हो जाता है। कीवर्ड खोज काम करता रहता है, और यदि आप इसे बंद करते हैं तो पृष्ठभूमि में फिर से एम्बेड करना जारी रहता है।',
  'settings.ai.signInWithOpenRouter': 'OpenRouter से साइन इन करें',
  'settings.ai.weekBudget': 'सप्ताह का बजट',
  'settings.ai.cycleRemaining': 'चक्र शेष है',
  'settings.ai.cycleTotalSpend': 'चक्र कुल खर्च',
  'settings.ai.avgSpendRow': 'औसत व्यय पंक्ति',
  'settings.ai.backgroundApiReads': 'बीजी API पढ़ता है',
  'settings.ai.backgroundWakeups': 'बीजी वेकअप',
  'settings.ai.budgetMath': 'बजट गणित',
  'settings.ai.rowsLeft': 'पंक्तियाँ शेष हैं',
  'settings.ai.rowsPerFullWeekBudget': 'पूरे सप्ताह के बजट के अनुसार पंक्तियाँ',
  'settings.ai.sampleBurnRate': 'नमूना जलने की दर',
  'settings.ai.projectedEmpty': 'खाली प्रक्षेपित किया गया',
  'settings.ai.apiReadsPerDollarRemaining': 'API प्रति $ शेष पढ़ता है',
  'settings.ai.loopCallBudget': 'लूप कॉल बजट',
  'settings.ai.heartbeatTicks': 'दिल की धड़कन टिक-टिक करती है',
  'settings.ai.calendarPlannerCalls': 'कैलेंडर योजनाकार कॉल करता है',
  'settings.ai.calendarFanoutCap': 'कैलेंडर फैनआउट कैप',
  'settings.ai.subconsciousModelCalls': 'अवचेतन मॉडल कॉल',
  'settings.ai.composioSyncScans': 'Composio सिंक स्कैन',
  'settings.ai.totalBackgroundApiReadBudget': 'कुल बीजी API बजट पढ़ें',
  'settings.ai.memoryWorkerPolls': 'स्मृति कार्यकर्ता सर्वेक्षण',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': 'प्रबंधित',
  'settings.ai.routing.managedAlwaysOn': 'हमेशा बने रहें',
  'settings.ai.routing.managedHint':
    'प्रबंधित हमेशा फ़ॉलबैक के रूप में उपलब्ध होता है। अपने स्वयं के मॉडल का उपयोग करने के लिए, नीचे एक रूटिंग मोड चुनें।',
  'settings.ai.routing.managedDesc':
    'OpenHuman बादल में सभी अनुमान चला जाएगा, कार्य के लिए सबसे अच्छा मॉडल चुनें, लागत के लिए अनुकूलन करें और सबसे सुरक्षित रूटिंग डिफ़ॉल्ट रखें।',
  'settings.ai.routing.managedMsg':
    'OpenHuman प्रत्येक कार्यभार के लिए सभी अनुमानों को संभालेंगे और स्वचालित रूप से लागत, गुणवत्ता और सुरक्षा के लिए सबसे अच्छा मार्ग चुनें।',
  'settings.ai.routing.useYourOwn': 'अपने खुद के मॉडल का प्रयोग करें',
  'settings.ai.routing.useYourOwnDesc':
    'एक प्रदाता + मॉडल चुनें और उसके माध्यम से हर कार्यभार को रूट करें। यह सरल है, लेकिन यह अक्षम हो सकता है क्योंकि हल्के और भारी वजन अनुमान सभी समान मार्ग साझा करते हैं।',
  'settings.ai.routing.advanced': 'उन्नत',
  'settings.ai.routing.advancedDesc':
    'विभिन्न कार्यों के लिए विभिन्न मॉडल चुनें। यह तंग लागत अनुकूलन और सबसे अधिक नियंत्रण के लिए सबसे अच्छा विकल्प है।',
  'settings.ai.routing.customDesc':
    'फाइन-ग्रेन रूटिंग आपको सर्वोत्तम लागत अनुकूलन और सबसे अधिक नियंत्रण देता है। यह तय करने के लिए नीचे की पंक्तियों का उपयोग करें कि कौन से वर्कलोड प्रबंधित रहते हैं, जो आपके साझा डिफ़ॉल्ट का उपयोग करते हैं, और जो एक विशिष्ट मॉडल के लिए पिन करते हैं।',
  'settings.ai.routing.chatAndConversations': 'चैट और बातचीत',
  'settings.ai.routing.chatDesc':
    'मॉडल प्रत्यक्ष उपयोगकर्ता बातचीत, उत्तर, तर्क, एजेंट छोरों और कोडिंग मदद के दौरान इस्तेमाल किया।',
  'settings.ai.routing.backgroundTasks': 'पृष्ठभूमि कार्य',
  'settings.ai.routing.bgTasksDesc':
    'मॉडल संक्षेपण, दिल की धड़कन, सीखने और अवचेतन मूल्यांकन के लिए मुख्य बातचीत प्रवाह के बाहर इस्तेमाल किया।',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description': 'आगे-पीछे सीधी बातचीत: बातचीत में "त्वरित" मोड',
  'settings.ai.routing.workload.chat.hint':
    'अनुशंसित: उच्च टोकन/सेकंड और कम विलंबता वाला एक सस्ता या मध्यम लागत वाला तेज़ चैट मॉडल। यदि ओपन-सोर्स स्थानीय मॉडल प्रतिक्रियाशील महसूस करते हैं तो वे यहां अच्छा काम कर सकते हैं।',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    'मुख्य चैट एजेंट, बैठक सारांश: बातचीत में "तर्क" मोड',
  'settings.ai.routing.workload.reasoning.hint':
    'अनुशंसित: गहरी सोच के लिए अधिक महंगा फ्रंटियर या मजबूत तर्क मॉडल। इसका उपयोग मुख्य चैट एजेंट, मीटिंग सारांश और भारी उत्तर संश्लेषण के लिए किया जाता है।',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description': 'सब-एजेंट रनर, टूल लूप, जीआईएफ निर्णय',
  'settings.ai.routing.workload.agentic.hint':
    'अनुशंसित: मजबूत उपकरण उपयोग के साथ एक विश्वसनीय निर्देश-अनुपालन मॉडल। मध्य-लागत सीमांत मॉडल आमतौर पर सबसे सुरक्षित होते हैं; यदि टूल कॉलिंग स्थिर है तो सक्षम ओपन-सोर्स मॉडल काम कर सकते हैं।',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description': 'कोड जनरेशन और रिफैक्टर पास होता है',
  'settings.ai.routing.workload.coding.hint':
    'अनुशंसित: मजबूत अनुदेशन, संपादन गुणवत्ता और लंबे-संदर्भ प्रदर्शन के साथ एक कोडिंग-ट्यून मॉडल। इस पर आमतौर पर अधिक खर्च करना उचित होता है।',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description':
    'विज़न सब-एजेंट के लिए छवि समझ: हमेशा मल्टीमॉडल',
  'settings.ai.routing.workload.vision.hint':
    'अनुशंसित: एक मल्टीमॉडल मॉडल जो छवि इनपुट स्वीकार करता है। प्रबंधित डिफ़ॉल्ट (विज़न-v1) छवि-सक्षम है; आप यहां जिस भी प्रदाता को रूट करते हैं उसे हमेशा दृष्टि-सक्षम माना जाता है।',
  'settings.ai.routing.workload.memory.label': 'स्मृति सारांश',
  'settings.ai.routing.workload.memory.description': 'वृक्ष-अर्क और समेकन',
  'settings.ai.routing.workload.memory.hint':
    'अनुशंसित: एक सस्ता सारांशीकरण मॉडल। यह सुसंगत और संक्षिप्त होना चाहिए, लेकिन इसके लिए प्रीमियम सीमांत-स्तरीय तर्क की आवश्यकता नहीं है।',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description': 'उपयोगकर्ता घुमावों के बीच पृष्ठभूमि तर्क',
  'settings.ai.routing.workload.heartbeat.hint':
    'अनुशंसित: एक सस्ता, कुशल पृष्ठभूमि मॉडल। यह अक्सर मोड़ों के बीच चलता है, इसलिए कम लागत अधिकतम बुद्धिमत्ता से अधिक मायने रखती है।',
  'settings.ai.routing.workload.learning.label': 'सीखना · चिंतन',
  'settings.ai.routing.workload.learning.description': 'हाल के इतिहास पर समय-समय पर चिंतन',
  'settings.ai.routing.workload.learning.hint':
    'अनुशंसित: एक मजबूत चिंतनशील मॉडल। यह मध्य-लागत या प्रीमियम हो सकता है क्योंकि यह हाल के इतिहास में बेहतर संश्लेषण से लाभान्वित होता है।',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description': 'घटनापूर्णता स्कोरिंग + बहाव जाँच',
  'settings.ai.routing.workload.subconscious.hint':
    'अनुशंसित: एक बहुत सस्ता निगरानी मॉडल, आदर्श रूप से हल्का और पूर्वानुमानित। यह घटनापूर्णता स्कोरिंग, बहाव जांच और शांत पृष्ठभूमि मूल्यांकन के लिए है।',
  'settings.ai.routing.addCustomProvider': 'कस्टम प्रदाता जोड़ें',
  'settings.ai.globalModel.title': 'हर चीज़ के लिए एक मॉडल चुनें',
  'settings.ai.globalModel.desc':
    'यह एक मॉडल के माध्यम से सभी inference मार्गों। यह सरल है, लेकिन यह लागत और गुणवत्ता के लिए अक्षम हो सकता है क्योंकि हल्के और भारी कार्य सभी एक ही मार्ग का उपयोग करेंगे।',
  'settings.ai.globalModel.noProviders':
    'पहले प्रदाता को जोड़ें या कनेक्ट करें। फिर आप यहां एक मॉडल के माध्यम से हर कार्यभार को रूट कर सकते हैं।',
  'settings.ai.globalModel.provider': 'प्रदाता',
  'settings.ai.globalModel.model': 'मॉडल',
  'settings.ai.globalModel.loadingModels': 'मॉडल लोड हो रहे हैं…',
  'settings.ai.globalModel.enterModelId': 'मॉडल आईडी दर्ज करें',
  'settings.ai.globalModel.appliesToAll':
    'उसी प्रदाता + मॉडल को चैट, तर्क, कोडिंग, मेमोरी, हार्टबीट, लर्निंग और अवचेतन को लागू करता है। एम्बेडिंग को अलग से कॉन्फ़िगर किया गया है। जब आप सेव पर क्लिक करते हैं तो चेंज सेव करते हैं।',
  'settings.ai.globalModel.saving': 'सहेजा जा रहा है...',
  'settings.ai.globalModel.saved': 'सहेजा गया',
  'settings.ai.workload.noModel': 'कोई मॉडल चयनित नहीं',
  'settings.ai.workload.changeModel': 'मॉडल बदलें',
  'settings.ai.workload.chooseModel': 'मॉडल चुनें',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': 'यह राशि जोड़ें',
  'settings.billing.autoRecharge.addCard': 'कार्ड जोड़ें',
  'settings.billing.autoRecharge.amountHint': 'राशि संकेत',
  'settings.billing.autoRecharge.defaultCard': 'डिफ़ॉल्ट कार्ड',
  'settings.billing.autoRecharge.lastRechargeFailed': 'आखिरी रिचार्ज विफल',
  'settings.billing.autoRecharge.lastRecharged': 'आखिरी रिचार्ज',
  'settings.billing.autoRecharge.expires': 'समाप्त {date}',
  'settings.billing.autoRecharge.noCards': 'कोई कार्ड नहीं',
  'settings.billing.autoRecharge.paymentMethods': 'पेमेंट तरीके',
  'settings.billing.autoRecharge.rechargeInProgress': 'रिचार्ज हो रहा है',
  'settings.billing.autoRecharge.spentThisWeek':
    'इस सप्ताह ${limit} में से ${spent} का उपयोग किया गया',
  'settings.billing.autoRecharge.rechargeWhen': 'बैलेंस इससे कम होने पर रिचार्ज करें',
  'settings.billing.autoRecharge.saveSettings': 'सेव हो रहा है…',
  'settings.billing.autoRecharge.saving': 'सेव हो रहा है…',
  'settings.billing.autoRecharge.setDefault': ':',
  'settings.billing.autoRecharge.subtitle': 'उपशीर्षक',
  'settings.billing.autoRecharge.title': 'ऑटो-रिचार्ज चालू करें',
  'settings.billing.autoRecharge.toggleAriaLabel': 'ऑटो-रिचार्ज टॉगल करें',
  'settings.billing.autoRecharge.weeklyLimit': 'साप्ताहिक खर्च सीमा',
  'settings.billing.history.desc': 'विवरण',
  'settings.billing.history.empty': 'खाली है',
  'settings.billing.history.openPortal': 'पोर्टल खोलें',
  'settings.billing.history.posted': 'पोस्ट हुआ',
  'settings.billing.history.title': 'शीर्षक',
  'settings.billing.inferenceBudget.cycleEnds': 'साइकल खत्म होती है',
  'settings.billing.inferenceBudget.exhausted': 'खत्म हो गया',
  'settings.billing.inferenceBudget.loadError': 'लोड एरर',
  'settings.billing.inferenceBudget.noBudgetDesc': 'कोई बजट विवरण नहीं',
  'settings.billing.inferenceBudget.noRecurringBudget': 'कोई रेकरिंग बजट नहीं',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': 'कोई आवर्ती योजना बजट नहीं',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    'आपकी वर्तमान योजना में एक आवर्ती साप्ताहिक अनुमान बजट शामिल नहीं है। उपयोग के बजाय उपलब्ध क्रेडिट से भुगतान किया जाता है।',
  'settings.billing.inferenceBudget.remaining': 'बचा हुआ',
  'settings.billing.inferenceBudget.remainingSummary': '{remaining} / {budget} शेष',
  'settings.billing.inferenceBudget.spentThisCycle': 'इस चक्र में {amount} खर्च हुआ',
  'settings.billing.inferenceBudget.cycleEndsOn': 'चक्र समाप्त होता है {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    'शामिल सदस्यता उपयोग समाप्त हो गया है। अगले चक्र के लिए इंतजार किए बिना एआई का उपयोग करने के लिए शीर्ष क्रेडिट।',
  'settings.billing.inferenceBudget.discountVsPayg':
    '{pct}% वेतन के रूप में आप जाओ की तुलना में प्रति कॉल सस्ता है।',
  'settings.billing.inferenceBudget.cycleSpend': 'साइकिल खर्च',
  'settings.billing.inferenceBudget.totalAmount': '{amount} कुल',
  'settings.billing.inferenceBudget.inference': 'अनुमान',
  'settings.billing.inferenceBudget.integrations': 'एकीकरण',
  'settings.billing.inferenceBudget.calls': '{count} कॉल',
  'settings.billing.inferenceBudget.dailySpend': 'दैनिक खर्च',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}: {amount}',
  'settings.billing.inferenceBudget.topModels': 'शीर्ष मॉडल',
  'settings.billing.inferenceBudget.noInferenceUsage': 'इस चक्र का कोई अनुमान उपयोग नहीं।',
  'settings.billing.inferenceBudget.topIntegrations': 'शीर्ष एकीकरण',
  'settings.billing.inferenceBudget.noIntegrationUsage': 'इस चक्र में कोई एकीकरण उपयोग नहीं।',
  'settings.billing.inferenceBudget.tenHourCap': 'दस घंटे की सीमा',
  'settings.billing.inferenceBudget.title': 'शीर्षक',
  'settings.billing.inferenceBudget.unableToLoad': 'उपयोग डेटा लोड करने में असमर्थ',
  'settings.billing.inferenceBudget.notAvailable': 'एन/ए',
  'settings.billing.payAsYouGo.available': 'उपलब्ध',
  'settings.billing.payAsYouGo.chargeCustomAmount': 'खुल रहा है…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': 'टॉप अप चुनें विवरण',
  'settings.billing.payAsYouGo.chooseTopUpTitle': 'टॉप अप चुनें शीर्षक',
  'settings.billing.payAsYouGo.creditBalanceDesc': 'क्रेडिट बैलेंस विवरण',
  'settings.billing.payAsYouGo.creditBalanceTitle': 'क्रेडिट बैलेंस शीर्षक',
  'settings.billing.payAsYouGo.customAmount': 'कस्टम राशि',
  'settings.billing.payAsYouGo.enterAmount': 'राशि डालें',
  'settings.billing.payAsYouGo.opening': 'खोला जा रहा है',
  'settings.billing.payAsYouGo.promotionalCredits': 'प्रमोशनल क्रेडिट',
  'settings.billing.payAsYouGo.topUpBalance': 'बैलेंस टॉप-अप',
  'settings.billing.payAsYouGo.topUpCredits': 'क्रेडिट टॉप अप करें',
  'settings.billing.payAsYouGo.unableToLoad': 'बैलेंस लोड नहीं हो पाया।',
  'settings.billing.subscription.annual': 'वार्षिक',
  'settings.billing.subscription.billedAnnually': 'सालाना बिल होता है',
  'settings.billing.subscription.chooseSubtitle': 'उपशीर्षक चुनें',
  'settings.billing.subscription.chooseTitle': 'शीर्षक चुनें',
  'settings.billing.subscription.cryptoDesc': 'क्रिप्टो विवरण',
  'settings.billing.subscription.cryptoQuestion': 'क्रिप्टो प्रश्न',
  'settings.billing.subscription.current': 'मौजूदा',
  'settings.billing.subscription.currentPlan': 'मौजूदा प्लान',
  'settings.billing.subscription.monthly': 'मासिक',
  'settings.billing.subscription.paymentConfirmed': 'पेमेंट कन्फर्म हुई',
  'settings.billing.subscription.perMonth': 'प्रति माह',
  'settings.billing.subscription.popular': 'लोकप्रिय',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': 'अपग्रेड करें',
  'settings.billing.subscription.waiting': 'इंतज़ार हो रहा है',
  'settings.billing.subscription.waitingPayment': 'पेमेंट का इंतज़ार',
  'settings.composio.apiKeyDesc': 'इस डिवाइस पर वर्तमान में एक Composio API कुंजी संग्रहीत है।',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'Composio API कुंजी',
  'settings.composio.apiKeyStored': 'API कुंजी संग्रहीत',
  'settings.composio.apiKeyStoredPlaceholder':
    '••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••',
  'settings.composio.clearedToBackend': 'Backend मोड पर स्विच हुआ',
  'settings.composio.confirmItem1': 'app.composio.dev पर API कुंजी के साथ एक खाता',
  'settings.composio.confirmItem2':
    'अपने व्यक्तिगत Composio खाते के माध्यम से प्रत्येक एकीकरण को फिर से लिंक करना',
  'settings.composio.confirmItem3':
    'नोट: Composio ट्रिगर्स (रीयल-टाइम वेबहुक्स) डायरेक्ट मोड में अभी फायर नहीं होते: केवल सिंक्रोनस टूल कॉल्स',
  'settings.composio.confirmNeedItems': 'आपको चाहिए:',
  'settings.composio.confirmSwitch': 'मैं समझ गया, डायरेक्ट पर स्विच करें',
  'settings.composio.confirmTitle': '⚠️ डायरेक्ट मोड पर स्विच कर रहे हैं',
  'settings.composio.confirmWarning':
    'आपके मौजूदा एकीकरण (Gmail, Slack, GitHub, आदि OpenHuman के माध्यम से लिंक किए गए) दिखाई नहीं देंगे: वे OpenHuman-प्रबंधित Composio टेनेंट में रहते हैं।',
  'settings.composio.intro':
    'Composio 250+ बाहरी ऐप्स को टूल्स के रूप में एकीकृत करता है जिन्हें आपका एजेंट कॉल कर सकता है। चुनें कि वे टूल कॉल कैसे रूट किए जाएँ।',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': 'डायरेक्ट (अपनी API key लाएं)',
  'settings.composio.modeDirectDesc':
    'कॉल सीधे backend.composio.dev पर जाती हैं। संप्रभु / ऑफ़लाइन-अनुकूल। टूल निष्पादन सिंक्रोनस रूप से कार्य करता है; रीयल-टाइम ट्रिगर वेबहुक्स अभी डायरेक्ट मोड में रूट नहीं हैं (फॉलो-अप मुद्दा)।',
  'settings.composio.modeManaged': 'मैनेज्ड (OpenHuman मैनेज करेगा)',
  'settings.composio.modeManagedDesc':
    'OpenHuman हमारे बैकएंड के माध्यम से टूल कॉल्स को प्रॉक्सी करता है (अनुशंसित)। प्रमाणीकरण ब्रोकर किया जाता है; आप कभी भी Composio API कुंजी पेस्ट नहीं करते। वेबहुक्स पूरी तरह से रूट किए जाते हैं।',
  'settings.composio.routingMode': 'रूटिंग मोड',
  'settings.composio.saveErrorNoKey':
    'सहेजने में विफल। डायरेक्ट मोड के लिए गैर-रिक्त API कुंजी आवश्यक है।',
  'settings.composio.saving': 'सेव हो रहा है…',
  'settings.composio.switching': 'स्विच हो रहा है…',
  'settings.cron.jobs.commandRequired': 'शेल जॉब के लिए कमांड आवश्यक है',
  'settings.cron.jobs.createJob': 'नई शेड्यूल्ड जॉब',
  'settings.cron.jobs.created': 'जॉब बनाई गई',
  'settings.cron.jobs.custom': 'कस्टम',
  'settings.cron.jobs.desc': 'विवरण',
  'settings.cron.jobs.edit': 'संपादित करें',
  'settings.cron.jobs.editJob': 'शेड्यूल्ड जॉब संपादित करें',
  'settings.cron.jobs.empty': 'कोई कोर cron job नहीं मिला।',
  'settings.cron.jobs.errorCreate': 'cron जॉब बनाने में विफल: {message}',
  'settings.cron.jobs.errorLoadList': 'कोर cron जॉब लोड करने में विफल: {message}',
  'settings.cron.jobs.errorLoadRuns': 'रन इतिहास लोड करने में विफल: {message}',
  'settings.cron.jobs.errorRemove': 'कोर cron जॉब हटाने में विफल: {message}',
  'settings.cron.jobs.errorRun': 'कोर cron जॉब चलाने में विफल: {message}',
  'settings.cron.jobs.errorToggle': 'कोर cron जॉब अपडेट करने में विफल: {message}',
  'settings.cron.jobs.errorUpdate': 'cron जॉब अपडेट करने में विफल: {message}',
  'settings.cron.jobs.formAtLabel': 'इस समय चलाएँ',
  'settings.cron.jobs.formCancel': 'रद्द करें',
  'settings.cron.jobs.formCommand': 'शेल कमांड',
  'settings.cron.jobs.formCommandPlaceholder': 'उदा. curl https://example.com/health',
  'settings.cron.jobs.formCreate': 'बनाएँ',
  'settings.cron.jobs.formCronCustom': 'कस्टम एक्सप्रेशन',
  'settings.cron.jobs.formCronCustomPlaceholder': 'उदा. */30 * * * *',
  'settings.cron.jobs.formCronPreset': 'प्रीसेट',
  'settings.cron.jobs.formCronPreview': 'चलता है: {preview}',
  'settings.cron.jobs.formDeleteAfterRun': 'पहली बार चलने के बाद हटाएँ',
  'settings.cron.jobs.formDelivery': 'डिलीवरी मोड',
  'settings.cron.jobs.formDeliveryNone': 'कोई नहीं (केवल आउटपुट)',
  'settings.cron.jobs.formDeliveryProactive': 'प्रोएक्टिव (पुश सूचना)',
  'settings.cron.jobs.formError': 'जॉब सहेजने में विफल',
  'settings.cron.jobs.formEveryLabel': 'अंतराल (मिलीसेकंड)',
  'settings.cron.jobs.formEveryPlaceholder': 'उदा. 3600000',
  'settings.cron.jobs.formJobType': 'जॉब प्रकार',
  'settings.cron.jobs.formJobTypeAgent': 'Agent (AI प्रॉम्प्ट)',
  'settings.cron.jobs.formJobTypeShell': 'शेल कमांड',
  'settings.cron.jobs.formName': 'जॉब नाम',
  'settings.cron.jobs.formNamePlaceholder': 'उदा. daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'Agent प्रॉम्प्ट',
  'settings.cron.jobs.formPromptPlaceholder': 'हर बार चलने पर agent को क्या करना चाहिए?',
  'settings.cron.jobs.formPromptRequired': 'agent जॉब के लिए प्रॉम्प्ट आवश्यक है',
  'settings.cron.jobs.formSave': 'सहेजें',
  'settings.cron.jobs.formSaving': 'सहेजा जा रहा है…',
  'settings.cron.jobs.formScheduleAt': 'एक-बार (इस समय चलाएँ)',
  'settings.cron.jobs.formScheduleCron': 'आवर्ती (cron)',
  'settings.cron.jobs.formScheduleEvery': 'अंतराल (हर N मि.से.)',
  'settings.cron.jobs.formScheduleRequired': 'शेड्यूल आवश्यक है',
  'settings.cron.jobs.formScheduleType': 'शेड्यूल प्रकार',
  'settings.cron.jobs.formSessionIsolated': 'पृथक (अनुशंसित)',
  'settings.cron.jobs.formSessionMain': 'मुख्य सत्र',
  'settings.cron.jobs.formSessionTarget': 'सत्र लक्ष्य',
  'settings.cron.jobs.formProfile': 'एजेंट प्रोफ़ाइल',
  'settings.cron.jobs.formProfileNone': 'कोई प्रोफ़ाइल नहीं',
  'settings.cron.jobs.formProfileHint':
    'इस कार्य को चयनित प्रोफ़ाइल के रूप में चलाएँ, उसकी पहचान, स्मृति और कार्यस्थान का उपयोग करते हुए।',
  'settings.cron.jobs.profile': 'प्रोफ़ाइल',
  'settings.cron.jobs.lastStatus': 'आखिरी स्टेटस',
  'settings.cron.jobs.loading': 'Cron jobs लोड हो रही हैं...',
  'settings.cron.jobs.loadingRuns': 'रन लोड हो रहे हैं',
  'settings.cron.jobs.nextRun': 'अगला रन',
  'settings.cron.jobs.pause': 'रोकें',
  'settings.cron.jobs.paused': 'रोका गया',
  'settings.cron.jobs.recentRuns': 'हाल के रन',
  'settings.cron.jobs.removing': 'हटाया जा रहा है',
  'settings.cron.jobs.resume': 'फिर शुरू करें',
  'settings.cron.jobs.runningNow': 'अभी चल रहा है',
  'settings.cron.jobs.saving': 'सेव हो रहा है…',
  'settings.cron.jobs.schedule': 'शेड्यूल',
  'settings.cron.jobs.title': 'कोर Cron Jobs',
  'settings.cron.jobs.updated': 'जॉब अपडेट की गई',
  'settings.cron.jobs.viewRuns': 'रन देखें',
  'settings.cron.schedule.every2hours': 'हर 2 घंटे',
  'settings.cron.schedule.every30min': 'हर 30 मिनट',
  'settings.cron.schedule.every6hours': 'हर 6 घंटे',
  'settings.cron.schedule.everyHour': 'हर घंटे',
  'settings.cron.schedule.onceDaily': 'दिन में एक बार (सुबह 9 बजे)',
  'settings.localModel.deviceCapability.active': 'एक्टिव',
  'settings.localModel.deviceCapability.appliedTier': 'लागू टियर',
  'settings.localModel.deviceCapability.applying': 'लागू हो रहा है',
  'settings.localModel.deviceCapability.cores': '{count}',
  'settings.localModel.deviceCapability.couldNotLoadPresets': 'प्रीसेट लोड नहीं हो पाई',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': 'कस्टम मॉडल IDs',
  'settings.localModel.deviceCapability.detected': 'डिटेक्ट हुआ',
  'settings.localModel.deviceCapability.disabled': 'बंद है',
  'settings.localModel.deviceCapability.disabledDesc': 'अक्षम विवरण',
  'settings.localModel.deviceCapability.downloadingModels': '(मॉडल डाउनलोड हो रहे हैं)',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    'OllamaSetup इन्स्टॉलर (~2 GB) डाउनलोड और अनपैक हो रहा है। पहली इन्स्टॉल पर एक मिनट लग सकता है।',
  'settings.localModel.deviceCapability.failedToApplyPreset': 'प्रीसेट लागू नहीं हो पाई',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'Ollama इन्स्टॉल विफल',
  'settings.localModel.deviceCapability.installFailedDesc':
    'Ollama यूज़ेबल होने से पहले इन्स्टॉलर बंद हो गया। दोबारा कोशिश करें या ollama.com से मैन्युअली इन्स्टॉल करें।',
  'settings.localModel.deviceCapability.installFirst': 'पहले Ollama चलाएँ।',
  'settings.localModel.deviceCapability.installFirstDesc':
    'स्थानीय टियर बाहरी रूप से प्रबंधित Ollama एंडपॉइंट पर निर्भर हैं। इसे स्वयं प्रारंभ करें, अपने इच्छित मॉडल खींचें, और जब तक रनटाइम पहुँच योग्य न हो तब तक "Disabled (cloud fallback)" का उपयोग करते रहें।',
  'settings.localModel.deviceCapability.installOllamaFirst':
    'इस टियर का उपयोग करने के लिए पहले Ollama चलाएँ',
  'settings.localModel.deviceCapability.installingOllama': 'Ollama इन्स्टॉल हो रहा है',
  'settings.localModel.deviceCapability.loadingDeviceInfo': 'डिवाइस जानकारी लोड हो रही है',
  'settings.localModel.deviceCapability.localAiDisabled':
    'लोकल AI बंद है: क्लाउड फ़ॉलबैक इस्तेमाल हो रहा है।',
  'settings.localModel.deviceCapability.modelTier': 'मॉडल टियर',
  'settings.localModel.deviceCapability.needsOllama': 'Ollama ज़रूरी है',
  'settings.localModel.deviceCapability.notDetected': 'डिटेक्ट नहीं हुआ',
  'settings.localModel.deviceCapability.disabledLowercase': 'अक्षम',
  'settings.localModel.deviceCapability.presetDetails':
    'चैट: {chatModel} · दृष्टि: {visionModel} · लक्ष्य रैम: {targetRamGb} जीबी',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': 'सुझावित',
  'settings.localModel.deviceCapability.retryInstall': 'फिर से कोशिश हो रही है…',
  'settings.localModel.deviceCapability.retrying': 'फिर से कोशिश हो रही है…',
  'settings.localModel.deviceCapability.starting': 'शुरू हो रहा है…',
  'settings.localModel.download.audioPathPlaceholder': 'ऑडियो फाइल का Absolute path',
  'settings.localModel.download.capabilityChat': 'बातचीत',
  'settings.localModel.download.capabilityEmbedding': 'एंबेडिंग',
  'settings.localModel.download.capabilityAssets': 'कैपेबिलिटी असेट्स',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': 'दृष्टि',
  'settings.localModel.download.downloading': 'डाउनलोड हो रहा है...',
  'settings.localModel.download.embeddingDimensions': 'आयाम: {dimensions}',
  'settings.localModel.download.embeddingModel': 'मॉडल: {modelId}',
  'settings.localModel.download.embeddingPlaceholder': 'एक इनपुट स्ट्रिंग प्रति लाइन...',
  'settings.localModel.download.embeddingVectors': 'वेक्टर: {count}',
  'settings.localModel.download.noThinkMode': 'नो थिंक मोड',
  'settings.localModel.download.notAvailable': 'एन/ए',
  'settings.localModel.download.promptPlaceholder':
    'कोई भी prompt टाइप करें और लोकल मॉडल पर चलाएं...',
  'settings.localModel.download.quantizationPref': 'क्वांटाइज़ेशन प्राथमिकता',
  'settings.localModel.download.runEmbeddingTest': 'चल रहा है...',
  'settings.localModel.download.runPromptTest': 'प्रॉम्प्ट टेस्ट चलाएँ',
  'settings.localModel.download.runSummaryTest': 'सारांश टेस्ट चलाएँ',
  'settings.localModel.download.runTranscriptionTest': 'चल रहा है...',
  'settings.localModel.download.runTtsTest': 'चल रहा है...',
  'settings.localModel.download.runVisionTest': 'चल रहा है...',
  'settings.localModel.download.running': 'चल रहा है...',
  'settings.localModel.download.runningPrompt': 'Prompt चल रहा है',
  'settings.localModel.download.summaryHelper':
    'रस्ट कोर के माध्यम से `openhuman.inference_summarize` को कॉल करता है',
  'settings.localModel.download.summarizePlaceholder':
    'लोकल मॉडल से समराइज़ करने के लिए टेक्स्ट पेस्ट करें...',
  'settings.localModel.download.testCustomPrompt': 'कस्टम Prompt टेस्ट करें',
  'settings.localModel.download.testEmbeddings': 'एम्बेडिंग टेस्ट करें',
  'settings.localModel.download.testSummarization': 'समराइज़ेशन टेस्ट करें',
  'settings.localModel.download.testVisionPrompt': 'विज़न Prompt टेस्ट करें',
  'settings.localModel.download.testVoiceInput': 'वॉइस इनपुट टेस्ट करें (STT)',
  'settings.localModel.download.testVoiceOutput': 'वॉइस आउटपुट टेस्ट करें (TTS)',
  'settings.localModel.download.transcript': 'प्रतिलेख:',
  'settings.localModel.download.ttsOutput': 'आउटपुट: {outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': 'वैकल्पिक आउटपुट WAV path',
  'settings.localModel.download.ttsPlaceholder': 'सिंथेसाइज़ करने के लिए टेक्स्ट डालें...',
  'settings.localModel.download.ttsVoice': 'आवाज़: {voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    'एक इमेज रेफरेंस प्रति लाइन (data URI, URL, या लोकल path मार्कर)',
  'settings.localModel.download.visionPromptPlaceholder': 'विज़न मॉडल के लिए prompt डालें...',
  'settings.localModel.status.allChecksPassed': 'सभी चेक पास हुए',
  'settings.localModel.status.artifact': 'आर्टिफैक्ट',
  'settings.localModel.status.backend': 'बैकएंड',
  'settings.localModel.status.binary': 'बाइनरी',
  'settings.localModel.status.bootstrapResume': 'बूटस्ट्रैप / फिर से शुरू',
  'settings.localModel.status.checking': 'चेक हो रहा है...',
  'settings.localModel.status.checkingOllama': 'Ollama चेक हो रहा है',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - {required} मिनट से नीचे',
  'settings.localModel.status.contextBelowMinimumTitle':
    'अस्वीकृत: संदर्भ विंडो {contextLength} टोकन मेमोरी परत के लिए आवश्यक न्यूनतम {required}-टोकन से नीचे है। मौन काट-छाँट से स्मरण भ्रष्ट हो जाएगा।',
  'settings.localModel.status.contextOkBadge': '{contextLength} ctx ✓',
  'settings.localModel.status.contextOkTitle':
    'संदर्भ विंडो {contextLength} टोकन न्यूनतम {required} टोकन की मेमोरी-लेयर को पूरा करती है।',
  'settings.localModel.status.contextUnknownBadge': 'सीटीएक्स अज्ञात',
  'settings.localModel.status.contextUnknownTitle':
    'प्रसंग विंडो अज्ञात; इसकी पुष्टि नहीं हो सकी कि यह न्यूनतम {required}-टोकन मेमोरी-लेयर को पूरा करता है।',
  'settings.localModel.status.customLocation': 'कस्टम लोकेशन',
  'settings.localModel.status.customLocationDesc': 'कस्टम स्थान विवरण',
  'settings.localModel.status.diagnosticsHint':
    'यह सत्यापित करने के लिए "Run Diagnostics" पर क्लिक करें कि Ollama चल रहा है और मॉडल इंस्टॉल हैं।',
  'settings.localModel.status.downloadingUnknown': 'डाउनलोड हो रहा है (साइज़ अज्ञात)',
  'settings.localModel.status.eta': 'ETA',
  'settings.localModel.status.expectedModels': 'एक्सपेक्टेड मॉडल',
  'settings.localModel.status.expectedChat': 'चैट: {model}',
  'settings.localModel.status.expectedEmbedding': 'एम्बेडिंग: {model}',
  'settings.localModel.status.expectedVision': 'दृष्टि: {model}',
  'settings.localModel.status.externalProcess': 'बाह्य प्रक्रिया',
  'settings.localModel.status.forceRebootstrap': 'बल पुनः बूटस्ट्रैप',
  'settings.localModel.status.generationTps': 'जनरेशन TPS',
  'settings.localModel.status.hideErrorDetails': 'एरर डिटेल्स छुपाएं',
  'settings.localModel.status.installManually': 'मैन्युअली इन्स्टॉल करें',
  'settings.localModel.status.installManuallyFrom': 'यहाँ से मैन्युअली इन्स्टॉल करें',
  'settings.localModel.status.installOllama': 'शुरू हो रहा है…',
  'settings.localModel.status.installedModels': 'इन्स्टॉल्ड मॉडल',
  'settings.localModel.status.installing': 'इन्स्टॉल हो रहा है...',
  'settings.localModel.status.installingOllama': 'Ollama रनटाइम इन्स्टॉल हो रहा है...',
  'settings.localModel.status.issues': 'समस्याएं',
  'settings.localModel.status.issuesFound': '{count} समस्या(एँ) मिलीं',
  'settings.localModel.status.lastLatency': 'आखिरी लेटेंसी',
  'settings.localModel.status.model': 'मॉडल',
  'settings.localModel.status.notAvailable': 'एन/ए',
  'settings.localModel.status.notFound': 'नहीं मिला',
  'settings.localModel.status.notRunning': 'नहीं चल रहा',
  'settings.localModel.status.ollamaBinaryPath': 'Ollama बाइनरी पथ',
  'localModel.ollamaServer.helperText': 'उदाहरण: http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'Ollama सर्वर URL',
  'localModel.ollamaServer.modelCount': 'मॉडल',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': 'पहुंचने योग्य',
  'localModel.ollamaServer.resetButton': 'डिफ़ॉल्ट पर रीसेट करें',
  'localModel.ollamaServer.saveButton': 'सहेजें',
  'localModel.ollamaServer.testButton': 'कनेक्शन जांचें',
  'localModel.ollamaServer.unreachable': 'पहुंचने योग्य नहीं',
  'localModel.ollamaServer.validationError': 'एक मान्य http:// या https:// URL होना चाहिए',
  'settings.localModel.status.ollamaDiagnostics': 'Ollama डायग्नोस्टिक्स',
  'settings.localModel.status.ollamaNotInstalled': 'Ollama रनटाइम अनुपलब्ध',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'OpenHuman अब Ollama को एक बाहरी इन्फ़रेंस रनटाइम के रूप में मानता है। अपना खुद का Ollama सर्वर शुरू करें, अपने इच्छित मॉडल खींचें, और वर्कलोड रूटिंग को इसकी ओर इंगित करें।',
  'settings.localModel.status.progress': 'प्रगति',
  'settings.localModel.status.provider': 'प्रोवाइडर',
  'settings.localModel.status.retryBootstrap': 'Bootstrap फिर से करें',
  'settings.localModel.status.runDiagnostics': 'चेक हो रहा है...',
  'settings.localModel.status.running': 'चल रहा है',
  'settings.localModel.status.runningExternalProcess': 'एक्सटर्नल प्रोसेस से चल रहा है',
  'settings.localModel.status.runtimeStatus': 'रनटाइम स्टेटस',
  'settings.localModel.status.server': 'सर्वर',
  'settings.localModel.status.setPath': 'सेट हो रहा है...',
  'settings.localModel.status.setting': 'सेट हो रहा है...',
  'settings.localModel.status.showErrorDetails': 'एरर डिटेल्स छुपाएं',
  'settings.localModel.status.showInstallErrorDetails': 'एरर डिटेल्स छुपाएं',
  'settings.localModel.status.suggestedFixes': 'सुझाए गए समाधान',
  'settings.localModel.status.thenSetPath': 'फिर path सेट करें',
  'settings.localModel.status.triggering': 'ट्रिगर हो रहा है...',
  'settings.localModel.status.unavailable': 'उपलब्ध नहीं',
  'settings.localModel.status.working': 'काम हो रहा है...',
  'settings.developerMenu.ai.title': 'AI कॉन्फ़िगरेशन',
  'settings.developerMenu.ai.desc': 'क्लाउड प्रदाता, स्थानीय Ollama मॉडल, और प्रति-वर्कलोड रूटिंग',
  'settings.developerMenu.messagingChannels.title': 'मैसेजिंग चैनल',
  'settings.developerMenu.messagingChannels.desc':
    'Telegram/Discord प्रमाणीकरण मोड और डिफ़ॉल्ट चैनल रूटिंग कॉन्फ़िगर करें',
  'settings.developerMenu.tools.title': 'टूल्स',
  'settings.developerMenu.tools.desc':
    'OpenHuman आपकी ओर से जिन क्षमताओं का उपयोग कर सकता है, उन्हें सक्षम या अक्षम करें',
  'settings.developerMenu.agentChat.title': 'एजेंट चैट',
  'settings.developerMenu.agentChat.desc':
    'मॉडल और तापमान ओवरराइड के साथ एजेंट वार्तालाप का परीक्षण करें',
  'settings.developerMenu.devWorkflow.title': 'देव वर्कफ़्लो',
  'settings.developerMenu.devWorkflow.desc':
    'स्वायत्त एजेंट जो आपके GitHub मुद्दों को चुनता है और एक शेड्यूल पर PR को बढ़ाता है',
  'settings.developerMenu.devWorkflow.panelDesc':
    'एक स्वायत्त डेवलपर एजेंट को कॉन्फ़िगर करें जो आपको सौंपे गए GitHub मुद्दों को चुनता है और एक शेड्यूल पर स्वचालित रूप से अनुरोध खींचता है।',
  'settings.developerMenu.skillsRunner.title': 'कौशल धावक',
  'settings.developerMenu.skillsRunner.desc':
    'किसी भी बंडल कौशल ऐड-हॉक को चलाएं - अपने इनपुट को भरें और एक पृष्ठभूमि स्वायत्त रन को आग लगा दें',
  'settings.developerMenu.skillsRunner.panelDesc':
    'एक बंडल कौशल चुनें, अपने घोषित इनपुट को भरें और एक फायर-एंड-फॉरगेट पृष्ठभूमि रन को फायर करें। इसके बजाय देव वर्कफ़्लो का उपयोग करें यदि आप एक क्रोन-अनुसूचीबद्ध आवर्ती नौकरी चाहते हैं।',
  'settings.skillsRunner.skill': 'कौशल',
  'settings.skillsRunner.selectSkill': 'एक कौशल चुनें...',
  'settings.skillsRunner.loadingSkills': 'कौशल लोड हो रहा है...',
  'settings.skillsRunner.loadingDescription': 'कौशल इनपुट लोड हो रहा है...',
  'settings.skillsRunner.noInputs': 'यह कौशल कोई इनपुट घोषित नहीं करता है।',
  'settings.skillsRunner.placeholder.required': 'required',
  'settings.skillsRunner.runNow': 'अब भागो',
  'settings.skillsRunner.starting': 'शुरू',
  'settings.skillsRunner.started': 'शुरू किया - रन आईडी:',
  'settings.skillsRunner.logPath': 'लॉग:',
  'settings.skillsRunner.error.listSkills': 'लोड कौशल में विफल:',
  'settings.skillsRunner.error.describe': 'इनपुट लोड करने में विफल:',
  'settings.skillsRunner.error.missingRequired': 'मिसिंग आवश्यक इनपुट (s):',
  'settings.skillsRunner.error.run': 'रन शुरू करने में विफल रहा:',
  'settings.skillsRunner.error.preflightGate': 'Preflight गेट विफल',
  'settings.skillsRunner.error.runtimeUnavailable': 'रनटाइम उपलब्ध नहीं है',
  'settings.skillsRunner.error.runtimeUnavailableDefault': 'उपलब्ध नहीं',
  'settings.skillsRunner.schedule.heading': 'अनुसूची (आवर्ती)',
  'settings.skillsRunner.schedule.help':
    'इस कौशल + इनपुट को एक आवर्ती क्रोन नौकरी के रूप में सहेजें। एजेंट प्रत्येक टिक पर run skill कॉल करेगा।',
  'settings.skillsRunner.schedule.frequency': 'आवृत्ति',
  'settings.skillsRunner.schedule.every30min': '30 मिनट',
  'settings.skillsRunner.schedule.everyHour': 'हर घंटे',
  'settings.skillsRunner.schedule.every2hours': 'हर 2 घंटे',
  'settings.skillsRunner.schedule.every6hours': '6 घंटे',
  'settings.skillsRunner.schedule.onceDaily': 'एक बार दैनिक (9:00)',
  'settings.skillsRunner.schedule.save': 'अनुसूची सहेजें',
  'settings.skillsRunner.schedule.saving': 'बचत',
  'settings.skillsRunner.schedule.saved': 'अनुसूची बचाया।',
  'settings.skillsRunner.schedule.error': 'अनुसूची असफल:',
  'settings.skillsRunner.schedule.loadingJobs': 'मौजूदा अनुसूची लोड हो रहा है...',
  'settings.skillsRunner.schedule.noJobs': 'इस कौशल के लिए अभी तक कोई शेड्यूल नहीं बचा है।',
  'settings.skillsRunner.schedule.existing': 'इस कौशल के लिए अनुसूचित नौकरियां:',
  'settings.skillsRunner.schedule.inputsLabel': 'इनपुट',
  'settings.skillsRunner.schedule.inputsNone': 'कोई इनपुट नहीं',
  'settings.skillsRunner.schedule.runNow': 'रन',
  'settings.skillsRunner.schedule.remove': 'निकालें',
  'settings.skillsRunner.scheduleEnabled': 'सक्षम',
  'settings.skillsRunner.scheduleDisabled': 'दलित',
  'settings.skillsRunner.scheduleToggleAria': 'Toggle अनुसूची सक्षम',
  'settings.skillsRunner.schedule.history': 'इतिहास',
  'settings.skillsRunner.schedule.historyLoading': 'इतिहास',
  'settings.skillsRunner.schedule.historyEmpty': 'इस कार्यक्रम के लिए अभी तक कोई रन नहीं है।',
  'settings.skillsRunner.schedule.historyNoOutput': 'कोई आउटपुट कब्जा नहीं किया गया।',
  'settings.skillsRunner.schedule.active': 'सक्रिय',
  'settings.skillsRunner.schedule.lastRunLabel': 'अंतिम:',
  'settings.skillsRunner.recentRuns.headingForSkill': 'इस कौशल के लिए हाल ही में रन',
  'settings.skillsRunner.recentRuns.headingAll': 'हाल के कौशल रन (सभी)',
  'settings.skillsRunner.recentRuns.refresh': 'ताज़ा',
  'settings.skillsRunner.recentRuns.loading': 'हाल ही में रन लोड हो रहा है...',
  'settings.skillsRunner.recentRuns.empty': 'हाल ही में रन नहीं।',
  'settings.skillsRunner.viewer.loading': 'लॉग इन करें',
  'settings.skillsRunner.viewer.tailing': 'लाइव पूंछ',
  'settings.skillsRunner.viewer.fetching': 'प्राप्त करना',
  'settings.skillsRunner.viewer.error': 'लॉग इन असफल:',
  'settings.skillsRunner.repoPicker.loading': 'सम्पर्क करने का विवरण',
  'settings.skillsRunner.repoPicker.select': 'एक प्रस्तावना चुनें...',
  'settings.skillsRunner.repoPicker.empty':
    'कोई प्रस्ताव वापस नहीं आया। इस सूची को पॉप्युलेट करने के लिए Composio के माध्यम से GitHub कनेक्ट करें।',
  'settings.skillsRunner.repoPicker.notConnected':
    'GitHub Composio से जुड़ा नहीं है। इसे पहले कौशल → Composio के तहत कनेक्ट करें।',
  'settings.skillsRunner.repoPicker.privateTag': '(निजी)',
  'settings.skillsRunner.branchPicker.needRepo': 'पहले एक रेपो चुनें...',
  'settings.skillsRunner.branchPicker.loading': 'लोड हो रहा है...',
  'settings.skillsRunner.branchPicker.select': 'एक शाखा चुनें...',
  'settings.devWorkflow.githubRepository': 'GitHub रिपॉजिटरी',
  'settings.devWorkflow.loadingRepositories': 'सम्पर्क करने का विवरण',
  'settings.devWorkflow.selectRepository': 'प्रस्तावना का चयन करें',
  'settings.devWorkflow.privateTag': '(निजी)',
  'settings.devWorkflow.detectingForkInfo': 'फोर्क जानकारी का पता लगाना...',
  'settings.devWorkflow.forkDetected': 'फोर्क का पता लगाना',
  'settings.devWorkflow.upstream': 'अपस्ट्रीम',
  'settings.devWorkflow.forkPrNote': 'पीआर को अपस्ट्रीम भंडार के खिलाफ उठाया जाएगा।',
  'settings.devWorkflow.notForkNote':
    'एक कांटा नहीं। पीआर को सीधे इस प्रस्ताव के खिलाफ उठाया जाएगा।',
  'settings.devWorkflow.targetBranch': 'लक्ष्य शाखा',
  'settings.devWorkflow.targetBranchNote': 'इस शाखा के खिलाफ पीआर उठाए जाएंगे',
  'settings.devWorkflow.loadingBranches': 'लोड हो रहा है...',
  'settings.devWorkflow.runFrequency': 'रन फ्रीक्वेंसी',
  'settings.devWorkflow.runFrequencyNote':
    'अक्सर एजेंट को मुद्दों के लिए कैसे जांचना चाहिए और पीआर बढ़ाने चाहिए।',
  'settings.devWorkflow.updateConfiguration': 'अद्यतन विन्यास',
  'settings.devWorkflow.saveConfiguration': 'कॉन्फ़िगरेशन सहेजें',
  'settings.devWorkflow.remove': 'निकालें',
  'settings.devWorkflow.saved': 'सेव',
  'settings.devWorkflow.activeConfiguration': 'सक्रिय विन्यास',
  'settings.devWorkflow.activeConfigRepository': 'भंडार:',
  'settings.devWorkflow.activeConfigUpstream': 'अपस्ट्रीम',
  'settings.devWorkflow.activeConfigTargetBranch': 'लक्ष्य शाखा:',
  'settings.devWorkflow.activeConfigSchedule': 'अनुसूची:',
  'settings.devWorkflow.enabled': 'सक्षम',
  'settings.devWorkflow.paused': 'दलित',
  'settings.devWorkflow.nextRun': 'अगला',
  'settings.devWorkflow.lastRun': 'अंतिम रन',
  'settings.devWorkflow.runNow': 'अब भागो',
  'settings.devWorkflow.running': 'दौड़ना...',
  'settings.devWorkflow.recentRuns': 'हाल ही में रन',
  'settings.devWorkflow.cronSaveError': 'विन्यास को बचाने में विफल',
  'settings.devWorkflow.lastOutput': 'अंतिम उत्पादन',
  'settings.devWorkflow.noOutput': 'कोई आउटपुट कैप्चर नहीं',
  'settings.devWorkflow.runningStatus':
    'एजेंट चल रहा है - एक मुद्दा उठा रहा है और एक फिक्स पर काम कर रहा है...',
  'settings.devWorkflow.errorNotConnected':
    'GitHub कनेक्ट नहीं है। कृपया सेटिंग्स के माध्यम से GitHub कनेक्ट करें > उन्नत > Composio पहले।',
  'settings.devWorkflow.errorToolNotEnabled':
    'GITHUB_LIST_REPOSITORIES_FOR_THE_AUTHENTICATED_USER टूल इस बैकएंड पर सक्षम नहीं है। कृपया अपने व्यवस्थापक से Composio एकीकरण (backend#842) में इसे सक्षम करने के लिए कहें।',
  'settings.devWorkflow.errorNotAuthenticated': 'प्रमाणित नहीं है। कृपया पहले साइन इन करें।',
  'settings.devWorkflow.errorNoRepositories': 'इस GitHub खाते के लिए कोई प्रस्ताव नहीं मिला।',
  'settings.devWorkflow.schedule.every30min': '30 मिनट',
  'settings.devWorkflow.schedule.everyHour': 'हर घंटे',
  'settings.devWorkflow.schedule.every2hours': 'हर 2 घंटे',
  'settings.devWorkflow.schedule.every6hours': '6 घंटे',
  'settings.devWorkflow.schedule.onceDaily': 'एक बार दैनिक (9 AM)',
  'settings.developerMenu.tasks.title': 'कार्य',
  'settings.developerMenu.tasks.desc':
    'टास्क बोर्ड ब्राउज़ करें और प्रबंधित करें: आपके अपने काम और बातचीत के दौरान एजेंट द्वारा बनाए गए बोर्ड।',
  'settings.developerMenu.cronJobs.title': 'Cron जॉब्स',
  'settings.developerMenu.cronJobs.desc':
    'रनटाइम स्किल्स के लिए शेड्यूल किए गए जॉब देखें और कॉन्फ़िगर करें',
  'settings.developerMenu.localModelDebug.title': 'लोकल मॉडल डिबग',
  'settings.developerMenu.localModelDebug.desc':
    'Ollama कॉन्फ़िगरेशन, एसेट डाउनलोड, मॉडल टेस्ट, और डायग्नोस्टिक्स',
  'settings.developerMenu.webhooks.title': 'वेबहुक्स',
  'settings.developerMenu.webhooks.desc':
    'रनटाइम वेबहुक रजिस्ट्रेशन और कैप्चर किए गए अनुरोध लॉग देखें',
  'settings.developerMenu.eventLog.title': 'घटना लॉग',
  'settings.developerMenu.eventLog.desc':
    'सभी एजेंट, टूल और सिस्टम इवेंट्स की लाइव कलर-कोडेड स्ट्रीम',
  'settings.developerMenu.eventLog.allTypes': 'सभी प्रकार',
  'settings.developerMenu.eventLog.filterAgent': 'फ़िल्टर...',
  'settings.developerMenu.eventLog.download': 'डाउनलोड',
  'settings.developerMenu.eventLog.events': 'कार्यक्रम',
  'settings.developerMenu.eventLog.live': 'लाइव',
  'settings.developerMenu.eventLog.disconnected': 'डिस्कनेक्ट',
  'settings.developerMenu.eventLog.waiting': 'घटनाओं के लिए प्रतीक्षा...',
  'settings.developerMenu.eventLog.notConnected': 'कोर से जुड़ा नहीं है',
  'settings.developerMenu.eventLog.jumpToLatest': 'नवीनतम',
  'settings.developerMenu.eventLog.badge.tool': 'TOOL',
  'settings.developerMenu.eventLog.badge.agent': 'AGENT',
  'settings.developerMenu.eventLog.badge.info': 'INFO',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': 'WARN',
  'settings.developerMenu.eventLog.badge.skill': 'SKILL',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': 'इंटेलिजेंस',
  'settings.developerMenu.intelligence.desc':
    'मेमोरी वर्कस्पेस, सबकॉन्शस इंजन, ड्रीम्स, और सेटिंग्स',
  'settings.developerMenu.notificationRouting.title': 'नोटिफ़िकेशन रूटिंग',
  'settings.developerMenu.notificationRouting.desc':
    'AI महत्व स्कोरिंग और इंटीग्रेशन अलर्ट के लिए ऑर्केस्ट्रेटर एस्केलेशन',
  'settings.developerMenu.composeioTriggers.title': 'ComposeIO ट्रिगर्स',
  'settings.developerMenu.composeioTriggers.desc': 'ComposeIO ट्रिगर इतिहास और आर्काइव देखें',
  'settings.developerMenu.composioRouting.title': 'Composio रूटिंग (डायरेक्ट मोड)',
  'settings.developerMenu.composioRouting.desc':
    'अपनी Composio API कुंजी लाएं और कॉल सीधे backend.composio.dev पर रूट करें',
  'settings.developerMenu.integrationTriggers.title': 'इंटीग्रेशन ट्रिगर्स',
  'settings.developerMenu.integrationTriggers.desc':
    'Composio इंटीग्रेशन ट्रिगर्स के लिए AI ट्रायेज सेटिंग्स कॉन्फ़िगर करें',
  'settings.developerMenu.mcpServer.title': 'MCP सर्वर',
  'settings.developerMenu.mcpServer.desc':
    'OpenHuman से कनेक्ट करने के लिए बाहरी MCP क्लाइंट को कॉन्फ़िगर करें',
  'settings.developerMenu.autonomy.title': 'एजेंट स्वायत्तता',
  'settings.developerMenu.autonomy.desc': 'टूल क्रिया दर सीमाएँ और सुरक्षा सीमाएँ',
  'settings.developerMenu.voiceDebug.title': 'वॉइस (डिबग)',
  'settings.developerMenu.voiceDebug.desc': 'वॉइस डिक्टेशन रनटाइम स्थिति और डिबग सेटिंग्स',
  'settings.mcpServer.title': 'MCP सर्वर',
  'settings.mcpServer.toolsSectionTitle': 'उपलब्ध उपकरण',
  'settings.mcpServer.toolsSectionDesc':
    'ओपनह्यूमन-कोर एमसीपी चलाने पर उपकरण MCP stdio सर्वर के माध्यम से उजागर होते हैं',
  'settings.mcpServer.configSectionTitle': 'क्लाइंट कॉन्फ़िगरेशन',
  'settings.mcpServer.configSectionDesc':
    'सही कॉन्फ़िगरेशन स्निपेट जनरेट करने के लिए अपना MCP क्लाइंट चुनें',
  'settings.mcpServer.copySnippet': 'क्लिपबोर्ड पर कॉपी करें',
  'settings.mcpServer.copied': 'नकल की गई!',
  'settings.mcpServer.openConfigFile': 'कॉन्फ़िग फ़ाइल खोलें',
  'settings.mcpServer.binaryPathNotFound':
    'OpenHuman बाइनरी नहीं मिली. यदि स्रोत से चल रहा है, तो इसके साथ निर्माण करें: cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': 'कॉन्फ़िग फ़ाइल खोलने में विफल',
  'settings.mcpServer.clientClaudeDesktop': 'क्लाउड डेस्कटॉप',
  'settings.mcpServer.clientCursor': 'कर्सर',
  'settings.mcpServer.clientCodex': 'कोडेक्स',
  'settings.mcpServer.clientZed': 'जेड',
  'settings.mcpServer.configFilePath': 'कॉन्फ़िग फ़ाइल',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP ग्राहक चयनकर्ता',
  'settings.appearance.menuDesc': 'लाइट, डार्क, या सिस्टम थीम से मिलान चुनें',
  'settings.agentAccess.title': 'एजेंट OS एक्सेस',
  'settings.agentAccess.menuDesc':
    'जहां एजेंट read/write को नियंत्रित कर सकता है और क्या यह खोल का उपयोग कर सकता है।',
  'settings.agentAccess.loadError': 'पहुँच सेटिंग्स लोड करने में विफल',
  'settings.agentAccess.saveError': 'पहुँच सेटिंग्स को बचाने में विफल',
  'settings.agentAccess.saved': 'सेव्ड - आपके अगले संदेश पर लागू होता है।',
  'settings.agentAccess.desktopOnly': 'एक्सेस सेटिंग्स केवल डेस्कटॉप ऐप में उपलब्ध हैं।',
  'settings.agentAccess.loading': 'लोड...',
  'settings.agentAccess.accessMode': 'एक्सेस मोड',
  'settings.agentAccess.tier.readonly.title': 'केवल',
  'settings.agentAccess.tier.readonly.desc':
    'फ़ाइलों को पढ़ता है और केवल पढ़ने के आदेश का पता लगाने के लिए - लेकिन कभी लिखने, संपादित नहीं करता है, या किसी भी चीज को चलाता है जो राज्य बदलता है।',
  'settings.agentAccess.tier.supervised.title': 'संपादित करने से पहले पूछें',
  'settings.agentAccess.tier.supervised.desc':
    'नई फ़ाइलों को स्वतंत्र रूप से बनाता है, लेकिन मौजूदा फ़ाइल को संपादित करने से पहले अपनी मंजूरी के लिए पूछता है, एक कमांड चला रहा है, नेटवर्क तक पहुंचता है, या कुछ भी स्थापित करता है।',
  'settings.agentAccess.tier.full.title': 'पूर्ण पहुँच',
  'settings.agentAccess.tier.full.desc':
    'अपने पूर्ण उपयोगकर्ता खाता एक्सेस के साथ कमांड चलाएं - यह क्रेडेंशियल और सिस्टम स्टोर को छोड़कर कहीं भी read/write अनुमति दे सकता है। विनाशकारी कमांड, नेटवर्क एक्सेस और इंस्टॉल अभी भी अनुमोदन के लिए पूछते हैं।',
  'settings.agentAccess.defaultTag': '(डिफ़ॉल्ट)',
  'settings.agentAccess.fullWarning':
    'A full access to the full account access. जब आप इस मशीन के साथ एजेंट को rust करते हैं तो केवल इसे सक्षम करें। क्रेडेंशियल और सिस्टम डायरेक्टरी अवरुद्ध रहते हैं, और विनाशकारी, नेटवर्क और स्थापित कार्रवाई अभी भी अनुमोदन के लिए पूछते हैं।',
  'settings.agentAccess.confine.label': 'वर्कस्पेस को कॉन्फ़िगर करें',
  'settings.agentAccess.confine.desc':
    'एजेंट को वर्कस्पेस डायरेक्टरी (साथ किसी भी स्वीकृत फ़ोल्डर) में प्रतिबंधित करें, जो भी एक्सेस मोड का चयन किया जाता है। जब बंद हो जाता है, तो यह कहीं भी आपके उपयोगकर्ता तक पहुंच सकता है - हमेशा अवरुद्ध क्रेडेंशियल और सिस्टम डायरेक्टरी को छोड़कर।',
  'settings.agentAccess.requireTaskPlanApproval.label': 'कार्य योजना अनुमोदन की आवश्यकता',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    'एक निर्धारित एजेंट से पहले रोकें एक एजेंट-लेखित कार्य संक्षिप्त निष्पादित करता है।',
  'settings.agentAccess.autoApproveAll.label': 'सभी कार्रवाइयों को स्वतः स्वीकृत करें',
  'settings.agentAccess.autoApproveAll.desc':
    'सक्षम होने पर, एजेंट आपकी अनुमति मांगे बिना सभी कार्रवाइयां निष्पादित करेगा। इसमें फ़ाइल लेखन, शेल कमांड, नेटवर्क अनुरोध और अन्य कोई भी दुष्प्रभाव शामिल हैं। कठोर सुरक्षा अवरोध (क्रेडेंशियल डायरेक्टरी, वर्कस्पेस-आंतरिक पथ) अब भी लागू रहते हैं।',
  'settings.agentAccess.tinyplaceAutopilot.title': 'स्वायत्त tiny.place एजेंट',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    'OpenHuman को tiny.place पर स्वयं कार्य करने दें। यह निर्धारित समय पर सार्थक काम ढूँढता है (पहले खुली बाउंटी), अपनी क्षमताओं के अनुरूप काम करता है और आपकी पहचान से कार्य करता है। यह बिना निगरानी के चलता है और खर्च कर सकता है, इसलिए परीक्षण के दौरान इसे devnet पर रखें। डिफ़ॉल्ट रूप से बंद।',
  'settings.agentAccess.tinyplaceAutopilot.label': 'स्वतः चलाएँ',
  'settings.agentAccess.timeout.label': 'क्रिया टाइमआउट',
  'settings.agentAccess.timeout.desc':
    'किसी एकल टूल या क्रिया को रद्द होने से पहले कितनी देर चलने दिया जाए। यदि कोई बड़ा लोकल मॉडल अपना उत्तर पूरा करने से पहले रुक जाता है तो इसे बढ़ाएँ।',
  'settings.agentAccess.timeout.unit': 'सेकंड',
  'settings.agentAccess.timeout.invalid': 'अनुमत सीमा के भीतर सेकंड की एक पूर्ण संख्या दर्ज करें',
  'settings.agentAccess.timeout.envOverride':
    'OPENHUMAN_TOOL_TIMEOUT_SECS एनवायरनमेंट वेरिएबल इस सेटिंग को ओवरराइड कर रहा है, इसलिए जब तक इसे अनसेट नहीं किया जाता, यहाँ किए गए बदलावों का कोई असर नहीं होगा।',
  'settings.agentAccess.grantedFolders': 'स्वीकृत फ़ोल्डर',
  'settings.agentAccess.alwaysAllow': 'हमेशा की अनुमति उपकरण',
  'settings.agentAccess.alwaysAllowDesc':
    'उपकरण जिन्हें आपने बिना पूछे चैट रन में "अलवे अनुमति" चिह्नित किया। एक बार फिर से शुरू करने के लिए।',
  'settings.agentAccess.alwaysAllowNone': 'अभी तक कोई हमेशा की अनुमति नहीं है।',
  'settings.agentAccess.grantedDesc':
    'फ़ोल्डर्स एजेंट वर्कस्पेस के अलावा, पढ़ सकते हैं और लिख सकते हैं। क्रेडेंशियल स्टोर (~/.ssh, ~/.gnupg, ~/.aws, keychains) और सिस्टम डायरेक्टरीज (/etc, / System, C:\\ Windows),...) हमेशा अवरुद्ध होते हैं, यहां तक कि एक दिए गए फ़ोल्डर के अंदर भी।',
  'settings.agentAccess.noneGranted': 'कोई फ़ोल्डर नहीं दिया गया।',
  'settings.agentAccess.readWrite': 'पढ़ना + लिखना',
  'settings.agentAccess.readOnly': 'केवल',
  'settings.agentAccess.remove': 'निकालें',
  'settings.agentAccess.pathPlaceholder': 'फ़ोल्डर का पूर्ण पथ',
  'settings.agentAccess.accessLevelLabel': 'प्रवेश स्तर',
  'settings.agentAccess.add': 'जोड़ें',
  'settings.agentAccess.saving': 'बचत',
  'settings.agentAccess.changesApply': 'परिवर्तन आपके अगले संदेश पर लागू होते हैं।',
  'settings.agentAccess.directories': 'निर्देशिकाएँ',
  'settings.agentAccess.actionSandbox': 'एक्शन सैंडबॉक्स',
  'settings.agentAccess.readWriteAccess': 'पढ़ना + लिखना',
  'settings.agentAccess.actionSandboxDesc':
    'शेल, फ़ाइल और git टूल के लिए डिफ़ॉल्ट कार्य निर्देशिका।',
  'settings.agentAccess.actionDir.edit': 'संपादित करें',
  'settings.agentAccess.actionDir.save': 'सहेजें',
  'settings.agentAccess.actionDir.cancel': 'रद्द करें',
  'settings.agentAccess.actionDir.placeholder': 'पूर्ण पथ, उदा. /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    'OPENHUMAN_ACTION_DIR द्वारा सेट किया गया। ओवरराइड करने के लिए एनवायरनमेंट वेरिएबल बदलें।',
  'settings.agentAccess.actionDir.saved': 'एक्शन डायरेक्टरी अपडेट हो गई।',
  'settings.agentAccess.internalState': 'आंतरिक स्थिति',
  'settings.agentAccess.agentBlocked': 'एजेंट-अवरुद्ध',
  'settings.agentAccess.internalStateDesc':
    'मेमोरी डेटाबेस, सत्र, टोकन और अन्य मुख्य डेटा। एजेंट टूल के लिए सुलभ नहीं।',
  'settings.agentAccess.actionDirInputLabel': 'क्रिया सैंडबॉक्स पथ',
  'settings.agentAccess.actionDirSave': 'सहेजें',
  'settings.agentAccess.actionDirSaving': 'सहेजा जा रहा है…',
  'settings.agentAccess.actionDirSaved': 'क्रिया सैंडबॉक्स अपडेट किया गया।',
  'settings.agentAccess.actionDirEmptyError': 'पथ खाली नहीं हो सकता।',
  'settings.agentAccess.actionDirSaveError': 'क्रिया सैंडबॉक्स अपडेट नहीं किया जा सका।',
  'settings.agentAccess.actionDirEnvOverrideError':
    'OPENHUMAN_ACTION_DIR सेट है: सेटिंग्स से संपादित करने के लिए env चर हटाएँ।',
  'settings.agentAccess.actionDirEnvOverrideNote':
    'OPENHUMAN_ACTION_DIR द्वारा ओवरराइड किया गया: सेटिंग्स से प्रबंधित करने के लिए env चर हटाएँ।',
  'settings.agentAccess.approvalHistory': 'अनुमोदन इतिहास',
  'settings.agentAccess.approvalHistoryDesc':
    'एजेंट द्वारा अनुरोधित पिछले स्वीकृति/अस्वीकृति निर्णयों की समीक्षा करें।',
  'settings.agentAccess.viewApprovalHistory': 'अनुमोदन इतिहास देखें',

  // ── अनुमति पैनल ──────────────────────────────────────────────────
  'settings.permissions.title': 'अनुमतियाँ',
  'settings.permissions.menuDesc': 'चुनें कि आपका सहायक क्या कर सकता है और कहाँ काम कर सकता है।',
  'settings.permissions.accessMode': 'सहायक क्या कर सकता है?',
  'settings.permissions.accessModeDesc':
    'चुनें कि आपके कंप्यूटर पर कार्रवाई करते समय सहायक को कितनी स्वतंत्रता है।',
  'settings.permissions.preset.readonly.title': 'देखो, छुओ मत',
  'settings.permissions.preset.readonly.desc':
    'सहायक फ़ाइलें पढ़ और खोज सकता है, लेकिन न तो लिखेगा, न संपादित करेगा और न ही ऐसा कुछ चलाएगा जो स्थिति बदले।',
  'settings.permissions.preset.supervised.title': 'पहले पूछो',
  'settings.permissions.preset.supervised.desc':
    'नई फ़ाइलें स्वतंत्र रूप से बना सकता है, लेकिन संपादन, कमांड चलाने या नेटवर्क तक पहुँचने से पहले हमेशा आपकी अनुमति माँगेगा।',
  'settings.permissions.preset.full.title': 'पूर्ण नियंत्रण',
  'settings.permissions.preset.full.desc':
    'आपके पूर्ण खाता पहुँच के साथ काम करता है। विनाशकारी कमांड, नेटवर्क एक्सेस और इंस्टॉलेशन फिर भी अनुमोदन माँगेंगे।',
  'settings.permissions.folders': 'यह कहाँ काम कर सकता है?',
  'settings.permissions.foldersDesc':
    'डिफ़ॉल्ट फ़ोल्डर जिसे सहायक पढ़ता और लिखता है। आप उन्नत सेटिंग्स में और फ़ोल्डर जोड़ सकते हैं।',

  'settings.meetings.title': 'मीटिंग',
  'settings.meetings.menuDesc': 'मीटिंग असिस्टेंट ऑटो-जॉइन, सारांश और ट्रांसक्रिप्ट',
  'settings.meetings.desktopOnly': 'मीटिंग सेटिंग्स केवल डेस्कटॉप पर उपलब्ध हैं।',
  'settings.meetings.loading': 'लोड हो रहा है…',
  'settings.meetings.loadError': 'मीटिंग सेटिंग्स लोड नहीं हो सकीं।',
  'settings.meetings.saveError': 'मीटिंग सेटिंग्स सहेजी नहीं जा सकीं।',
  'settings.meetings.saved': 'सहेजा गया',
  'settings.meetings.saving': 'सहेजा जा रहा है…',
  'settings.meetings.autoJoin.title': 'ऑटो-जॉइन नीति',
  'settings.meetings.autoJoin.desc': 'जब किसी कैलेंडर इवेंट में Google Meet लिंक हो',
  'settings.meetings.autoJoin.askEachTime': 'हर बार पूछें',
  'settings.meetings.autoJoin.always': 'हमेशा शामिल हों',
  'settings.meetings.autoJoin.never': 'कभी शामिल न हों',
  'settings.meetings.autoSummarize.title': 'कॉल के बाद सारांश',
  'settings.meetings.autoSummarize.desc': 'कॉल समाप्त होने के बाद सारांश बनाएं',
  'settings.meetings.autoSummarize.ask': 'कॉल के बाद पूछें',
  'settings.meetings.autoSummarize.always': 'हमेशा सारांश बनाएं',
  'settings.meetings.autoSummarize.never': 'कभी सारांश न बनाएं',
  'settings.meetings.listenOnly': 'केवल सुनने का मोड',
  'settings.meetings.listenOnlyDesc': 'माइक्रोफ़ोन म्यूट करके शामिल हों',
  'settings.meetings.ingestTranscripts': 'बैकएंड ट्रांसक्रिप्ट इनजेस्ट करें',
  'settings.meetings.ingestTranscriptsDesc': 'मीटिंग ट्रांसक्रिप्ट मेमोरी में सहेजें',
  'settings.sandbox.title': 'Sandbox निष्पादन',
  'settings.sandbox.menuDesc': 'एजेंट टूल आइसोलेशन के लिए Sandbox बैकएंड कॉन्फ़िगर करें।',
  'settings.sandbox.loading': 'लोड हो रहा है…',
  'settings.sandbox.desktopOnly': 'Sandbox सेटिंग केवल डेस्कटॉप ऐप में उपलब्ध हैं।',
  'settings.sandbox.loadError': 'Sandbox सेटिंग लोड करने में विफल।',
  'settings.sandbox.saveError': 'Sandbox सेटिंग सहेजने में विफल।',
  'settings.sandbox.saved': 'सहेजा गया: नए एजेंट सत्रों पर लागू होता है।',
  'settings.sandbox.saving': 'सहेजा जा रहा है…',
  'settings.sandbox.status': 'स्थिति',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': 'उपलब्ध',
  'settings.sandbox.unavailable': 'अनुपलब्ध',
  'settings.sandbox.detectedBackend': 'OS बैकएंड',
  'settings.sandbox.enableLabel': 'Sandbox निष्पादन सक्षम करें',
  'settings.sandbox.enableDesc': 'एक पृथक Sandbox वातावरण के अंदर एजेंट टूल चलाएं।',
  'settings.sandbox.backendLabel': 'बैकएंड',
  'settings.sandbox.backendDesc':
    'Sandbox निष्पादन के लिए उपयोग किया जाने वाला आइसोलेशन बैकएंड चुनें।',
  'settings.sandbox.backend.auto': 'स्वचालित (सर्वोत्तम उपलब्ध का पता लगाएं)',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': 'कोई नहीं (कोई sandbox नहीं)',
  'settings.sandbox.dockerSettings': 'Docker सेटिंग',
  'settings.sandbox.dockerImage': 'इमेज',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': 'मेमोरी सीमा',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'CPU सीमा',
  'settings.sandbox.cpuUnit': 'कोर',
  'settings.sandbox.envPassthrough': 'पर्यावरण पासथ्रू',
  'settings.sandbox.envPassthroughDesc': 'Sandbox में अग्रेषित पर्यावरण चर।',
  'settings.sandbox.noEnvVars': 'कोई पर्यावरण चर कॉन्फ़िगर नहीं किए गए।',
  'settings.approvalHistory.title': 'अनुमोदन इतिहास',
  'settings.approvalHistory.subtitle': 'हाल के टूल-अनुमोदन निर्णय, नवीनतम पहले।',
  'settings.approvalHistory.refresh': 'Refresh',
  'settings.approvalHistory.loading': 'अनुमोदन इतिहास लोड हो रहा है…',
  'settings.approvalHistory.retry': 'Retry',
  'settings.approvalHistory.emptyState': 'अभी तक कोई अनुमोदन निर्णय दर्ज नहीं हुआ।',
  'settings.approvalHistory.errorGeneric': 'अनुमोदन इतिहास लोड नहीं हो सका। पुनः प्रयास करें।',
  'settings.approvalHistory.decidedAt': '{date} को निर्णय लिया गया',
  'settings.approvalHistory.decision.approveOnce': 'एक बार स्वीकृत',
  'settings.approvalHistory.decision.approveAlways': 'हमेशा अनुमति',
  'settings.approvalHistory.decision.approveAlwaysFlow': 'हमेशा अनुमति (फ़्लो)',
  'settings.approvalHistory.decision.deny': 'Denied',
  'settings.theme.variantLight': 'हल्का',
  'settings.theme.variantDark': 'गहरा',
  'settings.theme.variantAuto': 'स्वचालित',
  'settings.theme.variantAria': 'थीम वैरिएंट',
  'settings.theme.backdropHeading': 'पृष्ठभूमि',
  'settings.theme.backdrop.mesh': 'मेश',
  'settings.theme.backdrop.solid': 'ठोस',
  'settings.theme.backdrop.image': 'छवि',
  'settings.theme.backdropImageUrl': 'पृष्ठभूमि छवि URL',
  'settings.theme.backdropDots': 'पृष्ठभूमि बिंदु दिखाएं',
  'settings.theme.backdropHint':
    'मेश एनिमेटेड ग्रेडिएंट दिखाता है; ठोस एक सपाट पृष्ठभूमि का उपयोग करता है; छवि आपकी अपनी पृष्ठभूमि बनाती है।',
  'settings.theme.autoForkHint':
    'किसी प्रीसेट को संपादित करने पर आपके बदलाव स्वचालित रूप से एक नई कस्टम थीम के रूप में सहेजे जाते हैं।',
  'settings.theme.title': 'थीम स्टूडियो',
  'settings.theme.menuDesc': 'रंगों और फ़ॉन्ट को पूरी तरह अनुकूलित करें, या कोई प्रीसेट थीम चुनें।',
  'settings.theme.presetsHeading': 'थीम',
  'settings.theme.builtInBadge': 'प्रीसेट',
  'settings.theme.customBadge': 'कस्टम',
  'settings.theme.customizeHint':
    'अंतर्निहित प्रीसेट केवल पढ़ने के लिए हैं। इसके रंग और फ़ॉन्ट संपादित करने के लिए इस थीम की प्रतिलिपि बनाएँ।',
  'settings.theme.duplicate': 'प्रतिलिपि बनाएँ और अनुकूलित करें',
  'settings.theme.copyName': '{name} (कस्टम)',
  'settings.theme.importedName': 'आयातित थीम',
  'settings.theme.contrastWarn':
    'पाठ और पृष्ठभूमि के बीच कम कंट्रास्ट: इस थीम को पढ़ना कठिन हो सकता है।',
  'settings.theme.group.surfaces': 'सतहें',
  'settings.theme.group.text': 'पाठ',
  'settings.theme.group.borders': 'किनारे',
  'settings.theme.group.accents': 'एक्सेंट रंग',
  'settings.theme.showShades': 'सभी एक्सेंट शेड दिखाएँ',
  'settings.theme.hideShades': 'सभी एक्सेंट शेड छिपाएँ',
  'settings.theme.fontsHeading': 'फ़ॉन्ट',
  'settings.theme.fontRole.title': 'शीर्षक',
  'settings.theme.fontRole.heading': 'मथालेख',
  'settings.theme.fontRole.body': 'मुख्य पाठ',
  'settings.theme.fontRole.mono': 'मोनोस्पेस',
  'settings.theme.fontRole.serif': 'सेरिफ़',
  'settings.theme.fontCurrent': 'वर्तमान',
  'settings.theme.actions': 'थीम प्रबंधित करें',
  'settings.theme.reset': 'ओवरराइड रीसेट करें',
  'settings.theme.delete': 'थीम हटाएँ',
  'settings.theme.export': 'JSON कॉपी करें',
  'settings.theme.copied': 'कॉपी हो गया!',
  'settings.theme.import': 'थीम आयात करें',
  'settings.theme.importHint':
    'इसे कस्टम थीम के रूप में जोड़ने के लिए निर्यात की गई थीम JSON पेस्ट करें।',
  'settings.theme.importApply': 'आयात करें',
  'settings.theme.importError': 'उस थीम JSON को पार्स नहीं किया जा सका।',
  'settings.appearance.title': 'दिखावट',
  'settings.appearance.themeHeading': 'थीम',
  'settings.appearance.themeAria': 'थीम',
  'settings.appearance.modeLight': 'रोशनी',
  'settings.appearance.modeLightDesc': 'चमकदार सतहें, गहरा पाठ।',
  'settings.appearance.modeDark': 'अंधेरा',
  'settings.appearance.modeDarkDesc': 'धुंधली सतह, शाम के बाद आंखों पर आसान।',
  'settings.appearance.modeSystem': 'मिलान प्रणाली',
  'settings.appearance.modeSystemDesc': 'अपने OS उपस्थिति सेटिंग का पालन करें.',
  'settings.appearance.helperText':
    'डार्क मोड पूरे ऐप - चैट, सेटिंग्स, पैनल - को एक मंद पैलेट में बदल देता है। "मैच सिस्टम" आपके ओएस की उपस्थिति और अपडेट का लाइव अनुसरण करता है।',
  'settings.appearance.fontSizeHeading': 'फ़ॉन्ट आकार',
  'settings.appearance.fontSizeAria': 'फ़ॉन्ट आकार',
  'settings.appearance.fontSizeSmall': 'छोटा',
  'settings.appearance.fontSizeSmallDesc': 'संक्षिप्त टेक्स्ट: स्क्रीन पर अधिक दिखाएँ।',
  'settings.appearance.fontSizeMedium': 'मध्यम',
  'settings.appearance.fontSizeMediumDesc': 'डिफ़ॉल्ट, संतुलित आकार।',
  'settings.appearance.fontSizeLarge': 'बड़ा',
  'settings.appearance.fontSizeLargeDesc': 'आसान पढ़ने के लिए बड़ा टेक्स्ट।',
  'settings.appearance.fontSizeXLarge': 'बहुत बड़ा',
  'settings.appearance.fontSizeXLargeDesc': 'अधिकतम पठनीयता के लिए सबसे बड़ा टेक्स्ट।',
  'settings.appearance.fontSizeHelperText':
    'आपके सिस्टम फ़ॉन्ट सेटिंग से स्वतंत्र रूप से पूरे ऐप (चैट, सेटिंग्स और पैनल) में टेक्स्ट का आकार बदलता है।',
  'settings.appearance.fontSizeCustomLabel': 'कस्टम आकार',
  'settings.appearance.fontSizeCustomAria': 'पिक्सेल में कस्टम फ़ॉन्ट आकार',
  'settings.appearance.fontSizeCustomSliderAria': 'कस्टम फ़ॉन्ट आकार स्लाइडर, पिक्सेल में',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': 'निचला टैब बार',
  'settings.appearance.tabBarAlwaysShowLabels': 'हमेशा लेबल दिखाएं',
  'settings.appearance.tabBarAlwaysShowLabelsDesc':
    'बंद होने पर, लेबल केवल होवर पर या सक्रिय टैब के लिए दिखाई देते हैं।',
  'settings.appearance.chatHeading': 'चैट',
  'settings.appearance.assistantTextMode': 'असिस्टेंट जवाब टेक्स्ट में',
  'settings.appearance.hideAgentInsights': 'एजेंट की सोच छिपाएँ',
  'settings.appearance.hideAgentInsightsDesc':
    'चैट में एजेंट की चरण-दर-चरण लाइव टाइमलाइन को छिपाएँ। एक ब्लिंक करता "प्रोसेसिंग" लिंक फिर भी आपको पूरी प्रक्रिया खोलने देता है।',
  'settings.appearance.showChatMascot': 'मैसेज बॉक्स पर Tiny दिखाएँ',
  'settings.appearance.showChatMascotDesc':
    'मैस्कॉट लिखने के बॉक्स पर खड़ा रहता है। छिपाने पर चैट सिर्फ़ टेक्स्ट रहेगी, जब तक आप इसे दोबारा चालू न करें।',
  'settings.appearance.assistantTextModeDesc':
    'असिस्टेंट के जवाबों को बिना फ्रेम वाले टेक्स्ट के रूप में दिखाएं और आपके संदेश बबल में रखें।',
  'settings.mascot.active': 'एक्टिव',
  'settings.mascot.characterDesc': 'कैरेक्टर विवरण',
  'settings.mascot.characterDraft': 'ड्राफ़्ट',
  'settings.mascot.characterHeading': 'कैरेक्टर शीर्षक',
  'settings.mascot.customGifError':
    'HTTPS, file://, या स्थानीय इमेज URL (PNG, GIF, JPEG, WebP, या BMP) दर्ज करें, या कोई फ़ाइल अपलोड करें।',
  'settings.mascot.customGifHeading': 'कस्टम इमेज अवतार',
  'settings.mascot.customGifLabel': 'कस्टम इमेज अवतार URL',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': 'इमेज अपलोड करें',
  'settings.mascot.customGifInvalidType':
    'असमर्थित फ़ाइल प्रकार। PNG, GIF, JPEG, WebP, या BMP इमेज अपलोड करें।',
  'settings.mascot.customGifTooLarge': 'इमेज बहुत बड़ी है। 1.5 MB तक की फ़ाइल अपलोड करें।',
  'settings.mascot.customGifReadError': 'यह इमेज पढ़ी नहीं जा सकी। कृपया दूसरी फ़ाइल आज़माएँ।',
  'settings.mascot.characterPreview': 'पूर्वावलोकन',
  'settings.mascot.characterStates': 'राज्य',
  'settings.mascot.characterVisemes': 'हिंदी',
  'settings.mascot.colorAria': 'OpenHuman रंग',
  'settings.mascot.colorDesc': 'रंग विवरण',
  'settings.mascot.colorHeading': 'रंग शीर्षक',
  'settings.mascot.colorBlack': 'काला',
  'settings.mascot.colorBurgundy': 'बरगंडी',
  'settings.mascot.colorCustom': 'कस्टम',
  'settings.mascot.colorNavy': 'नौसेना',
  'settings.mascot.primaryColor': 'प्राथमिक रंग',
  'settings.mascot.secondaryColor': 'माध्यमिक रंग',
  'settings.mascot.colorYellow': 'पीला',
  'settings.mascot.libraryUnavailable': 'OpenHuman लाइब्रेरी अनुपलब्ध है',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': 'OpenHuman लाइब्रेरी लोड हो रही है…',
  'settings.mascot.loadDetailError': 'शुभंकर लोड नहीं किया जा सका.',
  'settings.mascot.loadLibraryError': 'शुभंकर लाइब्रेरी लोड नहीं की जा सकी.',
  'settings.mascot.localDefault': 'लोकल OpenHuman (डिफ़ॉल्ट)',
  'settings.mascot.menuTitle': 'मास्कॉट',
  'settings.mascot.menuDesc': 'ऐप में उपयोग होने वाला मास्कॉट रंग चुनें',
  'settings.mascot.noCharacters': 'अभी तक कोई OpenHuman कैरेक्टर उपलब्ध नहीं है',
  'settings.mascot.noColorVariants': 'कोई कलर वेरिएंट नहीं',
  'settings.mascot.secondaryHeading': 'मीटिंग जोड़ी (दूसरा मैस्कट)',
  'settings.mascot.secondaryDesc':
    'मीटिंग के लिए एक दूसरा मैस्कट जोड़ें। दो सेट होने पर वे साथ दिखते हैं और बारी-बारी से बोलते हैं। एक ही मैस्कट के लिए कोई नहीं पर छोड़ें।',
  'settings.mascot.secondaryNone': 'कोई नहीं (एकल मैस्कट)',
  'settings.mascot.perMascotVoiceHeading': 'प्रति-मैस्कट आवाज़ें',
  'settings.mascot.primaryVoiceLabel': 'पहले मैस्कट की आवाज़',
  'settings.mascot.secondaryVoiceLabel': 'दूसरे मैस्कट की आवाज़',
  'settings.mascot.voice.current': 'वर्तमान',
  'settings.mascot.voice.customDesc':
    'वॉइस आईडी api.elevenlabs.io/v1/voices या अपने ElevenLabs डैशबोर्ड पर खोजें। केवल आईडी संग्रहीत होती है: आपकी API कुंजी बैकएंड पर रहती है।',
  'settings.mascot.voice.customHeading': 'कस्टम वॉइस आईडी',
  'settings.mascot.voice.customOption': 'अन्य (वॉइस आईडी पेस्ट करें)…',
  'settings.mascot.voice.customPlaceholder': 'जैसे 21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    'बोले गए उत्तरों के लिए मैस्कॉट जो ElevenLabs वॉइस उपयोग करता है उसे चुनें। लिंग के अनुसार फ़िल्टर करें, क्यूरेटेड सूची से चुनें, कस्टम आईडी पेस्ट करें, या ऐप को इंटरफ़ेस भाषा से मेल खाने वाली आवाज़ चुनने दें।',
  'settings.mascot.voice.genderFemale': 'स्त्री',
  'settings.mascot.voice.genderHeading': 'वॉइस लिंग',
  'settings.mascot.voice.genderMale': 'पुरुष',
  'settings.mascot.voice.heading': 'वॉइस',
  'settings.mascot.voice.preset': 'वॉइस प्रीसेट',
  'settings.mascot.voice.presetHeading': 'वॉइस प्रीसेट',
  'settings.mascot.voice.preview': 'वॉइस पूर्वावलोकन',
  'settings.mascot.voice.previewError': 'वॉइस पूर्वावलोकन विफल हुआ',
  'settings.mascot.voice.previewText': 'हाय, मैं तुम्हारा सहायक हूँ। यह एक आवाज पूर्वावलोकन है।',
  'settings.mascot.voice.previewing': 'पूर्वावलोकन हो रहा है…',
  'settings.mascot.voice.reset': 'डिफ़ॉल्ट पर रीसेट करें',
  'settings.mascot.voice.useLocaleDefault': 'ऐप भाषा से मिलाएँ',
  'settings.mascot.voice.useLocaleDefaultDesc':
    'वर्तमान इंटरफ़ेस भाषा के लिए स्वचालित रूप से एक आवाज़ चुनें।',
  'settings.persona.title': 'व्यक्तित्व',
  'settings.persona.menuTitle': 'व्यक्तित्व',
  'settings.persona.menuDesc': 'नाम, व्यक्तित्व, अवतार और आवाज - एक पहचान के रूप में आपका सहायक',
  'settings.persona.identityHeading': 'पहचान',
  'settings.persona.identityDesc':
    'आपके सहायक के लिए एक प्रदर्शन नाम और लघु विवरण। ऐप में दिखाया गया है; यह नहीं बदलता कि कैसे सहायक कारण हैं।',
  'settings.persona.displayNameLabel': 'नाम प्रदर्शित करें',
  'settings.persona.displayNamePlaceholder': 'जैसे Nova',
  'settings.persona.descriptionLabel': 'विवरण',
  'settings.persona.descriptionPlaceholder': 'e.g मेरी टीम के लिए एक शांत, संक्षिप्त सहायक।',
  'settings.persona.soul.heading': 'व्यक्तित्व (SOUL)',
  'settings.persona.soul.desc':
    'व्यक्तित्व ने प्रत्येक बातचीत में सहायक को प्रेरित किया। संपादन आपके कार्यक्षेत्र में सहेजे जाते हैं और अगले उत्तर में प्रभाव डालते हैं।',
  'settings.persona.soul.editorLabel': 'SOUL',
  'settings.persona.soul.reset': 'डिफ़ॉल्ट रूप से रीसेट करें',
  'settings.persona.soul.usingDefault': 'बंडल डिफ़ॉल्ट का उपयोग करना',
  'settings.persona.soul.loadError': 'SOUL',
  'settings.persona.soul.saveError': 'नहीं बचा सकता SOUL.md',
  'settings.persona.soul.resetError': 'SOUL.md रीसेट नहीं कर सका',
  'settings.persona.builder.modeLabel': 'पर्सोना एडिटर मोड',
  'settings.persona.builder.modeGuided': 'निर्देशित',
  'settings.persona.builder.modeAdvanced': 'उन्नत',
  'settings.persona.builder.intro':
    'कुछ फ़ील्ड भरें और हम उन्हें आपके पर्सोना में लिख देंगे। मार्कडाउन की ज़रूरत नहीं।',
  'settings.persona.builder.personalityLabel': 'व्यक्तित्व',
  'settings.persona.builder.personalityPlaceholder':
    'जैसे: गर्मजोश, जिज्ञासु और सीधा। अनिश्चितता पर ईमानदार।',
  'settings.persona.builder.voiceLabel': 'संवाद शैली',
  'settings.persona.builder.voicePlaceholder':
    'जैसे: पहले उत्तर दें, संक्षिप्त रखें और मेरे लहजे से मेल खाएँ।',
  'settings.persona.builder.aboutLabel': 'आपके बारे में',
  'settings.persona.builder.aboutPlaceholder':
    'जैसे: मैं एक छोटा डिज़ाइन स्टूडियो चलाता हूँ और सरल भाषा पसंद करता हूँ।',
  'settings.persona.builder.preservedNote':
    'आपके हाथ से लिखे अन्य अनुभाग सुरक्षित रहते हैं: पूरा पर्सोना देखने के लिए उन्नत पर जाएँ।',
  'settings.persona.builder.securityNote': 'तय करना चाहते हैं कि असिस्टेंट क्या कर सकता है?',
  'settings.persona.builder.securityLink': 'एजेंट एक्सेस खोलें',
  'settings.persona.templates.heading': 'टेम्पलेट से शुरू करें',
  'settings.persona.templates.desc':
    'एक शुरुआती बिंदु चुनें: यह व्यक्तित्व और संवाद शैली भर देता है। बाद में आप सब कुछ बदल सकते हैं।',
  'settings.persona.templates.doctor.label': 'क्लिनिकल सहायक',
  'settings.persona.templates.doctor.desc': 'सावधान, स्रोत बताता है, अनिश्चितता दर्शाता है',
  'settings.persona.templates.researcher.label': 'शोध सहायक',
  'settings.persona.templates.researcher.desc': 'सटीक, व्यवस्थित, साक्ष्य-आधारित',
  'settings.persona.templates.executive.label': 'कार्यकारी सहायक',
  'settings.persona.templates.executive.desc': 'संक्षिप्त, निर्णायक, कार्य-केंद्रित',
  'settings.persona.templates.teacher.label': 'शिक्षक',
  'settings.persona.templates.teacher.desc': 'धैर्यवान, कदम-दर-कदम समझाता है',
  'settings.persona.templates.student.label': 'अध्ययन साथी',
  'settings.persona.templates.student.desc': 'प्रोत्साहित करता है, सवाल पूछता है, सरल भाषा',
  'settings.persona.templates.family.label': 'पारिवारिक सहायक',
  'settings.persona.templates.family.desc': 'गर्मजोश, मिलनसार, हर उम्र के लिए सुरक्षित',
  'settings.persona.appearanceHeading': 'अवतार और आवाज',
  'settings.persona.appearanceDesc':
    'Mascot रंग, कस्टम इमेज अवतार, और उत्तर आवाज Mascot सेटिंग्स में कॉन्फ़िगर किया गया है।',
  'settings.persona.openMascotSettings': 'ओपन Mascot सेटिंग्स',
  'settings.memoryWindow.balanced.badge': 'अनुशंसित',
  'settings.memoryWindow.balanced.hint':
    'समझदारी भरा डिफ़ॉल्ट: हर रन पर अतिरिक्त टोकन खर्च किए बिना अच्छी निरंतरता।',
  'settings.memoryWindow.balanced.label': 'संतुलित',
  'settings.memoryWindow.description':
    'OpenHuman हर नए एजेंट रन में कितना याद किया गया संदर्भ इंजेक्ट करता है। बड़ी विंडोज़ पिछली बातचीत के बारे में अधिक जागरूक लगती हैं, लेकिन हर रन पर अधिक टोकन का उपयोग करती हैं, जिससे लागत भी बढ़ती है।',
  'settings.memoryWindow.extended.badge': 'अधिक संदर्भ',
  'settings.memoryWindow.extended.hint':
    'प्रत्येक रन में अधिक दीर्घकालिक मेमोरी इंजेक्ट होती है। प्रति टर्न उच्च टोकन लागत।',
  'settings.memoryWindow.extended.label': 'विस्तारित',
  'settings.memoryWindow.maximum.badge': 'सर्वोच्च लागत',
  'settings.memoryWindow.maximum.hint':
    'सबसे बड़ी सुरक्षित विंडो। सर्वोत्तम निरंतरता, हर रन पर काफी अधिक टोकन बिल।',
  'settings.memoryWindow.maximum.label': 'अधिकतम',
  'settings.memoryWindow.minimal.badge': 'सबसे सस्ता',
  'settings.memoryWindow.minimal.hint':
    'सबसे छोटी मेमोरी विंडो। सबसे सस्ता, सबसे तेज़, रनों के बीच कम से कम निरंतरता।',
  'settings.memoryWindow.minimal.label': 'न्यूनतम',
  'settings.memoryWindow.title': 'लॉन्ग-टर्म मेमोरी विंडो',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc': 'GMI Cloud मार्केटप्लेस एडॉप्टर की स्थिति और प्रदाता कॉन्फ़िगरेशन',
  'settings.agentbox.intro':
    'AgentBox मार्केटप्लेस एडॉप्टर की केवल-पढ़ने योग्य स्थिति। कोर शुरू होने पर मोड और GMI MaaS प्रदाता पर्यावरण वेरिएबल द्वारा सेट किए जाते हैं।',
  'settings.agentbox.modeLabel': 'मार्केटप्लेस मोड',
  'settings.agentbox.providerHeading': 'GMI MaaS प्रदाता',
  'settings.agentbox.slug': 'प्रदाता स्लग',
  'settings.agentbox.baseUrl': 'बेस URL',
  'settings.agentbox.model': 'मॉडल',
  'settings.agentbox.notConfigured':
    'कॉन्फ़िगर नहीं किया गया। GMI_MAAS_BASE_URL, GMI_MAAS_API_KEY, और GMI_MODELS पर्यावरण वेरिएबल सेट करें।',
  'settings.agentbox.unavailable': 'AgentBox स्थिति अनुपलब्ध',
  'settings.modelHealth.title': 'स्वास्थ्य',
  'settings.modelHealth.desc':
    'प्रति मॉडल की गुणवत्ता, मतिभ्रम दर, और सक्रिय मॉडलों में लागत तुलना',
  'settings.modelHealth.allStatuses': 'सभी स्थितियां',
  'settings.modelHealth.models': 'मॉडल',
  'settings.modelHealth.loading': 'मॉडल डेटा लोड हो रहा है...',
  'settings.modelHealth.empty': 'पंजीकृत मॉडल',
  'settings.modelHealth.col.model': 'मॉडल',
  'settings.modelHealth.col.quality': 'गुणवत्ता',
  'settings.modelHealth.col.halluc': 'हॉलुक दर',
  'settings.modelHealth.col.cost': 'लागत / 1M बाहर',
  'settings.modelHealth.col.agents': 'एजेंट',
  'settings.modelHealth.col.status': 'स्थिति',
  'settings.modelHealth.badge.keep': 'रखना',
  'settings.modelHealth.badge.replace': 'बदलें',
  'settings.modelHealth.badge.staging': 'स्टेजिंग टेस्ट',
  'settings.modelHealth.badge.vision': 'केवल दृष्टि',
  'settings.modelHealth.swap': 'स्वैप?',
  'settings.modelHealth.modal.title': 'मॉडल बदलें?',
  'settings.modelHealth.modal.hallucRate': 'सम्पर्क करने का विवरण',
  'settings.modelHealth.modal.cancel': 'रद्द करना',
  'settings.modelHealth.modal.apply': 'प्रतिस्थापन लागू करें',
  'settings.modelHealth.tag.cheaper': 'CHEAPER',
  'settings.modelHealth.tag.better': 'BETTER',
  'skills.card.moreActions': 'और एक्शन',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': 'वेब',
  'skills.channelIcon.yuanbao': 'Yuanbao',
  'skills.composio.poweredBy': 'Composio द्वारा संचालित',
  'skills.composio.staleStatusTitle': 'कनेक्शन पुरानी स्थिति दिखा रहे हैं',
  'skills.create.allowedTools': 'अनुमत टूल्स',
  'skills.create.allowedToolsHelp': 'SKILL.md फ्रंटमैटर में प्रस्तुत किया गया',
  'skills.create.allowedToolsPlaceholder': 'नोड_एक्सईसी, प्राप्त करें',
  'skills.create.author': 'लेखक',
  'skills.create.authorPlaceholder': 'आपका नाम',
  'skills.create.commaSeparated': '(कॉमा से अलग करें)',
  'skills.create.createBtn': 'स्किल बनाएँ',
  'skills.create.createError': 'स्किल नहीं बन पाई',
  'skills.create.creating': 'बन रहा है…',
  'skills.create.description': 'विवरण',
  'skills.create.descriptionPlaceholder': 'यह स्किल क्या करती है?',
  'skills.create.optional': '(वैकल्पिक)',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help':
    'स्किल को जिन पैरामीटर की आवश्यकता है उन्हें घोषित करें। Skills Runner रन टाइम पर इनके लिए एक फ़ॉर्म दिखाएगा।',
  'skills.create.inputs.add': 'इनपुट जोड़ें',
  'skills.create.inputs.row.name': 'इनपुट नाम',
  'skills.create.inputs.row.namePlaceholder': 'जैसे repo',
  'skills.create.inputs.row.nameError':
    'केवल अक्षर, अंक, अंडरस्कोर और डैश; अक्षर से शुरू होना चाहिए।',
  'skills.create.inputs.row.description': 'इनपुट विवरण',
  'skills.create.inputs.row.descriptionPlaceholder': 'इस फ़ील्ड में क्या जाता है?',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': 'इनपुट हटाएं',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': 'हाँ / नहीं',
  'skills.create.license': 'लाइसेंस',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': 'नाम',
  'skills.create.namePlaceholder': 'जैसे Trade Journal',
  'skills.create.scope': 'स्कोप',
  'skills.create.scopeProjectHint': '/.openhuman/skills/',
  'skills.create.scopeUserHint':
    '~/.openhuman/skills/<slug>/SKILL.md में लिखा जाता है: सभी वर्कस्पेस में उपलब्ध।',
  'skills.create.slugLabel': 'स्लग लेबल',
  'skills.create.subtitle': 'SKILL.md',
  'skills.create.tags': 'टैग्स',
  'skills.create.tagsPlaceholder': 'व्यापार, अनुसंधान',
  'skills.create.title': 'नया स्किल',
  'skills.detail.allowedTools': 'अनुमत टूल्स',
  'skills.detail.author': 'लेखक',
  'skills.detail.license': 'लाइसेंस',
  'skills.detail.bundledResources': 'बंडल्ड रिसोर्सेज़',
  'skills.detail.description': 'विवरण',
  'skills.detail.closeAriaLabel': 'स्किल डिटेल्स बंद करें',
  'skills.detail.location': 'लोकेशन',
  'skills.detail.noBundledResources': 'कोई बंडल्ड रिसोर्स नहीं।',
  'skills.detail.platforms': 'प्लैटफ़ॉर्म',
  'skills.detail.relatedSkills': 'संबंधित स्किल',
  'skills.detail.source': 'स्रोत URL',
  'skills.detail.sourceFormat': 'फ़ॉर्मैट',
  'skills.detail.stars': 'तारे',
  'skills.detail.tags': 'टैग्स',
  'skills.detail.warnings': 'चेतावनियाँ',
  'skills.detail.version': 'संस्करण',
  'skills.install.errors.alreadyInstalledHint':
    'इस स्लग के साथ एक कौशल कार्यक्षेत्र में पहले से ही मौजूद है। पहले इसे हटाएँ या फ्रंटमैटर `metadata.id` / `name` बदलें।',
  'skills.install.errors.alreadyInstalledTitle': 'कौशल पहले से ही स्थापित है',
  'skills.install.errors.fetchFailedHint':
    'अनुरोध सफलतापूर्वक पूरा नहीं हुआ. पहुंच योग्य सार्वजनिक फ़ाइल पर URL बिंदुओं की जांच करें, और होस्ट ने 2xx प्रतिक्रिया लौटाई है।',
  'skills.install.errors.fetchFailedTitle': 'फ़ेच विफल रहा',
  'skills.install.errors.fetchTimedOutHint':
    'दूरस्थ होस्ट ने समय पर उत्तर नहीं दिया. पुनः प्रयास करें या समयबाह्य बढ़ाएँ (1-600 सेकंड)।',
  'skills.install.errors.fetchTimedOutTitle': 'लाने का समय समाप्त हो गया',
  'skills.install.errors.fetchTooLargeHint':
    'SKILL.md 1 MiB से कम होना चाहिए। बंडल किए गए संसाधनों को इनलाइन करने के बजाय `संदर्भ/` या `स्क्रिप्ट/` फ़ाइलों में विभाजित करें।',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md बहुत बड़ा है',
  'skills.install.errors.genericHint': 'बैकएंड ने एक त्रुटि लौटाई. कच्चा संदेश नीचे दिखाया गया है।',
  'skills.install.errors.genericTitle': 'कौशल स्थापित नहीं किया जा सका',
  'skills.install.errors.invalidSkillHint':
    'फ्रंटमैटर गैर-रिक्त `नाम` और `विवरण` फ़ील्ड के साथ वैध YAML होना चाहिए, जो `---` द्वारा समाप्त हो।',
  'skills.install.errors.invalidSkillTitle': 'SKILL.md ने पार्स नहीं किया',
  'skills.install.errors.invalidUrlHint':
    'केवल सार्वजनिक HTTPS URLs की अनुमति है। निजी, लूपबैक और मेटाडेटा होस्ट अवरुद्ध हैं।',
  'skills.install.errors.invalidUrlTitle': 'URL अस्वीकृत',
  'skills.install.errors.unsupportedUrlHint':
    'केवल सीधे `.md` लिंक काम करते हैं। GitHub के लिए, एक फ़ाइल से लिंक करें (github.com/owner/repo/blob/.../SKILL.md) - ट्री और रेपो रूट स्थापित नहीं हैं।',
  'skills.install.errors.unsupportedUrlTitle': 'URL फॉर्म समर्थित नहीं है',
  'skills.install.errors.writeFailedHint':
    'कार्यक्षेत्र कौशल निर्देशिका लिखने योग्य नहीं थी. `<workspace>/.openhuman/skills/` के लिए फ़ाइल सिस्टम अनुमतियाँ जाँचें।',
  'skills.install.errors.writeFailedTitle': 'SKILL.md नहीं लिख सका',
  'skills.install.fetchLog': 'फ़ेच लॉग',
  'skills.install.fetchingPrefix': 'ला रहा है',
  'skills.install.fetchingSuffix':
    'इसमें आपके द्वारा कॉन्फ़िगर किया गया टाइमआउट तक का समय लग सकता है।',
  'skills.install.installBtn': 'इन्स्टॉल हो रहा है…',
  'skills.install.installComplete': 'इन्स्टॉल पूरा हुआ',
  'skills.install.installing': 'इन्स्टॉल हो रहा है…',
  'skills.install.parseWarnings': 'Parse चेतावनियाँ',
  'skills.install.rawError': 'रॉ एरर',
  'skills.install.subtitleMiddle': 'HTTPS के ऊपर और इसे नीचे स्थापित करता है',
  'skills.install.subtitlePrefix': 'एक सिंगल लाता है',
  'skills.install.subtitleSuffix': 'केवल HTTPS; निजी और लूपबैक होस्ट अवरुद्ध हैं।',
  'skills.install.successDiscovered': '{count} नए कौशल की खोज की।',
  'skills.install.successNoNewIds':
    'कौशल स्थापित किया गया, लेकिन कोई नई कौशल आईडी दिखाई नहीं दी - कैटलॉग में पहले से ही उसी स्लग वाला कौशल शामिल हो सकता है।',
  'skills.install.timeoutHint': '(सेकंड, वैकल्पिक)',
  'skills.install.timeoutHelp':
    'डिफ़ॉल्ट 60 सेकंड. 1-600 के बाहर के मान सर्वर-साइड पर क्लैंप किए गए हैं।',
  'skills.install.timeoutInvalid': '1 और 600 के बीच एक पूर्णांक होना चाहिए.',
  'skills.install.timeoutLabel': 'टाइमआउट लेबल',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': 'URL से स्किल इंस्टॉल करें',
  'skills.install.urlHelpMiddle': 'फ़ाइल.',
  'skills.install.urlHelpPrefix': 'ए से सीधा लिंक',
  'skills.install.urlHelpSuffix': 'URLs स्वतः पुनः लिखें',
  'skills.install.urlInvalidPrefix': 'URL एक सुगठित होना चाहिए',
  'skills.install.urlInvalidSuffix': 'लिंक.',
  'skills.install.urlLabel': 'स्किल URL',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': 'बैनर विवरण',
  'skills.meetingBots.bannerTitle': 'बैनर शीर्षक',
  'skills.meetingBots.busyTitle': 'OpenHuman व्यस्त है',
  'skills.meetingBots.comingSoon': 'जल्द आ रहा है',
  'skills.meetingBots.couldNotLeaveTitle': 'मीटिंग से नहीं निकल सके',
  'skills.meetingBots.couldNotStartTitle': 'OpenHuman प्रारंभ नहीं हो सका',
  'skills.meetingBots.displayName': 'डिस्प्ले नाम',
  'skills.meetingBots.failedToStart': 'OpenHuman शुरू नहीं हो पाया।',
  'skills.meetingBots.joiningMessage':
    'कुछ सेकंड में यह मीटिंग में पार्टिसिपेंट के रूप में दिखेगा।',
  'skills.meetingBots.joiningTitle': 'OpenHuman मीटिंग जॉइन कर रहा है',
  'skills.meetingBots.meetingLink': 'मीटिंग लिंक',
  'skills.meetingBots.modalAriaLabel': 'OpenHuman को मीटिंग में भेजें',
  'skills.meetingBots.modalDesc': 'मोडल विवरण',
  'skills.meetingBots.modalTitle': 'OpenHuman को मीटिंग में भेजें',
  'skills.meetingBots.newBadge': 'नया',
  'skills.meetingBots.platformComingSoon': '{label} समर्थन जल्द ही आ रहा है।',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'Teams.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'Zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google मिलें',
  'skills.meetingBots.platforms.teams': 'माइक्रोसॉफ्ट टीमें',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': 'ज़ूम करें',
  'skills.meetingBots.sendTo': 'भेजें',
  'skills.meetingBots.serverOverloaded':
    'OpenHuman अभी भारी लोड में है। कृपया कुछ मिनटों में फिर से प्रयास करें।',
  'skills.meetingBots.soonSuffix': 'जल्द ही',
  'skills.meetingBots.starting': 'शुरू हो रहा है…',
  'skills.meetingBots.recentCallsAriaLabel': 'हाल की मीटिंग कॉल',
  'skills.meetingBots.recentCallsHeading': 'हाल की कॉल',
  'skills.meetingBots.recentCallsEmpty':
    'अभी तक कोई पिछली कॉल नहीं: आपका मीटिंग इतिहास यहाँ दिखेगा।',
  'skills.meetingBots.recentCallsLoading': 'लोड हो रहा है\u2026',
  'skills.meetingBots.recentCallAddedBy': '{name} द्वारा जोड़ा गया',
  'skills.meetingBots.recentCallParticipants': '{names} के साथ',
  'skills.meetingBots.recentCallTurnSingular': '{count} बारी',
  'skills.meetingBots.recentCallTurnPlural': '{count} बारियां',
  'skills.meetingBots.recentCallDuration': 'कॉल पर {seconds} सेकंड',
  'skills.meetingBots.callDetailLoading': 'ट्रांसक्रिप्ट लोड हो रहा है…',
  'skills.meetingBots.callDetailError': 'ट्रांसक्रिप्ट लोड नहीं हो सका।',
  'skills.meetingBots.callDetailRetry': 'पुनः प्रयास करें',
  'skills.meetingBots.callDetailEmpty':
    'इस कॉल के लिए कोई ट्रांसक्रिप्ट या सारांश दर्ज नहीं किया गया।',
  'skills.meetingBots.callSummaryHeading': 'सारांश',
  'skills.meetingBots.callKeyPointsHeading': 'मुख्य बिंदु',
  'skills.meetingBots.callActionItemsHeading': 'कार्य आइटम',
  'skills.meetingBots.callTranscriptHeading': 'ट्रांसक्रिप्ट',
  'skills.meetingBots.liveBadge': 'लाइव',
  'skills.meetingBots.liveTitle': 'मीटिंग में',
  'skills.meetingBots.liveStatusJoining': 'शामिल हो रहा है\u2026',
  'skills.meetingBots.liveStatusActive': 'मीटिंग में लाइव',
  'skills.meetingBots.liveStatusListening': 'सुन रहा है (म्यूट)',
  'skills.meetingBots.liveStatusEnded': 'मीटिंग समाप्त',
  'skills.meetingBots.liveStatusError': 'शामिल होने में विफल',
  'skills.meetingBots.liveTranscriptHeading': 'लाइव ट्रांसक्रिप्ट',
  'skills.meetingBots.liveTranscriptEmpty': 'भाषण की प्रतीक्षा…',
  'skills.meetingBots.leaveButton': 'छोड़ें',
  'skills.meetingBots.leavingButton': 'छोड़ रहे हैं…',
  'skills.meetingBots.respondToParticipant': 'इस मीटिंग में आपका नाम',
  'skills.meetingBots.respondToParticipantHint': 'जैसे: अनीता (कॉल में आपका प्रदर्शन नाम)',
  'skills.meetingBots.replyName.label': 'मीटिंग में आपका नाम',
  'skills.meetingBots.replyName.description':
    'वह नाम जिसे बॉट सुनता है और जवाब देता है। कॉल में दिखने वाला अपना नाम दर्ज करें: यह हर मीटिंग पर लागू होता है जिसमें वह शामिल होता है।',
  'skills.meetingBots.replyName.placeholder': 'जैसे, एलेक्स किम',
  'skills.meetingBots.respondToParticipantDesc':
    'मीटिंग में अपना सटीक डिस्प्ले नाम दर्ज करें। बॉट केवल तभी जवाब देता है जब आप उसका नाम बोलते हैं (वेक फ्रेज़)।',
  'skills.meetingBots.wakePhrase': 'वेक फ्रेज़',
  'skills.meetingBots.wakePhraseHint': 'Hey OpenHuman',
  'skills.meetingBots.wakePhraseDesc': 'बोट के जवाब देने से पहले प्रतिभागी को यह कहना होगा।',
  'skills.meetingBots.activeMode': 'जब मैं बुलाऊँ तब जवाब दे',
  'skills.meetingBots.activeModeDesc':
    'चालू होने पर, वेक फ़्रेज़ कहने के बाद बॉट बोलकर जवाब देता है। बंद होने पर, यह सिर्फ़ सुनता और ट्रांसक्राइब करता है।',
  'skills.meetingBots.history.allPlatforms': 'सभी प्लेटफ़ॉर्म',
  'skills.meetingBots.history.copyTranscript': 'कॉपी करें',
  'skills.meetingBots.history.downloadTranscript': 'डाउनलोड',
  'skills.meetingBots.history.earlier': 'पहले',
  'skills.meetingBots.history.participantCount': '{count} प्रतिभागी',
  'skills.meetingBots.history.participantCountPlural': '{count} प्रतिभागी',
  'skills.meetingBots.history.runWithOpenHuman': 'OpenHuman के साथ चलाएँ',
  'skills.meetingBots.history.searchPlaceholder': 'कॉल खोजें…',
  'skills.meetingBots.history.selectPrompt': 'सारांश और ट्रांसक्रिप्ट देखने के लिए एक कॉल चुनें।',
  'skills.meetingBots.history.today': 'आज',
  'skills.meetingBots.history.yesterday': 'कल',
  'skills.meetingBots.upcoming.heading': 'आगामी',
  'skills.meetingBots.upcoming.when': 'कब',
  'skills.meetingBots.upcoming.meeting': 'मीटिंग',
  'skills.meetingBots.upcoming.platform': 'प्लेटफ़ॉर्म',
  'skills.meetingBots.upcoming.people': 'लोग',
  'skills.meetingBots.upcoming.joinPolicy': 'जॉइन नीति',
  'skills.meetingBots.upcoming.joinNow': 'अभी जॉइन करें',
  'skills.meetingBots.upcoming.joinNowAriaLabel': '{title} जॉइन करें',
  'skills.meetingBots.upcoming.join': 'जॉइन करें',
  'skills.meetingBots.upcoming.auto': 'ऑटो',
  'skills.meetingBots.upcoming.ask': 'पूछें',
  'skills.meetingBots.upcoming.skip': 'छोड़ें',
  'skills.meetingBots.upcoming.today': 'आज',
  'skills.meetingBots.upcoming.tomorrow': 'कल',
  'skills.meetingBots.upcoming.empty':
    'कोई आगामी मीटिंग नहीं: यहाँ देखने के लिए Google Calendar कनेक्ट करें।',
  'skills.meetingBots.upcoming.error': 'आगामी मीटिंग लोड नहीं हो सकीं।',
  'skills.meetingBots.upcoming.retry': 'पुनः प्रयास करें',
  'skills.meetingBots.upcoming.refresh': 'रिफ्रेश करें',
  'skills.meetingBots.upcoming.filterAll': 'सभी प्लेटफ़ॉर्म',
  'skills.meetingBots.upcoming.participants': '{count} प्रतिभागी',
  'skills.meetingBots.upcoming.imminent': 'जल्द शुरू हो रही है',
  'skills.meetingBots.upcoming.autoJoinsAt': 'ऑटो-जॉइन ~{time} पर',
  'skills.meetingBots.upcoming.asksAtStart': 'शुरुआत में पूछता है',
  'skills.meetingBots.upcoming.watchCalendarHint':
    "ऑटो/पूछें प्रभावी करने के लिए डिफ़ॉल्ट (गियर आइकन) में 'मेरा कैलेंडर देखें' चालू करें: अन्यथा ये नीतियाँ सहेजी जाती हैं लेकिन ट्रिगर नहीं होंगी।",
  'skills.meetingBots.relative.now': 'अभी',
  'skills.meetingBots.relative.inMinutes': '{count}म में',
  'skills.meetingBots.relative.inHours': '{count}घ में',
  'skills.meetingBots.relative.minutesAgo': '{count}म पहले',
  'skills.meetingBots.relative.hoursAgo': '{count}घ पहले',
  'skills.meetingBots.relative.daysAgo': '{count}दि पहले',
  'skills.meetingBots.relative.yesterday': 'कल',
  'skills.meetingBots.defaults.drawerTitle': 'मीटिंग डिफ़ॉल्ट',
  'skills.meetingBots.defaults.closeDrawer': 'बंद करें',
  'skills.meetingBots.defaults.openDefaults': 'मीटिंग सेटिंग',
  'skills.meetingBots.defaults.watchCalendar': 'मेरा कैलेंडर देखें',
  'skills.meetingBots.defaults.watchCalendarDesc':
    'OpenHuman को अपना कनेक्टेड कैलेंडर देखने दें ताकि यह नीचे दी गई नीतियों के आधार पर बैठकों में स्वचालित रूप से शामिल हो सके या संकेत दे सके। यह बैठक अनुस्मारक सूचनाओं से अलग है।',
  'skills.meetingBots.defaults.globalPolicy': 'वैश्विक ऑटो-जॉइन नीति',
  'skills.meetingBots.defaults.perPlatformTitle': 'प्रति-प्लेटफ़ॉर्म ओवरराइड',
  'skills.meetingBots.defaults.perPlatformDesc':
    'विशिष्ट प्लेटफ़ॉर्म के लिए वैश्विक नीति को ओवरराइड करें।',
  'skills.meetingBots.defaults.useDefault': 'डिफ़ॉल्ट उपयोग करें',
  'skills.resource.preview.closeAriaLabel': 'प्रीव्यू बंद करें',
  'skills.resource.preview.failed': 'पूर्वावलोकन विफल',
  'skills.resource.preview.loading': 'प्रीव्यू लोड हो रहा है…',
  'skills.resource.tree.assets': 'एसेट',
  'skills.resource.tree.examples': 'उदाहरण',
  'skills.resource.tree.other': 'अन्य',
  'skills.resource.tree.prompts': 'प्रॉम्प्ट',
  'skills.resource.tree.references': 'संदर्भ',
  'skills.resource.tree.scripts': 'स्क्रिप्ट',
  'skills.resource.tree.templates': 'टेम्पलेट',
  'skills.resource.tree.empty': 'कोई बंडल्ड रिसोर्स नहीं।',
  'skills.search.placeholder': 'प्लेसहोल्डर',
  'skills.setup.voice.activation': 'एक्टिवेशन',
  'skills.setup.voice.activeDescPrefix': 'एफ.एन',
  'skills.setup.voice.activeDescSuffix': 'एफ.एन',
  'skills.setup.voice.activeTitle': 'Voice Intelligence एक्टिव है',
  'skills.setup.voice.customizeSettings': 'सेटिंग्स कस्टमाइज़ करें',
  'skills.setup.voice.downloadSttBtn': 'STT डाउनलोड करें',
  'skills.setup.voice.enableDesc': 'सक्षम विवरण',
  'skills.setup.voice.hotkey': 'हॉटकी',
  'skills.setup.voice.startBtn': 'शुरू हो रहा है...',
  'skills.setup.voice.startError': 'वॉइस सर्वर शुरू नहीं हो पाया',
  'skills.setup.voice.starting': 'शुरू हो रहा है...',
  'skills.setup.voice.stepEnable': 'वॉइस सर्वर शुरू करें',
  'skills.setup.voice.stepSetup': 'मॉडल डाउनलोड ज़रूरी है',
  'skills.setup.voice.stepSuccess': 'तैयार है',
  'skills.setup.voice.sttNotReady': 'Speech-to-text मॉडल तैयार नहीं है',
  'skills.setup.voice.sttNotReadyDesc':
    'Voice Intelligence को ट्रांसक्रिप्शन के लिए लोकल Whisper मॉडल चाहिए। इसे Local Model सेटिंग्स से डाउनलोड करें।',
  'skills.setup.voice.sttReady': 'Speech-to-text मॉडल तैयार है',
  'skills.setup.voice.sttReturnHint': 'STT रिटर्न संकेत',
  'skills.setup.voice.title': 'वॉइस इंटेलिजेंस',
  'skills.uninstall.couldNotUninstall': 'अनइंस्टॉल नहीं हो सका',
  'skills.uninstall.description':
    'यह स्किल डायरेक्टरी और उसके सभी बंडल किए गए संसाधनों को स्थायी रूप से हटा देता है। एजेंट अगले टर्न पर इसे देखना बंद कर देगा।',
  'skills.uninstall.title': 'अनइंस्टॉल',
  'skills.uninstall.uninstallBtn': 'अनइंस्टॉल',
  'skills.uninstall.uninstalling': 'अनइंस्टॉल हो रहा है…',
  'upsell.global.limitMessage': 'जारी रखने के लिए अपना प्लान अपग्रेड करें या क्रेडिट टॉप अप करें',
  'upsell.global.limitTitle': 'आप',
  'upsell.global.nearLimitMessage':
    'आपने अपनी उपयोग सीमा का {pct}% इस्तेमाल कर लिया है। ज़्यादा सीमा के लिए अपग्रेड करें।',
  'upsell.global.nearLimitTitle': 'उपयोग सीमा के करीब',
  'upsell.usageLimit.bodyBudget':
    'आपने अपनी साप्ताहिक सीमा प्राप्त कर ली है।{reset} सीमाओं से बचने के लिए अपनी योजना अपग्रेड करें या क्रेडिट टॉप अप करें।',
  'upsell.usageLimit.bodyRate':
    'आपने अपनी 10-घंटे की इन्फ़रेंस दर सीमा प्राप्त कर ली है।{reset} उच्च सीमा के लिए अपग्रेड करें।',
  'upsell.usageLimit.heading': 'उपयोग सीमा पहुँच गई',
  'upsell.usageLimit.notNow': 'अभी नहीं',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': 'यह {time} रीसेट होती है।',
  'upsell.usageLimit.upgradePlan': 'प्लान अपग्रेड करें',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': 'चैट से शुरू करें',
  'walkthrough.steps.startChat.content':
    'चैट आपका शुरुआती स्थान है। नई विंडो उसी स्वागत संदेश और तेज़ कार्रवाइयों के साथ खुलती हैं जो आपने सेटअप के बाद देखीं।',
  'walkthrough.steps.sayHello.title': 'नमस्ते कहें',
  'walkthrough.steps.sayHello.content':
    'कभी भी अपने AI सहायक से बातचीत शुरू करने के लिए यहां टैप करें।',
  'walkthrough.steps.meetAi.title': 'अपने AI से मिलें',
  'walkthrough.steps.meetAi.content':
    'बातचीत यहीं होती है। सवाल पूछें, सारांश लें या विचार करें। सब कुछ खोजने योग्य रहता है।',
  'walkthrough.steps.connectWorld.title': 'अपनी दुनिया जोड़ें',
  'walkthrough.steps.connectWorld.content':
    'Gmail, Slack, WhatsApp और बहुत कुछ: हर कनेक्शन आपके सहायक को नई क्षमताएं देता है।',
  'walkthrough.steps.messagingApps.title': 'जहां आप पहले से हैं वहीं चैट करें',
  'walkthrough.steps.messagingApps.content':
    'WhatsApp, Telegram, Slack, Discord जोड़ें ताकि आपका सहायक आपको कहीं भी पहुंच सके।',
  'walkthrough.steps.settings.title': 'इसे अपना बनाएं',
  'walkthrough.steps.settings.content':
    'पसंद, गोपनीयता और सूचनाएं यहां हैं। आप इस पेज से यह टूर कभी भी फिर शुरू कर सकते हैं।',
  'walkthrough.steps.chatTab.title': 'चैट पर वापस जाएं',
  'walkthrough.steps.chatTab.content': 'जब भी बातचीत पर लौटना हो, Chat टैब का उपयोग करें।',
  'walkthrough.steps.humanTab.title': 'अपनी Human प्रोफ़ाइल देखें',
  'walkthrough.steps.humanTab.content':
    'Human आपका निजी संदर्भ, पहचान और सहायक को दिखने वाली प्रोफ़ाइल एक साथ रखता है।',
  'walkthrough.steps.brainTab.title': 'अपना Brain खोलें',
  'walkthrough.steps.brainTab.content':
    'Brain मेमोरी ग्राफ है: यहां देखें कि OpenHuman क्या जानता है और विचार कैसे जुड़े हैं।',
  'walkthrough.steps.agentWorldTab.title': 'Agent World देखें',
  'walkthrough.steps.agentWorldTab.content':
    'Agent World में पुन: उपयोग योग्य एजेंट और साझा ऑटोमेशन रहते हैं।',
  'walkthrough.steps.connectionsTab.title': 'कनेक्शन प्रबंधित करें',
  'walkthrough.steps.connectionsTab.content':
    'सेवाएं जोड़ने या बदलने के लिए Connections हमेशा मुख्य नेविगेशन में उपलब्ध है।',
  'walkthrough.steps.feedbackTab.title': 'फ़ीडबैक भेजें',
  'walkthrough.steps.feedbackTab.content':
    'Feedback समस्याएं बताने या सुधार मांगने की सीधी जगह है।',
  'walkthrough.steps.allSet.title': 'सब तैयार है!',
  'walkthrough.steps.allSet.content':
    'आपके सहायक ने स्वागत नोट छोड़ा है: यहां आप चैट कर सकते हैं, सवाल पूछ सकते हैं या विचार कर सकते हैं। आनंद लें!',
  'walkthrough.tooltip.letsGo': 'चलिए शुरू करें!',
  'walkthrough.tooltip.next': 'अगला →',
  'walkthrough.tooltip.skip': 'टूर छोड़ें',
  'walkthrough.tooltip.stepCounter': '{total} में से {n}',
  'webhooks.activity.empty': 'खाली है',
  'webhooks.activity.title': 'हाल की एक्टिविटी',
  'webhooks.composioHistory.empty': 'खाली है',
  'webhooks.composioHistory.metadataId': 'मेटाडेटा ID',
  'webhooks.composioHistory.metadataUuid': 'मेटाडेटा UUID',
  'webhooks.composioHistory.payload': 'पेलोड',
  'webhooks.composioHistory.title': 'ComposeIO ट्रिगर हिस्ट्री',
  'webhooks.tunnels.active': 'एक्टिव',
  'webhooks.tunnels.createFailed': 'टनल बनाने में दिक्कत',
  'webhooks.tunnels.creating': 'बन रहा है...',
  'webhooks.tunnels.deleteFailed': 'टनल डिलीट करने में दिक्कत',
  'webhooks.tunnels.descriptionPlaceholder': 'विवरण (वैकल्पिक)',
  'webhooks.tunnels.echo': 'इको',
  'webhooks.tunnels.empty': 'खाली है',
  'webhooks.tunnels.enableEcho': 'Echo चालू करें',
  'webhooks.tunnels.inactive': 'निष्क्रिय',
  'webhooks.tunnels.namePlaceholder': 'टनल का नाम (जैसे telegram-bot)',
  'webhooks.tunnels.newTunnel': 'नया टनल',
  'webhooks.tunnels.removeEcho': 'Echo हटाएं',
  'webhooks.tunnels.title': 'Webhook टनल',
  'webhooks.tunnels.toggleFailed': 'Echo टॉगल करने में दिक्कत',
  'composio.directModeRequiresKey':
    'सहेजने में विफल। डायरेक्ट मोड के लिए गैर-रिक्त API कुंजी आवश्यक है।',
  'composio.integrationSlugsHelp': 'अल्पविराम से अलग किए गए एकीकरण स्लग, उदा.',
  'composio.integrationSlugsExample': 'जीमेल, सुस्त',
  'composio.integrationSlugsCaseInsensitive': 'केस-असंवेदनशील.',
  'composio.integrationSlugsPlaceholder': 'जीमेल, स्लैक, ...',
  'composio.notYetRouted': 'अभी तक रूट नहीं हुआ',
  'composio.triggers.loading': 'लोड हो रहा है…',
  'conversations.taskKanban.todo': 'करना है',
  'chat.addReaction': 'प्रतिक्रिया जोड़ें',
  'chat.agentProfile.create': 'एजेंट प्रोफ़ाइल बनाएं',
  'chat.agentProfile.createFailed': 'एजेंट प्रोफ़ाइल नहीं बनाई जा सकी.',
  'chat.agentProfile.customDescription': 'कस्टम एजेंट प्रोफ़ाइल',
  'chat.agentProfile.defaultAgentLabel': 'ऑर्केस्ट्रेटर',
  'chat.agentProfile.exists': 'एजेंट प्रोफ़ाइल "{name}" पहले से मौजूद है।',
  'chat.agentProfile.label': 'एजेंट प्रोफ़ाइल',
  'chat.agentProfile.quick': 'त्वरित',
  'chat.agentProfile.reasoning': 'तर्क',
  'chat.agentProfile.namePlaceholder': 'प्रोफ़ाइल नाम',
  'chat.agentProfile.promptStylePlaceholder': 'शीघ्र शैली',
  'chat.agentProfile.allowedToolsPlaceholder': 'अनुमत उपकरण',
  'chat.backToThread': '{title} पर वापस',
  'chat.parentThread': 'मूल सूत्र',
  'chat.removeReaction': '{emoji} हटाएं',
  'settings.composio.loading': 'लोड हो रहा है…',
  'settings.mascot.noCharactersAvailable': 'अभी तक कोई OpenHuman कैरेक्टर उपलब्ध नहीं है',
  'skills.uninstall.confirmTitle': '{name} अनइंस्टॉल करें?',
  'conversations.taskKanban.blocked': 'अवरुद्ध',
  'conversations.taskKanban.done': 'पूर्ण',
  'conversations.taskKanban.pending': 'लंबित',
  'conversations.taskKanban.working': 'कार्य',
  'conversations.taskKanban.awaitingApproval': 'अनुमति देना',
  'conversations.taskKanban.ready': 'रेडी',
  'conversations.taskKanban.rejected': 'अस्वीकार',
  'conversations.taskKanban.inProgress': 'प्रगति पर',
  'conversations.taskKanban.awaitingApprovalColumn': 'अनुमोदन की प्रतीक्षा में',
  'conversations.taskKanban.blockedColumn': 'अवरुद्ध',
  'conversations.taskKanban.evidenceBadge': 'साक्ष्य ({count})',
  'conversations.taskKanban.needsInput': 'इन कार्यों के लिए आपके इनपुट की आवश्यकता है',
  'conversations.taskKanban.emptyColumn': 'कोई कार्य नहीं',
  'conversations.taskKanban.dragHint': 'कॉलम के बीच स्थानांतरित करने के लिए खींचें',
  'conversations.taskKanban.movingCard': 'स्थानांतरित हो रहा है…',
  'conversations.taskKanban.statusBadge.ready': 'शुरू करने के लिए तैयार',
  'conversations.taskKanban.statusBadge.rejected': 'अस्वीकृत',
  'intelligence.memoryChunk.detail.copiedHint': 'कॉपी हो गया',
  'settings.composio.notYetRouted': 'अभी तक रूट नहीं हुआ',
  'settings.localModel.download.manageExternal': 'इस मॉडल को अपने बाहरी रनटाइम में प्रबंधित करें।',
  'settings.localModel.status.manageOllamaExternal':
    'OpenHuman के बाहर Ollama प्रक्रिया और मॉडल पुल प्रबंधित करें, फिर डायग्नोस्टिक्स पुनः चलाएँ।',
  'settings.localModel.status.ollamaDocs': 'Ollama दस्तावेज़',
  'settings.localModel.status.thenRetry':
    'सेटअप निर्देशों के लिए, फिर आपका रनटाइम पहुँच योग्य होने के बाद पुनः प्रयास करें।',
  'devOptions.menuAi': 'एआई कॉन्फ़िगरेशन',
  'devOptions.menuAiDesc': 'क्लाउड प्रदाता, स्थानीय Ollama मॉडल, और प्रति-वर्कलोड रूटिंग',
  'devOptions.menuMessaging': 'मैसेजिंग चैनल',
  'devOptions.menuMessagingDesc':
    'Telegram/Discord प्रमाणीकरण मोड और डिफ़ॉल्ट चैनल रूटिंग कॉन्फ़िगर करें',
  'devOptions.menuTools': 'उपकरण',
  'devOptions.menuToolsDesc':
    'क्षमताओं को सक्षम या अक्षम करें OpenHuman आपकी ओर से उपयोग कर सकते हैं',
  'devOptions.menuAgentChat': 'एजेंट चैट',
  'devOptions.menuAgentChatDesc': 'मॉडल और तापमान ओवरराइड के साथ परीक्षण एजेंट की बातचीत',
  'devOptions.menuCronJobs': 'क्रॉन जॉब्स',
  'devOptions.menuCronJobsDesc': 'रनटाइम कौशल के लिए निर्धारित कार्य देखें और कॉन्फ़िगर करें',
  'devOptions.menuLocalModelDebug': 'स्थानीय मॉडल डीबग',
  'devOptions.menuLocalModelDebugDesc':
    'Ollama कॉन्फ़िगरेशन, एसेट डाउनलोड, मॉडल परीक्षण और डायग्नोस्टिक्स',
  'devOptions.menuWebhooksDebug': 'वेबहुक',
  'devOptions.menuWebhooksDebugDesc':
    'रनटाइम वेबहुक पंजीकरण और कैप्चर किए गए अनुरोध लॉग का निरीक्षण करें',
  'devOptions.menuIntelligence': 'बुद्धि',
  'devOptions.menuIntelligenceDesc': 'मेमोरी कार्यक्षेत्र, अवचेतन इंजन, सपने और सेटिंग्स',
  'devOptions.menuNotificationRouting': 'अधिसूचना रूटिंग',
  'devOptions.menuNotificationRoutingDesc':
    'एकीकरण अलर्ट के लिए एआई महत्व स्कोरिंग और ऑर्केस्ट्रेटर एस्केलेशन',
  'devOptions.menuComposeIOTriggers': 'कंपोज़आईओ ट्रिगर्स',
  'devOptions.menuComposeIOTriggersDesc': 'ComposeIO ट्रिगर इतिहास और संग्रह देखें',
  'devOptions.menuComposioRouting': 'Composio रूटिंग (डायरेक्ट मोड)',
  'devOptions.menuComposioRoutingDesc':
    'अपनी स्वयं की Composio API कुंजी लाएँ और कॉल को सीधे Backend.composio.dev पर रूट करें',
  'devOptions.menuComposioTriggers': 'एकीकरण ट्रिगर',
  'devOptions.menuComposioTriggersDesc':
    'Composio एकीकरण ट्रिगर के लिए AI ट्राइएज सेटिंग्स कॉन्फ़िगर करें',
  'memory.sourceFilterAria': 'स्रोत के अनुसार फ़िल्टर करें',
  'calls.comingSoonDescription': 'एआई-सहायक कॉल जल्द ही आ रही हैं। बने रहें।',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': 'आलोचनात्मक',
  'subconscious.priority.important': 'महत्वपूर्ण',
  'subconscious.priority.normal': 'सामान्य',
  'subconscious.durationSeconds': '{seconds}s',
  'subconscious.durationMilliseconds': '{milliseconds}ms',
  'settings.appearance': 'दिखावट',
  'settings.appearanceDesc': 'प्रकाश, अंधेरा, या अपने सिस्टम थीम से मेल चुनें',
  'settings.mascot': 'शुभंकर',
  'settings.mascotDesc': 'ऐप में उपयोग किया जाने वाला शुभंकर रंग चुनें',
  'pages.settings.account.walletBalances': 'वॉलेट बैलेंस',
  'pages.settings.account.walletBalancesDesc': 'अपने स्थानीय वॉलेट के मल्टी-चेन बैलेंस देखें',
  'walletBalances.title': 'वॉलेट बैलेंस',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': 'बैलेंस लोड हो रहा है…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState': 'अभी कोई वॉलेट अकाउंट नहीं: Recovery Phrase में वॉलेट सेटअप करें।',
  'walletBalances.copyAddress': 'पता कॉपी करें',
  'walletBalances.providerMissing': 'प्रोवाइडर अनुपलब्ध',
  'walletBalances.rawBalance': 'रॉ: {raw}',
  'walletBalances.errorGeneric':
    'वॉलेट बैलेंस लोड नहीं हो सका। Recovery Phrase में अपना वॉलेट सेटअप करें और पुनः प्रयास करें।',
  'walletBalances.setupHint':
    'आपका रिकवरी फ्रेज़ अभी सेटअप नहीं है। अपना वॉलेट सक्रिय करने और लाइव बैलेंस देखने के लिए इसे सेटअप करें।',
  'walletBalances.setupCta': 'रिकवरी फ्रेज़ सेटअप करें',
  'walletBalances.notSetUp': 'सेटअप नहीं है',
  'walletBalances.send': 'भेजें',
  'walletBalances.receive': 'प्राप्त करें',
  'walletReceive.scanHint':
    'फंड प्राप्त करने के लिए इस कोड को स्कैन करें या नीचे दिया पता कॉपी करें।',
  'walletReceive.addressLabel': '{network} पता',
  'walletReceive.onlyChainWarning':
    'इस पते पर केवल {network} एसेट भेजें। किसी अन्य नेटवर्क के एसेट भेजने से स्थायी हानि हो सकती है।',
  'walletSend.available': 'उपलब्ध',
  'walletSend.recipient': 'प्राप्तकर्ता का पता',
  'walletSend.recipientPlaceholder': 'गंतव्य पता पेस्ट करें',
  'walletSend.recipientRequired': 'प्राप्तकर्ता का पता दर्ज करें',
  'walletSend.amount': 'राशि',
  'walletSend.invalidAmount': 'एक मान्य राशि दर्ज करें',
  'walletSend.review': 'समीक्षा करें',
  'walletSend.preparing': 'तैयार किया जा रहा है…',
  'walletSend.confirmHint':
    'नीचे दिए विवरण की समीक्षा करें। हस्ताक्षर स्थानीय रूप से होता है: जब तक आप पुष्टि नहीं करते, कुछ भी प्रसारित नहीं होता।',
  'walletSend.estimatedFee': 'अनुमानित नेटवर्क शुल्क',
  'walletSend.confirmSend': 'पुष्टि करें और भेजें',
  'walletSend.sending': 'भेजा जा रहा है…',
  'walletSend.sent': 'लेनदेन भेजा गया',
  'walletSend.txHash': 'लेनदेन हैश',
  'walletSend.viewExplorer': 'एक्सप्लोरर में देखें',
  'walletSend.done': 'हो गया',
  'walletSend.genericError': 'स्थानांतरण पूरा नहीं हो सका। कृपया पुनः प्रयास करें।',
  'settings.taskSources.title': 'कार्य स्रोत',
  'settings.integrations.title': 'एकीकरण',
  'settings.integrations.menuDesc': 'कार्य स्रोत, Composio रूटिंग और वेबहुक ट्रिगर',
  'settings.taskSources.subtitle': 'एजेंट टोडो बोर्ड पर अपने उपकरणों से कार्य खींचें',
  'settings.taskSources.description':
    'GitHub, नॉटियन, रैखिक और क्लिकअप से कार्य वस्तुओं को इकट्ठा करें, उन्हें समृद्ध करें और उन्हें एजेंट टोडो बोर्ड पर ले जाएं।',
  'settings.taskSources.connectHint':
    'कार्य स्रोत आपके कनेक्टेड खातों का उपयोग करते हैं। उन्हें पहले एकीकरण के तहत कनेक्ट करें।',
  'settings.taskSources.disabledBanner':
    'कार्य स्रोत सेटिंग्स में अक्षम हैं। उन्हें स्वचालित रूप से मतदान करने में सक्षम बनाता है।',
  'settings.taskSources.loadError': 'कार्य स्रोतों को लोड करने में विफल',
  'settings.taskSources.addTitle': 'एक कार्य स्रोत जोड़ें',
  'settings.taskSources.provider': 'प्रदाता',
  'settings.taskSources.name': 'नाम (वैकल्पिक)',
  'settings.taskSources.namePlaceholder': 'e.g मेरे खुले मुद्दे',
  'settings.taskSources.github.repo': 'रिपॉज़िटरी (owner/name, वैकल्पिक)',
  'settings.taskSources.github.labels': 'लेबल (comma-separated)',
  'settings.taskSources.notion.database': 'डेटाबेस (बोर्ड) ID',
  'settings.taskSources.notion.browseDatabases': 'डेटाबेस ब्राउज़ करें',
  'settings.taskSources.notion.loadingDatabases': 'डेटाबेस लोड हो रहे हैं…',
  'settings.taskSources.notion.selectDatabase': 'एक डेटाबेस चुनें…',
  'settings.taskSources.notion.noDatabases': 'इस कनेक्शन के लिए कोई डेटाबेस नहीं मिला।',
  'settings.taskSources.linear.team': 'टीम आईडी (वैकल्पिक)',
  'settings.taskSources.clickup.team': 'कार्यक्षेत्र (टीम) आईडी (वैकल्पिक)',
  'settings.taskSources.assignedToMe': 'केवल मुझे सौंपा गया आइटम',
  'settings.taskSources.add': 'स्रोत जोड़ें',
  'settings.taskSources.adding': 'जोड़ना...',
  'settings.taskSources.preview': 'पूर्वावलोकन',
  'settings.taskSources.previewResult': '{count} कार्य इस फ़िल्टर से मेल खाता है',
  'settings.taskSources.fetchNow': 'अभी लेना',
  'settings.taskSources.fetching': '...',
  'settings.taskSources.fetchResult':
    '{fetched} कार्यों में से {routed} रूट किए गए; {pruned} पुराने कार्य हटाए गए',
  'settings.taskSources.syncAll': 'सभी सिंक करें',
  'settings.taskSources.syncing': 'सिंक हो रहा है...',
  'settings.taskSources.configured': 'संरूपित सूत्र',
  'settings.taskSources.empty': 'अभी तक कोई कार्य स्रोत नहीं है।',
  'settings.taskSources.proactive': 'सक्रिय',
  'settings.taskSources.lastFetch': 'अंतिम आगमन',
  'settings.taskSources.never': 'कभी नहीं',
  'settings.taskSources.statusEnabled': 'सक्षम',
  'settings.taskSources.statusDisabled': 'विकलांग',
  'settings.taskSources.enable': 'सक्षम',
  'settings.taskSources.disable': 'अक्षम',
  'settings.taskSources.remove': 'निकालें',
  'settings.taskSources.removeConfirm':
    'इस कार्य स्रोत को निकालें? सभी ingested कार्य इतिहास को हटा दिया जाएगा और नहीं किया जा सकता है।',
  'settings.taskSources.refresh': 'ताज़ा',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'धारणा',
  'settings.taskSources.providers.linear': 'रैखिक',
  'settings.taskSources.providers.clickup': 'क्लिक करें',
  'skills.dashboard.enable': 'शेड्यूल किया गया वर्कफ़्लो सक्षम करें',
  'skills.dashboard.disable': 'शेड्यूल किया गया वर्कफ़्लो अक्षम करें',
  'skills.dashboard.lastRun': 'अंतिम बार चला',
  'skills.dashboard.nextRun': 'अगली बार चलेगा',
  'skills.dashboard.cardOpenRunner': 'रनर में खोलें',
  'skills.new.title': 'एक वर्कफ़्लो बनाएं',
  'settings.agents.title': 'एजेंट',
  'settings.agents.subtitle':
    'प्रतिनिधिमंडल के लिए उपलब्ध एजेंटों को प्रबंधित करें - अंतर्निहित डिफ़ॉल्ट और अपने स्वयं के कस्टम एजेंट।',
  'settings.agents.menuDesc': 'अंतर्निहित और कस्टम एजेंट प्रबंधित करें',
  'settings.agents.newAgent': 'नया एजेंट',
  'settings.agents.loadError': 'एजेंट लोड नहीं कर सका',
  'settings.agents.empty': 'अभी तक कोई एजेंट नहीं',
  'settings.agents.sourceDefault': 'निर्मित',
  'settings.agents.sourceCustom': 'कस्टम',
  'settings.agents.enable': 'सक्षम एजेंट',
  'settings.agents.disable': 'अक्षम एजेंट',
  'settings.agents.edit': 'संपादित करें',
  'settings.agents.delete': 'Delete',
  'settings.agents.reset': 'डिफ़ॉल्ट रूप से रीसेट करें',
  'settings.agents.modelLabel': 'मॉडल',
  'settings.agents.toolsLabel': 'उपकरण',
  'settings.agents.toolsAll': 'सभी उपकरण',
  'settings.agents.toolsCount': '{count} उपकरण',
  'settings.agents.actionFailed': 'एजेंट को अपडेट नहीं कर सका',
  'settings.agents.orchestratorLocked': 'ऑर्केस्ट्रेटर हमेशा सक्षम होता है।',
  'settings.agents.editor.createTitle': 'नया एजेंट',
  'settings.agents.editor.editTitle': 'संपादन एजेंट',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': 'लोअरकेस अक्षर, संख्या,   और - केवल।',
  'settings.agents.editor.name': 'नाम',
  'settings.agents.editor.description': 'विवरण',
  'settings.agents.editor.model': 'मॉडल (वैकल्पिक)',
  'settings.agents.editor.modelPlaceholder': 'e.g. विरासत, संकेत: तेज, या एक मॉडल आईडी',
  'settings.agents.editor.systemPrompt': 'सिस्टम प्रॉम्प्ट (वैकल्पिक)',
  'settings.agents.editor.tools': 'अनुमति उपकरण',
  'settings.agents.editor.toolsHint':
    'एक उपकरण का नाम प्रति पंक्ति। सभी उपकरणों के लिए * का उपयोग करें।',
  'settings.agents.editor.defaultsNote':
    'एक अंतर्निहित एजेंट को संपादित करने से आपको बाद में रीसेट कर सकते हैं।',
  'settings.agents.editor.save': 'सहेजें',
  'settings.agents.editor.create': 'एजेंट बनाना',
  'settings.agents.editor.saving': 'बचत',
  'nav.workflows': 'Workflows',
  'workflows.title': 'वर्कफ़्लो',
  'workflows.subtitle':
    'पुन: प्रयोज्य, चलाने योग्य प्रक्रियाएँ: एक लक्ष्य और उसे प्राप्त करने के चरण। एक बनाएँ, URL से इंस्टॉल करें, या चलाने के लिए वर्कफ़्लो खोलें।',
  'workflows.createNew': 'नया वर्कफ़्लो',
  'workflows.listHeading': 'Workflows',
  'workflows.delete': 'वर्कफ़्लो हटाएँ',
  'workflows.deleteError': 'वर्कफ़्लो हटाने में विफल',
  'workflows.warnings': '{count} चेतावनी',
  'workflows.empty.title': 'अभी तक कोई वर्कफ़्लो नहीं',
  'workflows.empty.body':
    'कार्य जीवनचक्र चरणों के लिए नियम और स्क्रिप्ट परिभाषित करने हेतु वर्कफ़्लो बनाएँ।',
  'workflows.create.title': 'नया वर्कफ़्लो',
  'workflows.create.subtitle': 'एजेंट के लिए जीवनचक्र-बद्ध नियम सेट परिभाषित करें।',
  'workflows.create.name': 'Name',
  'workflows.create.namePlaceholder': 'उदा. Python प्रोजेक्ट वर्कफ़्लो',
  'workflows.create.description': 'Description',
  'workflows.create.descriptionPlaceholder': 'यह वर्कफ़्लो क्या करता है?',
  'workflows.create.whenToUse': 'कब उपयोग करें',
  'workflows.create.whenToUsePlaceholder': 'एजेंट को यह वर्कफ़्लो कब उठाना चाहिए?',
  'workflows.create.optional': '(वैकल्पिक)',
  'workflows.create.createBtn': 'वर्कफ़्लो बनाएँ',
  'workflows.create.creating': 'Creating…',
  'workflows.create.createError': 'वर्कफ़्लो नहीं बन सका',
  'workflows.create.successTitle': 'वर्कफ़्लो बनाया गया',
  'workflows.create.successMessage': 'सफलतापूर्वक बनाया गया।',
  'workflows.deleteConfirm.title': 'वर्कफ़्लो हटाएँ',
  'workflows.deleteConfirm.body': '"{name}" हटाएँ? यह पूर्ववत नहीं किया जा सकता।',
  'workflows.detail.tags': 'Tags',
  'workflows.detail.location': 'Location',
  'workflows.detail.warnings': 'Warnings',
  'workflows.detail.phases': 'Phases',
  'workflows.detail.noPhases': 'कोई चरण परिभाषित नहीं।',
  'workflows.detail.loadError': 'पूर्ण वर्कफ़्लो लोड करने में विफल',
  'workflows.phase.rules': 'Rules',
  'workflows.phase.rules.empty': 'कोई नियम नहीं।',
  'workflows.phase.scripts': 'Scripts',
  'workflows.phase.scripts.empty': 'कोई स्क्रिप्ट नहीं।',
  'workflows.phase.toolScope': 'टूल स्कोप',
  'workflows.phase.toolScope.allow': 'Allow',
  'workflows.phase.toolScope.deny': 'Deny',
  'workflows.phase.toolScope.inherited': 'वर्कफ़्लो डिफ़ॉल्ट से विरासत में मिला।',
  'workflows.phase.toolScope.empty': 'कोई टूल प्रतिबंध नहीं।',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': 'कोई संदर्भ प्रदाता नहीं।',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description':
    'अपने एजेंट, उनकी स्वायत्तता और इस कंप्यूटर पर वे क्या एक्सेस कर सकते हैं, यह प्रबंधित करें।',
  'settings.agentsSection.menuDesc': 'रजिस्ट्री, स्वायत्तता और OS एक्सेस',
  'settings.cryptoSection.title': 'क्रिप्टো',
  'settings.cryptoSection.description':
    'अपना रिकवरी फ्रेज़ प्रबंधित करें और अपने वॉलेट खातों के बैलेंस देखें।',
  'settings.cryptoSection.menuDesc': 'रिकवरी फ्रेज़ और वॉलेट बैलेंस',
  'settings.notificationsHub.title': 'सूचनाएं',
  'settings.notificationsHub.description':
    'अपना अलर्ट इनबॉक्स देखें और सूचना प्राथमिकताएं व रूटिंग प्रबंधित करें।',
  'settings.notificationsHub.menuDesc': 'अलर्ट इनबॉक्स और सूचना प्राथमिकताएं',
  'settings.notificationsHub.settingsItem': 'सूचना सेटिंग्स',
  'settings.notificationsHub.settingsItemDesc': 'प्राथमिकताएं और रूटिंग',
  'settings.agents.editor.notFound': 'एजेंट नहीं मिला।',
  'settings.agents.editor.modelInherit': 'इनहेरिट करें (प्लेटफ़ॉर्म डिफ़ॉल्ट)',
  'settings.agents.editor.modelHints': 'रूट संकेत',
  'settings.agents.editor.modelTiers': 'मॉडल स्तर',
  'settings.agents.editor.modelCustom': 'कस्टम मॉडल आईडी…',
  'settings.agents.editor.modelCustomPlaceholder': 'जैसे anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': 'टूल जोड़ें',
  'settings.agents.editor.toolsAllSelected': 'सभी टूल',
  'settings.agents.editor.toolsNoneSelected': 'कोई टूल चुना नहीं गया',
  'settings.agents.editor.removeToolAria': '{tool} हटाएं',
  'settings.agents.editor.toolsModalTitle': 'अनुमत टूल',
  'settings.agents.editor.toolsSelectedCount': '{count} चुने गए',
  'settings.agents.editor.toolsSearchPlaceholder': 'टूल खोजें…',
  'settings.agents.editor.toolsAllowAll': 'सभी टूल की अनुमति दें (*)',
  'settings.agents.editor.toolsAllowAllHint': 'यह एजेंट हर उपलब्ध टूल का उपयोग कर सकता है।',
  'settings.agents.editor.toolsLoading': 'टूल लोड हो रहे हैं…',
  'settings.agents.editor.toolsLoadError': 'टूल लोड नहीं हो सके',
  'settings.agents.editor.toolsEmpty': 'आपकी खोज से कोई टूल मेल नहीं खाता।',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    'बिल्ट-इन एजेंट संपादित नहीं किए जा सकते। आप एजेंट सूची से उन्हें सक्षम, अक्षम या रीसेट कर सकते हैं।',
  // Chat: agent-generated artifacts (#2779)
  'chat.artifact.aria': 'आर्टिफैक्ट: {title}',
  'chat.artifact.generating': '{kind} बना रहा है…',
  'chat.artifact.ready': 'तैयार',
  'chat.artifact.failed': 'निर्माण विफल',
  'chat.artifact.download': 'डाउनलोड',
  'chat.artifact.downloading': 'डाउनलोड हो रहा है…',
  'chat.artifact.downloaded': '{path} में सहेजा गया',
  'chat.artifact.download_failed': 'डाउनलोड विफल: {reason}',
  'chat.artifact.retry': 'पुनः प्रयास',
  'chat.artifact.reveal': 'फ़ोल्डर में दिखाएं',
  'chat.artifact.show_more': 'और दिखाएं',
  'chat.artifact.show_less': 'कम दिखाएं',

  // Chat: files panel (#3024)
  'chat.files.chip.aria.one': 'इस चैट में {count} फ़ाइल',
  'chat.files.chip.aria.other': 'इस चैट में {count} फ़ाइलें',
  'chat.files.panel.aria': 'इस चैट की फ़ाइलें',
  'chat.files.panel.title': 'फ़ाइलें ({count})',
  'chat.files.panel.empty': 'अभी कोई फ़ाइल नहीं। एजेंट से एक बनाने को कहें।',
  'chat.files.panel.close': 'फ़ाइल पैनल बंद करें',
  'chat.files.delete.aria': '{title} हटाएं',
  'chat.files.delete.confirm': 'यह फ़ाइल हटाएं?',
  'chat.files.delete.cancel': 'रद्द करें',
  'chat.files.delete.action': 'हटाएं',
  'chat.files.delete.failed': 'फ़ाइल हटाई नहीं जा सकी। पुनः प्रयास करें।',
  'chat.files.error.not_desktop': 'डाउनलोड केवल डेस्कटॉप ऐप में उपलब्ध हैं।',
  'chat.files.error.missing_artifact_id': 'आर्टिफैक्ट आईडी अनुपस्थित है।',
  'chat.files.error.missing_artifact_path': 'कोर प्रतिक्रिया से आर्टिफैक्ट पथ गायब है।',
  'chat.files.error.resolve_failed': 'आर्टिफैक्ट को हल नहीं किया जा सका। पुनः प्रयास करें।',
  'chat.files.error.download_failed': 'डाउनलोड विफल रहा। पुनः प्रयास करें।',
  'chat.files.error.delete_failed': 'फ़ाइल हटाई नहीं जा सकी। पुनः प्रयास करें।',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': 'स्वचालन',
  'activity.tabs.automationsDescription':
    'पुन: उपयोग योग्य, चलाने योग्य प्रक्रियाएँ: एक लक्ष्य और उसे प्राप्त करने के चरण।',
  'activity.tabs.backgroundActivity': 'सबकॉन्शस',
  'activity.tabs.alerts': 'अलर्ट',

  'intelligence.agents.title': 'एजेंट लाइब्रेरी',
  'intelligence.agents.subtitle':
    'चलाए जा सकने वाले विशेषज्ञ देखें और किसी नामित एजेंट को एक काम भेजें।',
  'intelligence.agents.refresh': 'रीफ्रेश',
  'intelligence.agents.loading': 'एजेंट लोड हो रहे हैं…',
  'intelligence.agents.failedToLoad': 'एजेंट लोड नहीं हो सके',
  'intelligence.agents.empty': 'कोई चलाने योग्य एजेंट उपलब्ध नहीं है।',
  'intelligence.agents.readOnly': 'केवल पढ़ें',
  'intelligence.agents.writeCapable': 'लिख सकता है',
  'intelligence.agents.allTools': 'सभी टूल',
  'intelligence.agents.toolCountOne': '{count} टूल',
  'intelligence.agents.toolCountOther': '{count} टूल',
  'intelligence.agents.subagentCountOne': '{count} सब-एजेंट',
  'intelligence.agents.subagentCountOther': '{count} सब-एजेंट',
  'intelligence.agents.startChat': 'चैट शुरू करें',
  'intelligence.agents.startChatPrompt':
    'इस एजेंट के साथ चैट शुरू करें। अपनी विशेषज्ञता बताएं, जरूरी जानकारी पूछें, और मेरे काम का इंतज़ार करें।',
  'intelligence.agents.copyId': 'ID कॉपी करें',
  'intelligence.agents.copied': 'कॉपी हो गया',
  'intelligence.agents.taskPlaceholder': 'इस एजेंट के लिए काम',
  'intelligence.agents.runTask': 'काम चलाएं',
  'intelligence.agents.running': 'चल रहा है…',
  'intelligence.agents.runFailed': 'चुना गया एजेंट शुरू नहीं हो सका',
  'intelligence.agents.model.inherit': 'इनहेरिट',
  'intelligence.agents.tier.chat': 'चैट',
  'intelligence.agents.tier.reasoning': 'तर्क',
  'intelligence.agents.tier.worker': 'वर्कर',
  'graphCohesion.brokerBadge': 'ब्रोकर',
  'graphCohesion.brokerTitle':
    'संरचनात्मक छेद: इस इकाई के पड़ोसी आपस में नहीं जुड़े: यह उनके बीच एकमात्र कड़ी है।',
  'graphCohesion.colCohesion': 'संसक्ति',
  'graphCohesion.colEntity': 'इकाई',
  'graphCohesion.colLinks': 'लिंक',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': 'अभी तक कोई नॉलेज ग्राफ नहीं।',
  'graphCohesion.emptyHint':
    'जैसे-जैसे सहायक आपके बारे में जुड़े हुए तथ्य दर्ज करता है, उनकी क्लस्टरिंग संरचना यहाँ उभरेगी।',
  'graphCohesion.errorPrefix': 'ग्राफ लोड नहीं हो सका:',
  'graphCohesion.intro':
    'यह दिखाता है कि हर इकाई के चारों ओर का पड़ोस कितना घनिष्ठ रूप से बुना हुआ है। ब्रोकर (वे इकाइयाँ जिनके पड़ोसी आपस में नहीं जुड़े) एकमात्र बिंदु हैं जो वरना अलग क्लस्टरों को साथ थामे रखते हैं, जिन्हें आवृत्ति या PageRank-आधारित क्रम नहीं दिखा सकता।',
  'graphCohesion.loading': 'संसक्ति गणना हो रही है…',
  'graphCohesion.metricConnections': 'कनेक्शन',
  'graphCohesion.metricEntities': 'इकाइयाँ',
  'graphCohesion.metricTriangles': 'त्रिकोण',
  'graphCohesion.namespaceAll': 'सभी नेमस्पेस',
  'graphCohesion.namespaceLabel': 'नेमस्पेस',
  'graphCohesion.noBrokers': 'अभी तक दो या अधिक कनेक्शन वाली कोई इकाई नहीं।',
  'graphCohesion.rankedHeading': 'ब्रोकर: सबसे ढीले पड़ोस',
  'graphCohesion.retry': 'पुनः प्रयास',
  'graphCohesion.summaryCaption': 'औसत क्लस्टरिंग {avg} · सकर्मकता {transitivity}',
  'graphCohesion.title': 'ग्राफ संसक्ति',
  'memory.tab.cohesion': 'Cohesion',

  'harnessInit.title': 'सेटअप किया जा रहा है',

  'announcement.gotIt': 'समझ गया',
  'harnessInit.subtitle': 'OpenHuman पहली बार शुरू होने पर आवश्यक घटक तैयार कर रहा है।',
  'harnessInit.stepPython': 'Python रनटाइम',
  'harnessInit.stepSpacy': 'भाषा मॉडल',
  'harnessInit.stepNode': 'Node.js रनटाइम',
  'harnessInit.statePending': 'प्रतीक्षारत',
  'harnessInit.stateRunning': 'इंस्टॉल हो रहा है…',
  'harnessInit.stateDone': 'तैयार',
  'harnessInit.stateSkipped': 'छोड़ा गया',
  'harnessInit.stateFailed': 'विफल',
  'harnessInit.failedMessage':
    'कुछ सेटअप चरण पूरे नहीं हुए। आप पुनः प्रयास कर सकते हैं, या जारी रख सकते हैं: OpenHuman एक अंतर्निहित फॉलबैक का उपयोग करेगा।',
  'harnessInit.retry': 'पुनः प्रयास करें',
  'harnessInit.continueAnyway': 'फिर भी जारी रखें',
  'harnessInit.runInBackground': 'पृष्ठभूमि में चलाएँ',
  'harnessInit.backgroundHint': 'जब तक यह पूरा होता है, आप OpenHuman का उपयोग जारी रख सकते हैं।',

  'keyring.consent.title': 'सुरक्षित भंडारण अनुपलब्ध',
  'keyring.consent.description':
    'आपके ऑपरेटिंग सिस्टम का कीचेन सुलभ नहीं है। OpenHuman को इसके बजाय स्थानीय एन्क्रिप्टेड भंडारण का उपयोग करके रहस्य संग्रहीत करने के लिए आपकी अनुमति चाहिए।',
  'keyring.consent.reasonPrefix': 'कारण:',
  'keyring.consent.showDetails': 'इसका क्या मतलब है?',
  'keyring.consent.hideDetails': 'विवरण छिपाएं',
  'keyring.consent.tradeoffTitle': 'सुरक्षा समझौता',
  'keyring.consent.tradeoffBody':
    'स्थानीय एन्क्रिप्टेड भंडारण में, आपके रहस्य डिस्क पर एक मास्टर कुंजी से एन्क्रिप्ट किए जाते हैं जो डेटा के साथ संग्रहीत होती है। यह OS कीचेन से कम सुरक्षित है, जो हार्डवेयर-समर्थित सुरक्षा का उपयोग करता है। बैकअप या फ़ाइल सिंकिंग में एन्क्रिप्टेड डेटा शामिल हो सकता है।',
  'keyring.consent.consentButton': 'स्थानीय एन्क्रिप्टेड भंडारण का उपयोग करें',
  'keyring.consent.retryButton': 'OS Keychain पुनः प्रयास करें',
  'keyring.consent.declineButton': 'अस्वीकार करें',
  'keyring.consent.retrying': 'पुनः प्रयास हो रहा है…',
  'keyring.consent.error': 'प्राथमिकता सहेजने में विफल। कृपया पुनः प्रयास करें।',
  'keyring.consent.retryFailed': 'कीचेन अभी भी अनुपलब्ध है।',
  'keyring.settings.title': 'सुरक्षा',
  'keyring.settings.storageMode': 'रहस्य भंडारण मोड',
  'keyring.settings.mode.osKeychain': 'OS कीचेन',
  'keyring.settings.mode.encryptedFile': 'स्थानीय एन्क्रिप्टेड',
  'keyring.settings.mode.consentPending': 'कॉन्फ़िगर नहीं किया गया',
  'keyring.settings.mode.declined': 'अस्वीकृत',
  'keyring.settings.availability': 'कीचेन उपलब्धता',
  'keyring.settings.available': 'OS कीचेन उपलब्ध है',
  'keyring.settings.unavailable': 'OS कीचेन अनुपलब्ध है',
  'keyring.settings.backend': 'बैकएंड',
  'keyring.settings.retryButton': 'कीचेन पहचान पुनः प्रयास करें',
  'keyring.settings.retryFailed': 'पुनः प्रयास विफल। कीचेन अभी भी अनुपलब्ध है।',
  'keyring.settings.consentTitle': 'भंडारण सहमति',
  'keyring.settings.consentDescription':
    'चुनें कि OS कीचेन अनुपलब्ध होने पर रहस्य कैसे संग्रहीत किए जाएं।',
  'keyring.settings.grantConsent': 'स्थानीय एन्क्रिप्टेड भंडारण की अनुमति दें',
  'keyring.settings.revokeConsent': 'स्थानीय भंडारण अस्वीकार करें',
  'pages.settings.account.security': 'सुरक्षा',
  'pages.settings.account.securityDesc': 'रहस्य भंडारण मोड और कीचेन स्थिति',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': 'अवक्रमित',
  'memoryTree.status.statusBudgetExhausted': 'रुका हुआ: एम्बेडिंग बजट समाप्त',
  'memoryTree.status.degradedRecall': 'सिमेंटिक रिकॉल अक्षम',
  'memoryTree.status.degradedStructure': 'विकी संरचना अधूरी',
  'memoryTree.status.extractionCoverage': 'एक्सट्रैक्शन कवरेज: {pct}% खंडों में संरचना है',
  'memory.health.remediation.budget_exhausted':
    'मेमोरी एम्बेडिंग प्रबंधित बजट तक पहुँच गई। स्थानीय Ollama एम्बेडिंग सेट करें (कनेक्शन → API कुंजियाँ → एम्बेडिंग्स) या मेमोरी बनाना जारी रखने के लिए अपनी स्वयं की एम्बेडिंग API कुंजी जोड़ें।',
  'memory.health.remediation.auth_missing':
    'कोई एम्बेडिंग क्रेडेंशियल नहीं मिला। OpenHuman में लॉग इन करें, या कनेक्शन → API कुंजियाँ → एम्बेडिंग्स में स्थानीय Ollama एम्बेडिंग सेट करें।',
  'memory.health.remediation.auth_invalid':
    'आपके एम्बेडिंग क्रेडेंशियल अस्वीकार कर दिए गए। फिर से प्रमाणित करें, या कनेक्शन → API कुंजियाँ → एम्बेडिंग्स में स्थानीय Ollama एम्बेडिंग पर स्विच करें।',
  'memory.health.remediation.embeddings_unconfigured':
    'कोई एम्बेडिंग प्रदाता कॉन्फ़िगर नहीं किया गया है, इसलिए सिमेंटिक रिकॉल बंद है। स्थानीय Ollama एम्बेडिंग सेट करें (अनुशंसित) या कनेक्शन → API कुंजियाँ → एम्बेडिंग्स में एम्बेडिंग कुंजी जोड़ें।',
  'memory.health.remediation.embedding_dim_mismatch':
    'एम्बेडिंग मॉडल गलत वेक्टर आकार लौटाता है (मेमोरी को 1024 आयाम अपेक्षित हैं)। 1024-आयाम वाला मॉडल चुनें, या अपने प्रदाता से 1024 आयाम का अनुरोध करें।',
  'memory.health.remediation.local_model_unavailable':
    'एक आवश्यक स्थानीय मॉडल उपलब्ध नहीं है। Ollama इंस्टॉल/चलाएँ और मॉडल डाउनलोड करें, या कनेक्शन → API कुंजियाँ में इस वर्कलोड को क्लाउड प्रदाता पर स्विच करें।',
  'memory.health.remediation.extraction_timeout':
    'मेमोरी एक्सट्रैक्शन मॉडल टाइम आउट हो रहा है, इसलिए विकी में बहुत कम संरचना है। कनेक्शन → API कुंजियाँ → LLM में मेमोरी एक्सट्रैक्शन मॉडल को तेज़ मॉडल में बदलें।',
  'memory.health.remediation.summarizer_unavailable':
    'सारांश ट्री बनाएँ के लिए कोई सारांश प्रदाता उपलब्ध नहीं है। स्थानीय AI (Ollama) सक्षम करें, या memory_tree.cloud_summarization_opt_in=true सेट करके कनेक्शन → API कुंजियाँ → LLM में LLM provider कॉन्फ़िगर करें।',
  'memory.health.remediation.empty_input_refused':
    'एक मेमोरी आइटम छोड़ दिया गया क्योंकि उसका टेक्स्ट खाली था। कोई कार्रवाई आवश्यक नहीं: नए आइटम सामान्य रूप से एम्बेड होते रहेंगे।',
  'memory.health.remediation.storage_unavailable':
    'OpenHuman अपने मेमोरी स्टोरेज में नहीं लिख पा रहा है: डिस्क या SD कार्ड खराब, भरा हुआ या केवल-पढ़ने योग्य लगता है। ड्राइव जाँचें और कुछ जगह खाली करें; स्टोरेज के फिर से लिखने योग्य होते ही मेमोरी प्रोसेसिंग अपने आप फिर शुरू हो जाएगी।',
  'memory.health.remediation.transient':
    'एक अस्थायी त्रुटि ने मेमोरी प्रोसेसिंग को बाधित किया। स्वचालित रूप से पुनः प्रयास किया जाएगा।',
  'memory.health.remediation.unknown':
    'मेमोरी प्रोसेसिंग में एक समस्या आई। कॉन्फ़िगरेशन के लिए कनेक्शन → API कुंजियाँ जाँचें।',
  // Chat: agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': 'फ़ाइल संलग्न करें',
  'composer.modelSelector': 'मॉडल',
  'composer.voiceMode': 'वॉइस मोड',
  'composer.qualityHigh': 'उच्च',
  // Agent activity level
  'activityLevel.title': 'एजेंट गतिविधि स्तर',
  'activityLevel.description':
    'नियंत्रित करें कि आपका एजेंट कितना सक्रिय है। उच्च स्तर पर अधिक टोकन का उपयोग होता है।',
  'activityLevel.off': 'बंद',
  'activityLevel.offDesc': 'पृष्ठभूमि में कोई प्रसंस्करण नहीं। केवल बटन दबाने पर सिंक होता है।',
  'activityLevel.minimal': 'न्यूनतम',
  'activityLevel.minimalDesc': 'दिन में एक बार स्रोत सिंक करता है। कोई सक्रिय संदेश नहीं।',
  'activityLevel.moderate': 'मध्यम',
  'activityLevel.moderateDesc': 'हर घंटे सिंक करता है। दैनिक सारांश। क्रियाएं सुझाता है।',
  'activityLevel.active': 'सक्रिय',
  'activityLevel.activeDesc':
    'हर 10 मिनट में सिंक करता है। चैनलों की निगरानी करता है, प्राथमिकता देता है और उत्तर तैयार करता है।',
  'activityLevel.alwaysOn': 'हमेशा चालू',
  'activityLevel.alwaysOnDesc': 'रीयल-टाइम सिंक। निर्धारित सीमाओं के भीतर पूर्ण स्वायत्तता।',
  'activityLevel.currentMonth': 'इस महीने: ${amount}',
  'activityLevel.saved': 'गतिविधि स्तर अपडेट किया गया।',
  'activityLevel.default': 'डिफ़ॉल्ट',
  'activityLevel.costFree': '$0',
  'activityLevel.costRange': '~${min}–${max}/माह',

  // Sync budget dialog
  'syncBudget.title': 'सिंक बजट',
  'syncBudget.maxTokens': 'प्रति सिंक अधिकतम टोकन',
  'syncBudget.maxTokensHelp': 'इतने टोकन उपयोग होने पर सिंक बंद करें।',
  'syncBudget.maxCost': 'प्रति सिंक अधिकतम लागत (USD)',
  'syncBudget.maxCostHelp': 'प्रति सिंक रन के लिए डॉलर की सीमा।',
  'syncBudget.syncDepth': 'सिंक गहराई',
  'syncBudget.syncDepthHelp': 'केवल इस समय सीमा के आइटम लाएं।',
  'syncBudget.days7': 'पिछले 7 दिन',
  'syncBudget.days30': 'पिछले 30 दिन',
  'syncBudget.days90': 'पिछले 90 दिन',
  'syncBudget.allTime': 'सब समय',
  'syncBudget.unlimited': 'असीमित',
  'syncBudget.saved': 'बजट सहेजा गया।',

  // Sync confirm dialog
  'syncConfirm.title': 'सिंक की पुष्टि करें',
  'syncConfirm.message': 'यह सिंक ~{items} आइटम (~{tokens} टोकन, अनुमानित ${cost}) प्रोसेस करेगा।',
  'syncConfirm.budgetNote': 'बजट सीमा: ${max}',
  'syncConfirm.proceed': 'आगे बढ़ें',
  'syncConfirm.cancel': 'रद्द करें',
  'syncConfirm.estimating': 'लागत का अनुमान लगाया जा रहा है...',

  // Monthly cost badge
  'monthlyCost.badge': 'इस महीने ${amount}',
  'monthlyCost.noData': 'इस महीने कोई सिंक नहीं',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': 'गतिविधि',
  'onboarding.custom.stepperVault': 'वॉल्ट',
  'onboarding.custom.activity.title': 'एजेंट गतिविधि',
  'onboarding.custom.activity.subtitle':
    'आपका एजेंट पृष्ठभूमि में कितनी सक्रियता से निगरानी और कार्य करता है।',
  'onboarding.custom.activity.defaultDesc': 'मध्यम गतिविधि: प्रति घंटे सिंक, दैनिक सारांश।',
  'onboarding.custom.activity.configureDesc':
    'अपना गतिविधि स्तर चुनें। सेटिंग्स › एजेंट गतिविधि स्तर में कॉन्फ़िगर करें।',
  'onboarding.custom.vault.title': 'मेमोरी और वॉल्ट सेटअप',
  'onboarding.custom.vault.subtitle':
    'पुष्टि करें कि मेमोरी नोट्स कहाँ लिखे जाते हैं, स्रोत डेटा कैसे पढ़ा जाता है, और आपका वॉल्ट पाइपलाइन स्वस्थ है या नहीं।',
  'onboarding.custom.vault.defaultDesc':
    'OpenHuman-प्रबंधित मेमोरी डिफ़ॉल्ट का उपयोग करें। वॉल्ट पाथ और सिंक स्वास्थ्य बाद में भी देखे जा सकते हैं।',
  'onboarding.custom.vault.configureDesc':
    'वॉल्ट स्वामित्व की समीक्षा करें, स्वास्थ्य जाँच चलाएँ और अभी मेमोरी नियंत्रण ठीक करें।',
  'onboarding.custom.vault.localDisabledReason':
    'प्रबंधित सेटअप के लिए OpenHuman साइन-इन आवश्यक है और लोकल मोड में उपलब्ध नहीं है।',
  'onboarding.custom.vault.exitError': 'ऑनबोर्डिंग पूरी नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'vaultHealth.title': 'वॉल्ट स्वास्थ्य चेकलिस्ट',
  'vaultHealth.setupTitle': 'वॉल्ट सेटअप स्वास्थ्य',
  'vaultHealth.workspaceVault': 'वर्कस्पेस वॉल्ट:',
  'vaultHealth.refresh': 'रिफ्रेश',
  'vaultHealth.refreshing': 'रिफ्रेश हो रहा है…',
  'vaultHealth.revealFolder': 'फ़ोल्डर दिखाएँ',
  'vaultHealth.openInObsidian': 'Obsidian में खोलें',
  'vaultHealth.installObsidian': 'Obsidian इंस्टॉल करें',
  'vaultHealth.openObsidianError': 'Obsidian नहीं खोला जा सका',
  'vaultHealth.revealError': 'वॉल्ट फ़ोल्डर नहीं दिखाया जा सका',
  'vaultHealth.downloadError': 'Obsidian डाउनलोड पृष्ठ नहीं खोला जा सका',
  'vaultHealth.loadError': 'वॉल्ट स्वास्थ्य लोड नहीं हो सका:',
  'vaultHealth.lastSync': 'अंतिम सिंक:',
  'vaultHealth.passed': 'पास',
  'vaultHealth.needsAttention': 'ध्यान आवश्यक',
  'vaultHealth.existsLabel': 'वर्कस्पेस वॉल्ट पाथ मौजूद है',
  'vaultHealth.existsRecovery':
    'वॉल्ट फ़ोल्डर गायब है। एक सिंक शुरू करें या यह फ़ोल्डर बनाएँ, फिर इस चेकलिस्ट को रिफ्रेश करें।',
  'vaultHealth.writableLabel': 'वॉल्ट OpenHuman द्वारा लिखने योग्य है',
  'vaultHealth.writableRecovery':
    'OpenHuman अभी इस वॉल्ट में नहीं लिख सकता। लिखने की अनुमति दें और रिफ्रेश करें।',
  'vaultHealth.obsidianLabel': 'वॉल्ट Obsidian में पंजीकृत है',
  'vaultHealth.obsidianRecovery':
    'Obsidian में इस पाथ के लिए "फ़ोल्डर को वॉल्ट के रूप में खोलें" चुनें, फिर इस चेकलिस्ट को रिफ्रेश करें।',
  'vaultHealth.pipelineLabel': 'मेमोरी पाइपलाइन स्वस्थ है',
  'vaultHealth.pipelineRecovery':
    'मेमोरी पाइपलाइन रुकी हुई है या त्रुटि में है। मेमोरी ट्री स्थिति में ऑटो-सिंक पुनः सक्षम करें और पुनः प्रयास करें।',
  'vaultHealth.timeNever': 'कभी नहीं',
  'vaultHealth.timeJustNow': 'अभी-अभी',
  'vaultHealth.timeMinAgo': '{n} मिनट पहले',
  'vaultHealth.timeHrAgo': '{n} घंटे पहले',
  'vaultHealth.timeDayAgo': '{n} दिन पहले',
  'vaultHealth.timeDaysAgo': '{n} दिन पहले',
  'memoryData.howItWorks': 'मेमोरी स्टोरेज कैसे काम करता है',
  'memoryData.workspaceVault': 'वर्कस्पेस वॉल्ट · लिखना',
  'memoryData.workspaceVaultDesc':
    'OpenHuman जनरेट किए गए मेमोरी नोट्स को memory_tree/content में लिखता है।',
  'memoryData.connectedSources': 'कनेक्टेड स्रोत · पढ़ना',
  'memoryData.connectedSourcesDesc':
    'फ़ोल्डर, मेलबॉक्स, चैट और रेपो मेमोरी इंडेक्सिंग के लिए आयात किए जाते हैं: उनकी मूल फ़ाइलें कभी नहीं बदली जातीं।',
  'memoryData.internalFiles': 'आंतरिक मेमोरी-ट्रि फ़ाइलें',
  'memoryData.internalFilesDesc':
    'इंडेक्स, क्यू स्थिति और सारांश OpenHuman द्वारा प्रबंधित किए जाते हैं ताकि रिकॉल और सिंक स्वस्थ रहे।',
  'memoryData.windowError': 'मेमोरी विंडो',
  'memoryData.windowUpdated': 'मेमोरी विंडो अपडेट हुई',
  'memoryData.windowUpdatedMsg': '{window} पर सेट किया गया।',
  'skills.create.whenToUse': 'कब उपयोग करें',
  'skills.create.whenToUsePlaceholder': 'उदा. जब उपयोगकर्ता अपना इनबॉक्स व्यवस्थित करने को कहे',
  'skills.create.whenToUseHelp':
    'वह ट्रिगर जिसके आधार पर एजेंट इस वर्कफ़्लो को चलाने का निर्णय लेता है। विवरण का पुनः उपयोग करने के लिए खाली छोड़ें।',
  'skills.create.inputs.row.descriptionError': 'प्रत्येक इनपुट के लिए विवरण आवश्यक है।',
  'skills.detail.run': 'चलाएँ',
  'skills.detail.runAriaLabel': 'यह वर्कफ़्लो चलाएँ',
  'skills.run.title': 'वर्कफ़्लो',
  'workflows.installFromUrl': 'URL से इंस्टॉल करें',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': 'अनुमोदन गेट अक्षम',
  'security.approvalGateDisabled.body':
    'आपके परिवेश में OPENHUMAN_APPROVAL_GATE=0 सेट है। बाहरी प्रभाव वाले टूल पुष्टि माँगे बिना चलेंगे।',
  'security.approvalGateOverrideIgnored.title': 'ओवरराइड अवरुद्ध',
  'security.approvalGateOverrideIgnored.body':
    'एक OPENHUMAN_APPROVAL_GATE=0 ओवरराइड का पता चला लेकिन अनदेखा कर दिया गया: डेस्कटॉप ऐप अनुमोदन गेट को हमेशा चालू रखता है।',

  // Run queue
  'runQueue.mode.interrupt': 'बाधित करें',
  'runQueue.mode.steer': 'दिशा दें',
  'runQueue.mode.followup': 'अनुसरण',
  'runQueue.mode.collect': 'संदर्भ जोड़ें',
  'runQueue.queued': 'संदेश कतार में है',
  'runQueue.steerHint': 'वर्तमान चरण को दिशा दें',
  'runQueue.followupHint': 'अनुसरण के रूप में कतार में जोड़ें',
  'runQueue.collectHint': 'अतिरिक्त संदर्भ के रूप में जोड़ें',
  'runQueue.status': '{total} कतार में',
  'runQueue.cleared': 'कतार साफ़ की गई',
  'notch.ready': 'तैयार',
  'notch.processing': 'प्रोसेस हो रहा है…',
  'notch.listening': 'सुन रहा हूं…',
  'notch.thinking': 'सोच रहा हूं…',
  'notch.speaking': 'बोल रहा हूं…',
  'notch.transcribing': 'ट्रांसक्राइब कर रहा हूं…',
  'notch.executing': 'चला रहा हूं…',
  'memory.tab.orchestration': 'ऑर्केस्ट्रेशन',
  'memory.tab.orchestrationDescription':
    'बहु-एजेंट वर्कफ़्लो चलाएं: एक प्रश्न को समानांतर एजेंटों में बाँटें, उनके निष्कर्षों की परस्पर जाँच करें, और देखें कि हर चरण एक संयोजित उत्तर में पूरा होता है।',
  'orchestration.subtitle':
    'बहु-एजेंट वर्कफ़्लो शुरू करें, उसके चरणों की प्रगति देखें, और संयोजित परिणाम पढ़ें।',
  'orchestration.loading': 'वर्कफ़्लो लोड हो रहे हैं…',
  'orchestration.failedToLoad': 'वर्कफ़्लो लोड करने में विफल',
  'orchestration.definitions': 'उपलब्ध वर्कफ़्लो',
  'orchestration.noDefinitions': 'कोई वर्कफ़्लो परिभाषा उपलब्ध नहीं है।',
  'orchestration.approvalRequired': 'अनुमोदन आवश्यक',
  'orchestration.start': 'शुरू करें',
  'orchestration.confirmStart': 'रन शुरू करें',
  'orchestration.starting': 'शुरू हो रहा है…',
  'orchestration.questionLabel': 'शोध प्रश्न (वैकल्पिक)',
  'orchestration.questionPlaceholder': 'एजेंटों को क्या शोध करना चाहिए?',
  'orchestration.runProgress': 'रन प्रगति',
  'orchestration.recentRuns': 'हाल के रन',
  'orchestration.noRuns': 'अभी तक कोई वर्कफ़्लो रन नहीं।',
  'orchestration.close': 'बंद करें',
  'orchestration.tier.readOnly': 'केवल-पढ़ने योग्य',
  'orchestration.tier.standard': 'मानक',
  'orchestration.tier.editCapable': 'संपादन-सक्षम',
  'orchestration.approval.title': 'इस वर्कफ़्लो रन को अनुमोदित करें',
  'orchestration.approval.body':
    'यह एक उच्च-लागत या उच्च-समवर्ती रन है और शुरू होने से पहले इसे आपके स्पष्ट अनुमोदन की आवश्यकता है:',
  'orchestration.approval.reason.tier': 'इसके एजेंट केवल-पढ़ने योग्य शोध से परे कार्य कर सकते हैं।',
  'orchestration.approval.reason.concurrency': 'यह एक साथ कई एजेंट चलाता है।',
  'orchestration.approval.reason.children':
    'यह कुल मिलाकर बहुत बड़ी संख्या में एजेंट उत्पन्न कर सकता है।',
  'orchestration.approval.tier': 'सुरक्षा स्तर',
  'orchestration.approval.concurrency': 'समवर्तीता',
  'orchestration.approval.maxChildren': 'अधिकतम एजेंट',
  'orchestration.approval.approve': 'अनुमोदित करें और शुरू करें',
  'orchestration.approval.starting': 'शुरू हो रहा है…',
  'orchestration.approval.cancel': 'रद्द करें',
  'orchestration.runStatus.pending': 'लंबित',
  'orchestration.runStatus.running': 'चल रहा है',
  'orchestration.runStatus.completed': 'पूर्ण',
  'orchestration.runStatus.failed': 'विफल',
  'orchestration.runStatus.cancelled': 'रद्द',
  'orchestration.runStatus.interrupted': 'बाधित',
  'orchestration.phaseStatus.pending': 'लंबित',
  'orchestration.phaseStatus.running': 'चल रहा है',
  'orchestration.phaseStatus.completed': 'पूर्ण',
  'orchestration.phaseStatus.failed': 'विफल',
  'orchestration.detail.stop': 'रोकें',
  'orchestration.detail.resume': 'पुनः आरंभ करें',
  'orchestration.detail.agents': 'एजेंट',
  'orchestration.detail.childRefs': 'चाइल्ड एजेंट',
  'orchestration.detail.synthesis': 'अंतिम संश्लेषण',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': 'एजेंट प्रोफ़ाइल',
  'settings.profiles.subtitle': 'विशिष्ट एजेंट: हर एक की अपनी आत्मा, स्मृति, कनेक्टर और कौशल।',
  'settings.profiles.menuDesc': 'एजेंट प्रोफ़ाइल बनाएँ और प्रबंधित करें',
  'settings.profiles.new': 'नई प्रोफ़ाइल',
  'settings.profiles.empty': 'अभी कोई एजेंट प्रोफ़ाइल नहीं',
  'settings.profiles.loadError': 'प्रोफ़ाइल लोड नहीं हो सकीं',
  'settings.profiles.active': 'सक्रिय',
  'settings.profiles.setActive': 'सक्रिय बनाएँ',
  'settings.profiles.sourceBuiltIn': 'अंतर्निहित',
  'settings.profiles.sourceCustom': 'कस्टम',
  'settings.profiles.deleteConfirm': 'यह प्रोफ़ाइल हटाएँ? इसे पूर्ववत नहीं किया जा सकता।',
  'settings.profiles.editor.createTitle': 'नई प्रोफ़ाइल',
  'settings.profiles.editor.editTitle': 'प्रोफ़ाइल संपादित करें',
  'settings.profiles.editor.name': 'नाम',
  'settings.profiles.editor.id': 'आईडी',
  'settings.profiles.editor.idHint': 'केवल छोटे अक्षर, अंक और डैश।',
  'settings.profiles.editor.description': 'विवरण',
  'settings.profiles.editor.soul': 'आत्मा (SOUL.md)',
  'settings.profiles.editor.soulHint':
    'इस प्रोफ़ाइल की कस्टम पहचान। खाली होने पर वर्कस्पेस की SOUL.md पर लौटता है।',
  'settings.profiles.editor.baseAgent': 'आधार एजेंट',
  'settings.profiles.editor.baseAgentHint':
    'यह प्रोफ़ाइल किस एजेंट परिभाषा के रूप में चलती है (जैसे orchestrator)।',
  'settings.profiles.editor.model': 'मॉडल',
  'settings.profiles.editor.modelHint':
    'वैकल्पिक मॉडल ओवरराइड। खाली होने पर डिफ़ॉल्ट विरासत में लेता है।',
  'settings.profiles.editor.temperature': 'तापमान',
  'settings.profiles.editor.systemPromptSuffix': 'सिस्टम प्रॉम्प्ट प्रत्यय',
  'settings.profiles.editor.agentConversations': 'एजेंट वार्तालाप स्मरण करें',
  'settings.profiles.editor.agentConversationsHint':
    'इस प्रोफ़ाइल के संदर्भ में पिछली और क्रॉस-चैट स्मृति शामिल करें।',
  'settings.profiles.editor.memorySources': 'स्मृति स्रोत',
  'settings.profiles.editor.memorySourcesHint': 'इस प्रोफ़ाइल के स्मरण के स्रोत।',
  'settings.profiles.editor.connectors': 'कनेक्टर',
  'settings.profiles.editor.connectorsHint': 'इस प्रोफ़ाइल द्वारा उपयोग योग्य Composio टूलकिट।',
  'settings.profiles.editor.skills': 'कौशल',
  'settings.profiles.editor.skillsHint':
    'इस प्रोफ़ाइल द्वारा सूचीबद्ध और चलाए जा सकने वाले वर्कफ़्लो।',
  'settings.profiles.editor.mcpServers': 'MCP सर्वर',
  'settings.profiles.editor.mcpServersHint': 'इस प्रोफ़ाइल द्वारा पहुँचने योग्य MCP सर्वर।',
  'settings.profiles.editor.dedicatedMemory': 'समर्पित मेमोरी',
  'settings.profiles.editor.dedicatedMemoryHint':
    'डिफ़ॉल्ट मेमोरी साझा करने के बजाय इस प्रोफ़ाइल को अपनी खुद की मेमोरी दें।',
  'settings.profiles.editor.dedicatedWorkspace': 'समर्पित वर्कस्पेस',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    'फ़ाइल और टूल कार्यों के लिए इस प्रोफ़ाइल को अपनी खुद की वर्किंग डायरेक्टरी दें।',
  'settings.profiles.editor.soulMdFile': 'SOUL.md फ़ाइल',
  'settings.profiles.editor.workspaceDir': 'वर्कस्पेस डायरेक्टरी',
  'settings.profiles.editor.skillsDir': 'स्किल निर्देशिका',
  'settings.profiles.editor.skillsDirHint':
    'यहाँ रखी गई SKILL.md फ़ाइलें केवल इस प्रोफ़ाइल के लिए निजी हैं।',
  'settings.profiles.editor.all': 'सभी',
  'settings.profiles.editor.selected': 'चयनित',
  'settings.profiles.editor.addPlaceholder': 'आईडी टाइप करें, एंटर दबाएँ',
  'settings.profiles.editor.removeAria': '{item} हटाएँ',
  'settings.profiles.editor.notFound': 'प्रोफ़ाइल नहीं मिली',
  'settings.profiles.editor.saving': 'सहेजा जा रहा है…',
  'settings.profiles.editor.idRequired': 'प्रोफ़ाइल आईडी खाली नहीं हो सकती',
  'agentworld.jobs.applyModal.title': 'नौकरी के लिए आवेदन करें',
  'agentworld.jobs.applyModal.successHeading': 'प्रस्ताव सफलतापूर्वक सबमिट हुआ!',
  'agentworld.jobs.applyModal.successBody': 'नौकरी पोस्टर आपके आवेदन की समीक्षा करेगा।',
  'agentworld.jobs.applyModal.coverLetterLabel': 'कवर लेटर',
  'agentworld.jobs.applyModal.coverLetterPlaceholder':
    'अपना अनुभव और इस भूमिका के लिए उपयुक्तता बताएं',
  'agentworld.jobs.applyModal.bidAmountLabel': 'बोली राशि',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': 'उदा. 450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': 'अनुमानित डिलीवरी',
  'agentworld.jobs.applyModal.deliveryPlaceholder': 'उदा. 2 सप्ताह',
  'agentworld.feed.live': 'लाइव',
  'agentworld.jobs.applyModal.cancel': 'रद्द करें',
  'agentworld.jobs.applyModal.submit': 'आवेदन सबमिट करें',
  'agentworld.jobs.applyModal.submitting': 'आवेदन हो रहा है…',
  'agentworld.messaging.live': 'लाइव',
  'agentworld.messaging.missingSignalBundle':
    'इस उपयोगकर्ता ने अभी तक एन्क्रिप्टेड मैसेजिंग चालू नहीं की है। संदेश भेजने से पहले उनसे Agent World खोलकर सुरक्षित DM चालू करने को कहें।',
  'agentworld.messaging.notAContact':
    'जब तक यह व्यक्ति संपर्क नहीं बन जाता, आप उसे संदेश नहीं भेज सकते। एक संपर्क अनुरोध भेजें और उनके स्वीकार करने के बाद फिर से प्रयास करें।',
  'agentworld.messaging.sendContactRequest': 'संपर्क अनुरोध भेजें',
  'agentworld.messaging.contactRequestSending': 'अनुरोध भेजा जा रहा है…',
  'agentworld.messaging.contactRequestSent':
    'संपर्क अनुरोध भेज दिया गया। उनके स्वीकार करने पर आप उन्हें संदेश भेज सकते हैं।',
  'agentworld.messaging.contactRequestFailed':
    'संपर्क अनुरोध नहीं भेजा जा सका। कृपया फिर से प्रयास करें।',

  // User-actionable runtime errors (#3931)
  'userErrors.title': 'कार्रवाई आवश्यक',
  'userErrors.dismiss': 'खारिज करें',
  'userErrors.action.openBilling': 'बिलिंग खोलें',
  'userErrors.action.openProviderSettings': 'प्रदाता सेटिंग्स',
  'userErrors.action.openEmbeddingsSettings': 'एम्बेडिंग सेट करें',
  'userErrors.budgetExceeded.title': 'प्रबंधित बजट समाप्त',
  'userErrors.budgetExceeded.body': 'प्रबंधित AI बजट समाप्त। बजट जोड़ें या प्लान बदलें।',
  'userErrors.insufficientCredits.title': 'प्रदाता क्रेडिट आवश्यक',
  'userErrors.insufficientCredits.body':
    'AI प्रदाता के क्रेडिट समाप्त। रिचार्ज करें या API कुंजी बदलें।',
  'userErrors.apiKeyMissing.title': 'API कुंजी आवश्यक',
  'userErrors.apiKeyMissing.body':
    'आपके AI प्रदाता के लिए कोई API कुंजी सेट नहीं है। जारी रखने के लिए प्रदाता सेटिंग्स में एक जोड़ें।',
  'userErrors.localModelUnavailable.title': 'लोकल मॉडल उपलब्ध नहीं है',
  'userErrors.localModelUnavailable.body':
    'कॉन्फ़िगर किए गए एंडपॉइंट पर Ollama तक पहुँच नहीं है, या ज़रूरी मॉडल वहाँ इंस्टॉल नहीं है। Ollama शुरू करके उसी एंडपॉइंट पर मॉडल पुल करें, या इस काम को किसी क्लाउड प्रोवाइडर पर ले जाएँ।',
  'userErrors.scope.chat': 'चैट',
  'userErrors.scope.cron': 'निर्धारित कार्य',
  'userErrors.scope.workspace': 'वर्कस्पेस',
  'userErrors.memoryBudgetExhausted.title': 'मेमोरी बढ़ना बंद हो गई है',
  'userErrors.memoryBudgetExhausted.body':
    'आपका एम्बेडिंग बजट खत्म हो गया है, इसलिए नई सामग्री अब मेमोरी में नहीं जुड़ रही। दोबारा शुरू करने के लिए लोकल एम्बेडिंग सेट करें या अपनी API कुंजी जोड़ें।',
  'memoryBudget.approachingTitle': 'मेमोरी अपनी एम्बेडिंग सीमा के पास पहुंच रही है',
  'memoryBudget.approachingMessage':
    'आपने अपने एम्बेडिंग बजट का {pct}% इस्तेमाल कर लिया है। मेमोरी बिना रुकावट बढ़ती रहे, इसके लिए लोकल एम्बेडिंग सेट करें या अपनी API कुंजी जोड़ें।',
  'memoryBudget.exhaustedTitle': 'मेमोरी बढ़ना बंद हो गई है',
  'memoryBudget.exhaustedMessage':
    'आपका एम्बेडिंग बजट खत्म हो गया है, इसलिए नई सामग्री अब मेमोरी में नहीं जुड़ रही। दोबारा शुरू करने के लिए लोकल एम्बेडिंग सेट करें या अपनी API कुंजी जोड़ें।',
  'memoryBudget.cta': 'एम्बेडिंग सेट करें',
  'userErrors.scope.memory': 'मेमोरी',
  // Agent World: Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': 'राशि',
  'agentWorld.trading.networkLabel': 'नेटवर्क',
  'agentWorld.trading.balanceLabel': 'आपका बैलेंस',
  'agentWorld.trading.walletLabel': 'वॉलेट',
  'agentWorld.trading.balanceUnknown': 'अज्ञात',
  'agentWorld.trading.cancel': 'रद्द करें',
  'agentWorld.trading.addFunds': 'फंड जोड़ें',
  'agentWorld.trading.confirmPay': 'पुष्टि करें और भुगतान करें',
  'agentWorld.trading.confirmCommit': 'पुष्टि करें',
  'agentWorld.trading.continue': 'जारी रखें',
  'agentWorld.trading.submitting': 'भेजा जा रहा है…',
  'agentWorld.trading.placeBid': 'बोली लगाएं',
  'agentWorld.trading.submitOffer': 'ऑफ़र भेजें',
  'agentWorld.trading.bidTitlePrefix': 'बोली:',
  'agentWorld.trading.offerTitlePrefix': 'ऑफ़र:',
  'agentWorld.trading.bidReviewTitlePrefix': 'बोली की पुष्टि करें:',
  'agentWorld.trading.offerReviewTitlePrefix': 'ऑफ़र की पुष्टि करें:',
  'agentWorld.trading.spendInsufficient':
    'यह भुगतान पूरा करने के लिए पर्याप्त बैलेंस नहीं है। जारी रखने के लिए अपने वॉलेट में फंड जोड़ें।',
  'agentWorld.trading.spendBroadcastNote':
    'आपका वॉलेट इस भुगतान पर हस्ताक्षर करके इसे प्रसारित करेगा',
  'agentWorld.trading.commitInsufficientWarning':
    'यदि प्रतिबद्धता स्वीकार की जाती है तो आपका बैलेंस इसे कवर नहीं कर सकता। आप फिर भी इसे भेज सकते हैं: फंड केवल स्वीकृति पर ही स्थानांतरित होते हैं।',
  'agentWorld.trading.commitSettleNote':
    'यह एक हस्ताक्षरित प्रतिबद्धता है: फंड केवल स्वीकार किए जाने पर ही स्थानांतरित होते हैं।',
  'agentWorld.trading.commitReviewSubtitle': 'भेजने से पहले अपनी प्रतिबद्धता की समीक्षा करें।',
  'agentWorld.trading.balanceUnverified':
    'हम आपके वॉलेट बैलेंस की पुष्टि नहीं कर सके। आप फिर भी जारी रख सकते हैं: भुगतान भेजे जाने पर जांचा जाता है।',
  'agentWorld.trading.amountTooManyDecimals': 'इस राशि में बहुत अधिक दशमलव स्थान हैं।',
  'agentWorld.trading.amountMustBePositive': 'शून्य से बड़ी राशि दर्ज करें।',
  'agentWorld.trading.amountInvalid': 'एक मान्य राशि दर्ज करें।',

  // Code block chrome
  'codeBlock.copy': 'कॉपी करें',
  'codeBlock.copied': 'कॉपी हो गया!',
  'flows.editor.undo': 'पूर्ववत करें',
  'flows.editor.redo': 'फिर से करें',
  'flows.editor.onboardingTitle': 'अपना वर्कफ़्लो बनाएं',
  'flows.editor.onboardingBody':
    'बाईं ओर के पैलेट से एक नोड जोड़ें, फिर उन्हें जोड़ने के लिए प्रत्येक कार्ड पर बिंदुओं के बीच खींचें।',
  'flows.palette.search': 'नोड खोजें…',
  'flows.palette.noResults': 'कोई मिलता-जुलता नोड नहीं',
  'flows.palette.group.triggers': 'ट्रिगर',
  'flows.palette.group.actions': 'क्रियाएं',
  'flows.palette.group.logic': 'लॉजिक',
  'flows.list.duplicate': 'डुप्लिकेट करें',
  'flows.list.duplicated': 'वर्कफ़्लो डुप्लिकेट किया गया',
  'flows.list.delete': 'हटाएं',
  'flows.list.deleted': 'वर्कफ़्लो हटाया गया',
  'flows.list.moreActions': 'और क्रियाएं',
  'flows.delete.title': 'वर्कफ़्लो हटाएं?',
  'flows.delete.body':
    '"{name}" और इसका रन इतिहास स्थायी रूप से हटा दिया जाएगा। इसे पूर्ववत नहीं किया जा सकता।',
  'flows.delete.cancel': 'रद्द करें',
  'flows.delete.confirm': 'हटाएं',
  'flows.delete.deleting': 'हटाया जा रहा है…',
  'flows.canvas.renameLabel': 'वर्कफ़्लो का नाम बदलें',
  'memorySources.codingSessions.title': 'कोडिंग-एजेंट सत्र',
  'memorySources.codingSessions.description':
    'Codex और Claude Code के निर्णयों व सुधारों को निजी व्यक्तित्व स्मृति में बदलें।',
  'memorySources.codingSessions.importAll': 'सभी सत्र आयात करें',
  'memorySources.codingSessions.draining': 'आयात हो रहा है… पास {passes}',
  'memorySources.codingSessions.stop': 'रोकें',
  'memorySources.codingSessions.progress': '{processed} सत्र आयात किए गए · {observations} अवलोकन',
  'memorySources.codingSessions.remaining': 'लगभग {remaining} शेष',
  'memorySources.codingSessions.stopped': 'आयात रोका गया',
  'memorySources.codingSessions.stoppedMessage':
    '{processed} सत्र आयात किए गए। शेष {remaining} जारी रखने के लिए फिर से आयात चलाएँ।',
  'memorySources.codingSessions.claude': 'क्लॉड कोड',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files} सत्र · {evidence} मानवीय संदेश',
  'memorySources.codingSessions.notFound': 'कोई स्थानीय इतिहास नहीं मिला',
  'memorySources.codingSessions.scanning': 'स्थानीय सत्र इतिहास स्कैन हो रहा है…',
  'memorySources.codingSessions.truncated': 'स्कैन पहले 1,000 सत्र फ़ाइलों तक सीमित था।',
  'memorySources.codingSessions.complete': 'कोडिंग सत्र शामिल हो गए',
  'memorySources.codingSessions.completeMessage':
    '{processed} सत्रों से {observations} व्यक्तित्व अवलोकन बने।',
  'memorySources.codingSessions.partialFailure':
    '{processed} सत्र संसाधित हुए, जबकि {failed} विफल रहे। दोबारा प्रयास करने के लिए अंतर्ग्रहण फिर चलाएँ।',
  'memorySources.codingSessions.failed': 'कोडिंग सत्र शामिल करना विफल रहा',
  'flows.canvas.sidePanelToggle': 'साइड पैनल',
  'flows.canvas.legendTab': 'मैनुअल',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': 'गोपनीयता स्थिति',
  'privacy.status.external': 'डिवाइस के बाहर',
  'privacy.status.local': 'डिवाइस पर',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': 'केवल अंतर्ग्रहीत',
  'sync.pipeline.storedWithoutVectors': 'वेक्टर के बिना संग्रहीत। सिमेंटिक खोज अनुपलब्ध।',
  'sync.pipeline.signInToEnable': 'सक्षम करने के लिए साइन इन करें',
  'sync.pipeline.extractionFailed': 'मेमोरी संरचना निष्कर्षण विफल रहा। विकी अपूर्ण हो सकता है।',
  'sync.pipeline.treeDegraded': 'मेमोरी ट्री अवक्रमित। पुनर्प्राप्ति पुराने परिणाम दे सकती है।',
  'sync.pipeline.viewHealth': 'मेमोरी स्वास्थ्य देखें',
  'notifications.configRecovered.title': 'सेटिंग फ़ाइल पुनर्प्राप्त की गई',
  'notifications.configRecovered.body':
    'आपकी सेटिंग फ़ाइल पढ़ी नहीं जा सकी, इसलिए इसे बैकअप से पुनर्स्थापित किया गया या डिफ़ॉल्ट पर रीसेट कर दिया गया। न पढ़ी जा सकने वाली फ़ाइल को, ज़रूरत पड़ने पर, ".corrupted" प्रत्यय के साथ रखा गया है।',
};

export default messages;
